/**
 * Auto-generated translation store on 2026-04-20T16:30:38.190Z
 * Do not modify this file directly.
 * 
 * This file contains all translations bundled at build time for optimal performance.
 * Translations are automatically updated when source files change.
 */

import { TranslationStore } from './translation-store.interface';

export const translationStore: TranslationStore = {
  "pt-PT": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DE ADMINISTRAÇÃO",
      "SUPPORT": "ASSISTÊNCIA",
      "U": "U",
      "USER": "Utilizador",
      "LOGOUT": "Terminar sessão",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Assistência",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONE",
      "CAMERA": "CÂMARA",
      "ACCESS_DENIED": "ACESSO_NEGADO"
    },
    "teams": {
      "MY_TEAMS": "As minhas equipas",
      "COMPLETED": "Concluído",
      "IN_PROGRESS": "Em curso",
      "NOT_STARTED": "Não iniciada",
      "ASSIGNMET_MODULE": "Módulo de tarefa",
      "START_DATE": "Data de início",
      "DUE_DATE": "Data limite",
      "ASSIGNED_MEMBERS": "Membros atribuídos",
      "CALLS_IN_MODULE": "Simulações no módulo",
      "COMPLETION_REQUIRMENT": "Requisito de conclusão",
      "COMPLETE_ALL_CALLS": "Completar todas as simulações com uma pontuação de",
      "OR_HIGHER": "ou superior",
      "PROGRESS_OVERVIEW": "SÍNTESE DO PROGRESSO",
      "TEAM_MEMBERS": "membros da equipa",
      "AVERAGE_HIGH_SCORE": "Média das pontuações mais elevadas",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número médio de tentativas por simulação",
      "TOTAL_PRACTICES": "Total de práticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DA SIMULAÇÃO INDIVIDUAL",
      "OF_TEAM_MEMBERS": "de membros da equipa concluídos",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Média de práticas até à conclusão",
      "TEAM_MEMBER_DETAILS": "DETALHES DO MEMBRO DA EQUIPA",
      "DOWNLOAD_ACTIVITY_REPORT": "Transferir o relatório de atividade",
      "TEAM_MEMBER": "Membro da equipa",
      "PROGRESS": "Progresso",
      "CALLS_COMPLETED": "Simulações concluídas",
      "PRACTICES": "Sessões de prática",
      "MOST_RECENT_PRACTICE": "Sessão mais recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Esta equipa não tem tarefas ativas neste momento",
      "CALL_NAME_LABEL": "Nome da simulação",
      "HIGHEST_SCORE": "Pontuação mais elevada"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Vamos certificar-nos de que o seu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "É necessário um microfone funcional.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se não vir um pedido de pop-up para ativar os seus dispositivos após atualizar esta página, aceda às definições do seu sistema ou navegador e ative os seus dispositivos. Abaixo encontram-se páginas de apoio com instruções adicionais.",
      "ENABLE_CAMERA": "Como ativar a sua câmara:",
      "WINDOWS_USERS": "Utilizadores de Windows",
      "MAC_USERS": "Utilizadores de Mac",
      "IPAD_USERS": "Utilizadores de iPad",
      "ENABLE_MICROPHONE": "Como ativar o microfone:",
      "ENABLE_DEVICES_BY_BROWSER": "Como ativar os seus dispositivos por browser:",
      "CHROME_USERS": "Utilizadores do Chrome",
      "SAFARI_USERS": "Utilizadores do Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sem câmara",
      "START_CALL_BUTTON": "Iniciar chamada",
      "MICROPHONE_REQUIRED_WARNING": "É necessário um microfone funcional.",
      "MICROPHONE_ALT": "microfone",
      "MICROPHONE": "Microfone",
      "SELECT_MICROPHONE": "Selecione o seu microfone",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar autorização",
      "SELECT_VIDEO_DEVICE": "Selecione o seu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que negou o acesso deste navegador a um ou mais dos seus dispositivos. Para ativar os dispositivos, aceda às definições do sistema ou às definições do browser e ative o acesso.",
      "DEVICE_SETTINGS": "Definições do dispositivo",
      "CONFIRM_SETTINGS": "Confirmar definições",
      "LAPTOP": "Computador portátil",
      "SAD_EMOTE_FACE": "Carinha triste",
      "GRANT_BROWSER_ACCESS": "Para concluir esta simulação, conceda o acesso do navegador ao reconhecimento de voz",
      "USING_IPAD": "Se estiver a utilizar um iPad, aceda a",
      "SETTINGS": "Definições",
      "PRIVACY_AND_SECURITY": "Privacidade e segurança",
      "SPEECH_RECOGNITION": "Reconhecimento de voz",
      "GRANT_ACCESS_REFRESH": "Conceder acesso ao navegador e atualizar a página",
      "REFRESH_PAGE": "ATUALIZAR A PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "O navegador não consegue aceder a este dispositivo",
      "ACCESS_DENIED": "acesso negado",
      "CAMERA": "Câmara",
      "DIAGNOSTIC_PASSED": "Todos os testes de diagnóstico foram aprovados com sucesso.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alguns testes de diagnóstico falharam. Clique no botão «Copiar resultados de diagnóstico» acima e envie os resultados para a equipa de apoio para obter assistência.",
      "DIAGNOSTIC_PARTIAL": "A maioria dos testes de diagnóstico foi aprovada com sucesso. A sua ligação parece estar boa.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Aguarde enquanto os testes de diagnóstico estão a ser executados...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico em execução",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados do diagnóstico",
      "RUN_DIAGNOSTIC": "Executar diagnóstico",
      "RERUN_DIAGNOSTIC": "Voltar a executar diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados do diagnóstico copiados para a área de transferência",
      "DIAGNOSTIC_FAILED": "Falha no diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos quantificados",
      "DIAGNOSTIC_TIME": "tempo",
      "DIAGNOSTIC_SUMMARY": "Resumo",
      "DIAGNOSTIC_CLIENT_INFO": "Informações do cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perda de pacotes (envio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Velocidade de transmissão média",
      "DIAGNOSTIC_NA": "n/a"
    },
    "results": {
      "RETURN_HOME": "REGRESSAR AO INÍCIO",
      "CLOSE_BUTTON": "Botão de fechar",
      "CONVERSATIONAL_CALL": "DRAMATIZAÇÃO",
      "INFORMATION_ICON": "Ícone de informação",
      "TOOLTIP_ARROW": "Seta de descrição",
      "INFORMATION_TOOLTIP_CONTENT": "O utilizador controla o fluxo da simulação, conduzindo a conversa para um conjunto de objetivos. As dramatizações são ótimas para testar competências como aprofundar questões, fazer perguntas de segundo nível, identificar pontos críticos e criar relações.",
      "CLOCK_ICON": "Ícone do relógio",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Competências",
      "MESSAGE_ADHERENCE": "Aderência à mensagem",
      "TRY_AGAIN_MESSAGE": "Tente novamente e melhore a sua pontuação.",
      "PRACTICE_BENEFITS": "A prática semanal aumenta a confiança e melhora os resultados no mundo real.",
      "CALL_SUCCESS": "Excelente trabalho! Esta simulação foi concluída com êxito.",
      "MAX_ATTEMPTS_REACHED": "Atingiu o número máximo de tentativas",
      "TRY_AGAIN": "Tentar de novo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excelente trabalho! Conseguiu completar",
      "COMPLETED_THIS_CALL": "completou esta simulação.",
      "ACHIEVED_SCORE": "O formando obteve uma pontuação de",
      "ACHIEVE_SCORE": "Obtenha uma pontuação de",
      "OR_HIGHER": "ou superior.",
      "OBJECTIVES_NOT_MET": "Não cumpriu todos os objetivos exigidos.",
      "TRY_AGAIN_TARGET_SCORE": "Tente novamente para obter uma pontuação de",
      "YOUR_SCORE": "A sua pontuação",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMO DO FEEDBACK",
      "STRENGTH_ICON_ALT": "Ícone de força",
      "OPPORTUNITIES_ICON_ALT": "Ícone de oportunidades",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SOBRE A METODOLOGIA",
      "SESSION_ID": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "O seu desempenho:",
      "LIGHTBULB_ICON_ALT": "Ícone de lâmpada",
      "WHAT_WE_SUGGEST": "O que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "O nosso sistema não conseguiu encontrar uma recomendação específica para si.",
      "WHY": "Porquê?",
      "NO_INSIGHTS_AVAILABLE": "O nosso sistema não foi capaz de fornecer informações sobre esta sugestão.",
      "CONFETTI_ICON_ALT": "Ícone de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Excelente desempenho nesta metodologia, mantenha o bom trabalho!",
      "PROCESSING_CALL": "Estamos a preparar a sua pontuação e o seu feedback.",
      "HANG_TIGHT": "Aguarde ou volte mais tarde para",
      "VIEW_YOUR_RESULTS": "ver os seus resultados.",
      "NEED_MORE_TIME": "Precisamos de mais tempo para calcular os resultados.",
      "REFRESH_INSTRUCTION": "Verifique novamente ou atualize a tarefa",
      "RESULTS_IN_FEW_MINUTES": "resultados em poucos minutos.",
      "SCORE_CALCULATION_QUESTION": "Como é que isto é calculado?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulação tem apenas um componente de pontuação, pelo que a pontuação exibida corresponde tanto à pontuação da secção individual como à pontuação global.",
      "OVERALL_SCORE_PERCENT": "% da pontuação global",
      "SECTION_SCORE": "Pontuação da secção",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Aumente a aderência da mensagem na conversa",
      "MESSAGE_ADHERENCE_NOTE": "A aderência à mensagem é fundamental para conduzir conversas bem sucedidas, mas não afeta a sua pontuação global.",
      "NO_CREDIT": "Sem crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito total",
      "WHAT_YOU_DID_WELL": "O que fez bem",
      "MISSED_ALL_KEY_POINTS": "Falhou todos os pontos-chave; reveja-os e tente novamente.",
      "WHAT_TO_IMPROVE": "O que pode melhorar",
      "PERFECT_SCORE_MESSAGE": "Parabéns! Obteve uma pontuação perfeita, falando corretamente de todos os pontos-chave.",
      "POINTS_LABEL": "Pontos",
      "TALKING_POINTS_COVERED": "Temas de discussão abordados",
      "CHECKMARK_ICON_ALT": "marca de verificação",
      "TALKING_POINTS_MISSED": "Temas de discussão não abordados",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Praticar novamente",
      "OUT_OF": "de",
      "POSSIBLE_TALKING_POINTS": "possíveis temas de discussão",
      "YOU_COVERED": "Abordou",
      "THROUGHOUT_CALL": "durante a simulação.",
      "POSITIVE_FEEDBACK_COVERAGE": "Fez um excelente trabalho ao destacar pontos-chave ao longo da chamada e abordou",
      "MIXED_FEEDBACK_COVERAGE": "Perdeu alguns dos pontos-chave ao longo da simulação e abordou",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Melhore a sua metodologia de conversação",
      "OBJECTIVES_NOTE": "A metodologia é fundamental para conduzir conversas bem sucedidas, mas não afeta a sua pontuação global.",
      "UNTIL": "até",
      "TO_IMPROVE_SCORE": "para melhorar a sua pontuação.",
      "TO_SCORE": "para pontuar",
      "BEFORE": "antes de",
      "YOU_HAVE": "Tem",
      "MORE_ATTEMPTS": "mais tentativas de pontuar",
      "OR_HIGHER_BEFORE": "ou superior antes de",
      "AND_TRY_AGAIN": "e tentar novamente.",
      "UNEXPECTED_STATE": "Ocorreu um estado inesperado.",
      "REVIEW_APP_LOGIC": "Reveja a lógica da aplicação.",
      "ASSIGNMENTS": "Tarefas",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "PRACTICE_SESSION": "Sessão de prática",
      "OVERALL_SCORE": "Pontuação global",
      "OVERALL_SCORE_EXPLANATION": "A pontuação global é calculada através de uma média ponderada da pontuação de cada secção. O peso de cada secção é apresentado como uma percentagem junto à pontuação.",
      "SCORE_CONFIG_NOTE": "As percentagens de peso, bem como a inclusão e exclusão de secções, são definidas pela sua empresa. Todas as pontuações são arredondadas ao décimo mais próximo.",
      "STRENGTHS": "Pontos fortes",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "A sua resposta",
      "MINUS": "menos",
      "PLUS": "mais",
      "RECOMMENDED_RESPONSE": "Resposta recomendada",
      "REVIEW_MISSED_TITLE": "Reveja o que falhou.",
      "NO_TALKING_POINTS_COVERED": "Não abrangeu nenhum dos temas de discussão necessários para este tópico.",
      "LEARN_WHAT_YOU_MISSED": "Saiba o que falhou",
      "NICE_JOB": "Bom trabalho!",
      "ALL_POINTS_COVERED": "Conseguiu abordar todos os temas de discussão necessários para este tópico.",
      "COVER_ALL_MESSAGES": "Abordou todas as mensagens-chave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Destacar os pontos-chave durante a chamada ajudará a manter a conversa focada.",
      "MESSAGES_LABEL": "Mensagens",
      "NO_FACTS_COVERED": "Ups! Parece que não abordou nenhum dos factos desta mensagem.",
      "NO_SPECIFICS_AVAILABLE": "Ups! Parece que não foi possível fornecer detalhes sobre o que foi falhou.",
      "ALL_KEY_POINTS_COVERED": "Excelente trabalho! Abordou todos os pontos essenciais.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos a processar o feedback das suas competências.",
      "SKILLS_SCORING_NOT_ENABLED": "Lamentamos, mas não foi possível analisar a sua chamada recente porque a pontuação de competências não estava ativada no momento da submissão. Para obter feedback, basta voltar a submeter a sua prática da chamada como fez anteriormente. Se precisar de ajuda, não hesite em contactar a nossa equipa de assistência. Agradecemos a sua compreensão e empenho em melhorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Melhore as suas capacidades de conversação",
      "SKILLS_NOTE": "As competências são fundamentais para conduzir conversas bem-sucedidas, mas não afetam a sua pontuação global.",
      "SKILLS_SUMMARY_TITLE": "RESUMO DAS COMPETÊNCIAS",
      "LEARN_MORE_ABOUT_SKILLS": "Saiba mais sobre as competências",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "O que são competências",
      "SKILLS_DESCRIPTION": "As competências são ajustadas para favorecer o desenvolvimento pessoal. Embora estas competências não façam parte da avaliação numérica da sua chamada, foram selecionadas pela sua organização para aumentar a sua eficácia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE PROFICIÊNCIA",
      "EXPERT": "Perito",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "CALL_TRANSCRIPT": "Transcrição da chamada",
      "COLLAPSE_ALL": "Fechar tudo",
      "EXPAND_ALL": "Expandir tudo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 pontos",
      "TALKING_POINTS": "temas de discussão",
      "TRANSCRIPT_LABEL": "Transcrição",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Não há mais tentativas.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Reveja as diretrizes e mantenha-se em conformidade no futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Tente novamente, tendo em conta as diretrizes de conformidade.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Verificámos que não houve conformidade, pelo que não foi atribuída pontuação.",
      "WHY_OUT_OF_COMPLIANCE": "Porque é que não estava em conformidade",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Reveja a sua transcrição para ver onde não cumpriu as diretrizes de conformidade.",
      "YOU_DID_FOLLOW_GUIDELINES": "Seguiu efetivamente estas diretrizes.",
      "REVIEW_MISSED_GUIDELINES": "Rever as diretrizes de conformidade em falta.",
      "OUT_OF_COMPLIANCE": "Não conformidade",
      "SCORE_CALCULATION_TITLE": "Cálculo da pontuação",
      "PROCESSING_TRANSCRIPT": "Estamos a processar a sua transcrição.",
      "WAIT_OR_REVIEW_SCORES": "Aguarde aqui ou reveja as outras secções",
      "TRANSCRIPT_LOADING": "de pontuação enquanto a transcrição é carregada.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Analise o seu feedback e continue a praticar.",
      "HIGH_PERFORMERS_PRACTICE": "Os formandos com bom desempenho praticam pelo menos uma vez por semana",
      "SUCCESSFULLY_PASSED": "Excelente trabalho! Passou esta simulação com sucesso.",
      "DIDNT_REACH_PASSING_SCORE": "Não atingiu a pontuação mínima para passar nesta simulação.",
      "OUT_OF_ATTEMPTS": "<b>Não há tentativas disponíveis.</b> Analise o seu feedback para saber como pode melhorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Analise o feedback e volte à página inicial quando quiser.",
      "GREAT_JOB_PRACTICED": "Bom trabalho, praticou {{count}} {{times}}. Continue!",
      "TIME": "tempo",
      "TIMES": "tempos",
      "COMPLIANCE_GUIDELINES": "Diretrizes de conformidade",
      "TALKING_POINT_TITLE": "TEMAS DE DISCUSSÃO NÃO ABORDADOS OU ABORDADOS NO MOMENTO ERRADO",
      "NO_TRANSCRIPT": "Não há transcrição disponível."
    },
    "reportingV2": {
      "DASHBOARD": "Painel de controlo",
      "LOADING_ACCOUNTS": "A carregar contas...",
      "SELECT_AN_ACCOUNT": "Selecionar uma conta",
      "SEARCH_TEAMS": "Pesquisar equipas",
      "LOADING_TEAMS": "A carregar equipas...",
      "ALL_TEAMS": "Todas as equipas",
      "ACCOUNT": "Conta",
      "TEAMS": "Equipas",
      "TEAM_LABEL": "Equipa",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Pontuação de aprovação",
      "ASSIGNMENT_LABEL": "Tarefas",
      "USER_LABEL": "Utilizadores",
      "PRACTICE_LABEL": "Prática",
      "CERTIFICATION_LABEL": "Certificação",
      "RESULTS_DESCRIPTION": "Aqui estão os resultados da(s) sua(s) equipa(s) em todas as tarefas de treino:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Envolvimento por tarefa",
      "ASSIGNMENT_ENGAGEMENT": "Envolvimento com a tarefa",
      "ENGAGED_LABEL": "Com participação",
      "ENGAGEMENT_STATUS_LABEL": "Estado do envolvimento",
      "PROFICIENT_LABEL": "Proficiente",
      "ASSIGNMENT_NAME": "Nome da tarefa",
      "ACTIVE_USERS": "Utilizadores ativos",
      "ASSIGNMENT_PROGRESS": "Progresso por tarefa",
      "IN_PROGRESS_LABEL": "Em curso",
      "CERTIFIED_LABEL": "Certificado",
      "OUT_OF_ATTEMPTS_LABEL": "Sem tentativas",
      "USERS_ENGAGED_LABEL": "Utilizadores com participação",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessões por utilizador ativo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Mais de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sessões concluídas",
      "USER_CERTIFIED": "Utilizadores certificados em todas as tarefas",
      "ASSIGNMENT_CERTIFICATION": "Tarefas com certificação a 100%",
      "TRAINER_TIME_SAVED": "Poupança de tempo do formador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tarefas práticas",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tarefas de certificação",
      "START_DATE_LABEL": "Data de início",
      "END_DATE_LABEL": "Data final",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membro de equipas",
      "ASSIGNMENTS_COUNT_LABEL": "Número de tarefas",
      "TOTAL_SESSIONS_LABEL": "Total de sessões",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sessões",
      "TOTAL_USERS_LABEL": "Total de utilizadores",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "INITIAL_SCORE_LABEL": "Pontuação inicial",
      "HIGH_SCORE_LABEL": "Pontuação elevada",
      "LAST_PRACTICE_DATE_LABEL": "Data do último treino",
      "PERCENT_IMPROVED_LABEL": "% de melhoria",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica analisa as pontuações de cada sessão e traça uma linha reta num gráfico para ilustrar a tendência. Uma percentagem mais elevada indica que as pontuações estão a melhorar mais rapidamente, uma percentagem mais baixa indica que as pontuações estão a melhorar mais lentamente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tarefas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tarefas com bom desempenho",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "O número de tarefas em que o utilizador cumpriu ou excedeu os critérios de pontuação para todas as simulações na tarefa.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "O número de tarefas em que o utilizador cumpriu ou excedeu os critérios de pontuação, pelo menos uma vez, em todas as simulações da tarefa.",
      "PROFICIENT_TOOLTIP": "O número de utilizadores nesta tarefa que atingiram ou superaram, pelo menos uma vez, os critérios definidos para pontuação alta em todas as chamadas desta tarefa.",
      "IN_PROGRESS_TOOLTIP": "A percentagem de utilizadores que completaram pelo menos uma sessão de uma simulação nesta tarefa e receberam uma pontuação.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "A percentagem de utilizadores que excederam as tentativas atribuídas para uma ou mais simulações na tarefa.",
      "CERTIFIED_TOOLTIP": "A percentagem de utilizadores que atingiram ou excederam os critérios de pontuação para todas as simulações na tarefa.",
      "SEARCH_FOR_A_USER_LABEL": "Procurar um utilizador",
      "NO_USERS_FOUND_LABEL": "Nenhum utilizador encontrado",
      "TRAINER_TIME_SAVED_TOOLTIP": "A quantidade de tempo que os utilizadores passaram na Quantified a completar tentativas de certificação.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Média de sessões por tarefa",
      "ASSIGNMENTS_ENGAGED_WITH": "Tarefas com participação com",
      "AVERAGE_IMPROVEMENT": "Melhoria média",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sessões",
      "DATE_OF_LAST_PRACTICE": "Data do último treino",
      "CALL_NAME": "Nome da chamada",
      "SESSION_DATE": "Data da sessão",
      "DURATION_OF_SESSION": "Duração da sessão",
      "OVERALL_SCORE": "Pontuação global",
      "MESSAGING_SCORE": "Pontuação de adesão à mensagem",
      "METHODOLOGY_SCORE": "Pontuação metodológica",
      "SKILLS_SCORE": "Pontuação de competências",
      "SESSIONS": "Sessões",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas as tarefas",
      "RECENT_ASSIGNMENTS": "Tarefas recentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Média de sessões de utilizadores ativos",
      "HOURS_IN_SIMULATIONS": "Horas em simulações",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Média de sessões até à proficiência",
      "PERCENT_PROFICIENT": "Percentagem de proficiência",
      "SYSTEM_RUNNING_NORMALLY": "O sistema está a funcionar normalmente",
      "PRACTICE_SIMULATIONS_LABEL": "Simulações",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nenhum resultado corresponde aos seus filtros. Tente limpar um ou mais filtros para alargar a pesquisa.",
      "USERS_PASSED": "Utilizadores que passaram na simulação",
      "AVERAGE_TIME": "Tempo médio para certificar",
      "USERS_OUT_OF_ATTEMPTS": "Utilizadores sem tentativas",
      "NO_CERTIFICATION_SIMULATION": "Não foram encontradas simulações de certificação",
      "SIMULATION": "Simulação",
      "No_SIMULATION": "Sem sessões",
      "PERCENT_CERTIFIED": "Percentagem de certificação",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentagem de certificação na 1.ª tentativa",
      "USERS": "Utilizadores",
      "ATTEMPTS_LABEL": "Tentativas",
      "NO_ATTEMPTS": "Sem tentativas",
      "DATE_OF_SESSION": "Data da sessão",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nenhuma tarefa corresponde aos filtros selecionados",
      "NO_TEAMS_DATA": "Não existem equipas nesta conta",
      "SIMULATION_NAME": "Nome da simulação",
      "AVERAGE_DURATION_OF_SESSION": "Duração média da sessão",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Número médio de sessões por utilizador ativo",
      "AVERAGE_OVERALL_SCORE": "Pontuação média global",
      "AVERAGE_CERTIFICATION_SCORE": "Pontuação média de certificação",
      "CERTIFICATION_STATUS_LABEL": "Estado da certificação",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado da certificação:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificado na primeira tentativa?",
      "CERTIFIED_ON_FIRST_TRY": "Certificado na primeira tentativa",
      "DATE_OF_CERTIFICATION": "Data da certificação",
      "DATE_OF_CERTIFICATION_LABEL": "Data da certificação",
      "DATE_RANGE": "Intervalo de datas",
      "DATE_RANGE_LABEL": "Intervalo de datas",
      "DURATION_OF_ATTEMPT": "Duração da tentativa",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado do envolvimento:",
      "LEARNER": "Formando",
      "OF_THE_TIME": "do tempo",
      "SEARCH_DATES": "Procurar datas...",
      "SEARCH_SIMULATIONS": "Procurar simulações...",
      "SEARCH_USERS": "Procurar utilizadores...",
      "TOTAL_TIME_CERTIFYING": "Tempo total de certificação",
      "USER_NAME": "Nome do utilizador",
      "ASSIGNMENTS_CERTIFIED": "Tarefas certificadas",
      "HOURS_SPENT_PRACTICING": "Horas passadas a praticar",
      "LAST_LOGIN": "Último login",
      "SELECT_ASSIGNMENTS": "Selecionar tarefas",
      "TOTAL_ASSIGNMENTS": "Total de atribuições",
      "TOTAL_SESSIONS": "Total de sessões",
      "ASSIGNED_LABEL": "Não iniciada",
      "USERS_ASSIGNED_LABEL": "Total de utilizadores atribuídos",
      "SESSION_ID": "ID da sessão",
      "NO_SIMULATIONS_FOUND_LABEL": "Nenhuma simulação encontrada",
      "USER_NAME_LABEL": "Nome do utilizador",
      "MIN": "min.",
      "SEC": "seg.",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Atribuído",
      "ENGAGED_TOOLTIP": "A porcentagem de utilizadores que concluíram uma ou mais sessões de simulação nesta tarefa, mas ainda não atingiram proficiência em todas as simulações.",
      "SEARCH_ASSIGNMENTS": "Pesquisar tarefas...",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "START_DATE": "Data de início",
      "END_DATE": "Data final",
      "NO_ASSIGNMENTS": "Nenhuma tarefa encontrada para este utilizador.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tarefas práticas",
      "SESSION_SCORES_OVER_TIME": "Pontuações de sessão ao longo do tempo",
      "TIME": "tempo",
      "SCORE": "média",
      "NO_SESSIONS_AVAILABLE": "Nenhuma sessão disponível para representar graficamente.",
      "MESSAGING_SCORE_LABEL": "Pontuação de mensagens",
      "PERSONALIZED_PRACTICE_LABEL": "Prática personalizada",
      "ASSIGNMENT_ENAGEMENT": "Envolvimento por tarefa",
      "NO_PRODUCTS": "Nenhum produto de prática personalizado para as equipas selecionadas",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo total passado a praticar",
      "AVERAGE_SESSIONS_PER_USER": "Sessões médias por utilizador",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Seleção do tipo de conversa mais comum",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Seleção do tipo de conversa menos comum",
      "CLEAR_TEAMS": "Limpar equipas",
      "METHODOLOGY_SCORE_DESCRIPTION": "Pontuação média dos objetivos em todas as sessões desta chamada.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Mensagens",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "As mensagens medem se os formandos articulam 2 ideias importantes nesta simulação. Estas visualizações mostram a percentagem de mensagens num determinado tema de mensagens que os utilizadores articularam, em média, em todas as sessões desta chamada.",
      "NO_METRICS_MESSAGE": "Nenhuma sessão concluída para as equipas selecionadas.",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "SKILLS": "Competências",
      "SKILLS_SCORE_STATS_DESCRIPTION": "As pontuações de competências são uma avaliação de IA das competências demonstradas pelos utilizadores numa chamada.",
      "EXPERT": "Perito",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "FULLY_ARTICULATED": "Totalmente articulada",
      "PARTIALLY_ARTICULATED": "Parcialmente articulada",
      "NOT_MENTIONED": "Não mencionada",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "As mensagens medem se os utilizadores articulam 3 ideias importantes nesta chamada."
    },
    "reporting": {
      "AT_GLANCE": "Resumo das tarefas",
      "OPEN_ASSIGNMENTS": "Tarefas em aberto",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificado",
      "VIEW_LIST": "Ver lista",
      "CERTIFICATION_ASSIGNMENTS": "Tarefas de certificação",
      "CERTIFICATION_SUMMARY_TEXT": "As certificações são tarefas que têm uma data limite e critérios específicos para serem aprovadas",
      "PRACTICE_ASSIGNMENTS": "Tarefas práticas",
      "PRACTICE_SUMMARY_TEXT": "As tarefas práticas estão disponíveis para os utilizadores sem uma data limite específica. São concebidas para permitir aos utilizadores praticar regularmente para melhorar as suas competências",
      "THE": "A",
      "WILL_CLOSE": "encerrará em",
      "USERS_HAVE": "os utilizadores não",
      "USER_HAS": "o utilizador não",
      "NOT_STARTED_ASSIGNMENT_DUE": "iniciou/iniciaram uma tarefa que deverá ser entregue na semana seguinte",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "completou/completaram uma tarefa que deverá ser entregue na semana seguinte",
      "DAYS": "dias",
      "DAY": "dia",
      "MODULES": "Módulos",
      "MODULE": "Módulo",
      "CALL": "Simulação",
      "CALLS": "Simulações",
      "CERTIFICATION_ASSIGNMENT": "Tarefa de certificação",
      "PRACTICE_ASSIGNMENT": "Tarefa de prática",
      "AND": "e",
      "VIEW_ENGAGEMENT_DETAILS": "Ver detalhes do envolvimento",
      "SEE_ALL": "Ver tudo",
      "SEE_LESS": "Ver menos",
      "ASSIGNMENT": "Atribuição",
      "ASSIGNED": "Atribuído",
      "IN_PROGRESS": "Em curso",
      "DUE_DATE": "Data limite",
      "ASSIGNMENT_ENDS_IN": "A tarefa termina em",
      "ASSIGNMENT_CLOSED": "Tarefa terminada",
      "OLDER_CERTIFICATION": "certificação mais antiga",
      "ASSIGNMENT_IS": "a tarefa está",
      "ASSIGNMENT_ARE": "as tarefas estão",
      "CURRENTLY_HIDDEN": "atualmente oculta",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Todas as tarefas de certificação estão a ser exibidas.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Utilizadores que ainda não concluíram e receberam uma pontuação para quaisquer simulações.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Utilizadores que concluíram pelo menos uma simulação e receberam uma pontuação.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Utilizadores que cumpriram o requisito de certificação.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Este é o número de utilizadores que podem aceder à tarefa para efeitos de certificação.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Ver todas as tarefas de certificação",
      "HIDE_OLDER_ASSIGNMENTS": "Ocultar tarefas mais antigas",
      "AVG_PRACTICES": "Práticas médias",
      "PRACTICED": "Praticado",
      "SCORED_HIGH": "Pontuação elevada",
      "AVG_ASSIGNMENT": "Melhoria média",
      "DAYS_AGO": "dias atrás",
      "NA": "N/A",
      "OLDER_PRACTICE": "prática mais antiga",
      "SEE_PRACTICE_ASSIGNMENT": "Ver todas as tarefas práticas",
      "ALL_PRACTICE_ASSIGNMENTS": "Todas os tarefas práticas estão a ser apresentadas.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Utilizadores que ainda não concluíram e receberam uma pontuação para quaisquer simulações.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Estes utilizadores terminaram pelo menos uma simulação e receberam uma pontuação.",
      "PRACTICE_CERTIFIED_TOOLTIP": "O número de utilizadores nesta tarefa que atingiram ou superaram, pelo menos uma vez, os critérios definidos para pontuação alta em todas as simulações desta tarefa.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Estes utilizadores podem aceder à tarefa para praticar.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Este número mostra o número médio de vezes que os utilizadores praticaram simulações que fazem parte desta tarefa.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Esta métrica analisa as pontuações de cada sessão e traça uma linha reta num gráfico para ilustrar a tendência. Uma percentagem mais elevada indica que as pontuações estão a melhorar mais rapidamente, uma percentagem mais baixa indica que as pontuações estão a melhorar mais lentamente.",
      "USERS": "utilizadores",
      "USER": "utilizador",
      "DOWNLOAD_CSV": "Transferir CSV",
      "ERROR": "Ocorreu um erro",
      "FIRST_NAME": "Nome próprio",
      "LAST_NAME": "Apelido",
      "ATTEMPTS": "Tentativas",
      "EMAIL": "E-mail",
      "LAST_LOGIN": "Último início de sessão",
      "ASSIGNMENT_NOT_STARTED": "Tarefa não iniciada",
      "ASSIGNMENT_IN_PROGRESS": "Tarefa em curso",
      "SCORE_CRITERIA_MET": "Critérios de pontuação satisfeitos",
      "NEVER_LOGGED_IN": "Sessão não iniciada",
      "QUANTIFIED_REPORTING": "Relatórios da Quantified",
      "ASSIGNED_USERS": "Utilizadores atribuídos",
      "COMPLETION_REQUIREMENT": "Requisito de conclusão",
      "AVG_SCORE_Of": "Média média de",
      "REPORTING": "Relatórios",
      "CERTIFICATIONS": "Certificações",
      "PRACTICES": "de práticas",
      "CALL_ANALYSIS": "Análise de simulação",
      "PERCENT_CERTIFIED_ON": "Percentagem de certificação em",
      "SHOWING": "A mostrar",
      "PRACTICE_SESSIONS": "Total acumulado de sessões de prática em todas as simulações do módulo",
      "AVG_PRACTICE_HEADING": "Número médio de sessões práticas por utilizador ativo",
      "AVG_SCORE_LABEL": "Média média",
      "AVG_SCORE_HEADING": "Pontuação média por utilizador",
      "AVG_PRACTICES_LABEL": "Média de práticas",
      "EXPORT_LEARNER_LIST": "Exportar lista de formandos",
      "PERCENT_NOT_STARTED": "% não iniciada",
      "PERCENT_IN_PROGRESS": "% em curso",
      "PERCENT_CERTIFIED": "% certificada",
      "USER_CERTIFIED": "Utilizador certificado",
      "USERS_CERTIFIED": "Utilizadores certificados",
      "TOTAL_ATTEMPTS": "Total de tentativas",
      "Avg_ATTEMPTS_CERTIFY": "Média de tentativas de certificação",
      "ASTERICK_GROUP": "Designa um grupo que contém um ou mais subgrupos",
      "NO_DATA_FOUND": "Não foram encontrados dados",
      "MODULE_HIGHLIGHTS": "Destaques do módulo",
      "MODULE_HIGHLIGHT_SUMMARY": "Principais métricas em todas as simulações. Para uma análise pormenorizada de cada simulação, ver a síntese abaixo",
      "HIGHEST_SCORING_QUESTION_TITLE": "PERGUNTA COM A PONTUAÇÃO MAIS ELEVADA",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Pergunta com a pontuação mais elevada",
      "QUESTION_BAR_MSG": "Percentagem média de pontos de resposta respondidos corretamente",
      "LOWEST_SCORING_QUESTION_TITLE": "PERGUNTA COM A PONTUAÇÃO MAIS BAIXA",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Pergunta com a pontuação mais baixa",
      "TOP_SCORED_ANSWER_POINT_TITLE": "PONTO DE RESPOSTA MAIS BEM CLASSIFICADO",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Pergunta com menor falha no ponto de resposta",
      "SCORE_BAR_MSG": "das vezes, os utilizadores acertam.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "PONTO DE RESPOSTA PIOR CLASSIFICADO",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Pergunta mais errada no ponto de resposta",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA DE PONTUAÇÃO MAIS BAIXA",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia da pontuação mais baixa",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA DE PONTUAÇÃO MAIS ELEVADA",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia de pontuação mais elevada",
      "OBJECTIVE_BAR_MSG": "pontuação média nesta metodologia",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MENSAGEM MENOS ARTICULADA",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensagem menos articulada",
      "LEAST_ARTICULATED_BAR_MSG": "Articular esta mensagem",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MENSAGEM MAIS ARTICULADA",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensagem mais articulada",
      "MOST_ARTICULATED_BAR_MSG": "Articular completamente esta mensagem",
      "Overview": "Síntese",
      "CONSISTS_Of": "consiste em",
      "CALL_OVERVIEW_LABEL": "O gráfico mostra o número de utilizadores que",
      "PASSED": "Passaram",
      "ATTEMPTED": "Tentaram",
      "NOT_ATTEMPTED": "Não tentaram",
      "GUIDED_CALL": "Verificação de conhecimentos",
      "QUESTIONS": "Perguntas",
      "QUESTION": "Questão",
      "CONVERSATIONAL_CALL": "Dramatização",
      "AVG_ATTEMPTS": "Média Tentativas",
      "USERS_PASSED": "utilizadores aprovados",
      "DETAILED_ANALYSIS": "Análise pormenorizada",
      "CALL_DETAILS": "Detalhes da simulação",
      "CALL_TYPE": "Tipo de simulação",
      "TOTAL_SESSIONS": "Total de sessões",
      "WHAT_WE_MEASURED": "O que medimos",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Pontuação média global",
      "OVERALL_SCORE_DETAIL": "O nosso sistema fornece uma \"pontuação global\" para cada conversa. Este número é a pontuação global média em",
      "CALL_RUN": "os utilizadores concluíram esta simulação",
      "TIME": "tempo",
      "TIMES": "tempos",
      "OBJECTIVES": "Metodologia",
      "AVG_OBJECTIVE": "Pontuação média das metodologias em todas as",
      "OF_THIS_CALL": "desta simulação",
      "MESSAGE_ADHERENCE": "Aderência à mensagem",
      "MESSAGE_ADHERENCE_DETAILS_1": "A aderência à mensagem avalia se os formandos articulam",
      "MESSAGE_ADHERENCE_DETAILS_2": "ideias importantes durante esta simulação. Estas visualizações mostram a percentagem de mensagens num determinado tema de mensagens que os utilizadores articularam, em média, em todas as",
      "IMPORTANT_IDEAS": "ideias importantes durante esta simulação",
      "PERCENT_MESSAGE_ARTICULATED": "Estas visualizações mostram a percentagem de tempo em que cada mensagem é articulada em",
      "FULLY_ARTICULATED": "Totalmente articulada",
      "PARTIALLY_ARTICULATED": "Parcialmente articulada",
      "NOT_MENTIONED": "Não mencionada",
      "SKILLS_LABEL": "Competências",
      "SKILLS_DETAILS": "As pontuações de competências são uma avaliação de IA das competências demonstradas pelos utilizadores durante uma simulação. Estas visualizações mostram a percentagem de vezes que os utilizadores obtiveram pontuações de \"Perito\" (a mais alta), \"Proficiente\" e \"Em desenvolvimento\" (a mais baixa) em todas as",
      "DEVELOPING": "Em desenvolvimento",
      "PROFICIENT": "Proficiente",
      "Expert": "Perito",
      "NO_RESULT": "Ainda sem resultados",
      "NO_RESULT_TEXT": "Nenhum dos utilizadores da sua organização tentou ainda efetuar esta simulação. Assim que o fizerem, poderá ver os seus resultados aqui!",
      "CONVERSATIONAL_CALL_TOOLTIP": "Nas dramatizações, o utilizador pode orientar o fluxo da conversa e a IA responderá em conformidade. As dramatizações são menos estruturadas do que \"verificações de conhecimento\", que têm um formato estrito de pergunta-resposta",
      "TOTAL_SESSION_TOOLTIP": "O número total de vezes que esta simulação foi concluída por todos os utilizadores a quem foi atribuída",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "AVERAGE_SCORE_DETAIL": "A pontuação média de todos os utilizadores nesta simulação",
      "ANSWER_POINTS": "Pontos de resposta",
      "DETAILS": "Detalhes",
      "CONVERSATIONAL_CALL_MSG": "Os relatórios de conteúdo para dramatizações estarão disponíveis em breve",
      "ALL_CALL_DETAILS": "Todos os detalhes da simulação",
      "QUESTION_TEXT_LABEL": "Texto da pergunta",
      "AVG_POINTS_LABEL": "Pontuação média",
      "SHOW_ALL": "Mostrar tudo",
      "CORRECT_ANSWER": "respostas corretas de entre",
      "OBJECTIVE_MEASURED_ON": "Esta metodologia é medida em",
      "CALLS_IN_MODULE": "simulações neste módulo",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "QUESTION_UPDATED": "Esta pergunta foi atualizada",
      "QUESTION_UPDATED_MESSAGE": "Não é possível mostrar informações detalhadas sobre o ponto de resposta porque foram feitas atualizações a esta pergunta. As \"pontuações médias\" apresentadas representam a média de todas as sessões desta pergunta (incluindo antes e depois das atualizações)",
      "CLOSE_ALT": "Fechar",
      "Q_LABEL": "Q",
      "SCORING_LABEL": "Pontuação",
      "AVERAGE_ANSWER": "Média de pontos de resposta obtidos por pergunta",
      "MINIMIZE_LABEL": "Minimizar",
      "VIEW_ALL_LABEL": "Ver tudo",
      "DOWN_ARROW": "Seta para baixo",
      "NOTIFICATION": "Notificação",
      "PROGRESS_ICON": "Ícone de progresso",
      "VIEW_MODAL": "Ver modal",
      "VIEW_INFO": "Ver informação",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Expandir grupo",
      "MESSAGE_ADHERENCE_V2": "Aderência à mensagem",
      "SCORE_OVERALL": "Pontuação global",
      "SCORE_SKILLS": "Competências",
      "SCORE_CUSTOMIZED": "Metodologia",
      "SESSIONS": "sessões",
      "SESSION": "sessão"
    },
    "personalizedPractice": {
      "TITLE": "Prática personalizada",
      "DESCRIPTION": "Olá, {{userFirstName}}! As práticas personalizadas permitem-lhe definir os seus próprios cenários para que sejam o mais realistas possível.",
      "LOADING": "A carregar...",
      "VIEW_SESSIONS": "Ver sessões",
      "VIEW_SIMULATION": "Ver simulação",
      "TOTAL_SESSION": "sessão total",
      "TOTAL_SESSIONS": "Total de sessões",
      "BREADCRUMB": "Prática personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalhes do cenário",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecione variáveis a partir das opções abaixo para ajustar a simulação de acordo com as suas necessidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Selecionar",
      "CONVERSATION_TYPE": "Tipo de conversa",
      "SELECT_CONVERSATION_TYPE": "Selecionar tipo de conversa",
      "LAUNCH_SIMULATION": "Lançar simulação com seleções",
      "PREVIOUS_SESSIONS": "Sessões anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Data",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data da sessão",
      "SESSION_SCORE": "Pontuação da sessão",
      "DURATION": "Duração",
      "OVERALL_SCORE": "Pontuação global",
      "MESSAGING": "Mensagens",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Competências",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver feedback",
      "OVERALL_SCORE_LABEL": "Pontuação global",
      "SCORE": "média",
      "NO_PRODUCTS_TITLE": "Não existem produtos disponíveis",
      "NO_PRODUCTS_DESCRIPTION": "Ainda não tem nenhum produto de prática personalizado.",
      "NO_SESSIONS_FOUND": "Não foram encontradas sessões com os filtros selecionados",
      "TIME": "tempo",
      "ALL": "Todas",
      "LEARNER": "Formando",
      "MOOD": "Humor",
      "CLEAR_FILTERS": "Limpar filtros"
    },
    "login": {
      "TITLE": "Damos-lhe as boas-vindas novamente",
      "SUB_TITLE": "Como gostaria de iniciar sessão?  ",
      "LOGIN_WITH_SSO": "Iniciar sessão com o SSO da empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sessão com palavra-passe",
      "PROVIDE_EMAIL": "Forneça o seu endereço de e-mail",
      "HELP_TEXT": "Precisa de ajuda? Contacto",
      "EMAIL_ERROR": "Não foi possível iniciar sessão. Contacte o administrador da sua empresa ou o departamento de TI.",
      "EMAIL": "E-mail",
      "LOGIN": "Iniciar sessão",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Ao iniciar sessão na sua conta, o utilizador concorda com os {{termsLink}} e a {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Termos do serviço",
      "PRIVACY_POLICY": "Política de privacidade"
    },
    "learningPathway": {
      "BEGIN": "Começar",
      "DUE_DATE": "Data limite",
      "FOOTER_SUBTITLE_READY": "Pergunte-me o que quiser! Estou a postos para ajudar.",
      "LEAVE_STEP": "Deixar passo",
      "NEXT_STEP": "Próximo passo",
      "NOTIFICATIONS_ARIA": "Notificações",
      "PDF_NEXT_PAGE": "Próxima página",
      "PDF_NO_SOURCE": "Nenhuma fonte em PDF fornecida.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deixe-nos feedback enquanto processamos os seus resultados",
      "POST_CALL_TITLE": "Chegou ao fim deste questionário.",
      "SETTINGS": "Definições",
      "TOAST_CONTENT": "Clique abaixo para visualizar ou volte ao ecrã de detalhes do percurso para o próximo passo.",
      "TOAST_TITLE": "Os resultados da sua simulação foram processados",
      "ASSIGNMENTS": "Tarefas",
      "USER_FALLBACK": "Utilizador",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Quiz"
    },
    "leaderboard": {
      "LEADERBOARD": "Tabela de classificação",
      "TOP10PERCENT": "Top 10%",
      "PRACTICE_ASSIGNMENT": "Tarefas práticas",
      "SIMULATION": "Simulação",
      "SELECT_ASSIGNMENT": "Selecionar tarefa",
      "SELECT_SIMULATION": "Selecionar simulação",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecione uma tarefa e uma simulação para ver os líderes",
      "NO_DATA": "Ainda não há atividade. Quando a equipa começar a envolver-se, verá as classificações aparecerem aqui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Não há tarefas disponíveis",
      "NO_SIMULATIONS_AVAILABLE": "Não há simulações disponíveis",
      "NAME": "Nome",
      "HIGH_SCORE": "Pontuação elevada",
      "AVERAGE_SCORE": "Pontuação média",
      "TOTAL_SESSIONS": "Total de sessões",
      "LAST_SESSION": "Última sessão",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "utilizadores com participação",
      "ENGAGED_USER": "utilizador com participação",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar sessões com pontuações de competências baixas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "As sessões com uma pontuação de \"em desenvolvimento\" na secção de competências não contribuem para as colunas de pontuação alta ou média.",
      "NO_USERS_ENGAGED": "Nenhum utilizador envolvido"
    },
    "general": {
      "NEED_HELP_QUESTION": "Precisa de ajuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Conta principal",
      "ACCOUNT": "Conta",
      "CHECKMARK": "Marca de verificação",
      "ICON": "Ícone",
      "ALERT": "alerta",
      "HEADS_UP": "Atenção!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para otimizar o áudio no iPad, utilize auscultadores.",
      "SETTINGS": "DEFINIÇÕES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gestor de equipa para",
      "MIAMI_SALE": "Vendas de Miami",
      "CHARLOTTE_SALES": "Vendas de Charlotte",
      "ATLANTA_SALES": "Vendas de Atlanta",
      "TEAM": "Equipa",
      "ASSIGNMENTS": "Tarefas",
      "MY_TEAMS": "As minhas equipas",
      "REPORTING": "Relatórios",
      "DASHBOARD": "Painel de controlo",
      "LEADERBOARD": "Tabela de classificação",
      "PERSONALIZED_PRACTICE": "Prática personalizada",
      "HELP_SEARCH_OUR": "Pesquise na nossa",
      "HELP_OR_REACH_OUT_TO": "ou entre em contato com",
      "HELP_WITH_QUESTIONS": "com perguntas",
      "KNOWLEDGE_BASE": "base de conhecimento"
    },
    "dashboard": {
      "ALL": "Todas",
      "IN_COMPLETE": "Incompletas",
      "COMPLETED": "Concluído",
      "NO_ASSIGNMENT_TITLE": "Não tem quaisquer tarefas.",
      "NO_ASSIGNMENT_DETAILS": "Receberá uma notificação quando tiver tarefas para completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Não tem tarefas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Receberá uma notificação quando houver uma nova tarefa com prazo.",
      "COMPLETED_ASSIGNMENT_TITLE": "Não tem tarefas concluídas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Volte a consultar quando tiver concluído uma tarefa.",
      "VIEW_ASSIGNMENT": "Ver tarefa",
      "ASSIGNMENT_LABEL": "Tarefas",
      "MODULE_ASSIGNMENT_ALT": "Ícone da tarefa do módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarefa para",
      "DAY": "Dia",
      "UNTILL_DUE": "Até ao vencimento",
      "PAST_DUE": "Vencido",
      "AVAILABLE_IN": "Disponível em",
      "DUE_TODAY": "Vencimento hoje",
      "PRACTICE": "Prática",
      "CERTIFICATION": "Certificação",
      "UPCOMING": "Em breve",
      "TEST_ASSIGNMENT": "Atribuição de teste",
      "CLOSED": "Encerrada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Não foram encontrados tarefas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Tente ajustar os filtros para ver as tarefas disponíveis ou volte mais tarde quando novas tarefas forem adicionadas.",
      "VIEW_PATHWAY": "Ver percurso",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de trabalho",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de trabalho:",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificado",
      "NOT_CERTIFIED": "Não Certificado",
      "IN_PROGRESS": "Em curso",
      "PATHWAY": "Percurso de aprendizagem",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Damos-lhe as boas-vindas ao Quantified!",
      "INVITATION_MESSAGE": "Estamos muito felizes por contar consigo! Para começar, siga os passos abaixo para iniciar sessão na sua conta pela primeira vez.",
      "ACCOUNT_DETAILS": "Os dados da sua conta:",
      "USERNAME": "Nome de utilizador",
      "PASSWORD": "Palavra-passe temporária",
      "STEPS_LABEL": "Próximos passos para iniciar sessão",
      "STEP_1": "1. Clique no botão \"Iniciar sessão\" abaixo para aceder à página de início de sessão.",
      "STEP_2": "2. Introduza o seu nome de utilizador e a palavra-passe temporária fornecidos acima.",
      "STEP_3": "3. Uma vez iniciada a sessão, ser-lhe-á pedido que defina uma nova palavra-passe.",
      "LOGIN_BUTTON": "Iniciar sessão",
      "ABOUT_US": "O Simulador da Quantified é um ambiente virtual concebido para o ajudar a desenvolver rapidamente competências essenciais, permitindo-lhe estabelecer ligações e comunicar mais eficazmente com os clientes.",
      "EXPIRY_TIME": "Esta palavra-passe temporária expira dentro de 24 horas. Se tiver algum problema ao iniciar sessão, contacte a nossa equipa de assistência através de",
      "TEAM": "A equipa Quantified",
      "INVITATION_SMS_USERNAME": "O seu nome de utilizador é",
      "INVITATION_SMS_PASSWORD": "e a palavra-passe temporária é",
      "AUTHENTICATION_CODE": "O seu código de autenticação é",
      "PASSWORD_RESET_CODE": "O seu código de reposição da palavra-passe da Quantified",
      "RESET_PASSWORD_EMAIL": "Redefinir a palavra-passe do e-mail",
      "HELLO": "Olá,",
      "USE_VERIFICATION_CODE": "Solicitou uma reposição da palavra-passe. Utilize o código de verificação abaixo para concluir o processo.",
      "VERIFICATION_CODE": "Código de verificação",
      "NEXT_STEP": "Próximas etapas",
      "RESET_PASSWORD_PAGE": "Regressar à página de reposição da palavra-passe no seu browser.",
      "ENTER_VERIFICATION_CODE": "Introduza o código de verificação quando lhe for pedido.",
      "CREATE_PASSWORD": "Quando o código for verificado, siga as instruções para criar uma nova palavra-passe.",
      "DISREGARD_NOTE": "Se não solicitou uma redefinição da palavra-passe, ignore esta mensagem de e-mail.",
      "CONTACT_SUPPORT": "Para obter mais assistência, contacte a nossa equipa de assistência através de",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Agradecimentos,",
      "QUANTIFIED_TEAM": "A equipa Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos"
    },
    "call": {
      "LOADING": "A carregar",
      "SIMULATION_PAUSED": "A simulação foi colocada em pausa.",
      "CLICK_RESUME": "Clique no botão \"Retomar\" abaixo para continuar.",
      "NO_INTERNET": "Sem ligação à Internet",
      "TRY_AGAIN": "Verifique a sua ligação e tente novamente.",
      "MIC_MUTED": "O microfone está sem som",
      "MIC_MUTED_DESCRIPTION": "Ups, parece que o seu microfone está sem som. Desative o som para responder e continuar.",
      "NO_RESPONSE": "Nenhuma resposta detetada",
      "MIC_NOT_CONNECTED": "Ups, parece que o seu microfone não está ligado. Volte a selecionar o seu dispositivo para responder e continuar.",
      "AUDIO_ISSUE": "Ups, algo correu mal. Verifique as definições do seu dispositivo e certifique-se de que se encontra num local calmo e sem ruídos de fundo.",
      "LOADING_ALT": "A carregar...",
      "REPEAT_RESPONSE": "Será automaticamente reencaminhado para a sua simulação para repetir a sua resposta e tentar novamente.",
      "NEEDS_MORE_TIME_QUESTION": "precisa de mais tempo para pensar, quer esperar?",
      "NEEDS_MORE_TIME": "precisa de mais tempo para pensar.",
      "WAIT_OR_END_CALL": "Informá-lo-emos quando estiverem prontos ou pode terminar a chamada e",
      "RETURN_TO_ASSIGNMENTS": "Regressar à tarefa",
      "READY": "Pronto",
      "IS_READY": "está pronto para continuar a vossa conversa.",
      "TRY_AGAIN_LABEL": "Tentar de novo",
      "CHECK_SETTINGS": "Verificar definições",
      "PAUSED_SIMULATION": "A simulação foi interrompida.",
      "PAUSED_SIMULATION_DESCRIPTION": "A gravação de vídeo e áudio é interrompida até que a simulação seja retomada.",
      "RESUME": "Retomar",
      "SETTINGS": "Definições",
      "CAPTURING_RESPONSE": "A capturar as suas respostas",
      "TOUR_MESSAGE": "Quando terminar de falar, não se esqueça de clicar no botão Continuar para garantir que as suas respostas são registadas e classificadas.",
      "NEXT": "Seguinte",
      "START_CALL": "Início",
      "END_CALL_TITLE": "Tem a certeza de que quer terminar esta simulação?",
      "END_CALL_DESCRIPTION": "Se terminar a simulação agora, não receberá uma pontuação ou feedback sobre a sua conversa.",
      "END_CALL": "Fim",
      "BROWSER_ACCESS_DENIED": "O seu browser não tem acesso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID da sessão",
      "TIPS_GUIDANCE_MESSAGE": "Os temas de discussão e as dicas aparecerão aqui.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Dicas e sugestões",
      "HINT_LABEL": "Dica",
      "CAPTIONS_LABEL": "Legendas",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de festa",
      "CALL_ENDED_MESSAGE": "Chegou ao fim desta simulação.",
      "CALL_ENDED_INACTIVITY": "Esta simulação terminou devido a inatividade",
      "CALL_ENDED_GENERIC": "Esta simulação terminou",
      "FEEDBACK_PROMPT": "Deixe-nos feedback enquanto processamos os seus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "Não atingiu o limiar mínimo de interações para receber uma pontuação, tente novamente.",
      "REALISTIC_CONVERSATION_QUESTION": "Esta conversa foi realista e natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Esta simulação ajudou a aumentar a sua preparação e conhecimento?",
      "FEEDBACK_THANK_YOU": "Agradecemos o seu feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o seu feedback! Estamos a empenhar-nos para aprimorar a experiência.",
      "AUDIO": "Áudio",
      "VISUAL_AID_LOAD_ERROR": "Não foi possível carregar o auxílio visual",
      "BEGIN_CALL": "Início",
      "LEAVE_CALL_BRIEFING": "Terminar o resumo",
      "RESTORE_CALL": "Restaurar a sua simulação",
      "FEW_SECONDS": "Isto pode demorar alguns segundos.",
      "CHECK_ALT": "Verificar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Dicas",
      "CLOSE_CAPTIONS": "Fechar legendas",
      "MICROPHONE_MUTED": "Microfone sem som",
      "RETURN_TO_CALL": "Regressar à simulação",
      "YES": "Sim",
      "NO": "Não",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Regressar à tarefa",
      "HAVING_ISSUES": "Estamos com problemas de ligação, verifique a sua ligação à Internet e clique em OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Lamentamos, mas não é possível gerar resultados neste momento. Tente novamente.",
      "INACTIVITY_ALERT_MESSAGE": "Esta chamada está a ser terminada devido a inatividade. Fale com o avatar para continuar ou selecione \"Terminar chamada\" para terminar a chamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta chamada terminará em {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta chamada terminará dentro de alguns segundos",
      "TELL_YOUR_GENDER_HEADING": "Indique-nos o seu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Ao conhecer o seu género, o avatar consegue utilizar a gramática correta, tornando a conversa mais natural e realista.",
      "GENDER_SELECTION": "Seleção do género:",
      "SELECT_OPTION": "Selecionar uma opção",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Feminino",
      "NON_BINARY": "Não binário/Outro",
      "PREFER_NOT_TO_ANSWER": "Prefiro não responder",
      "NON_BINARY_MESSAGE": "Compreendemos e respeitamos a sua identidade de género não binária. Devido às atuais limitações tecnológicas, utilizamos por defeito os pronomes masculinos. Saiba que estamos a trabalhar em melhorias para melhor acomodar todas as identidades de género no futuro. Agradecemos a sua compreensão e paciência.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respeitamos a sua opção de não indicar um género. Nesses casos, a nossa tecnologia utiliza por defeito os pronomes masculinos devido às limitações atuais.",
      "DISPLAY_VISUAL_AID": "Exibir auxílio visual",
      "FULL_SCREEN": "Ecrã inteiro",
      "COLLAPSE": "Fechar",
      "COMPLETED_CONVERSATION_MESSAGE": "Obrigado por completar esta conversa",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deixe-nos feedback enquanto processamos a sua conversa.",
      "ERROR_MESSAGE": "Ocorreu um erro. Entre em contato com",
      "SAVED_CONVERSATION_MESSAGE": "A sua conversa foi guardada.",
      "RETURN_TO_MY_ASSIGNMENTS": "Voltar às minhas tarefas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Voltar à prática personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabou de completar uma conversa de prática personalizada.",
      "LEAVE_STEP_TITLE": "Tem a certeza de que deseja sair desta etapa?",
      "EXIT": "Sair"
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PONTUAÇÃO",
      "MUST_ACHIEVE": "Deve atingir um",
      "OR_HIGHER": "ou superior",
      "TEST": "Teste",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "TENTATIVA MAIS RECENTE",
      "TOTAL_ATTEMPTS": "total de tentativas",
      "UNLIMITED": "Ilimitadas",
      "REMAINING": "Restantes",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "MAX_ATTEMPTS_REACHED": "Atingiu o número máximo de tentativas",
      "DUE_DATE": "Data limite",
      "DAYS": "Dias",
      "DAY": "Dia",
      "UNTILL_DUE": "Até ao vencimento",
      "PAST_DUE": "Vencido",
      "ONGOING": "Em curso",
      "SCORE_REQUIREMENT": "Exigência de pontuação",
      "SCORE_REQUIREMENT_DETAIL": "O formando deve obter uma pontuação de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulação necessária.",
      "CALLS_IN_ASSIGNMENT": "Simulações na tarefa",
      "INCOMPLETE_CALL": "Incompletas",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Data",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver feedback",
      "LAUNCH_CALL": "Arranque",
      "CLOSE_BUTTON": "Botão de fechar",
      "CHECKMARK": "marca de verificação",
      "CALL": "Chamada",
      "QUESTION": "Questão",
      "COMPLETED": "Concluído",
      "IN_PROGRESS": "Em curso",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificado",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversação",
      "GUIDED_SIMULATION": "Verificação de conhecimentos",
      "CONVERSATIONAL_SIMULATION": "Dramatização",
      "NO_ATTEMPTS_LEFT": "Não restam tentativas",
      "NO_ATTEMPTS": "Sem tentativas",
      "OVERVIEW": "Síntese",
      "ABOUT_THE_AVATAR": "Sobre o avatar",
      "SCORING_CRITERIA": "Critérios de pontuação",
      "SIMULATION_OVERVIEW": "Visão geral da simulação",
      "ABOUT_THE_PERSONA": "Sobre a Persona",
      "OUTOF_COMPLIANCE": "Não conformidade",
      "CLOSED": "Encerrada"
    }
  },
  "pt-BR": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DO ADMINISTRADOR",
      "SUPPORT": "SUPORTE",
      "U": "U",
      "USER": "Usuário",
      "LOGOUT": "Sair",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Suporte",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONE",
      "CAMERA": "CÂMERA",
      "ACCESS_DENIED": "ACESSO_NEGADO"
    },
    "teams": {
      "MY_TEAMS": "Minhas equipes",
      "COMPLETED": "Concluída",
      "IN_PROGRESS": "Em andamento",
      "NOT_STARTED": "Não iniciada",
      "ASSIGNMET_MODULE": "Módulo de tarefas",
      "START_DATE": "Data de início",
      "DUE_DATE": "Data de vencimento",
      "ASSIGNED_MEMBERS": "Membros designados",
      "CALLS_IN_MODULE": "Simulações no módulo",
      "COMPLETION_REQUIRMENT": "Requisito de conclusão",
      "COMPLETE_ALL_CALLS": "Conclua todas as simulações com pontuação de",
      "OR_HIGHER": "ou mais",
      "PROGRESS_OVERVIEW": "VISÃO GERAL DO PROGRESSO",
      "TEAM_MEMBERS": "membros da equipe",
      "AVERAGE_HIGH_SCORE": "Média de pontuação alta",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número médio de tentativas por simulação",
      "TOTAL_PRACTICES": "Total de práticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DA SIMULAÇÃO INDIVIDUAL",
      "OF_TEAM_MEMBERS": "dos membros da equipe concluíram",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Média de práticas até a conclusão",
      "TEAM_MEMBER_DETAILS": "DETALHES DOS MEMBROS DA EQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Baixar relatório de atividades",
      "TEAM_MEMBER": "Membro da equipe",
      "PROGRESS": "Progresso",
      "CALLS_COMPLETED": "Simulações concluídas",
      "PRACTICES": "Sessões de prática",
      "MOST_RECENT_PRACTICE": "Sessão mais recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Esta equipe não tem tarefas ativas no momento",
      "CALL_NAME_LABEL": "Nome da simulação",
      "HIGHEST_SCORE": "Pontuação mais alta"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Vamos garantir que seu dispositivo esteja configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "É necessário ter um microfone funcionando.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se não apareceu uma solicitação pop-up para ativar seus dispositivos após atualizar esta página, acesse as configurações do sistema ou do navegador e ative-os. Confira abaixo as páginas de suporte com instruções adicionais.",
      "ENABLE_CAMERA": "Como ativar sua câmera:",
      "WINDOWS_USERS": "Usuários do Windows",
      "MAC_USERS": "Usuários de Mac",
      "IPAD_USERS": "Usuários de iPad",
      "ENABLE_MICROPHONE": "Como ativar seu microfone:",
      "ENABLE_DEVICES_BY_BROWSER": "Como ativar seus dispositivos por navegador:",
      "CHROME_USERS": "Usuários do Chrome",
      "SAFARI_USERS": "Usuários do Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sem câmera",
      "START_CALL_BUTTON": "Iniciar chamada",
      "MICROPHONE_REQUIRED_WARNING": "É necessário ter um microfone funcionando.",
      "MICROPHONE_ALT": "microfone",
      "MICROPHONE": "Microfone",
      "SELECT_MICROPHONE": "Selecione seu microfone",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permissão",
      "SELECT_VIDEO_DEVICE": "Selecione seu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que você negou o acesso desse navegador a um ou mais dos seus dispositivos. Para ativar os dispositivos, acesse as configurações do sistema ou do navegador e ative o acesso.",
      "DEVICE_SETTINGS": "Configurações do dispositivo",
      "CONFIRM_SETTINGS": "Confirmar configurações",
      "LAPTOP": "Notebook",
      "SAD_EMOTE_FACE": "Rosto de emote triste",
      "GRANT_BROWSER_ACCESS": "Para concluir essa simulação, conceda ao navegador acesso ao reconhecimento de fala",
      "USING_IPAD": "Se estiver usando um iPad, acesse",
      "SETTINGS": "Configurações",
      "PRIVACY_AND_SECURITY": "Privacidade e segurança",
      "SPEECH_RECOGNITION": "Reconhecimento de fala",
      "GRANT_ACCESS_REFRESH": "Conceda acesso ao navegador e atualize a página",
      "REFRESH_PAGE": "ATUALIZAR A PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "O navegador não consegue acessar este dispositivo",
      "ACCESS_DENIED": "acesso negado",
      "CAMERA": "Câmera",
      "DIAGNOSTIC_PASSED": "Todos os testes de diagnóstico foram concluídos com sucesso.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alguns testes de diagnóstico falharam. Clique no botão \"Copiar resultados de diagnóstico\" acima e envie os resultados para a equipe de suporte para receber assistência.",
      "DIAGNOSTIC_PARTIAL": "A maioria dos testes de diagnóstico foi aprovada com sucesso. Sua conexão parece boa.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Aguarde enquanto os testes de diagnóstico estão sendo executados...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico em execução",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados de diagnóstico",
      "RUN_DIAGNOSTIC": "Executar diagnóstico",
      "RERUN_DIAGNOSTIC": "Executar diagnóstico novamente",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados do diagnóstico copiados para a área de transferência",
      "DIAGNOSTIC_FAILED": "Falha no diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos da Quantified",
      "DIAGNOSTIC_TIME": "Tempo",
      "DIAGNOSTIC_SUMMARY": "Resumo",
      "DIAGNOSTIC_CLIENT_INFO": "Informações do cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perda de pacotes (envio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Taxa média de bits de envio",
      "DIAGNOSTIC_NA": "n/a"
    },
    "results": {
      "RETURN_HOME": "VOLTAR PARA O INÍCIO",
      "CLOSE_BUTTON": "Botão Fechar",
      "CONVERSATIONAL_CALL": "SIMULAÇÃO DE PAPÉIS",
      "INFORMATION_ICON": "Ícone de informações",
      "TOOLTIP_ARROW": "Seta de dica",
      "INFORMATION_TOOLTIP_CONTENT": "Você controla o fluxo da simulação, conduzindo a conversa para um conjunto de objetivos. As simulações de papéis são ótimas para testar habilidades, como aprofundar perguntas, fazer perguntas de segundo nível, identificar pontos problemáticos e criar empatia.",
      "CLOCK_ICON": "Ícone de relógio",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adesão à mensagem",
      "TRY_AGAIN_MESSAGE": "Tente novamente e melhore sua pontuação.",
      "PRACTICE_BENEFITS": "A prática semanal aumenta a confiança e melhora os resultados no mundo real.",
      "CALL_SUCCESS": "Ótimo trabalho! Você concluiu esta simulação com êxito.",
      "MAX_ATTEMPTS_REACHED": "Você atingiu o número máximo de tentativas",
      "TRY_AGAIN": "Tentar novamente",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Ótimo trabalho! Você concluiu",
      "COMPLETED_THIS_CALL": "essa simulação com êxito.",
      "ACHIEVED_SCORE": "Você deve conseguir uma pontuação de",
      "ACHIEVE_SCORE": "Consiga uma pontuação de",
      "OR_HIGHER": "ou mais.",
      "OBJECTIVES_NOT_MET": "Você não atingiu todos os objetivos necessários.",
      "TRY_AGAIN_TARGET_SCORE": "Tente novamente para conseguir uma pontuação de",
      "YOUR_SCORE": "Sua pontuação",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMO DO FEEDBACK",
      "STRENGTH_ICON_ALT": "Ícone de força",
      "OPPORTUNITIES_ICON_ALT": "Ícone de oportunidades",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SOBRE A METODOLOGIA",
      "SESSION_ID": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "Como você se saiu:",
      "LIGHTBULB_ICON_ALT": "Ícone de lâmpada",
      "WHAT_WE_SUGGEST": "O que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nosso sistema não conseguiu encontrar uma recomendação específica para você.",
      "WHY": "Por quê?",
      "NO_INSIGHTS_AVAILABLE": "Nosso sistema não conseguiu fornecer insights sobre essa sugestão.",
      "CONFETTI_ICON_ALT": "Ícone de confete",
      "OBJECTIVE_SUCCESS_MESSAGE": "Você se saiu muito bem nesta metodologia. Continue assim!",
      "PROCESSING_CALL": "Estamos preparando sua pontuação e feedback.",
      "HANG_TIGHT": "Aguarde ou volte mais tarde para",
      "VIEW_YOUR_RESULTS": "ver seus resultados.",
      "NEED_MORE_TIME": "Precisamos de mais tempo para calcular os resultados.",
      "REFRESH_INSTRUCTION": "Verifique novamente ou atualize a tarefa",
      "RESULTS_IN_FEW_MINUTES": "resultados em poucos minutos.",
      "SCORE_CALCULATION_QUESTION": "Como isso é calculado?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulação tem apenas um componente de pontuação. Por isso, a pontuação exibida é tanto a pontuação da seção individual quanto a pontuação geral.",
      "OVERALL_SCORE_PERCENT": "% da pontuação geral",
      "SECTION_SCORE": "Pontuação da seção",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Aumente a adesão à mensagem da sua conversa",
      "MESSAGE_ADHERENCE_NOTE": "A adesão à mensagem é essencial para conduzir conversas bem-sucedidas, mas não afeta sua pontuação geral.",
      "NO_CREDIT": "Sem crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito total",
      "WHAT_YOU_DID_WELL": "O que você fez bem",
      "MISSED_ALL_KEY_POINTS": "Você deixou de abordar todos os pontos principais; revise-os e tente novamente.",
      "WHAT_TO_IMPROVE": "O que você pode melhorar",
      "PERFECT_SCORE_MESSAGE": "Parabéns! Você conseguiu uma pontuação perfeita, falando corretamente sobre todos os pontos principais.",
      "POINTS_LABEL": "Pontos",
      "TALKING_POINTS_COVERED": "Pontos de discussão abordados",
      "CHECKMARK_ICON_ALT": "marca de verificação",
      "TALKING_POINTS_MISSED": "Pontos de discussão não abordados",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Pratique novamente",
      "OUT_OF": "de",
      "POSSIBLE_TALKING_POINTS": "pontos de discussão possíveis",
      "YOU_COVERED": "Você abordou",
      "THROUGHOUT_CALL": "durante toda a simulação.",
      "POSITIVE_FEEDBACK_COVERAGE": "Você fez um ótimo trabalho destacando os pontos principais durante a chamada e abordou",
      "MIXED_FEEDBACK_COVERAGE": "Você deixou de abordar alguns dos pontos principais durante a simulação e abordou",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Melhore suas habilidades de conversa",
      "OBJECTIVES_NOTE": "A metodologia é essencial para conduzir conversas bem-sucedidas, mas não afeta sua pontuação geral.",
      "UNTIL": "até",
      "TO_IMPROVE_SCORE": "para melhorar sua pontuação.",
      "TO_SCORE": "para marcar",
      "BEFORE": "antes de",
      "YOU_HAVE": "Você tem",
      "MORE_ATTEMPTS": "mais tentativas de atingir a pontuação de",
      "OR_HIGHER_BEFORE": "ou mais antes de",
      "AND_TRY_AGAIN": "e tente novamente.",
      "UNEXPECTED_STATE": "Ocorreu uma condição inesperada.",
      "REVIEW_APP_LOGIC": "Verifique a lógica do aplicativo.",
      "ASSIGNMENTS": "Tarefas",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "PRACTICE_SESSION": "Sessão de prática",
      "OVERALL_SCORE": "Pontuação geral",
      "OVERALL_SCORE_EXPLANATION": "A pontuação geral é calculada por meio de uma média ponderada da pontuação de cada seção. O peso de cada seção é exibido como uma porcentagem ao lado da pontuação.",
      "SCORE_CONFIG_NOTE": "As porcentagens de peso e a inclusão e exclusão de seções são definidas pela sua empresa. Todas as pontuações são arredondadas para a primeira casa decimal.",
      "STRENGTHS": "Pontos fortes",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Sua resposta",
      "MINUS": "menos",
      "PLUS": "mais",
      "RECOMMENDED_RESPONSE": "Resposta recomendada",
      "REVIEW_MISSED_TITLE": "Revise o que você deixou passar.",
      "NO_TALKING_POINTS_COVERED": "Você não abordou nenhum dos pontos de discussão necessários para esse tema.",
      "LEARN_WHAT_YOU_MISSED": "Saiba o que você deixou passar",
      "NICE_JOB": "Bom trabalho!",
      "ALL_POINTS_COVERED": "Você abordou com sucesso todos os pontos de discussão necessários para esse tema.",
      "COVER_ALL_MESSAGES": "Aborde todas as mensagens principais.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Destacar os pontos principais durante a chamada ajudará a manter o foco da conversa.",
      "MESSAGES_LABEL": "Mensagens",
      "NO_FACTS_COVERED": "Ops! Parece que você não abordou nenhum dos fatos desta mensagem.",
      "NO_SPECIFICS_AVAILABLE": "Ops! Não conseguimos detalhar o que não foi abordado.",
      "ALL_KEY_POINTS_COVERED": "Ótimo trabalho! Você abordou todos os pontos principais.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos processando o feedback das suas habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lamentamos, mas não foi possível analisar sua chamada recente porque a pontuação de habilidades não estava ativada no momento do envio. Para receber feedback, basta reenviar sua prática de chamada como fez anteriormente. Se precisar de ajuda, entre em contato com a nossa equipe de suporte. Agradecemos sua compreensão e compromisso com o aprimoramento!",
      "ELEVATE_CONVERSATION_SKILLS": "Melhore suas habilidades de conversação",
      "SKILLS_NOTE": "As habilidades são essenciais para conduzir conversas bem-sucedidas, mas não afetam sua pontuação geral.",
      "SKILLS_SUMMARY_TITLE": "RESUMO DAS HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Saiba mais sobre habilidades",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "O que são habilidades",
      "SKILLS_DESCRIPTION": "As habilidades são calibradas para auxiliar no desenvolvimento do crescimento pessoal. Embora essas habilidades não façam parte da avaliação numérica da sua chamada, elas foram selecionadas pela sua organização para aumentar sua eficácia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE PROFICIÊNCIA",
      "EXPERT": "Especialista",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "CALL_TRANSCRIPT": "Transcrição da chamada",
      "COLLAPSE_ALL": "Recolher tudo",
      "EXPAND_ALL": "Expandir tudo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 pontos",
      "TALKING_POINTS": "pontos de discussão",
      "TRANSCRIPT_LABEL": "Transcrição",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Você não tem mais tentativas.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revise as diretrizes e mantenha-se em conformidade daqui para a frente.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Tente novamente e preste atenção às diretrizes de conformidade.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Percebemos que você não estava em conformidade, por isso não recebeu uma pontuação.",
      "WHY_OUT_OF_COMPLIANCE": "Por que você não estava em conformidade",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revise a transcrição para ver onde você não seguiu as diretrizes de conformidade.",
      "YOU_DID_FOLLOW_GUIDELINES": "Você seguiu efetivamente essas diretrizes.",
      "REVIEW_MISSED_GUIDELINES": "Revise as diretrizes de conformidade não observadas.",
      "OUT_OF_COMPLIANCE": "Fora de conformidade",
      "SCORE_CALCULATION_TITLE": "Cálculo da pontuação",
      "PROCESSING_TRANSCRIPT": "Estamos processando a transcrição.",
      "WAIT_OR_REVIEW_SCORES": "Aguarde aqui ou revise as outras seções de pontuação",
      "TRANSCRIPT_LOADING": "enquanto a transcrição é carregada.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revise o feedback e continue praticando",
      "HIGH_PERFORMERS_PRACTICE": "Profissionais de alto desempenho praticam pelo menos uma vez por semana",
      "SUCCESSFULLY_PASSED": "Ótimo trabalho! Você conseguiu a aprovação nesta simulação.",
      "DIDNT_REACH_PASSING_SCORE": "Você não atingiu a pontuação de aprovação para esta simulação.",
      "OUT_OF_ATTEMPTS": "<b>Você não tem mais tentativas.</b> Revise o feedback para saber como melhorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revise o feedback e volte para o início quando estiver tudo pronto.",
      "GREAT_JOB_PRACTICED": "Ótimo trabalho, você praticou {{count}} {{times}}. Continue assim!",
      "TIME": "vez",
      "TIMES": "vezes",
      "COMPLIANCE_GUIDELINES": "Diretrizes de conformidade",
      "TALKING_POINT_TITLE": "PONTOS DE DISCUSSÃO NÃO ABORDADOS OU DITOS NO MOMENTO ERRADO",
      "NO_TRANSCRIPT": "Não há transcrição disponível."
    },
    "reportingV2": {
      "DASHBOARD": "Painel",
      "LOADING_ACCOUNTS": "Carregando contas...",
      "SELECT_AN_ACCOUNT": "Selecione uma conta",
      "SEARCH_TEAMS": "Pesquisar equipes",
      "LOADING_TEAMS": "Carregando equipes...",
      "ALL_TEAMS": "Todas as equipes",
      "ACCOUNT": "Conta",
      "TEAMS": "Equipes",
      "TEAM_LABEL": "Equipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Pontuação de aprovação",
      "ASSIGNMENT_LABEL": "Tarefas",
      "USER_LABEL": "Usuários",
      "PRACTICE_LABEL": "Prática",
      "CERTIFICATION_LABEL": "Certificação",
      "RESULTS_DESCRIPTION": "Aqui estão os resultados de sua(s) equipe(s) em todas as tarefas de prática:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engajamento por tarefa",
      "ASSIGNMENT_ENGAGEMENT": "Engajamento na tarefa",
      "ENGAGED_LABEL": "Engajado",
      "ENGAGEMENT_STATUS_LABEL": "Status do engajamento",
      "PROFICIENT_LABEL": "Proficiente",
      "ASSIGNMENT_NAME": "Nome da tarefa",
      "ACTIVE_USERS": "Usuários ativos",
      "ASSIGNMENT_PROGRESS": "Progresso por tarefa",
      "IN_PROGRESS_LABEL": "Em andamento",
      "CERTIFIED_LABEL": "Certificada",
      "OUT_OF_ATTEMPTS_LABEL": "Sem tentativas",
      "USERS_ENGAGED_LABEL": "Usuários engajados",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessões por usuário ativo",
      "HIGHER_THAN_LABEL": "Maior que",
      "MORE_THAN_LABEL": "Mais de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sessões concluídas",
      "USER_CERTIFIED": "Usuários certificados em todas as tarefas",
      "ASSIGNMENT_CERTIFICATION": "Tarefas com 100% de certificação",
      "TRAINER_TIME_SAVED": "Economia de tempo do treinador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tarefas de prática",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tarefas de certificação",
      "START_DATE_LABEL": "Data de início",
      "END_DATE_LABEL": "Data de término",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membro de equipes",
      "ASSIGNMENTS_COUNT_LABEL": "N.º de tarefas",
      "TOTAL_SESSIONS_LABEL": "Total de sessões",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sessões",
      "TOTAL_USERS_LABEL": "Total de usuários",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "INITIAL_SCORE_LABEL": "Pontuação inicial",
      "HIGH_SCORE_LABEL": "Pontuação alta",
      "LAST_PRACTICE_DATE_LABEL": "Data do último treino",
      "PERCENT_IMPROVED_LABEL": "% de melhoria",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica analisa as pontuações de cada sessão e desenha uma linha reta em um gráfico para ilustrar a tendência. Uma porcentagem maior indica que as pontuações estão melhorando mais rápido, enquanto uma porcentagem menor indica que as pontuações estão melhorando mais lentamente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tarefas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tarefas com proficiência",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "O número de tarefas em que o usuário atingiu ou excedeu os critérios de pontuação para todas as simulações da tarefa.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "O número de tarefas em que o usuário atingiu ou excedeu os critérios de pontuação pelo menos uma vez em todas as simulações da tarefa.",
      "PROFICIENT_TOOLTIP": "A porcentagem de usuários nesta tarefa que atenderem ou excederam os critérios de pontuação pelo menos uma vez em todas as simulações desta tarefa.",
      "IN_PROGRESS_TOOLTIP": "A porcentagem de usuários que concluíram pelo menos uma sessão de uma simulação desta tarefa e receberam uma pontuação.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "A porcentagem de usuários que excederam as tentativas alocadas para uma ou mais simulações da tarefa.",
      "CERTIFIED_TOOLTIP": "A porcentagem de usuários que atingiram ou excederam os critérios de pontuação em todas as simulações da tarefa.",
      "SEARCH_FOR_A_USER_LABEL": "Pesquisar um usuário",
      "NO_USERS_FOUND_LABEL": "Nenhum usuário encontrado",
      "TRAINER_TIME_SAVED_TOOLTIP": "O tempo que os usuários gastaram na Quantified para concluir tentativas de certificação.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Média de sessões por tarefa",
      "ASSIGNMENTS_ENGAGED_WITH": "Tarefas em que houve progresso",
      "AVERAGE_IMPROVEMENT": "Melhoria média",
      "STATUS": "Status",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sessões",
      "DATE_OF_LAST_PRACTICE": "Data da última prática",
      "CALL_NAME": "Nome da chamada",
      "SESSION_DATE": "Data da sessão",
      "DURATION_OF_SESSION": "Duração da sessão",
      "OVERALL_SCORE": "Pontuação geral",
      "MESSAGING_SCORE": "Pontuação de adesão à mensagem",
      "METHODOLOGY_SCORE": "Pontuação de metodologia",
      "SKILLS_SCORE": "Pontuação de habilidades",
      "SESSIONS": "Sessões",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas as tarefas",
      "RECENT_ASSIGNMENTS": "Tarefas recentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Média de sessões por usuário ativo",
      "HOURS_IN_SIMULATIONS": "Horas em simulações",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Média de sessões até a proficiência",
      "PERCENT_PROFICIENT": "Porcentagem de proficiência",
      "SYSTEM_RUNNING_NORMALLY": "O sistema está funcionando normalmente no momento",
      "PRACTICE_SIMULATIONS_LABEL": "Simulações",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nenhum resultado corresponde aos seus filtros. Tente limpar um ou mais filtros para ampliar a pesquisa.",
      "USERS_PASSED": "Usuários que passaram na simulação",
      "AVERAGE_TIME": "Tempo médio para certificação",
      "USERS_OUT_OF_ATTEMPTS": "Usuários sem tentativas restantes",
      "NO_CERTIFICATION_SIMULATION": "Nenhuma simulação de certificação encontrada",
      "SIMULATION": "Simulação",
      "No_SIMULATION": "Nenhuma sessão",
      "PERCENT_CERTIFIED": "Percentual de certificados",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentual de certificados na primeira tentativa",
      "USERS": "Usuários",
      "ATTEMPTS_LABEL": "Tentativas",
      "NO_ATTEMPTS": "Nenhuma tentativa",
      "DATE_OF_SESSION": "Data da sessão",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nenhuma tarefa corresponde aos filtros escolhidos",
      "NO_TEAMS_DATA": "Não há equipes nessa conta",
      "SIMULATION_NAME": "Nome da simulação",
      "AVERAGE_DURATION_OF_SESSION": "Duração média da sessão",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Média de sessões por usuário ativo",
      "AVERAGE_OVERALL_SCORE": "Pontuação geral média",
      "ASSIGNMENTS_CERTIFIED": "Tarefas certificadas",
      "HOURS_SPENT_PRACTICING": "Horas gastas praticando",
      "LAST_LOGIN": "Último login",
      "SELECT_ASSIGNMENTS": "Selecionar tarefas",
      "TOTAL_ASSIGNMENTS": "Total de tarefas",
      "TOTAL_SESSIONS": "Total de sessões",
      "CERTIFICATION_STATUS_LABEL": "Status da certificação",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Status da certificação:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificado na primeira tentativa?",
      "DATE_OF_CERTIFICATION_LABEL": "Data da certificação",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Status do engajamento:",
      "DURATION_OF_ATTEMPT": "Duração da tentativa",
      "USER_NAME": "Nome do usuário",
      "LEARNER": "Aprendiz",
      "DATE_RANGE": "Intervalo de datas",
      "DATE_RANGE_LABEL": "Intervalo de datas",
      "SEARCH_USERS": "Pesquisar usuários...",
      "SEARCH_SIMULATIONS": "Pesquisar simulações...",
      "SEARCH_DATES": "Pesquisar datas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado na primeira tentativa",
      "DATE_OF_CERTIFICATION": "Data da certificação",
      "AVERAGE_CERTIFICATION_SCORE": "Pontuação média de certificação",
      "TOTAL_TIME_CERTIFYING": "Tempo total de certificação",
      "OF_THE_TIME": "do tempo",
      "ASSIGNED_LABEL": "Não iniciada",
      "USERS_ASSIGNED_LABEL": "Total de usuários atribuídos",
      "SESSION_ID": "ID da sessão",
      "NO_SIMULATIONS_FOUND_LABEL": "Nenhuma simulação encontrada",
      "USER_NAME_LABEL": "Nome do usuário",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Atribuído",
      "ENGAGED_TOOLTIP": "Porcentagem de usuários que completaram uma ou mais sessões de uma simulação nesta tarefa, mas ainda não alcançaram proficiência em todas as simulações.",
      "SEARCH_ASSIGNMENTS": "Pesquisar tarefas...",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "START_DATE": "Data de início",
      "END_DATE": "Data de término",
      "NO_ASSIGNMENTS": "Nenhuma tarefa encontrada para este usuário.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tarefas de prática",
      "SESSION_SCORES_OVER_TIME": "Pontuações da sessão ao longo do tempo",
      "TIME": "vez",
      "SCORE": "Pontuação",
      "NO_SESSIONS_AVAILABLE": "Nenhuma sessão disponível para gerar o gráfico.",
      "MESSAGING_SCORE_LABEL": "Pontuação de mensagens",
      "PERSONALIZED_PRACTICE_LABEL": "Prática personalizada",
      "ASSIGNMENT_ENAGEMENT": "Engajamento por tarefa",
      "NO_PRODUCTS": "Não há produtos de prática personalizados para as equipes selecionadas",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo de prática total",
      "AVERAGE_SESSIONS_PER_USER": "Média de sessões por usuário",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Tipo de conversa mais comum selecionada",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Tipo de conversa menos comum selecionada",
      "CLEAR_TEAMS": "Limpar equipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Média das pontuações objetivas em todas as sessões desta chamada.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Mensagens",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "As mensagens medem se os alunos articulam duas ideias importantes durante esta simulação. Estas visualizações mostram as porcentagens de mensagens em um determinado tema de mensagem que os usuários articularam, em média, em todas as sessões desta chamada.",
      "NO_METRICS_MESSAGE": "Nenhuma sessão concluída para as equipes selecionadas.",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "As pontuações de habilidades são uma avaliação de IA das habilidades demonstradas pelos usuários em uma chamada.",
      "EXPERT": "Especialista",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "Não mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "As mensagens medem se os usuários articulam três ideias importantes nesta chamada."
    },
    "reporting": {
      "AT_GLANCE": "Resumo das tarefas",
      "OPEN_ASSIGNMENTS": "Tarefas em aberto",
      "NOT_STARTED": "Não iniciadas",
      "CERTIFIED": "Certificada",
      "VIEW_LIST": "Ver lista",
      "CERTIFICATION_ASSIGNMENTS": "Tarefas de certificação",
      "CERTIFICATION_SUMMARY_TEXT": "Certificações são tarefas que têm uma data de vencimento e critérios específicos para aprovação",
      "PRACTICE_ASSIGNMENTS": "Tarefas de prática",
      "PRACTICE_SUMMARY_TEXT": "As tarefas de prática estão disponíveis para os usuários sem uma data de vencimento específica. Elas são desenvolvidas para permitir que os usuários pratiquem regularmente e aprimorem suas habilidades",
      "THE": "O(a)",
      "WILL_CLOSE": "fechará em",
      "USERS_HAVE": "os usuários",
      "USER_HAS": "o usuário",
      "NOT_STARTED_ASSIGNMENT_DUE": "não iniciou(aram) uma tarefa com vencimento na próxima semana",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "não concluiu(íram) uma tarefa com vencimento na próxima semana",
      "DAYS": "dias",
      "DAY": "dia",
      "MODULES": "Módulos",
      "MODULE": "Módulo",
      "CALL": "Simulação",
      "CALLS": "Simulações",
      "CERTIFICATION_ASSIGNMENT": "Tarefa de certificação",
      "PRACTICE_ASSIGNMENT": "Tarefa de prática",
      "AND": "e",
      "VIEW_ENGAGEMENT_DETAILS": "Ver detalhes da participação",
      "SEE_ALL": "Ver tudo",
      "SEE_LESS": "Ver menos",
      "ASSIGNMENT": "Tarefa",
      "ASSIGNED": "Atribuído",
      "IN_PROGRESS": "Em andamento",
      "DUE_DATE": "Prazo",
      "ASSIGNMENT_ENDS_IN": "A tarefa termina em",
      "ASSIGNMENT_CLOSED": "Tarefa encerrada",
      "OLDER_CERTIFICATION": "certificação mais antiga",
      "ASSIGNMENT_IS": "a tarefa está",
      "ASSIGNMENT_ARE": "as tarefas estão",
      "CURRENTLY_HIDDEN": "atualmente oculta(s)",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Todas as tarefas de certificação estão sendo mostradas.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Usuários que ainda não concluíram nem receberam uma pontuação para alguma simulação.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Usuários que concluíram pelo menos uma simulação e receberam uma pontuação.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Usuários que cumpriram o requisito de certificação.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Esse é o número de usuários que podem acessar a tarefa de suas certificações.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Veja todas as tarefas de certificação",
      "HIDE_OLDER_ASSIGNMENTS": "Ocultar tarefas mais antigas",
      "AVG_PRACTICES": "Média de práticas",
      "PRACTICED": "Praticado",
      "SCORED_HIGH": "Pontuação alta",
      "AVG_ASSIGNMENT": "Melhoria média",
      "DAYS_AGO": "dias atrás",
      "NA": "N/A",
      "OLDER_PRACTICE": "prática mais antiga",
      "SEE_PRACTICE_ASSIGNMENT": "Veja todas as tarefas de prática",
      "ALL_PRACTICE_ASSIGNMENTS": "Todos as tarefas de prática estão sendo exibidas.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Usuários que ainda não concluíram nem receberam uma pontuação para alguma simulação.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Esses usuários concluíram pelo menos uma simulação e receberam uma pontuação.",
      "PRACTICE_CERTIFIED_TOOLTIP": "O número de usuários nesta tarefa que receberam pontuação igual ou superior aos critérios de pontuação alta definidos pelo menos uma vez em todas as simulações nesta tarefa.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Esses usuários podem acessar a tarefa para praticar.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Esse número mostra o número médio de vezes que os usuários praticaram simulações que fazem parte desta tarefa.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Esta métrica analisa as pontuações de cada sessão e desenha uma linha reta em um gráfico para ilustrar a tendência. Uma porcentagem maior indica que as pontuações estão melhorando mais rápido, enquanto uma porcentagem menor indica que as pontuações estão melhorando mais lentamente.",
      "USERS": "usuários",
      "USER": "usuário",
      "DOWNLOAD_CSV": "Baixar CSV",
      "ERROR": "Ocorreu um erro",
      "FIRST_NAME": "Nome",
      "LAST_NAME": "Sobrenome",
      "ATTEMPTS": "Tentativas",
      "EMAIL": "E-mail",
      "LAST_LOGIN": "Último login",
      "ASSIGNMENT_NOT_STARTED": "Tarefa não iniciada",
      "ASSIGNMENT_IN_PROGRESS": "Tarefa em andamento",
      "SCORE_CRITERIA_MET": "Critérios de pontuação atendidos",
      "NEVER_LOGGED_IN": "Não conectado",
      "QUANTIFIED_REPORTING": "Relatórios da Quantified",
      "ASSIGNED_USERS": "Usuários atribuídos",
      "COMPLETION_REQUIREMENT": "Requisito de conclusão",
      "AVG_SCORE_Of": "Média Pontuação de",
      "REPORTING": "Relatórios",
      "CERTIFICATIONS": "Certificações",
      "PRACTICES": "Práticas",
      "CALL_ANALYSIS": "Análise de simulação",
      "PERCENT_CERTIFIED_ON": "Percentual certificado em",
      "SHOWING": "Exibindo",
      "PRACTICE_SESSIONS": "Acumulado de sessões de práticas em todas as simulações do módulo",
      "AVG_PRACTICE_HEADING": "Número médio de sessões de prática por usuário ativo",
      "AVG_SCORE_LABEL": "Média Pontuação",
      "AVG_SCORE_HEADING": "Pontuação média por usuário",
      "AVG_PRACTICES_LABEL": "Média Práticas",
      "EXPORT_LEARNER_LIST": "Exportar lista de participantes",
      "PERCENT_NOT_STARTED": "% de não iniciados",
      "PERCENT_IN_PROGRESS": "% em andamento",
      "PERCENT_CERTIFIED": "% certificados",
      "USER_CERTIFIED": "Usuário certificado",
      "USERS_CERTIFIED": "Usuários certificados",
      "TOTAL_ATTEMPTS": "Total de tentativas",
      "Avg_ATTEMPTS_CERTIFY": "Média de tentativas de certificação",
      "ASTERICK_GROUP": "indica um grupo que contém um ou mais subgrupos",
      "NO_DATA_FOUND": "Nenhum dado encontrado",
      "MODULE_HIGHLIGHTS": "Destaques do módulo",
      "MODULE_HIGHLIGHT_SUMMARY": "Principais métricas em todas as simulações. Para obter uma análise detalhada de cada simulação, consulte a visão geral abaixo",
      "HIGHEST_SCORING_QUESTION_TITLE": "PERGUNTA COM MAIOR PONTUAÇÃO",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Pergunta com maior pontuação",
      "QUESTION_BAR_MSG": "% média de pontos de resposta acertados",
      "LOWEST_SCORING_QUESTION_TITLE": "PERGUNTA COM MENOR PONTUAÇÃO",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Pergunta com menor pontuação",
      "TOP_SCORED_ANSWER_POINT_TITLE": "PONTO DE RESPOSTA COM A MELHOR PONTUAÇÃO",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Ponto de resposta menos esquecido",
      "SCORE_BAR_MSG": "das vezes, os usuários acertam.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "PONTO DE RESPOSTA COM A PIOR PONTUAÇÃO",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Ponto de resposta mais esquecido",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA DE MENOR PONTUAÇÃO",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia de menor pontuação",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA DE MAIOR PONTUAÇÃO",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia de maior pontuação",
      "OBJECTIVE_BAR_MSG": "média de pontos nesta metodologia",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MENSAGEM MENOS ARTICULADA",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensagem menos articulada",
      "LEAST_ARTICULATED_BAR_MSG": "Articule esta mensagem",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MENSAGEM MAIS ARTICULADA",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensagem mais articulada",
      "MOST_ARTICULATED_BAR_MSG": "Articule plenamente esta mensagem",
      "Overview": "Visão geral",
      "CONSISTS_Of": "consiste em",
      "CALL_OVERVIEW_LABEL": "O gráfico mostra o número de usuários que",
      "PASSED": "Aprovados",
      "ATTEMPTED": "Tentaram",
      "NOT_ATTEMPTED": "Não tentaram",
      "GUIDED_CALL": "Verificação de conhecimento",
      "QUESTIONS": "Perguntas",
      "QUESTION": "Pergunta",
      "CONVERSATIONAL_CALL": "Simulação de papéis",
      "AVG_ATTEMPTS": "Média Tentativas",
      "USERS_PASSED": "usuários aprovados",
      "DETAILED_ANALYSIS": "Análise detalhada",
      "CALL_DETAILS": "Detalhes da simulação",
      "CALL_TYPE": "Tipo de simulação",
      "TOTAL_SESSIONS": "Total de sessões",
      "WHAT_WE_MEASURED": "O que medimos",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Pontuação geral média",
      "OVERALL_SCORE_DETAIL": "Nosso sistema fornece uma \"pontuação geral\" para cada conversa. Esse número é a pontuação geral média em",
      "CALL_RUN": "usuários concluíram esta simulação",
      "TIME": "vez",
      "TIMES": "vezes",
      "OBJECTIVES": "Metodologia",
      "AVG_OBJECTIVE": "Pontuações médias da metodologia em todas as",
      "OF_THIS_CALL": "desta simulação",
      "MESSAGE_ADHERENCE": "Adesão à mensagem",
      "MESSAGE_ADHERENCE_DETAILS_1": "A adesão à mensagem mede se os participantes articulam",
      "MESSAGE_ADHERENCE_DETAILS_2": "ideias importantes durante esta simulação. Estas visualizações mostram a porcentagem de mensagens em um determinado tema de mensagem que os usuários articularam, em média, em todas as",
      "IMPORTANT_IDEAS": "ideias importantes durante esta simulação",
      "PERCENT_MESSAGE_ARTICULATED": "Estas visualizações mostram a porcentagem de tempo em que cada mensagem é articulada em todas as",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "Não mencionado",
      "SKILLS_LABEL": "Habilidades",
      "SKILLS_DETAILS": "As pontuações de habilidades são uma avaliação de IA das habilidades demonstradas pelos usuários em uma simulação. Estas visualizações mostram a porcentagem de vezes que os usuários receberam pontuações de \"especialista\" (mais alta), \"proficiente\" e \"em desenvolvimento\" (mais baixa) em todos(as) os(as)",
      "DEVELOPING": "Em desenvolvimento",
      "PROFICIENT": "Proficiente",
      "Expert": "Especialista",
      "NO_RESULT": "Ainda não há resultados",
      "NO_RESULT_TEXT": "Nenhum usuário da sua organização tentou fazer esta simulação ainda. Assim que o fizerem, você poderá ver os resultados aqui!",
      "CONVERSATIONAL_CALL_TOOLTIP": "Nas simulações de papéis, o usuário pode direcionar o fluxo da conversa e a IA responderá de acordo. As simulações de papéis são menos estruturadas do que as \"verificações de conhecimento\", que têm um formato rígido de perguntas e respostas",
      "TOTAL_SESSION_TOOLTIP": "O número total de vezes que esta simulação foi realizada por todos os usuários aos quais ela foi atribuída",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "AVERAGE_SCORE_DETAIL": "A pontuação média de todos os usuários nesta simulação",
      "ANSWER_POINTS": "Pontos de resposta",
      "DETAILS": "Detalhes",
      "CONVERSATIONAL_CALL_MSG": "Os relatórios de conteúdo para simulações de papéis chegarão em breve",
      "ALL_CALL_DETAILS": "Todos os detalhes da simulação",
      "QUESTION_TEXT_LABEL": "Texto da pergunta",
      "AVG_POINTS_LABEL": "Média de pontos",
      "SHOW_ALL": "Mostrar tudo",
      "CORRECT_ANSWER": "respostas corretas de",
      "OBJECTIVE_MEASURED_ON": "Esta metodologia é medida em",
      "CALLS_IN_MODULE": "simulações neste módulo",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "QUESTION_UPDATED": "Esta pergunta foi atualizada",
      "QUESTION_UPDATED_MESSAGE": "Não é possível mostrar informações detalhadas do ponto de resposta porque esta pergunta passou por atualizações. A \"média de pontos\" exibida representa a média de todas as sessões desta pergunta (inclusive antes e depois das atualizações)",
      "CLOSE_ALT": "Fechar",
      "Q_LABEL": "P",
      "SCORING_LABEL": "Pontuação",
      "AVERAGE_ANSWER": "Média de pontos de resposta marcados por pergunta",
      "MINIMIZE_LABEL": "Minimizar",
      "VIEW_ALL_LABEL": "Ver tudo",
      "DOWN_ARROW": "Seta para baixo",
      "NOTIFICATION": "Notificação",
      "PROGRESS_ICON": "Ícone de progresso",
      "VIEW_MODAL": "Exibir modal",
      "VIEW_INFO": "Exibir informações",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Expandir grupo",
      "MESSAGE_ADHERENCE_V2": "Adesão à mensagem",
      "SCORE_OVERALL": "Pontuação geral",
      "SCORE_SKILLS": "Habilidades",
      "SCORE_CUSTOMIZED": "Metodologia",
      "SESSIONS": "sessões",
      "SESSION": "sessão"
    },
    "personalizedPractice": {
      "TITLE": "Prática personalizada",
      "DESCRIPTION": "Olá, {{userFirstName}}! As práticas personalizadas permitem que você defina seus próprios cenários para que sejam o mais realistas possível.",
      "LOADING": "Carregando...",
      "VIEW_SESSIONS": "Ver sessões",
      "VIEW_SIMULATION": "Ver simulação",
      "TOTAL_SESSION": "sessão no total",
      "TOTAL_SESSIONS": "sessões no total",
      "BREADCRUMB": "Prática personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalhes do cenário",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecione as variáveis nas opções abaixo para ajustar a simulação às suas necessidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Selecione",
      "CONVERSATION_TYPE": "Tipo de conversa",
      "SELECT_CONVERSATION_TYPE": "Selecione o tipo de conversa",
      "LAUNCH_SIMULATION": "Iniciar simulação com seleções",
      "PREVIOUS_SESSIONS": "Sessões anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Data",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data da sessão",
      "SESSION_SCORE": "Pontuação da sessão",
      "DURATION": "Duração",
      "OVERALL_SCORE": "Pontuação geral",
      "MESSAGING": "Mensagens",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver feedback",
      "OVERALL_SCORE_LABEL": "Pontuação geral",
      "SCORE": "Pontuação",
      "NO_PRODUCTS_TITLE": "Não há produtos disponíveis",
      "NO_PRODUCTS_DESCRIPTION": "Você ainda não possui nenhum produto de prática personalizada.",
      "NO_SESSIONS_FOUND": "Nenhuma sessão encontrada com os filtros selecionados",
      "TIME": "vez",
      "ALL": "Todas",
      "LEARNER": "Aprendiz",
      "MOOD": "Clima",
      "CLEAR_FILTERS": "Limpar filtros"
    },
    "login": {
      "TITLE": "Bem-vindo de volta",
      "SUB_TITLE": "Como deseja fazer login?  ",
      "LOGIN_WITH_SSO": "Fazer login com o SSO da empresa",
      "LOGIN_WITH_PASSWORD": "Fazer login com senha",
      "PROVIDE_EMAIL": "Informe seu endereço de e-mail",
      "HELP_TEXT": "Precisa de ajuda? Contato",
      "EMAIL_ERROR": "Não foi possível efetuar o login. Fale com o administrador ou com o departamento de TI da empresa.",
      "EMAIL": "E-mail",
      "LOGIN": "Fazer login",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Ao fazer login na sua conta, você concorda com os {{termsLink}} e a {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Termos de Serviço",
      "PRIVACY_POLICY": "Política de Privacidade"
    },
    "learningPathway": {
      "BEGIN": "Começar",
      "DUE_DATE": "Prazo",
      "FOOTER_SUBTITLE_READY": "Pergunte qualquer coisa! Estou pronto para ajudar.",
      "LEAVE_STEP": "Sair da etapa",
      "NEXT_STEP": "Próxima etapa",
      "NOTIFICATIONS_ARIA": "Notificações",
      "PDF_NEXT_PAGE": "Próxima página",
      "PDF_NO_SOURCE": "Nenhuma fonte em PDF fornecida.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deixe um feedback enquanto processamos seus resultados",
      "POST_CALL_TITLE": "Você chegou ao final deste teste.",
      "SETTINGS": "Configurações",
      "TOAST_CONTENT": "Clique abaixo para ver os resultados ou volte à tela de detalhes do caminho para a próxima etapa.",
      "TOAST_TITLE": "Os resultados da simulação de papéis foram processados",
      "ASSIGNMENTS": "Tarefas",
      "USER_FALLBACK": "Usuário",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Teste"
    },
    "leaderboard": {
      "LEADERBOARD": "Tabela de classificação",
      "TOP10PERCENT": "10% superiores",
      "PRACTICE_ASSIGNMENT": "Tarefas de prática",
      "SIMULATION": "Simulação",
      "SELECT_ASSIGNMENT": "Selecionar tarefa",
      "SELECT_SIMULATION": "Selecionar simulação",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecione uma tarefa e uma simulação para ver os líderes",
      "NO_DATA": "Nenhuma atividade ainda. Quando a equipe começar a se envolver, você verá as classificações aparecerem aqui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Não há tarefas disponíveis",
      "NO_SIMULATIONS_AVAILABLE": "Não há simulações disponíveis",
      "NAME": "Nome",
      "HIGH_SCORE": "Pontuação alta",
      "AVERAGE_SCORE": "Pontuação média",
      "TOTAL_SESSIONS": "Total de sessões",
      "LAST_SESSION": "Última sessão",
      "TOP5": "5 superiores",
      "OF": "de",
      "ENGAGED_USERS": "usuários engajados",
      "ENGAGED_USER": "usuário engajado",
      "NO_USERS_ENGAGED": "Nenhum usuário engajado",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar sessões com baixa pontuação de habilidades",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "As sessões com uma pontuação de \"desenvolvimento\" na seção de habilidades não contribuirão para as colunas de pontuação alta ou média."
    },
    "general": {
      "NEED_HELP_QUESTION": "Precisa de ajuda?",
      "CONTACT": "Contato",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Conta principal",
      "ACCOUNT": "Conta",
      "CHECKMARK": "Marca de verificação",
      "ICON": "Ícone",
      "ALERT": "alerta",
      "HEADS_UP": "Atenção!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para otimizar o áudio no iPad, use fones de ouvido.",
      "SETTINGS": "CONFIGURAÇÕES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipe para",
      "MIAMI_SALE": "Vendas em Miami",
      "CHARLOTTE_SALES": "Vendas em Charlotte",
      "ATLANTA_SALES": "Vendas em Atlanta",
      "TEAM": "Equipe",
      "ASSIGNMENTS": "Tarefas",
      "MY_TEAMS": "Minhas equipes",
      "REPORTING": "Relatórios",
      "DASHBOARD": "Painel",
      "LEADERBOARD": "Tabela de classificação",
      "PERSONALIZED_PRACTICE": "Prática personalizada",
      "HELP_SEARCH_OUR": "Pesquise em nossa",
      "HELP_OR_REACH_OUT_TO": "ou entre em contato com",
      "HELP_WITH_QUESTIONS": "com dúvidas",
      "KNOWLEDGE_BASE": "base de conhecimento"
    },
    "dashboard": {
      "ALL": "Todas",
      "IN_COMPLETE": "Incompletas",
      "COMPLETED": "Concluída",
      "NO_ASSIGNMENT_TITLE": "Você não tem nenhuma tarefa.",
      "NO_ASSIGNMENT_DETAILS": "Você receberá uma notificação quando tiver tarefas para concluir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Você não tem tarefas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Você receberá uma notificação quando uma nova tarefa estiver pendente.",
      "COMPLETED_ASSIGNMENT_TITLE": "Você não tem tarefas concluídas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Verifique novamente quando tiver concluído uma tarefa.",
      "VIEW_ASSIGNMENT": "Ver tarefa",
      "ASSIGNMENT_LABEL": "Tarefas",
      "MODULE_ASSIGNMENT_ALT": "Ícone de tarefa do módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarefa para",
      "DAY": "Dia",
      "UNTILL_DUE": "Até o prazo",
      "PAST_DUE": "Vencido",
      "AVAILABLE_IN": "Disponível em",
      "DUE_TODAY": "Prazo hoje",
      "PRACTICE": "Prática",
      "CERTIFICATION": "Certificação",
      "UPCOMING": "Em breve",
      "TEST_ASSIGNMENT": "Tarefa de teste",
      "CLOSED": "Fechada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Nenhuma tarefa encontrada.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Tente ajustar os filtros para ver as tarefas disponíveis ou volte mais tarde quando novas tarefas forem adicionadas.",
      "VIEW_PATHWAY": "Exibir caminho",
      "TOTAL": "Total",
      "STATUS_LABEL": "Status",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Tipo de tarefa",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarefa:",
      "NOT_STARTED": "Não iniciadas",
      "CERTIFIED": "Certificada",
      "NOT_CERTIFIED": "Não certificado",
      "IN_PROGRESS": "Em andamento",
      "PATHWAY": "Caminho de aprendizagem",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bem-vindo à Quantified!",
      "INVITATION_MESSAGE": "É muito bom ter você conosco! Para começar, siga as etapas abaixo para acessar sua conta pela primeira vez.",
      "ACCOUNT_DETAILS": "Detalhes da sua conta:",
      "USERNAME": "Nome de usuário",
      "PASSWORD": "Senha temporária",
      "STEPS_LABEL": "Próximas etapas para fazer login",
      "STEP_1": "1. Clique no botão \"Fazer login\" abaixo para acessar a página de login.",
      "STEP_2": "2. Digite seu nome de usuário e a senha temporária fornecidos acima.",
      "STEP_3": "3. Após fazer login, você deverá definir uma nova senha.",
      "LOGIN_BUTTON": "Fazer login",
      "ABOUT_US": "O Simulador da Quantified é um ambiente virtual projetado para ajudar você a desenvolver rapidamente habilidades essenciais, permitindo que se conecte e se comunique de forma mais eficaz com os clientes.",
      "EXPIRY_TIME": "Essa senha temporária expirará em 24 horas. Se tiver algum problema ao fazer login, entre em contato com nossa equipe de suporte em",
      "TEAM": "A equipe da Quantified",
      "INVITATION_SMS_USERNAME": "Seu nome de usuário é",
      "INVITATION_SMS_PASSWORD": "e a senha temporária é",
      "AUTHENTICATION_CODE": "Seu código de autenticação é",
      "PASSWORD_RESET_CODE": "Seu código de redefinição de senha da Quantified",
      "RESET_PASSWORD_EMAIL": "E-mail para redefinir a senha",
      "HELLO": "Olá",
      "USE_VERIFICATION_CODE": "Você solicitou uma redefinição de senha. Use o código de verificação abaixo para concluir o processo.",
      "VERIFICATION_CODE": "Código de verificação",
      "NEXT_STEP": "Próximas etapas",
      "RESET_PASSWORD_PAGE": "Volte à página de redefinição de senha no seu navegador.",
      "ENTER_VERIFICATION_CODE": "Digite o código de verificação quando solicitado.",
      "CREATE_PASSWORD": "Depois que o código for verificado, siga as instruções para criar uma nova senha.",
      "DISREGARD_NOTE": "Se você não solicitou a redefinição de senha, desconsidere este e-mail.",
      "CONTACT_SUPPORT": "Para receber mais ajuda, entre em contato com nossa equipe de suporte em",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Obrigado",
      "QUANTIFIED_TEAM": "A equipe da Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos"
    },
    "call": {
      "LOADING": "Carregando",
      "SIMULATION_PAUSED": "A simulação foi pausada.",
      "CLICK_RESUME": "Clique no botão \"Retomar\" abaixo para continuar.",
      "NO_INTERNET": "Sem conexão com a internet",
      "TRY_AGAIN": "Verifique sua conexão e tente novamente.",
      "MIC_MUTED": "O microfone está mudo",
      "MIC_MUTED_DESCRIPTION": "Ops, parece que seu microfone está mudo. Reative o som para responder e continuar.",
      "NO_RESPONSE": "Nenhuma resposta detectada",
      "MIC_NOT_CONNECTED": "Ops, parece que seu microfone não está conectado. Selecione novamente seu dispositivo para responder e continuar.",
      "AUDIO_ISSUE": "Ops, algo deu errado. Verifique as configurações do dispositivo e certifique-se de estar em um local silencioso e sem ruídos de fundo.",
      "LOADING_ALT": "Carregando...",
      "REPEAT_RESPONSE": "Você retornará automaticamente à simulação para repetir sua resposta e tentar novamente.",
      "NEEDS_MORE_TIME_QUESTION": "precisa de mais tempo para pensar. Você quer esperar?",
      "NEEDS_MORE_TIME": "precisa de mais tempo para pensar.",
      "WAIT_OR_END_CALL": "Nós avisaremos você quando o participante estiver pronto, ou você pode encerrar a chamada e",
      "RETURN_TO_ASSIGNMENTS": "Retornar à tarefa",
      "READY": "Pronto",
      "IS_READY": "já está disponível para continuar sua conversa.",
      "TRY_AGAIN_LABEL": "Tentar novamente",
      "CHECK_SETTINGS": "Verificar configurações",
      "PAUSED_SIMULATION": "Você pausou a simulação.",
      "PAUSED_SIMULATION_DESCRIPTION": "A gravação de vídeo e áudio fica pausada até que a simulação seja retomada.",
      "RESUME": "Retomar",
      "SETTINGS": "Configurações",
      "CAPTURING_RESPONSE": "Capturando suas respostas",
      "TOUR_MESSAGE": "Quando terminar de falar, não se esqueça de clicar no botão Continuar para garantir que suas respostas sejam capturadas e pontuadas.",
      "NEXT": "Avançar",
      "START_CALL": "Início",
      "END_CALL_TITLE": "Deseja mesmo encerrar esta simulação?",
      "END_CALL_DESCRIPTION": "Se você encerrar a simulação agora, não receberá pontuação nem feedback sobre sua conversa.",
      "END_CALL": "Fim",
      "BROWSER_ACCESS_DENIED": "Seu navegador não tem acesso a esse dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID da sessão",
      "TIPS_GUIDANCE_MESSAGE": "Pontos de discussão e dicas aparecerão aqui.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Dicas e sugestões",
      "HINT_LABEL": "Dica",
      "CAPTIONS_LABEL": "Legendas",
      "PAUSE_LABEL": "Pausar",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de festa",
      "CALL_ENDED_MESSAGE": "Você chegou ao final da simulação.",
      "CALL_ENDED_INACTIVITY": "Esta simulação foi encerrada devido à inatividade",
      "CALL_ENDED_GENERIC": "Esta simulação foi encerrada",
      "FEEDBACK_PROMPT": "Deixe um feedback enquanto processamos seus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "Você não atingiu nosso limite de interação para pontuação. Tente novamente.",
      "REALISTIC_CONVERSATION_QUESTION": "Essa conversa pareceu realista e natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Você se sente mais bem informado e preparado depois desta simulação?",
      "FEEDBACK_THANK_YOU": "Agradecemos o feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o feedback! Vamos trabalhar para melhorar a experiência.",
      "AUDIO": "Áudio",
      "VISUAL_AID_LOAD_ERROR": "Não foi possível carregar o auxílio visual",
      "BEGIN_CALL": "Início",
      "LEAVE_CALL_BRIEFING": "Sair da preparação",
      "RESTORE_CALL": "Restaurando sua simulação",
      "FEW_SECONDS": "Isso pode levar alguns segundos.",
      "CHECK_ALT": "Marca de verificação",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Dicas",
      "CLOSE_CAPTIONS": "Fechar legendas",
      "MICROPHONE_MUTED": "Microfone mudo",
      "RETURN_TO_CALL": "Retornar à simulação",
      "YES": "Sim",
      "NO": "Não",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Retornar à tarefa",
      "HAVING_ISSUES": "Estamos com problemas de conexão. Verifique sua conexão com a internet e clique em OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Desculpe, não foi possível gerar resultados no momento. Tente novamente.",
      "INACTIVITY_ALERT_MESSAGE": "Esta chamada está sendo encerrada devido à inatividade. Fale com o avatar para continuar ou selecione \"Encerrar chamada\" para encerrar a chamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta chamada será encerrada em {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta chamada será encerrada em alguns segundos",
      "TELL_YOUR_GENDER_HEADING": "Informe seu gênero:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Ao saber seu gênero, o avatar pode usar a gramática adequada, tornando a conversa mais natural e realista.",
      "GENDER_SELECTION": "Seleção de gênero:",
      "SELECT_OPTION": "Selecione uma opção",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Feminino",
      "NON_BINARY": "Não binário/outros",
      "PREFER_NOT_TO_ANSWER": "Prefiro não responder",
      "NON_BINARY_MESSAGE": "Entendemos e respeitamos sua identidade de gênero não binária. Devido às limitações tecnológicas atuais, o padrão é usar pronomes masculinos. Saiba que estamos trabalhando em melhorias para acomodar melhor todas as identidades de gênero no futuro. Agradecemos sua compreensão e paciência.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respeitamos sua opção de não fornecer um gênero. Nesses casos, nossa tecnologia tem como padrão o uso de pronomes masculinos devido às limitações atuais.",
      "DISPLAY_VISUAL_AID": "Exibir auxílio visual",
      "FULL_SCREEN": "Tela cheia",
      "COLLAPSE": "Recolher",
      "COMPLETED_CONVERSATION_MESSAGE": "Obrigado por concluir esta conversa",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deixe um feedback enquanto processamos sua conversa.",
      "ERROR_MESSAGE": "Ocorreu um erro. Entre em contato com",
      "SAVED_CONVERSATION_MESSAGE": "Sua conversa foi salva.",
      "RETURN_TO_MY_ASSIGNMENTS": "Voltar às minhas tarefas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retornar à prática personalizada",
      "PERSONALIZED_CALL_NOTE": "Você acaba de concluir uma conversa de prática personalizada.",
      "LEAVE_STEP_TITLE": "Deseja mesmo sair desta etapa?",
      "EXIT": "Sair"
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "PONTUAÇÃO",
      "MUST_ACHIEVE": "Deve atingir",
      "OR_HIGHER": "ou mais",
      "TEST": "Teste",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "TENTATIVA MAIS RECENTE",
      "TOTAL_ATTEMPTS": "total de tentativas",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "MAX_ATTEMPTS_REACHED": "Você atingiu o número máximo de tentativas",
      "DUE_DATE": "Prazo",
      "DAYS": "Dias",
      "DAY": "Dia",
      "UNTILL_DUE": "Até o prazo",
      "PAST_DUE": "Vencido",
      "ONGOING": "Em andamento",
      "SCORE_REQUIREMENT": "Requisito de pontuação",
      "SCORE_REQUIREMENT_DETAIL": "Você deve conseguir uma pontuação de",
      "TO_COMPLETE_EACH_CALL": "para concluir cada simulação necessária.",
      "CALLS_IN_ASSIGNMENT": "Simulações na tarefa",
      "INCOMPLETE_CALL": "Incompletas",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Data",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver feedback",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botão Fechar",
      "CHECKMARK": "marca de verificação",
      "CALL": "Chamada",
      "QUESTION": "Pergunta",
      "COMPLETED": "Concluída",
      "IN_PROGRESS": "Em andamento",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificada",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Verificação de conhecimento",
      "CONVERSATIONAL_SIMULATION": "Simulação de papéis",
      "NO_ATTEMPTS_LEFT": "Nenhuma tentativa restante",
      "NO_ATTEMPTS": "Nenhuma tentativa",
      "OVERVIEW": "Visão geral",
      "ABOUT_THE_AVATAR": "Sobre o avatar",
      "SCORING_CRITERIA": "Critérios de pontuação",
      "SIMULATION_OVERVIEW": "Visão geral da simulação",
      "ABOUT_THE_PERSONA": "Sobre a persona",
      "OUTOF_COMPLIANCE": "Fora de conformidade",
      "CLOSED": "Fechada"
    }
  },
  "it": {
    "root": {
      "ADMIN_PORTAL": "PORTALE AMMINISTRATIVO",
      "SUPPORT": "ASSISTENZA",
      "U": "U",
      "USER": "Utente",
      "LOGOUT": "Esci",
      "ADMIN": "Amministratore",
      "SUPPORT_SMALL": "Assistenza",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONO",
      "CAMERA": "TELECAMERA",
      "ACCESS_DENIED": "ACCESSO_NEGATO"
    },
    "teams": {
      "MY_TEAMS": "I miei team",
      "COMPLETED": "Completato",
      "IN_PROGRESS": "In corso",
      "NOT_STARTED": "Non iniziato",
      "ASSIGNMET_MODULE": "Modulo incarico",
      "START_DATE": "Data di inizio",
      "DUE_DATE": "Data di scadenza",
      "ASSIGNED_MEMBERS": "Membri con incarichi",
      "CALLS_IN_MODULE": "Simulazioni nel modulo",
      "COMPLETION_REQUIRMENT": "Requisito di completamento",
      "COMPLETE_ALL_CALLS": "Completa tutte le simulazioni con un punteggio di",
      "OR_HIGHER": "o superiore",
      "PROGRESS_OVERVIEW": "PANORAMICA DEI PROGRESSI",
      "TEAM_MEMBERS": "membri del team",
      "AVERAGE_HIGH_SCORE": "Punteggio medio alto",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Numero medio di tentativi per simulazione",
      "TOTAL_PRACTICES": "Totale esercitazioni",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DELLA SIMULAZIONE INDIVIDUALE",
      "OF_TEAM_MEMBERS": "dei membri del team completate",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Media esercitazioni da completare",
      "TEAM_MEMBER_DETAILS": "DETTAGLI DEI MEMBRI DEL TEAM",
      "DOWNLOAD_ACTIVITY_REPORT": "Scarica il report attività",
      "TEAM_MEMBER": "Membro del team",
      "PROGRESS": "Avanzamento",
      "CALLS_COMPLETED": "Simulazioni completate",
      "PRACTICES": "Sessioni di esercitazione",
      "MOST_RECENT_PRACTICE": "Sessione più recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Questo team non ha incarichi attivi al momento",
      "CALL_NAME_LABEL": "Nome simulazione",
      "HIGHEST_SCORE": "Punteggio più alto"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assicurati che il dispositivo sia configurato.",
      "MICROPHONE_REQUIRED_NOTICE": "È necessario un microfono funzionante.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se non hai visualizzato un pop-up di richiesta di abilitazione dei dispositivi dopo l'aggiornamento di questa pagina, accedi alle impostazioni del sistema o del browser e abilita i dispositivi. Di seguito sono riportate le pagine di supporto con ulteriori istruzioni.",
      "ENABLE_CAMERA": "Come attivare la fotocamera:",
      "WINDOWS_USERS": "Utenti Windows",
      "MAC_USERS": "Utenti Mac",
      "IPAD_USERS": "Utenti iPad",
      "ENABLE_MICROPHONE": "Come attivare il microfono:",
      "ENABLE_DEVICES_BY_BROWSER": "Come abilitare i dispositivi in base al browser:",
      "CHROME_USERS": "Utenti di Chrome",
      "SAFARI_USERS": "Utenti di Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Bordo",
      "START_WITHOUT_CAMERA_BUTTON": "Avvio senza telecamera",
      "START_CALL_BUTTON": "Avvia chiamata",
      "MICROPHONE_REQUIRED_WARNING": "È necessario un microfono funzionante.",
      "MICROPHONE_ALT": "microfono",
      "MICROPHONE": "Microfono",
      "SELECT_MICROPHONE": "Seleziona il microfono",
      "ALERT": "avviso",
      "GIVE_PERMISSION": "Dai il permesso",
      "SELECT_VIDEO_DEVICE": "Seleziona il dispositivo video",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Sembra che tu abbia negato a questo browser l'accesso a uno o più dispositivi. Per abilitare i dispositivi, accedi alle impostazioni del sistema o del browser e abilita l'accesso.",
      "DEVICE_SETTINGS": "Impostazioni del dispositivo",
      "CONFIRM_SETTINGS": "Conferma impostazioni",
      "LAPTOP": "Computer portatile",
      "SAD_EMOTE_FACE": "Faccina emoji triste",
      "GRANT_BROWSER_ACCESS": "Per completare questa simulazione, concedi al browser l'accesso al riconoscimento vocale",
      "USING_IPAD": "Se utilizzi un iPad, vai su",
      "SETTINGS": "Impostazioni",
      "PRIVACY_AND_SECURITY": "Privacy e sicurezza",
      "SPEECH_RECOGNITION": "Riconoscimento vocale",
      "GRANT_ACCESS_REFRESH": "Consenti l'accesso al browser e aggiorna la pagina",
      "REFRESH_PAGE": "AGGIORNA LA PAGINA",
      "BROWSER_UNABLE_TO_ACCESS": "Il browser non è in grado di accedere a questo dispositivo",
      "ACCESS_DENIED": "accesso negato",
      "CAMERA": "Telecamera",
      "DIAGNOSTIC_PASSED": "Tutti i test diagnostici sono stati superati con successo.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alcuni test diagnostici non sono stati superati. Clicca sul pulsante \"Copia risultati diagnostici\" sopra e invia i risultati al team di supporto per assistenza.",
      "DIAGNOSTIC_PARTIAL": "La maggior parte dei test diagnostici è stata superata con successo. La tua connessione sembra buona.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Attendi mentre i test diagnostici sono in esecuzione...",
      "DIAGNOSTIC_RUNNING": "Diagnostica in esecuzione",
      "COPY_DIAGNOSTIC_RESULTS": "Copia risultati diagnostici",
      "RUN_DIAGNOSTIC": "Esegui diagnostica",
      "RERUN_DIAGNOSTIC": "Ripeti diagnostica",
      "DIAGNOSTIC_RESULTS_COPIED": "Risultati diagnostici copiati negli appunti",
      "DIAGNOSTIC_FAILED": "Diagnostica non riuscita",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostica Quantified",
      "DIAGNOSTIC_TIME": "Volta",
      "DIAGNOSTIC_SUMMARY": "Riepilogo",
      "DIAGNOSTIC_CLIENT_INFO": "Informazioni client",
      "DIAGNOSTIC_PLATFORM": "Piattaforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perdita di pacchetti (invio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Bitrate medio di invio",
      "DIAGNOSTIC_NA": "N/D"
    },
    "results": {
      "RETURN_HOME": "TORNA ALLA HOME",
      "CLOSE_BUTTON": "Pulsante di chiusura",
      "CONVERSATIONAL_CALL": "GIOCO DI RUOLO",
      "INFORMATION_ICON": "Icona informazioni",
      "TOOLTIP_ARROW": "Freccia suggerimento",
      "INFORMATION_TOOLTIP_CONTENT": "Sei tu a controllare l'andamento della simulazione, guidando la conversazione verso una serie di obiettivi. I giochi di ruolo sono ottimi per testare le competenze di approfondimento e formulazione di domande di secondo livello, individuazione di punti dolenti e sviluppo di un rapporto.",
      "CLOCK_ICON": "Icona orologio",
      "CALL_RESULTS": "Risultati",
      "SKILLS": "Competenze",
      "MESSAGE_ADHERENCE": "Rispetto del messaggio",
      "TRY_AGAIN_MESSAGE": "Riprova e migliora il tuo punteggio.",
      "PRACTICE_BENEFITS": "Esercitarsi settimanalmente aumenta la fiducia e migliora i risultati nel mondo reale.",
      "CALL_SUCCESS": "Ottimo lavoro! Hai completato la simulazione con successo.",
      "MAX_ATTEMPTS_REACHED": "Hai raggiunto il numero massimo di tentativi",
      "TRY_AGAIN": "Riprova",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Ottimo lavoro! Hai completato",
      "COMPLETED_THIS_CALL": "questa simulazione con successo.",
      "ACHIEVED_SCORE": "Hai raggiunto un punteggio di",
      "ACHIEVE_SCORE": "Raggiungi un punteggio di",
      "OR_HIGHER": "o superiore.",
      "OBJECTIVES_NOT_MET": "Non hai raggiunto tutti gli obiettivi richiesti.",
      "TRY_AGAIN_TARGET_SCORE": "Riprova a raggiungi un punteggio di",
      "YOUR_SCORE": "Il tuo punteggio",
      "OUT_OF_5": "SU 5",
      "CALL_FEEDBACK": "RIEPILOGO DEL FEEDBACK",
      "STRENGTH_ICON_ALT": "Icona forza",
      "OPPORTUNITIES_ICON_ALT": "Icona opportunità",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SULLA METODOLOGIA",
      "SESSION_ID": "ID sessione:",
      "SESSION_ID_COPIED": "ID sessione copiato!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "Il tuo risultato:",
      "LIGHTBULB_ICON_ALT": "Icona lampadina",
      "WHAT_WE_SUGGEST": "Cosa suggeriamo:",
      "NO_SPECIFIC_RECOMMENDATION": "Il nostro sistema non è riuscito a trovare un suggerimento specifico per te.",
      "WHY": "Perché?",
      "NO_INSIGHTS_AVAILABLE": "Il nostro sistema non è stato in grado di fornire indicazioni su questo suggerimento.",
      "CONFETTI_ICON_ALT": "Icona coriandoli",
      "OBJECTIVE_SUCCESS_MESSAGE": "Hai ottenuto ottimi risultati per questa metodologia, continua così!",
      "PROCESSING_CALL": "Stiamo preparando il tuo punteggio e il tuo feedback.",
      "HANG_TIGHT": "Rimani in attesa o riprova più tardi a",
      "VIEW_YOUR_RESULTS": "visualizzare i risultati.",
      "NEED_MORE_TIME": "Abbiamo bisogno di più tempo per calcolare i risultati.",
      "REFRESH_INSTRUCTION": "Ricontrolla o aggiorna i risultati",
      "RESULTS_IN_FEW_MINUTES": "dell'incarico tra qualche minuto.",
      "SCORE_CALCULATION_QUESTION": "Come viene calcolato?",
      "SINGLE_SCORE_EXPLANATION": "Questa simulazione ha un solo componente di punteggio, quindi il punteggio visualizzato rappresenta sia quello della singola sezione sia quello complessivo.",
      "OVERALL_SCORE_PERCENT": "% del punteggio complessivo",
      "SECTION_SCORE": "Punteggio della sezione",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Migliora il rispetto dei messaggi conversazionali",
      "MESSAGE_ADHERENCE_NOTE": "Il rispetto del messaggio è fondamentale per condurre conversazioni di successo, ma non influisce sul punteggio complessivo.",
      "NO_CREDIT": "Nessun credito",
      "PARTIAL_CREDIT": "Credito parziale",
      "FULL_CREDIT": "Credito pieno",
      "WHAT_YOU_DID_WELL": "Aspetti svolti con successo",
      "MISSED_ALL_KEY_POINTS": "Non hai capito tutti i punti chiave; rivedili e riprova.",
      "WHAT_TO_IMPROVE": "Aspetti da migliorare",
      "PERFECT_SCORE_MESSAGE": "Congratulazioni! Hai ottenuto un punteggio perfetto, rispondendo correttamente a tutti i punti chiave.",
      "POINTS_LABEL": "Punti",
      "TALKING_POINTS_COVERED": "Punti di discussione trattati",
      "CHECKMARK_ICON_ALT": "segno di spunta",
      "TALKING_POINTS_MISSED": "Punti di discussione non trattati",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Esercitati di nuovo",
      "OUT_OF": "di",
      "POSSIBLE_TALKING_POINTS": "possibili punti di discussione",
      "YOU_COVERED": "Hai trattato",
      "THROUGHOUT_CALL": "durante la simulazione.",
      "POSITIVE_FEEDBACK_COVERAGE": "Hai svolto un ottimo lavoro evidenziando i punti chiave nel corso della chiamata e hai trattato",
      "MIXED_FEEDBACK_COVERAGE": "Non hai affrontato alcuni dei punti chiave della simulazione e hai trattato",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Migliora la tua metodologia di conversazione",
      "OBJECTIVES_NOTE": "La metodologia è fondamentale per condurre conversazioni di successo, ma non influisce sul punteggio complessivo.",
      "UNTIL": "fino al",
      "TO_IMPROVE_SCORE": "per migliorare il tuo punteggio.",
      "TO_SCORE": "per ottenere",
      "BEFORE": "prima",
      "YOU_HAVE": "Hai",
      "MORE_ATTEMPTS": "ulteriori tentativi per ottenere un punteggio di",
      "OR_HIGHER_BEFORE": "o superiore prima del",
      "AND_TRY_AGAIN": "e riprova.",
      "UNEXPECTED_STATE": "Si è verificato uno stato inatteso.",
      "REVIEW_APP_LOGIC": "Rivedi la logica dell'applicazione.",
      "ASSIGNMENTS": "Incarichi",
      "VIEW_CALL_DETAILS": "Visualizza dettagli chiamata",
      "PRACTICE_SESSION": "Sessione di esercitazione",
      "OVERALL_SCORE": "Punteggio complessivo",
      "OVERALL_SCORE_EXPLANATION": "Il punteggio complessivo viene calcolato facendo la media ponderata dei punteggi di ciascuna sezione. Il peso di ciascuna sezione viene visualizzato in percentuale accanto al punteggio.",
      "SCORE_CONFIG_NOTE": "Le percentuali di peso, nonché l'inclusione e l'esclusione delle sezioni sono stabilite dalla tua azienda. Tutti i punteggi sono arrotondati al decimo di punto più vicino.",
      "STRENGTHS": "Punti di forza",
      "OPPORTUNITIES": "Opportunità",
      "YOUR_RESPONSE": "La tua risposta",
      "MINUS": "meno",
      "PLUS": "più",
      "RECOMMENDED_RESPONSE": "Risposta suggerita",
      "REVIEW_MISSED_TITLE": "Rivedi gli aspetti che ti sono sfuggiti.",
      "NO_TALKING_POINTS_COVERED": "Non hai trattato nessuno dei punti di discussione richiesti per questo argomento.",
      "LEARN_WHAT_YOU_MISSED": "Scopri gli aspetti che ti sono sfuggiti",
      "NICE_JOB": "Bel lavoro!",
      "ALL_POINTS_COVERED": "Hai trattato con successo tutti i punti di discussione richiesti per questo argomento.",
      "COVER_ALL_MESSAGES": "Tratta tutti i messaggi chiave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Evidenziare i punti chiave nel corso della telefonata aiuterà a mantenere la conversazione focalizzata sull'obiettivo.",
      "MESSAGES_LABEL": "Messaggi",
      "NO_FACTS_COVERED": "Ops! Sembra che tu non abbia affrontato nessuno degli argomenti di questo messaggio.",
      "NO_SPECIFICS_AVAILABLE": "Ops! Sembra che non siamo riusciti a fornire informazioni specifiche su ciò che ti è sfuggito.",
      "ALL_KEY_POINTS_COVERED": "Ottimo lavoro! Hai trattato tutti i punti chiave.",
      "PROCESSING_SKILLS_FEEDBACK": "Stiamo elaborando il feedback sulle tue competenze.",
      "SKILLS_SCORING_NOT_ENABLED": "Siamo spiacenti, ma non abbiamo potuto analizzare la tua chiamata recente perché il punteggio delle competenze non era abilitato al momento dell'invio. Per ottenere un riscontro, è sufficiente ripresentare l'esercitazione di chiamata come fatto in precedenza. Se hai bisogno di aiuto, non esitare a contattare il nostro team di assistenza. Grazie per la comprensione e per il tuo impegno a migliorare!",
      "ELEVATE_CONVERSATION_SKILLS": "Migliora le tue competenze di conversazione",
      "SKILLS_NOTE": "Le competenze sono fondamentali per condurre conversazioni di successo, ma non influiscono sul punteggio complessivo.",
      "SKILLS_SUMMARY_TITLE": "SINTESI DELLE COMPETENZE",
      "LEARN_MORE_ABOUT_SKILLS": "Per saperne di più sulle competenze",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "Cosa sono le competenze",
      "SKILLS_DESCRIPTION": "Le competenze sono calibrate per supportare lo sviluppo della crescita personale. Anche se queste competenze non fanno parte della valutazione numerica della chiamata, sono state selezionate dalla tua organizzazione per migliorare la tua efficacia.",
      "PROFICIENCY_SCALE_TITLE": "SCALA DI COMPETENZA",
      "EXPERT": "Esperto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "In crescita",
      "CALL_TRANSCRIPT": "Trascrizione della chiamata",
      "COLLAPSE_ALL": "Chiudi tutto",
      "EXPAND_ALL": "Espandi tutto",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 punti",
      "TALKING_POINTS": "punti di discussione",
      "TRANSCRIPT_LABEL": "Trascrizione",
      "YOU_ARE_OUT_OF_ATTEMPTS": "I tentativi sono finiti.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Rivedi le linee guida e rimani conforme in futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Riprova e presta attenzione alle linee guida di conformità.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Abbiamo notato che non eri conforme, quindi non hai ricevuto un punteggio.",
      "WHY_OUT_OF_COMPLIANCE": "Perché non eri conforme",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Rivedi la tua trascrizione per capire in che momento non hai rispettato le linee guida per la conformità.",
      "YOU_DID_FOLLOW_GUIDELINES": "Hai effettivamente seguito queste linee guida.",
      "REVIEW_MISSED_GUIDELINES": "Rivedi le linee guida sulla conformità mancante.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcolo del punteggio",
      "PROCESSING_TRANSCRIPT": "Stiamo elaborando la tua trascrizione.",
      "WAIT_OR_REVIEW_SCORES": "Aspetta qui o rivedi le altre sezioni",
      "TRANSCRIPT_LOADING": "del punteggio mentre la trascrizione viene caricata.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Esamina il feedback e continua a esercitarti",
      "HIGH_PERFORMERS_PRACTICE": "Gli artisti di alto livello si esercitano almeno una volta alla settimana",
      "SUCCESSFULLY_PASSED": "Ottimo lavoro! La simulazione è stata superata con successo.",
      "DIDNT_REACH_PASSING_SCORE": "Non hai raggiunto il punteggio minimo per questa simulazione.",
      "OUT_OF_ATTEMPTS": "<b>Hai terminato i tentativi.</b> Esamina il feedback per scoprire come puoi migliorare.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Esamina il feedback, quindi torna alla home.",
      "GREAT_JOB_PRACTICED": "Ottimo lavoro, hai svolto l'esercitazione {{count}} {{times}}. Continua così!",
      "TIME": "volta",
      "TIMES": "volte",
      "COMPLIANCE_GUIDELINES": "Linee guida per la conformità",
      "TALKING_POINT_TITLE": "PUNTI DI DISCUSSIONE NON AFFRONTATI O TRATTATI NEL MOMENTO SBAGLIATO",
      "NO_TRANSCRIPT": "La trascrizione non è disponibile."
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Caricamento account in corso...",
      "SELECT_AN_ACCOUNT": "Seleziona un account",
      "SEARCH_TEAMS": "Cerca team",
      "LOADING_TEAMS": "Caricamento team in corso...",
      "ALL_TEAMS": "Tutti i team",
      "ACCOUNT": "Account",
      "TEAMS": "Team",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Totale",
      "PASSING_SCORE": "Punteggio minimo per il superamento",
      "ASSIGNMENT_LABEL": "Incarichi",
      "USER_LABEL": "Utenti",
      "PRACTICE_LABEL": "Esercitazione",
      "CERTIFICATION_LABEL": "Certificazione",
      "RESULTS_DESCRIPTION": "Ecco i risultati del tuo (o dei tuoi) team in tutti gli incarichi di esercitazione:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Impegno per incarico",
      "ASSIGNMENT_ENGAGEMENT": "Impegno per gli incarichi",
      "ENGAGED_LABEL": "Impegno in corso",
      "ENGAGEMENT_STATUS_LABEL": "Stato dell'impegno",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nome dell'incarico",
      "ACTIVE_USERS": "Utenti attivi",
      "ASSIGNMENT_PROGRESS": "Progresso per incarico",
      "IN_PROGRESS_LABEL": "In corso",
      "CERTIFIED_LABEL": "Certificato",
      "OUT_OF_ATTEMPTS_LABEL": "Tentativi esauriti",
      "USERS_ENGAGED_LABEL": "Utenti con impegni in corso",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessioni per utente attivo",
      "HIGHER_THAN_LABEL": "Superiore a",
      "MORE_THAN_LABEL": "Più di",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Totale sessioni completate",
      "USER_CERTIFIED": "Utenti certificati su tutti gli incarichi",
      "ASSIGNMENT_CERTIFICATION": "Incarichi con certificazione al 100%",
      "TRAINER_TIME_SAVED": "Tempo risparmiato dagli istruttori",
      "HOURS_LABEL": "ore",
      "PRACTICE_ASSIGNMENT_LABEL": "Incarichi di esercitazione",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Incarichi di certificazione",
      "START_DATE_LABEL": "Data di inizio",
      "END_DATE_LABEL": "Data di fine",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "Email",
      "MEMBER_OF_TEAMS_LABEL": "Membro dei team",
      "ASSIGNMENTS_COUNT_LABEL": "N. di incarichi",
      "TOTAL_SESSIONS_LABEL": "Totale sessioni",
      "NUMBER_OF_SESSIONS_LABEL": "Numero di sessioni",
      "TOTAL_USERS_LABEL": "Utenti totali",
      "AVERAGE_SCORE_LABEL": "Punteggio medio",
      "INITIAL_SCORE_LABEL": "Punteggio iniziale",
      "HIGH_SCORE_LABEL": "Punteggio elevato",
      "LAST_PRACTICE_DATE_LABEL": "Data dell'ultima esercitazione",
      "PERCENT_IMPROVED_LABEL": "% di miglioramento",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Questa metrica analizza i punteggi di ogni sessione e traccia una linea retta su un grafico per illustrare la tendenza. Una percentuale più alta indica che i punteggi stanno migliorando più velocemente, mentre una percentuale più bassa indica che i punteggi stanno migliorando più lentamente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Incarichi certificati",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Incarichi con punteggio Competente",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Il numero di incarichi in cui l'utente ha soddisfatto o superato i criteri di valutazione per tutte le simulazioni dell'incarico.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Il numero di incarichi in cui l'utente ha soddisfatto o superato almeno una volta i criteri di valutazione in tutte le simulazioni dell'incarico.",
      "PROFICIENT_TOOLTIP": "La percentuale di utenti in questo incarico che hanno soddisfatto o superato almeno una volta i criteri di valutazione in tutte le simulazioni dell'incarico.",
      "IN_PROGRESS_TOOLTIP": "La percentuale di utenti che hanno completato almeno una sessione di simulazione in questo incarico e hanno ricevuto un punteggio.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "La percentuale di utenti che hanno superato i tentativi assegnati per una o più simulazioni nell'incarico.",
      "CERTIFIED_TOOLTIP": "La percentuale di utenti che hanno soddisfatto o superato i criteri di valutazione per tutte le simulazioni dell'incarico.",
      "SEARCH_FOR_A_USER_LABEL": "Ricerca di un utente",
      "NO_USERS_FOUND_LABEL": "Nessun utente trovato",
      "TRAINER_TIME_SAVED_TOOLTIP": "La quantità di tempo che gli utenti hanno trascorso in Quantified completando i tentativi di certificazione.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sessioni medie per incarico",
      "ASSIGNMENTS_ENGAGED_WITH": "Incarichi a cui ha partecipato",
      "AVERAGE_IMPROVEMENT": "Miglioramento medio",
      "STATUS": "Stato",
      "TOTAL_NUMBER_OF_SESSIONS": "Numero totale di sessioni",
      "DATE_OF_LAST_PRACTICE": "Data dell'ultima esercitazione",
      "CALL_NAME": "Nome della chiamata",
      "SESSION_DATE": "Data sessione",
      "DURATION_OF_SESSION": "Durata sessione",
      "OVERALL_SCORE": "Punteggio complessivo",
      "MESSAGING_SCORE": "Punteggio rispetto del messaggio",
      "METHODOLOGY_SCORE": "Punteggio metodologia",
      "SKILLS_SCORE": "Punteggio competenze",
      "SESSIONS": "Sessioni",
      "TOTAL": "Totale",
      "ALL_ASSIGNMENTS": "Tutti gli incarichi",
      "RECENT_ASSIGNMENTS": "Incarichi recenti",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Sessioni medie per utente attivo",
      "HOURS_IN_SIMULATIONS": "Ore in simulazioni",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Sessioni medie al conseguimento della competenza",
      "PERCENT_PROFICIENT": "Percentuale di competenti",
      "SYSTEM_RUNNING_NORMALLY": "Il sistema sta funzionando normalmente",
      "PRACTICE_SIMULATIONS_LABEL": "Simulazioni",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nessun risultato corrisponde ai filtri impostati. Prova a deselezionare uno o più filtri per ampliare la ricerca.",
      "USERS_PASSED": "Utenti che hanno superato la simulazione",
      "AVERAGE_TIME": "Tempo medio impiegato per ottenere la certificazione",
      "USERS_OUT_OF_ATTEMPTS": "Utenti senza tentativi",
      "NO_CERTIFICATION_SIMULATION": "Nessuna simulazione di certificazione trovata",
      "SIMULATION": "Simulazione",
      "No_SIMULATION": "Nessuna sessione",
      "PERCENT_CERTIFIED": "Percentuale certificata",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentuale certificata al primo tentativo",
      "USERS": "Utenti",
      "ATTEMPTS_LABEL": "Tentativi",
      "NO_ATTEMPTS": "Nessun tentativo",
      "DATE_OF_SESSION": "Data della sessione",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nessun incarico corrisponde ai filtri scelti",
      "NO_TEAMS_DATA": "Non sono presenti team in questo account",
      "SIMULATION_NAME": "Nome simulazione",
      "AVERAGE_DURATION_OF_SESSION": "Durata media della sessione",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Numero medio di sessioni per utente attivo",
      "AVERAGE_OVERALL_SCORE": "Punteggio complessivo medio",
      "TOTAL_ASSIGNMENTS": "Totale incarichi",
      "ASSIGNMENTS_CERTIFIED": "Incarichi certificati",
      "TOTAL_SESSIONS": "Totale sessioni",
      "HOURS_SPENT_PRACTICING": "Ore dedicate alle esercitazioni",
      "LAST_LOGIN": "Ultimo accesso",
      "SELECT_ASSIGNMENTS": "Seleziona incarichi",
      "CERTIFICATION_STATUS_LABEL": "Stato della certificazione",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Stato della certificazione:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificazione ottenuta al primo tentativo?",
      "DATE_OF_CERTIFICATION_LABEL": "Data della certificazione",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Stato dell'impegno:",
      "DURATION_OF_ATTEMPT": "Durata tentativo",
      "USER_NAME": "Nome utente",
      "LEARNER": "Studente",
      "DATE_RANGE": "Intervallo di date",
      "DATE_RANGE_LABEL": "Intervallo di date",
      "SEARCH_USERS": "Cerca utenti...",
      "SEARCH_SIMULATIONS": "Cerca simulazioni...",
      "SEARCH_DATES": "Cerca date...",
      "CERTIFIED_ON_FIRST_TRY": "Certificazione ottenuta al primo tentativo",
      "DATE_OF_CERTIFICATION": "Data della certificazione",
      "AVERAGE_CERTIFICATION_SCORE": "Punteggio medio di certificazione",
      "TOTAL_TIME_CERTIFYING": "Tempo totale impiegato per ottenere la certificazione",
      "OF_THE_TIME": "del tempo",
      "ASSIGNED_LABEL": "Non iniziato",
      "USERS_ASSIGNED_LABEL": "Totale utenti con incarichi",
      "SESSION_ID": "ID sessione",
      "NO_SIMULATIONS_FOUND_LABEL": "Nessuna simulazione trovata",
      "USER_NAME_LABEL": "Nome utente",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "di",
      "SECOND": "secondo",
      "SECONDS": "secondi",
      "MINUTE": "minuto",
      "MINUTES": "minuti",
      "ASSIGNED": "Assegnato",
      "ENGAGED_TOOLTIP": "La percentuale di utenti che hanno completato una o più sessioni di una simulazione in questo incarico, ma non hanno ancora raggiunto la competenza richiesta in tutte le simulazioni.",
      "SEARCH_ASSIGNMENTS": "Cerca incarichi...",
      "ASSIGNMENT_NAME_LABEL": "Nome dell'incarico",
      "SIMULATION_NAME_LABEL": "Nome simulazione",
      "START_DATE": "Data di inizio",
      "END_DATE": "Data di fine",
      "NO_ASSIGNMENTS": "Nessun incarico trovato per questo utente.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Totale incarichi di esercitazione",
      "SESSION_SCORES_OVER_TIME": "Punteggi sessioni nel tempo",
      "TIME": "Volta",
      "SCORE": "Punteggio",
      "NO_SESSIONS_AVAILABLE": "Nessuna sessione disponibile da tracciare nel grafico.",
      "MESSAGING_SCORE_LABEL": "Punteggio messaggistica",
      "PERSONALIZED_PRACTICE_LABEL": "Esercitazione personalizzata",
      "ASSIGNMENT_ENAGEMENT": "Impegno per incarico",
      "NO_PRODUCTS": "Nessun prodotto di esercitazione personalizzato per i team selezionati",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo totale dedicato all'esercitazione",
      "AVERAGE_SESSIONS_PER_USER": "Sessioni medie per utente",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selezione del tipo di conversazione più comune",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selezione del tipo di conversazione meno comune",
      "CLEAR_TEAMS": "Cancella i team",
      "METHODOLOGY_SCORE_DESCRIPTION": "Punteggi obiettivo medi in tutte le sessioni di questa chiamata.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Messaggistica",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "La messaggistica misura se gli studenti esprimono 2 idee importanti durante questa simulazione. Queste visualizzazioni mostrano le percentuali di messaggi relativi a un determinato tema espressi dagli utenti, in media, in base a tutte le sessioni di questa chiamata.",
      "NO_METRICS_MESSAGE": "Nessuna sessione completata per i team selezionati.",
      "SELECT_ALL": "Seleziona tutto",
      "DESELECT_ALL": "Deseleziona tutto",
      "SKILLS": "Competenze",
      "SKILLS_SCORE_STATS_DESCRIPTION": "I punteggi delle competenze sono una valutazione dell'IA delle competenze dimostrate dagli utenti durante una chiamata.",
      "EXPERT": "Esperto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "In crescita",
      "FULLY_ARTICULATED": "Completamente espresso",
      "PARTIALLY_ARTICULATED": "Parzialmente espresso",
      "NOT_MENTIONED": "Non menzionato",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "La messaggistica misura se gli Utenti esprimono 3 idee importanti in questa chiamata."
    },
    "reporting": {
      "AT_GLANCE": "Panoramica degli incarichi",
      "OPEN_ASSIGNMENTS": "Incarichi aperti",
      "NOT_STARTED": "Non iniziato",
      "CERTIFIED": "Certificato",
      "VIEW_LIST": "Visualizza elenco",
      "CERTIFICATION_ASSIGNMENTS": "Incarichi di certificazione",
      "CERTIFICATION_SUMMARY_TEXT": "Le certificazioni sono incarichi che hanno una data di scadenza specifica e criteri da superare",
      "PRACTICE_ASSIGNMENTS": "Incarichi di esercitazione",
      "PRACTICE_SUMMARY_TEXT": "Gli incarichi di esercitazione sono disponibili per gli utenti senza una data di scadenza specifica. Sono stati ideati per consentire agli utenti di esercitarsi regolarmente per migliorare le proprie capacità",
      "THE": "Il",
      "WILL_CLOSE": "chiuderà tra",
      "USERS_HAVE": "utenti non hanno",
      "USER_HAS": "utente ha",
      "NOT_STARTED_ASSIGNMENT_DUE": "iniziato un incarico da consegnare entro la prossima settimana",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "completato un incarico da consegnare entro la prossima settimana",
      "DAYS": "giorni",
      "DAY": "giorno",
      "MODULES": "Moduli",
      "MODULE": "Modulo",
      "CALL": "Simulazione",
      "CALLS": "Simulazioni",
      "CERTIFICATION_ASSIGNMENT": "Incarico di certificazione",
      "PRACTICE_ASSIGNMENT": "Incarico di esercitazione",
      "AND": "e",
      "VIEW_ENGAGEMENT_DETAILS": "Visualizza i dettagli dell'impegno",
      "SEE_ALL": "Vedi tutti",
      "SEE_LESS": "Vedi meno",
      "ASSIGNMENT": "Incarico",
      "ASSIGNED": "Assegnato",
      "IN_PROGRESS": "In corso",
      "DUE_DATE": "Data di scadenza",
      "ASSIGNMENT_ENDS_IN": "L'incarico termina tra",
      "ASSIGNMENT_CLOSED": "Incarico chiuso",
      "OLDER_CERTIFICATION": "certificazione meno recente",
      "ASSIGNMENT_IS": "incarico è",
      "ASSIGNMENT_ARE": "incarichi sono",
      "CURRENTLY_HIDDEN": "attualmente nascosto/i",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Vengono mostrati tutti gli incarichi di certificazione.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Utenti che non hanno ancora completato e ricevuto un punteggio per nessuna simulazione.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Utenti che hanno completato almeno una simulazione e ricevuto un punteggio.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Utenti che hanno soddisfatto i requisiti di certificazione.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "È il numero di utenti che possono accedere all'incarico per le loro certificazioni.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Vedi tutti gli incarichi di certificazione",
      "HIDE_OLDER_ASSIGNMENTS": "Nascondi incarichi meno recenti",
      "AVG_PRACTICES": "Media esercitazioni",
      "PRACTICED": "Esercitazione completata",
      "SCORED_HIGH": "Punteggio alto",
      "AVG_ASSIGNMENT": "Media miglioramento",
      "DAYS_AGO": "giorni fa",
      "NA": "N/D",
      "OLDER_PRACTICE": "esercitazione meno recente",
      "SEE_PRACTICE_ASSIGNMENT": "Vedi tutti gli incarichi di esercitazione",
      "ALL_PRACTICE_ASSIGNMENTS": "Vengono mostrati tutti gli incarichi di esercitazione.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Utenti che non hanno ancora completato e ricevuto un punteggio per nessuna simulazione.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Questi utenti hanno terminato almeno una simulazione e ricevuto un punteggio.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Il numero di utenti in questo incarico che hanno ottenuto, almeno una volta su tutte le simulazioni di questo incarico, un punteggio pari o superiore al criterio di punteggio elevato definito.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Questi utenti possono accedere all'incarico per esercitarsi.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Questo numero indica il numero medio di volte in cui gli utenti si sono esercitati nelle simulazioni che fanno parte di questo incarico.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Questa metrica analizza i punteggi di ogni sessione e traccia una linea retta su un grafico per illustrare la tendenza. Una percentuale più alta indica che i punteggi stanno migliorando più velocemente, mentre una percentuale più bassa indica che i punteggi stanno migliorando più lentamente.",
      "USERS": "utenti",
      "USER": "utente",
      "DOWNLOAD_CSV": "Scarica il CSV",
      "ERROR": "Si è verificato un errore",
      "FIRST_NAME": "Nome",
      "LAST_NAME": "Cognome",
      "ATTEMPTS": "Tentativi",
      "EMAIL": "Email",
      "LAST_LOGIN": "Ultimo accesso",
      "ASSIGNMENT_NOT_STARTED": "Incarico non iniziato",
      "ASSIGNMENT_IN_PROGRESS": "Incarico in corso",
      "SCORE_CRITERIA_MET": "Criterio del punteggio soddisfatto",
      "NEVER_LOGGED_IN": "Non è stato effettuato l'accesso",
      "QUANTIFIED_REPORTING": "Report Quantified",
      "ASSIGNED_USERS": "Utenti con incarichi",
      "COMPLETION_REQUIREMENT": "Requisito di completamento",
      "AVG_SCORE_Of": "Media Punteggio di",
      "REPORTING": "Report",
      "CERTIFICATIONS": "Certificazioni",
      "PRACTICES": "Esercitazioni",
      "CALL_ANALYSIS": "Analisi di simulazione",
      "PERCENT_CERTIFIED_ON": "Percentuale certificata su",
      "SHOWING": "Mostra",
      "PRACTICE_SESSIONS": "Sessioni di esercitazione cumulative per tutte le simulazioni nel modulo",
      "AVG_PRACTICE_HEADING": "Numero medio di sessioni di esercitazione per utente attivo",
      "AVG_SCORE_LABEL": "Media Punteggio",
      "AVG_SCORE_HEADING": "Punteggio medio per utente",
      "AVG_PRACTICES_LABEL": "Media Esercitazioni",
      "EXPORT_LEARNER_LIST": "Esporta elenco studenti",
      "PERCENT_NOT_STARTED": "% non iniziata",
      "PERCENT_IN_PROGRESS": "% in corso",
      "PERCENT_CERTIFIED": "% certificata",
      "USER_CERTIFIED": "Utente certificato",
      "USERS_CERTIFIED": "Utenti certificati",
      "TOTAL_ATTEMPTS": "Tentativi totali",
      "Avg_ATTEMPTS_CERTIFY": "Tentativi medi di certificazione",
      "ASTERICK_GROUP": "Indica un gruppo che contiene uno o più sottogruppi",
      "NO_DATA_FOUND": "Nessun dato trovato",
      "MODULE_HIGHLIGHTS": "Punti salienti del modulo",
      "MODULE_HIGHLIGHT_SUMMARY": "Metriche chiave per tutte le chiamate. Per un'analisi dettagliata di ogni simulazione, vedi la panoramica qui sotto",
      "HIGHEST_SCORING_QUESTION_TITLE": "DOMANDA CON IL PUNTEGGIO PIÙ ALTO",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Domanda con il punteggio più alto",
      "QUESTION_BAR_MSG": "% media di risposte corrette",
      "LOWEST_SCORING_QUESTION_TITLE": "DOMANDA CON IL PUNTEGGIO PIÙ BASSO",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Domanda con il punteggio più basso",
      "TOP_SCORED_ANSWER_POINT_TITLE": "PUNTO DI RISPOSTA CON IL PUNTEGGIO PIÙ ALTO",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Domanda sul punto con più risposte corrette",
      "SCORE_BAR_MSG": "delle volte, gli utenti rispondono correttamente.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "PUNTO DI RISPOSTA CON IL PUNTEGGIO PIÙ BASSO",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Domanda sul punto con più risposte errate",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA CON IL PUNTEGGIO PIÙ BASSO",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia con il punteggio più basso",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METODOLOGIA CON IL PUNTEGGIO PIÙ ALTO",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodologia con il punteggio più alto",
      "OBJECTIVE_BAR_MSG": "punti medi su questa metodologia",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MESSAGGIO MENO ESPRESSO",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Messaggio meno espresso",
      "LEAST_ARTICULATED_BAR_MSG": "Esprimi questo messaggio",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MESSAGGIO PIÙ ESPRESSO",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Messaggio più espresso",
      "MOST_ARTICULATED_BAR_MSG": "Esprimi a pieno questo messaggio",
      "Overview": "Panoramica",
      "CONSISTS_Of": "consiste in",
      "CALL_OVERVIEW_LABEL": "Il grafico mostra il numero di utenti che hanno",
      "PASSED": "Passato",
      "ATTEMPTED": "Tentativo eseguito",
      "NOT_ATTEMPTED": "Tentativo non eseguito",
      "GUIDED_CALL": "Controllo delle conoscenze",
      "QUESTIONS": "Domande",
      "QUESTION": "Domanda",
      "CONVERSATIONAL_CALL": "Gioco di ruolo",
      "AVG_ATTEMPTS": "Media Tentativi",
      "USERS_PASSED": "utenti passati",
      "DETAILED_ANALYSIS": "Analisi dettagliata",
      "CALL_DETAILS": "Dettagli simulazione",
      "CALL_TYPE": "Tipo simulazione",
      "TOTAL_SESSIONS": "Totale sessioni",
      "WHAT_WE_MEASURED": "Cosa abbiamo misurato",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Punteggio complessivo medio",
      "OVERALL_SCORE_DETAIL": "Il nostro sistema fornisce un \"punteggio complessivo\" per ogni conversazione. Questo numero rappresenta il Punteggio complessivo medio di tutti",
      "CALL_RUN": "gli utenti che hanno completato questa simulazione",
      "TIME": "volta",
      "TIMES": "volte",
      "OBJECTIVES": "Metodologia",
      "AVG_OBJECTIVE": "Punteggi metodologia medi complessivi per tutte le",
      "OF_THIS_CALL": "di questa simulazione",
      "MESSAGE_ADHERENCE": "Rispetto del messaggio",
      "MESSAGE_ADHERENCE_DETAILS_1": "Il rispetto del messaggio misura se gli studenti esprimono",
      "MESSAGE_ADHERENCE_DETAILS_2": "idee importanti durante questa simulazione. Queste visualizzazioni mostrano la percentuale di messaggi relativi a un determinato tema espressa dagli utenti, in base a tutte le",
      "IMPORTANT_IDEAS": "idee importanti durante questa simulazione",
      "PERCENT_MESSAGE_ARTICULATED": "Queste visualizzazioni mostrano la percentuale di volte in cui ogni messaggio viene espresso durante",
      "FULLY_ARTICULATED": "Completamente espresso",
      "PARTIALLY_ARTICULATED": "Parzialmente espresso",
      "NOT_MENTIONED": "Non menzionato",
      "SKILLS_LABEL": "Competenze",
      "SKILLS_DETAILS": "I punteggi delle competenze sono una valutazione dell'IA delle competenze dimostrate dagli utenti durante una simulazione. Queste visualizzazioni mostrano la percentuale di volte in cui gli utenti hanno ottenuto i punteggi \"Esperto\" (il più alto), \"Competente\" e \"In crescita\" (il più basso) durante tutte le",
      "DEVELOPING": "In crescita",
      "PROFICIENT": "Competente",
      "Expert": "Esperto",
      "NO_RESULT": "Ancora nessun risultato",
      "NO_RESULT_TEXT": "Nessuno degli utenti dell'organizzazione ha ancora tentato di effettuare questa simulazione. Una volta effettuato un tentativo, potrai vedere i risultati qui.",
      "CONVERSATIONAL_CALL_TOOLTIP": "Nei giochi di ruolo, l'utente può dirigere il flusso della conversazione e l'IA risponderà di conseguenza. I giochi di ruolo sono meno strutturati rispetto ai controlli delle conoscenze, che hanno un formato rigido di domande e risposte",
      "TOTAL_SESSION_TOOLTIP": "Il numero totale di volte in cui questa simulazione è stata completata dagli utenti a cui è stata assegnata",
      "AVERAGE_SCORE_LABEL": "Punteggio medio",
      "AVERAGE_SCORE_DETAIL": "Il punteggio medio degli utenti per questa simulazione",
      "ANSWER_POINTS": "Punti di risposta",
      "DETAILS": "Dettagli",
      "CONVERSATIONAL_CALL_MSG": "Sono in arrivo i report sui contenuti dei giochi di ruolo",
      "ALL_CALL_DETAILS": "Tutti i dettagli simulazione",
      "QUESTION_TEXT_LABEL": "Testo domanda",
      "AVG_POINTS_LABEL": "Media punti",
      "SHOW_ALL": "Mostra tutto",
      "CORRECT_ANSWER": "risposte corrette su",
      "OBJECTIVE_MEASURED_ON": "Questa metodologia è misurata su",
      "CALLS_IN_MODULE": "simulazioni in questo modulo",
      "VIEW_CALL_DETAILS": "Visualizza dettagli",
      "QUESTION_UPDATED": "Questa domanda è stata aggiornata",
      "QUESTION_UPDATED_MESSAGE": "Non siamo in grado di mostrare informazioni dettagliate sui punti di risposta perché sono stati apportati aggiornamenti a questa domanda. La \"Media punti\" visualizzata rappresenta la media di tutte le sessioni di questa domanda (comprese quelle svolte prima e dopo gli aggiornamenti)",
      "CLOSE_ALT": "Chiudi",
      "Q_LABEL": "D",
      "SCORING_LABEL": "Punteggio",
      "AVERAGE_ANSWER": "Media punti di risposta ottenuti per domanda",
      "MINIMIZE_LABEL": "Riduci al minimo",
      "VIEW_ALL_LABEL": "Visualizza tutti",
      "DOWN_ARROW": "Freccia giù",
      "NOTIFICATION": "Notifica",
      "PROGRESS_ICON": "Icona di avanzamento",
      "VIEW_MODAL": "Visualizza modale",
      "VIEW_INFO": "Visualizza info",
      "TOTAL_LABEL": "Totale",
      "EXPAND_GROUP": "Espandi gruppo",
      "MESSAGE_ADHERENCE_V2": "Rispetto del messaggio",
      "SCORE_OVERALL": "Punteggio complessivo",
      "SCORE_SKILLS": "Competenze",
      "SCORE_CUSTOMIZED": "Metodologia",
      "SESSIONS": "sessioni",
      "SESSION": "sessione"
    },
    "personalizedPractice": {
      "TITLE": "Esercitazione personalizzata",
      "DESCRIPTION": "Ciao {{userFirstName}}. Le pratiche personalizzate ti consentono di impostare i tuoi scenari in modo che siano il più realistici possibile.",
      "LOADING": "Caricamento in corso...",
      "VIEW_SESSIONS": "Visualizza sessioni",
      "VIEW_SIMULATION": "Visualizza simulazione",
      "TOTAL_SESSION": "totale sessione",
      "TOTAL_SESSIONS": "totale sessioni",
      "BREADCRUMB": "Esercitazione personalizzata",
      "SCENARIO_DETAILS_TITLE": "Dettagli scenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Seleziona le variabili dalle opzioni qui sotto per adattare la simulazione alle tue esigenze.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleziona",
      "CONVERSATION_TYPE": "Tipo di conversazione",
      "SELECT_CONVERSATION_TYPE": "Seleziona il tipo di conversazione",
      "LAUNCH_SIMULATION": "Lancia simulazione con selezioni",
      "PREVIOUS_SESSIONS": "Sessioni precedenti",
      "TOTAL": "Totale",
      "FILTERS": "Filtri:",
      "DATE": "Data",
      "DIFFICULTY": "Difficoltà",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data sessione",
      "SESSION_SCORE": "Punteggio sessione",
      "DURATION": "Durata",
      "OVERALL_SCORE": "Punteggio complessivo",
      "MESSAGING": "Messaggistica",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Competenze",
      "RESULTS": "Risultati",
      "VIEW_FEEDBACK": "Visualizza feedback",
      "OVERALL_SCORE_LABEL": "Punteggio complessivo",
      "SCORE": "Punteggio",
      "NO_PRODUCTS_TITLE": "Nessun prodotto disponibile",
      "NO_PRODUCTS_DESCRIPTION": "Non hai ancora prodotti di esercitazione personalizzati.",
      "NO_SESSIONS_FOUND": "Nessuna sessione trovata con i filtri selezionati",
      "TIME": "Volta",
      "ALL": "Tutti",
      "LEARNER": "Studente",
      "MOOD": "Umore",
      "CLEAR_FILTERS": "Filtri trasparenti"
    },
    "login": {
      "TITLE": "Che bello rivederti qua",
      "SUB_TITLE": "Come desideri effettuare il login?  ",
      "LOGIN_WITH_SSO": "Accedi con l'SSO aziendale",
      "LOGIN_WITH_PASSWORD": "Accedi con la password",
      "PROVIDE_EMAIL": "Fornisci l'indirizzo e-mail",
      "HELP_TEXT": "Hai bisogno di aiuto? Contatta",
      "EMAIL_ERROR": "Impossibile effettuare l'accesso, contatta l'amministratore dell'azienda o il reparto IT.",
      "EMAIL": "Email",
      "LOGIN": "Accedi",
      "ALERT": "Avviso",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Effettuando l'accesso al tuo account accetti le {{termsLink}} e la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condizioni di servizio",
      "PRIVACY_POLICY": "Informativa sulla privacy"
    },
    "learningPathway": {
      "BEGIN": "Inizia",
      "DUE_DATE": "Data di scadenza",
      "FOOTER_SUBTITLE_READY": "Chiedimi ciò che vuoi. Sono qua per aiutarti.",
      "LEAVE_STEP": "Esci da questo passaggio",
      "NEXT_STEP": "Passaggio successivo",
      "NOTIFICATIONS_ARIA": "Notifiche",
      "PDF_NEXT_PAGE": "Pagina successiva",
      "PDF_NO_SOURCE": "Nessuna fonte PDF fornita.",
      "PDF_PREVIOUS_PAGE": "Pagina precedente",
      "POST_CALL_SUBTITLE": "Lascia un feedback mentre elaboriamo i tuoi risultati",
      "POST_CALL_TITLE": "Hai raggiunto la fine di questo quiz.",
      "SETTINGS": "Impostazioni",
      "TOAST_CONTENT": "Clicca qui sotto per visualizzarle oppure torna alla schermata dei dettagli del percorso per procedere con il passaggio successivo.",
      "TOAST_TITLE": "I risultati del gioco di ruolo sono stati elaborati",
      "ASSIGNMENTS": "Incarichi",
      "USER_FALLBACK": "Utente",
      "VIEW_RESULTS": "Visualizza risultati",
      "QUIZ_TITLE": "Quiz"
    },
    "leaderboard": {
      "LEADERBOARD": "Classifica",
      "TOP10PERCENT": "10% dei migliori",
      "PRACTICE_ASSIGNMENT": "Incarichi di esercitazione",
      "SIMULATION": "Simulazione",
      "SELECT_ASSIGNMENT": "Seleziona incarico",
      "SELECT_SIMULATION": "Seleziona simulazione",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Seleziona un incarico e una simulazione per vedere la classifica",
      "NO_DATA": "Ancora nessuna attività. Una volta che il team inizia a impegnarsi, la classifica apparirà qui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Nessun incarico disponibile",
      "NO_SIMULATIONS_AVAILABLE": "Nessuna simulazione disponibile",
      "NAME": "Nome",
      "HIGH_SCORE": "Punteggio elevato",
      "AVERAGE_SCORE": "Punteggio medio",
      "TOTAL_SESSIONS": "Totale sessioni",
      "LAST_SESSION": "Ultima sessione",
      "TOP5": "Migliori 5",
      "OF": "di",
      "ENGAGED_USERS": "utenti impegnati",
      "ENGAGED_USER": "utente impegnato",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Nascondi le sessioni con punteggi di competenza bassi",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Le sessioni con un punteggio della sezione di competenza equivalente a \"In crescita\" non contribuiranno alle colonne dei punteggi alti o medi.",
      "NO_USERS_ENGAGED": "Nessun utente impegnato"
    },
    "general": {
      "NEED_HELP_QUESTION": "Hai bisogno di aiuto?",
      "CONTACT": "Contatta",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Account parent",
      "ACCOUNT": "Account",
      "CHECKMARK": "Segno di spunta",
      "ICON": "Icona",
      "ALERT": "avviso",
      "HEADS_UP": "Attenzione!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Per un audio ottimale su iPad, utilizza le cuffie.",
      "SETTINGS": "IMPOSTAZIONI",
      "RP": "RP",
      "EMAIL_LABEL": "Email",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Team manager per",
      "MIAMI_SALE": "Vendite a Miami",
      "CHARLOTTE_SALES": "Vendite a Charlotte",
      "ATLANTA_SALES": "Vendite ad Atlanta",
      "TEAM": "Team",
      "ASSIGNMENTS": "Incarichi",
      "MY_TEAMS": "I miei team",
      "REPORTING": "Report",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Classifica",
      "PERSONALIZED_PRACTICE": "Esercitazione personalizzata",
      "HELP_SEARCH_OUR": "Effettua una ricerca nella nostra",
      "HELP_OR_REACH_OUT_TO": "o contatta",
      "HELP_WITH_QUESTIONS": "se hai domande",
      "KNOWLEDGE_BASE": "base di conoscenza"
    },
    "dashboard": {
      "ALL": "Tutti",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completato",
      "NO_ASSIGNMENT_TITLE": "Non hai incarichi.",
      "NO_ASSIGNMENT_DETAILS": "Ti avviseremo quando avrai degli incarichi da completare.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Non ci sono incarichi incompleti.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Ti avviseremo della scadenza di un nuovo incarico.",
      "COMPLETED_ASSIGNMENT_TITLE": "Non hai incarichi completati.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Ricontrolla una volta completato un incarico.",
      "VIEW_ASSIGNMENT": "Visualizza l'incarico",
      "ASSIGNMENT_LABEL": "Incarichi",
      "MODULE_ASSIGNMENT_ALT": "Icona modulo incarico",
      "VIEW_ASSIGNMENT_FOR": "Visualizza l'incarico per",
      "DAY": "Giorno",
      "UNTILL_DUE": "Scadenza",
      "PAST_DUE": "Scaduto",
      "AVAILABLE_IN": "Disponibile tra",
      "DUE_TODAY": "In scadenza oggi",
      "PRACTICE": "Esercitazione",
      "CERTIFICATION": "Certificazione",
      "UPCOMING": "Prossimamente",
      "TEST_ASSIGNMENT": "Incarico di test",
      "CLOSED": "Chiuso",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Nessun incarico trovato.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Prova a regolare i tuoi filtri per vedere gli incarichi disponibili oppure controlla più tardi quando verranno aggiunti nuovi incarichi.",
      "VIEW_PATHWAY": "Visualizza percorso",
      "TOTAL": "Totale",
      "STATUS_LABEL": "Stato",
      "STATUS_SELECTION_LABEL": "Stato:",
      "ASSIGNMENT_TYPE": "Tipo di incarico",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo di incarico:",
      "NOT_STARTED": "Non iniziato",
      "CERTIFIED": "Certificato",
      "NOT_CERTIFIED": "Non certificato",
      "IN_PROGRESS": "In corso",
      "PATHWAY": "Percorso di apprendimento",
      "SELECT_ALL": "Seleziona tutto",
      "DESELECT_ALL": "Deseleziona tutto"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Ti diamo il benvenuto su Quantified!",
      "INVITATION_MESSAGE": "Siamo entusiasti di averti a bordo! Segui la procedura seguente per accedere al tuo account per la prima volta.",
      "ACCOUNT_DETAILS": "I dati del tuo account:",
      "USERNAME": "Nome utente",
      "PASSWORD": "Password temporanea",
      "STEPS_LABEL": "Passi successivi per l'accesso",
      "STEP_1": "1. Clicca sul pulsante \"Accedi\" per accedere alla pagina di login.",
      "STEP_2": "2. Inserisci il nome utente e la password temporanea forniti sopra.",
      "STEP_3": "3. Una volta effettuato l'accesso, ti verrà richiesto di impostare una nuova password.",
      "LOGIN_BUTTON": "Accedi",
      "ABOUT_US": "Il simulatore di Quantified è un ambiente virtuale progettato per aiutarti a sviluppare rapidamente le competenze essenziali. Questo ti consente di connetterti e comunicare in modo più efficace con i clienti.",
      "EXPIRY_TIME": "Questa password temporanea scadrà tra 24 ore. In caso di problemi di accesso, contatta il nostro team di assistenza all'indirizzo",
      "TEAM": "Il team Quantified",
      "INVITATION_SMS_USERNAME": "Il tuo nome utente è",
      "INVITATION_SMS_PASSWORD": "e la password temporanea è",
      "AUTHENTICATION_CODE": "Il codice di autenticazione è",
      "PASSWORD_RESET_CODE": "Il codice di reimpostazione della password Quantified",
      "RESET_PASSWORD_EMAIL": "Ripristino della password via e-mail",
      "HELLO": "Ciao",
      "USE_VERIFICATION_CODE": "Hai richiesto la reimpostazione della password. Per completare la procedura, utilizza il codice di verifica riportato di seguito.",
      "VERIFICATION_CODE": "Codice di verifica",
      "NEXT_STEP": "I prossimi passi",
      "RESET_PASSWORD_PAGE": "Torna alla pagina di reimpostazione della password nel browser.",
      "ENTER_VERIFICATION_CODE": "Immetti il codice di verifica quando richiesto.",
      "CREATE_PASSWORD": "Una volta verificato il codice, segui le istruzioni per creare una nuova password.",
      "DISREGARD_NOTE": "Se non hai richiesto la reimpostazione della password, ignora questa e-mail.",
      "CONTACT_SUPPORT": "Per ulteriore assistenza, contatta il nostro team di assistenza all'indirizzo",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Grazie",
      "QUANTIFIED_TEAM": "Il team Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Stati Uniti"
    },
    "call": {
      "LOADING": "Caricamento",
      "SIMULATION_PAUSED": "La simulazione è stata messa in pausa.",
      "CLICK_RESUME": "Clicca sul pulsante \"Riprendi\" qui sotto per continuare.",
      "NO_INTERNET": "Nessuna connessione a Internet",
      "TRY_AGAIN": "Controlla la connessione e riprova.",
      "MIC_MUTED": "Il microfono è disattivato",
      "MIC_MUTED_DESCRIPTION": "Ops, sembra che il tuo microfono sia disattivato. Attiva il microfono per rispondere e continuare.",
      "NO_RESPONSE": "Nessuna risposta rilevata",
      "MIC_NOT_CONNECTED": "Ops, sembra che il microfono non sia collegato. Riseleziona il dispositivo per rispondere e continuare.",
      "AUDIO_ISSUE": "Ops, qualcosa è andato storto. Controlla le impostazioni del dispositivo e assicurati di trovarti in un luogo tranquillo e privo di rumori di fondo.",
      "LOADING_ALT": "Caricamento in corso...",
      "REPEAT_RESPONSE": "Il sistema ti rimanderà automaticamente alla simulazione per ripetere la risposta e riprovare.",
      "NEEDS_MORE_TIME_QUESTION": "ha bisogno di più tempo per pensare, vuoi aspettare?",
      "NEEDS_MORE_TIME": "ha bisogno di più tempo per pensare.",
      "WAIT_OR_END_CALL": "Ti comunicheremo quando avrà terminato oppure puoi chiudere la chiamata e",
      "RETURN_TO_ASSIGNMENTS": "Ritorna all'incarico",
      "READY": "Pronto",
      "IS_READY": "è pronto per continuare la conversazione.",
      "TRY_AGAIN_LABEL": "Riprova",
      "CHECK_SETTINGS": "Controlla le impostazioni",
      "PAUSED_SIMULATION": "Hai messo in pausa la simulazione.",
      "PAUSED_SIMULATION_DESCRIPTION": "La registrazione video e audio viene messa in pausa fino alla ripresa della simulazione.",
      "RESUME": "Riprendi",
      "SETTINGS": "Impostazioni",
      "CAPTURING_RESPONSE": "Acquisizione delle risposte",
      "TOUR_MESSAGE": "Una volta terminata la conversazione, fai clic sul pulsante Continua per assicurarti che le risposte vengano acquisite e valutate.",
      "NEXT": "Avanti",
      "START_CALL": "Avvia",
      "END_CALL_TITLE": "Confermi di voler terminare questa simulazione?",
      "END_CALL_DESCRIPTION": "Se termini la simulazione ora, riceverai un punteggio o un feedback sulla conversazione.",
      "END_CALL": "Termina",
      "BROWSER_ACCESS_DENIED": "Al browser è negato l'accesso a questo dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copia ID sessione",
      "TIPS_GUIDANCE_MESSAGE": "I punti di discussione e i suggerimenti appariranno qui.",
      "CONTINUE": "Continua",
      "SESSION_ID_LABEL": "ID sessione:",
      "SESSION_ID_COPIED": "ID sessione copiato!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Suggerimenti e indicazioni",
      "HINT_LABEL": "Suggerimento",
      "CAPTIONS_LABEL": "Didascalie",
      "PAUSE_LABEL": "Metti in pausa",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "emoji della festa",
      "CALL_ENDED_MESSAGE": "Hai raggiunto la fine di questa simulazione.",
      "CALL_ENDED_INACTIVITY": "La simulazione è terminata per inattività",
      "CALL_ENDED_GENERIC": "La simulazione è terminata",
      "FEEDBACK_PROMPT": "Lascia un feedback mentre elaboriamo i tuoi risultati.",
      "INTERACTION_THRESHOLD_NOT_MET": "Non hai raggiunto la soglia di interazione per il punteggio, riprova.",
      "REALISTIC_CONVERSATION_QUESTION": "La conversazione è stata realistica e naturale?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Pensi che questa simulazione ti abbia aiutato a migliorare competenza e preparazione?",
      "FEEDBACK_THANK_YOU": "Grazie per il tuo feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Grazie per il tuo feedback! Lavoreremo per migliorare l'esperienza.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "Impossibile caricare l'aiuto visivo",
      "BEGIN_CALL": "Avvia",
      "LEAVE_CALL_BRIEFING": "Esci dal resoconto",
      "RESTORE_CALL": "Ripristino della simulazione in corso",
      "FEW_SECONDS": "L'operazione potrebbe richiedere alcuni secondi.",
      "CHECK_ALT": "Spunta",
      "COPY_ALT": "Copia",
      "HINTS_ALT": "Suggerimenti",
      "CLOSE_CAPTIONS": "Chiudi didascalie",
      "MICROPHONE_MUTED": "Microfono disattivato",
      "RETURN_TO_CALL": "Torna alla simulazione",
      "YES": "Sì",
      "NO": "No",
      "VIEW_RESULTS": "Visualizza risultati",
      "RETURN_TO_ASSIGNMENT": "Ritorna all'incarico",
      "HAVING_ISSUES": "Stiamo riscontrando problemi di connessione, controlla la connessione a Internet, quindi clicca su OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Siamo spiacenti, ma non siamo in grado di generare risultati in questo momento.",
      "INACTIVITY_ALERT_MESSAGE": "La chiamata viene interrotta per inattività. Parlare all'avatar per continuare o selezionare \"Fine chiamata\" per terminare la chiamata.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Questa chiamata terminerà tra {{secondsUntilHangup}} secondi",
      "INACTIVITY_SHORT_ALERT_TITLE": "La chiamata terminerà tra pochi secondi",
      "TELL_YOUR_GENDER_HEADING": "Indicaci il tuo genere:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Conoscendo il tuo genere, l'avatar può utilizzare una grammatica corretta, rendendo la conversazione più naturale e realistica.",
      "GENDER_SELECTION": "Selezione del genere:",
      "SELECT_OPTION": "Seleziona un'opzione",
      "CONFIRM": "Conferma",
      "MALE": "Uomo",
      "FEMALE": "Donna",
      "NON_BINARY": "Non-binario/altro",
      "PREFER_NOT_TO_ANSWER": "Preferisco non rispondere",
      "NON_BINARY_MESSAGE": "Comprendiamo e rispettiamo la tua identità di genere non binaria. A causa delle attuali limitazioni tecnologiche, usiamo di default i pronomi maschili. Sappi che stiamo lavorando per migliorarci e poter accogliere meglio tutte le identità di genere in futuro. Grazie per la comprensione e la pazienza.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Rispettiamo la tua scelta di non fornire un genere. In questi casi, la nostra tecnologia utilizza di default i pronomi maschili a causa delle limitazioni attuali.",
      "DISPLAY_VISUAL_AID": "Display aiuto visivo",
      "FULL_SCREEN": "Schermo intero",
      "COLLAPSE": "Comprimi",
      "COMPLETED_CONVERSATION_MESSAGE": "Grazie per aver completato questa conversazione",
      "CONVERSATION_COMPLETION_FEEDBACK": "Lasciaci un feedback mentre elaboriamo la tua conversazione.",
      "ERROR_MESSAGE": "Si è verificato un errore. Contatta",
      "SAVED_CONVERSATION_MESSAGE": "La tua conversazione è stata salvata.",
      "RETURN_TO_MY_ASSIGNMENTS": "Torna ai miei incarichi",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Torna all'esercitazione personalizzata",
      "PERSONALIZED_CALL_NOTE": "Hai appena completato un'esercitazione personalizzata di conversazione.",
      "LEAVE_STEP_TITLE": "Confermi di voler uscire da questo passaggio?",
      "EXIT": "Esci"
    },
    "assignment": {
      "STATUS": "STATO",
      "SCORE": "PUNTEGGIO",
      "MUST_ACHIEVE": "Deve raggiungere un",
      "OR_HIGHER": "o superiore",
      "TEST": "Test",
      "OUT_OF_5": "su 5",
      "LATEST_ATTEMPT": "ULTIMO TENTATIVO",
      "TOTAL_ATTEMPTS": "tentativi totali",
      "UNLIMITED": "Illimitato",
      "REMAINING": "Rimanente",
      "VIEW_CALL_DETAILS": "Visualizza dettagli",
      "MAX_ATTEMPTS_REACHED": "Hai raggiunto il numero massimo di tentativi",
      "DUE_DATE": "Data di scadenza",
      "DAYS": "Giorni",
      "DAY": "Giorno",
      "UNTILL_DUE": "Scadenza",
      "PAST_DUE": "Scaduto",
      "ONGOING": "In corso",
      "SCORE_REQUIREMENT": "Requisito punteggio",
      "SCORE_REQUIREMENT_DETAIL": "È necessario raggiungere un punteggio di",
      "TO_COMPLETE_EACH_CALL": "per completare ogni simulazione richiesta.",
      "CALLS_IN_ASSIGNMENT": "Simulazioni nell'incarico",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Risultati precedenti",
      "DATE": "Data",
      "RESULTS": "Risultati",
      "VIEW_PREVIOUS_RESULTS": "Visualizza risultati precedenti",
      "VIEW_FEEDBACK": "Visualizza feedback",
      "LAUNCH_CALL": "Lancia",
      "CLOSE_BUTTON": "Pulsante di chiusura",
      "CHECKMARK": "segno di spunta",
      "CALL": "Chiamata",
      "QUESTION": "Domanda",
      "COMPLETED": "Completato",
      "IN_PROGRESS": "In corso",
      "NOT_STARTED": "Non iniziato",
      "CERTIFIED": "Certificato",
      "GUIDED": "Guidata",
      "CONVERSATIONAL": "Conversazionale",
      "GUIDED_SIMULATION": "Controllo delle conoscenze",
      "CONVERSATIONAL_SIMULATION": "Gioco di ruolo",
      "NO_ATTEMPTS_LEFT": "Non ci sono più tentativi",
      "NO_ATTEMPTS": "Nessun tentativo",
      "OVERVIEW": "Panoramica",
      "ABOUT_THE_AVATAR": "Informazioni sull'Avatar",
      "SCORING_CRITERIA": "Criteri di valutazione",
      "SIMULATION_OVERVIEW": "Panoramica della simulazione",
      "ABOUT_THE_PERSONA": "Informazioni sulla persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Chiuso"
    }
  },
  "fr-FR": {
    "root": {
      "ADMIN_PORTAL": "PORTAIL ADMIN",
      "SUPPORT": "ASSISTANCE",
      "U": "U",
      "USER": "Utilisateur",
      "LOGOUT": "Déconnexion",
      "ADMIN": "Administrateur",
      "SUPPORT_SMALL": "Assistance",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMÉRA",
      "ACCESS_DENIED": "ACCÈS_REFUSÉ"
    },
    "teams": {
      "MY_TEAMS": "Mes équipes",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Non commencée",
      "ASSIGNMET_MODULE": "Module de mission",
      "START_DATE": "Date de début",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNED_MEMBERS": "Membres assignés",
      "CALLS_IN_MODULE": "Simulations dans le module",
      "COMPLETION_REQUIRMENT": "Condition d’achèvement",
      "COMPLETE_ALL_CALLS": "Terminez toutes les simulations avec une note de",
      "OR_HIGHER": "ou plus",
      "PROGRESS_OVERVIEW": "APERÇU DE LA PROGRESSION",
      "TEAM_MEMBERS": "membres de l’équipe",
      "AVERAGE_HIGH_SCORE": "Moyenne des meilleures notes",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Nombre moyen de tentatives par simulation",
      "TOTAL_PRACTICES": "Nombre total d’entraînements",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSION DE SIMULATION INDIVIDUELLE",
      "OF_TEAM_MEMBERS": "des membres de l’équipe ont terminé",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Entraînements moyens jusqu’à l’achèvement",
      "TEAM_MEMBER_DETAILS": "INFORMATIONS SUR LES MEMBRES DE L’ÉQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Télécharger le rapport d’activité",
      "TEAM_MEMBER": "Membre de l’équipe",
      "PROGRESS": "Progression",
      "CALLS_COMPLETED": "Simulations terminées",
      "PRACTICES": "Sessions d’entraînement",
      "MOST_RECENT_PRACTICE": "Session la plus récente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Cette équipe n’a pas de missions actives pour le moment",
      "CALL_NAME_LABEL": "Nom de la simulation",
      "HIGHEST_SCORE": "Meilleure note"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assurons-nous que votre appareil est configuré.",
      "MICROPHONE_REQUIRED_NOTICE": "Un microphone en état de marche est nécessaire.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si vous n’avez pas vu de fenêtre contextuelle vous demandant d’activer vos appareils après avoir actualisé cette page, veuillez accéder aux paramètres de votre système ou de votre navigateur, puis activer vos appareils. Vous trouverez ci-dessous des pages d'aide contenant des instructions supplémentaires.",
      "ENABLE_CAMERA": "Comment activer votre caméra :",
      "WINDOWS_USERS": "Utilisateurs de Windows",
      "MAC_USERS": "Utilisateurs de Mac",
      "IPAD_USERS": "Utilisateurs d’iPad",
      "ENABLE_MICROPHONE": "Comment activer votre microphone :",
      "ENABLE_DEVICES_BY_BROWSER": "Comment activer vos appareils par navigateur :",
      "CHROME_USERS": "Utilisateurs de Chrome",
      "SAFARI_USERS": "Utilisateurs de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Commencer sans caméra",
      "START_CALL_BUTTON": "Commencer l’appel",
      "MICROPHONE_REQUIRED_WARNING": "Un microphone en état de marche est nécessaire.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Sélectionner votre microphone",
      "ALERT": "alerte",
      "GIVE_PERMISSION": "Donner l’autorisation",
      "SELECT_VIDEO_DEVICE": "Sélectionner votre appareil vidéo",
      "VIDEO": "vidéo",
      "DEVICE_BLOCKED_ERROR": "Il semble que vous ayez refusé à ce navigateur l’accès à un ou plusieurs de vos appareils. Pour activer les appareils, veuillez accéder aux paramètres de votre système ou de votre navigateur, puis activer l’accès.",
      "DEVICE_SETTINGS": "Paramètres de l’appareil",
      "CONFIRM_SETTINGS": "Confirmer les paramètres",
      "LAPTOP": "Ordinateur portable",
      "SAD_EMOTE_FACE": "Émoji visage triste",
      "GRANT_BROWSER_ACCESS": "Pour effectuer cette simulation, veuillez autoriser le navigateur à accéder à la reconnaissance vocale",
      "USING_IPAD": "Si vous utilisez un iPad, accédez à",
      "SETTINGS": "Paramètres",
      "PRIVACY_AND_SECURITY": "Confidentialité et sécurité",
      "SPEECH_RECOGNITION": "Reconnaissance vocale",
      "GRANT_ACCESS_REFRESH": "Accordez l’accès au navigateur, puis actualisez la page",
      "REFRESH_PAGE": "ACTUALISER LA PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Le navigateur ne peut pas accéder à cet appareil",
      "ACCESS_DENIED": "accès refusé",
      "CAMERA": "Caméra",
      "DIAGNOSTIC_PASSED": "Tous les tests de diagnostic ont réussi.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Certains tests de diagnostic ont échoué. Veuillez cliquer sur le bouton « Copier les résultats du diagnostic » ci-dessus et envoyer les résultats à l'équipe d’assistance pour qu’elle vous aide.",
      "DIAGNOSTIC_PARTIAL": "La plupart des tests de diagnostic ont réussi. Votre connexion semble bonne.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Veuillez patienter pendant que les tests de diagnostic sont en cours…",
      "DIAGNOSTIC_RUNNING": "Diagnostic en cours",
      "COPY_DIAGNOSTIC_RESULTS": "Copier les résultats du diagnostic",
      "RUN_DIAGNOSTIC": "Exécuter le diagnostic",
      "RERUN_DIAGNOSTIC": "Relancer le diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Résultats du diagnostic copiés dans le presse-papiers",
      "DIAGNOSTIC_FAILED": "Le diagnostic a échoué",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostics quantifiés",
      "DIAGNOSTIC_TIME": "Temps",
      "DIAGNOSTIC_SUMMARY": "Résumé",
      "DIAGNOSTIC_CLIENT_INFO": "Infos du client",
      "DIAGNOSTIC_PLATFORM": "Plate-forme",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perte de paquets (envoi)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Débit binaire d'envoi moyen",
      "DIAGNOSTIC_NA": "N/A"
    },
    "results": {
      "RETURN_HOME": "RETOURNER À L’ACCUEIL",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CONVERSATIONAL_CALL": "JEU DE RÔLE",
      "INFORMATION_ICON": "Icône d’information",
      "TOOLTIP_ARROW": "Flèche d’info-bulle",
      "INFORMATION_TOOLTIP_CONTENT": "Vous contrôlez le flux de la simulation en orientant la conversation vers un ensemble d’objectifs. Les jeux de rôle sont parfaits pour tester des capacités telles que l’analyse approfondie et les questions de second niveau, la recherche de difficultés et l’établissement d’une relation.",
      "CLOCK_ICON": "Icône d’horloge",
      "CALL_RESULTS": "Résultats",
      "SKILLS": "Compétences",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "TRY_AGAIN_MESSAGE": "Réessayez pour améliorer votre note.",
      "PRACTICE_BENEFITS": "Un entraînement hebdomadaire renforce la confiance en soi et améliore les résultats en situation concrète.",
      "CALL_SUCCESS": "Excellent travail ! Vous avez terminé cette simulation avec succès.",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "TRY_AGAIN": "Réessayer",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excellent travail ! Vous avez terminé",
      "COMPLETED_THIS_CALL": "a terminé cette simulation.",
      "ACHIEVED_SCORE": "Vous avez obtenu une note de",
      "ACHIEVE_SCORE": "Obtenez une note de",
      "OR_HIGHER": "ou plus.",
      "OBJECTIVES_NOT_MET": "Vous n’avez pas atteint tous les objectifs requis.",
      "TRY_AGAIN_TARGET_SCORE": "Essayez à nouveau d’obtenir une note de",
      "YOUR_SCORE": "Votre note",
      "OUT_OF_5": "SUR 5",
      "CALL_FEEDBACK": "RÉSUMÉ DU RETOUR D'INFORMATION",
      "STRENGTH_ICON_ALT": "Icône de force",
      "OPPORTUNITIES_ICON_ALT": "Icône des opportunités",
      "OBJECTIVES_FEEDBACK": "RETOUR D'INFORMATION SUR LA MÉTHODOLOGIE",
      "SESSION_ID": "ID de session :",
      "SESSION_ID_COPIED": "L’ID de session a été copié !",
      "OBJECTIVE": "MÉTHODOLOGIE :",
      "HOW_YOU_DID": "Vos résultats :",
      "LIGHTBULB_ICON_ALT": "Icône d’ampoule",
      "WHAT_WE_SUGGEST": "Ce que nous suggérons :",
      "NO_SPECIFIC_RECOMMENDATION": "Notre système n’a pas trouvé de recommandation propre à votre cas.",
      "WHY": "Pourquoi ?",
      "NO_INSIGHTS_AVAILABLE": "Notre système n’a pas été en mesure de fournir des informations sur cette suggestion.",
      "CONFETTI_ICON_ALT": "Icône de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Vous avez fait du bon travail sur cette méthodologie. Continuez comme ça !",
      "PROCESSING_CALL": "Nous préparons votre note et votre retour d'information.",
      "HANG_TIGHT": "Patientez ou revenez plus tard pour",
      "VIEW_YOUR_RESULTS": "consulter vos résultats.",
      "NEED_MORE_TIME": "Nous avons besoin de plus de temps pour calculer les résultats.",
      "REFRESH_INSTRUCTION": "Veuillez revenir plus tard ou actualiser la mission",
      "RESULTS_IN_FEW_MINUTES": "résultats dans quelques minutes.",
      "SCORE_CALCULATION_QUESTION": "Quelle est la méthode de calcul ?",
      "SINGLE_SCORE_EXPLANATION": "Cette simulation comporte un seul élément de notation. La note affichée correspond donc à la fois à la note de la section et à votre note globale.",
      "OVERALL_SCORE_PERCENT": "% de la note globale",
      "SECTION_SCORE": "Note de la section",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Améliorez votre adhésion au message de conversation",
      "MESSAGE_ADHERENCE_NOTE": "L’adhésion au message est essentielle pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "NO_CREDIT": "Aucun crédit",
      "PARTIAL_CREDIT": "Crédit partiel",
      "FULL_CREDIT": "Crédit complet",
      "WHAT_YOU_DID_WELL": "Ce que vous avez réussi",
      "MISSED_ALL_KEY_POINTS": "Vous avez omis tous les points clés. Revoyez-les et essayez à nouveau.",
      "WHAT_TO_IMPROVE": "Ce que vous pouvez améliorer",
      "PERFECT_SCORE_MESSAGE": "Félicitations ! Vous avez obtenu une note parfaite, en abordant correctement tous les points clés.",
      "POINTS_LABEL": "Points",
      "TALKING_POINTS_COVERED": "Points de discussion abordés",
      "CHECKMARK_ICON_ALT": "coche",
      "TALKING_POINTS_MISSED": "Points de discussion manqués",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Entraînez-vous à nouveau",
      "OUT_OF": "sur",
      "POSSIBLE_TALKING_POINTS": "points de discussion possibles",
      "YOU_COVERED": "Vous avez abordé",
      "THROUGHOUT_CALL": "au cours de la simulation.",
      "POSITIVE_FEEDBACK_COVERAGE": "Vous avez très bien mis en évidence les points clés tout au long de l’appel, et abordé",
      "MIXED_FEEDBACK_COVERAGE": "Vous avez omis certains points clés au cours de la simulation, et abordé",
      "OBJECTIVES": "Méthodologie",
      "ELEVATE_OBJECTIVES_TITLE": "Améliorez votre méthodologie de conversation",
      "OBJECTIVES_NOTE": "La méthodologie est essentielle pour mener des conversations fructueuses, mais elle n’a pas d’incidence sur votre note globale.",
      "UNTIL": "jusqu’au",
      "TO_IMPROVE_SCORE": "pour améliorer votre note.",
      "TO_SCORE": "pour recevoir une note de",
      "BEFORE": "avant",
      "YOU_HAVE": "Vous avez",
      "MORE_ATTEMPTS": "tentatives supplémentaires pour obtenir une note de",
      "OR_HIGHER_BEFORE": "ou plus avant",
      "AND_TRY_AGAIN": "et réessayer.",
      "UNEXPECTED_STATE": "Un état inattendu s’est produit.",
      "REVIEW_APP_LOGIC": "Veuillez revoir la logique de l’application.",
      "ASSIGNMENTS": "Missions",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "PRACTICE_SESSION": "Session d’entraînement",
      "OVERALL_SCORE": "Note globale",
      "OVERALL_SCORE_EXPLANATION": "La note globale est calculée en faisant la moyenne pondérée des notes de chaque section. Le poids de chaque section s’affiche sous forme de pourcentage à côté de la note.",
      "SCORE_CONFIG_NOTE": "Les pourcentages de pondération, ainsi que l’inclusion et l’exclusion de sections, sont fixés par votre entreprise. Toutes les notes sont arrondies au dixième de point le plus proche.",
      "STRENGTHS": "Points forts",
      "OPPORTUNITIES": "Opportunités",
      "YOUR_RESPONSE": "Votre réponse",
      "MINUS": "moins",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Réponse recommandée",
      "REVIEW_MISSED_TITLE": "Passez en revue ce que vous avez manqué.",
      "NO_TALKING_POINTS_COVERED": "Vous n’avez abordé aucun des points de discussion requis pour ce sujet.",
      "LEARN_WHAT_YOU_MISSED": "Découvrir ce que vous avez manqué",
      "NICE_JOB": "Beau travail !",
      "ALL_POINTS_COVERED": "Vous avez réussi à aborder tous les points de discussion requis pour ce sujet.",
      "COVER_ALL_MESSAGES": "Abordez tous les messages clés.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "En mettant l’accent sur les points clés tout au long de l’appel, vous contribuerez à maintenir la conversation sur les rails.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oups ! Il semble que vous n’ayez abordé aucun des faits de ce message.",
      "NO_SPECIFICS_AVAILABLE": "Oups ! Il semble que nous n’ayons pas pu fournir de précisions sur ce qui a été omis.",
      "ALL_KEY_POINTS_COVERED": "Excellent travail ! Vous avez abordé tous les points clés.",
      "PROCESSING_SKILLS_FEEDBACK": "Nous sommes en train de traiter votre retour d’information sur les compétences.",
      "SKILLS_SCORING_NOT_ENABLED": "Nous sommes désolés, mais nous n’avons pas pu analyser votre appel récent, car la notation des compétences n’était pas activée au moment de l’envoi. Pour obtenir un retour d’information, il vous suffit de renvoyer votre appel d’entraînement, comme vous l’avez fait précédemment. Si vous avez besoin d’aide, n’hésitez pas à contacter notre équipe d’assistance. Merci de votre compréhension et de votre volonté à vous améliorer !",
      "ELEVATE_CONVERSATION_SKILLS": "Améliorer vos compétences en matière de conversation",
      "SKILLS_NOTE": "Les compétences sont essentielles pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "SKILLS_SUMMARY_TITLE": "RÉSUMÉ DES COMPÉTENCES",
      "LEARN_MORE_ABOUT_SKILLS": "En savoir plus sur les compétences",
      "SKILLS_FEEDBACK_LABEL": "RETOUR D’INFORMATION",
      "WHAT_ARE_SKILLS_TITLE": "Définition des compétences",
      "SKILLS_DESCRIPTION": "Les compétences sont établies pour favoriser la croissance et le développement personnels. Bien que ces compétences ne fassent pas partie de l’évaluation numérique de votre appel, elles ont été sélectionnées par votre entreprise pour améliorer votre efficacité.",
      "PROFICIENCY_SCALE_TITLE": "ÉCHELLE DE COMPÉTENCE",
      "EXPERT": "Expert",
      "PROFICIENT": "Compétent",
      "DEVELOPING": "En développement",
      "CALL_TRANSCRIPT": "Transcription de l’appel",
      "COLLAPSE_ALL": "Tout réduire",
      "EXPAND_ALL": "Tout développer",
      "THUMBNAIL": "Miniature",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "points de discussion",
      "TRANSCRIPT_LABEL": "Transcription",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Vous avez épuisé toutes vos tentatives.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Passez en revue les consignes, et tâchez de les respecter à l’avenir.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Réessayez en veillant à respecter les consignes de conformité.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nous avons constaté que vous n’étiez pas conforme. Vous n’avez donc pas obtenu de note.",
      "WHY_OUT_OF_COMPLIANCE": "Raison de votre non-conformité",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Examinez votre transcription pour voir où vous n’avez pas respecté les directives en matière de conformité.",
      "YOU_DID_FOLLOW_GUIDELINES": "Vous avez suivi efficacement ces directives.",
      "REVIEW_MISSED_GUIDELINES": "Passez en revue les directives relatives à la conformité que vous avez manquées.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcul de la note",
      "PROCESSING_TRANSCRIPT": "Nous sommes en train de traiter votre transcription.",
      "WAIT_OR_REVIEW_SCORES": "Patientez ici, ou passez en revue les autres sections de notes",
      "TRANSCRIPT_LOADING": "pendant le chargement de la transcription.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Passez en revue votre retour d’information, et continuez de vous entraîner",
      "HIGH_PERFORMERS_PRACTICE": "Les personnes très performantes s’entraînent au moins une fois par semaine",
      "SUCCESSFULLY_PASSED": "Excellent travail ! Vous avez réussi cette simulation.",
      "DIDNT_REACH_PASSING_SCORE": "Vous n’avez pas atteint la note minimale pour cette simulation.",
      "OUT_OF_ATTEMPTS": "<b>Vous avez épuisé toutes vos tentatives.</b> Consultez votre retour d’information pour savoir comment vous améliorer.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Passez en revue votre retour d’information, puis retournez à l’accueil lorsque vous serez prêt.",
      "GREAT_JOB_PRACTICED": "Bon travail. Vous vous êtes entraîné {{count}} {{times}}. Continuez comme ça !",
      "TIME": "fois",
      "TIMES": "fois",
      "COMPLIANCE_GUIDELINES": "Directives en matière de conformité",
      "TALKING_POINT_TITLE": "POINTS DE DISCUSSION MANQUÉS OU DITS AU MAUVAIS MOMENT",
      "NO_TRANSCRIPT": "Aucune transcription disponible."
    },
    "reportingV2": {
      "DASHBOARD": "Tableau de bord",
      "LOADING_ACCOUNTS": "Chargement des comptes...",
      "SELECT_AN_ACCOUNT": "Sélectionner un compte",
      "SEARCH_TEAMS": "Chercher des équipes",
      "LOADING_TEAMS": "Chargement des équipes...",
      "ALL_TEAMS": "Toutes les équipes",
      "ACCOUNT": "Compte",
      "TEAMS": "Équipes",
      "TEAM_LABEL": "Équipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Note minimale",
      "ASSIGNMENT_LABEL": "Missions",
      "USER_LABEL": "Utilisateurs",
      "PRACTICE_LABEL": "Entraînement",
      "CERTIFICATION_LABEL": "Certification",
      "RESULTS_DESCRIPTION": "Voici les résultats de votre ou vos équipes pour l'ensemble des missions d’entraînement :",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement par mission",
      "ASSIGNMENT_ENGAGEMENT": "Engagement de mission",
      "ENGAGED_LABEL": "Engagé",
      "ENGAGEMENT_STATUS_LABEL": "État de l’engagement",
      "PROFICIENT_LABEL": "Compétent",
      "ASSIGNMENT_NAME": "Nom de la mission",
      "ACTIVE_USERS": "Utilisateurs actifs",
      "ASSIGNMENT_PROGRESS": "Progression par mission",
      "IN_PROGRESS_LABEL": "En cours",
      "CERTIFIED_LABEL": "Certifié",
      "OUT_OF_ATTEMPTS_LABEL": "Nombre de tentatives épuisé",
      "USERS_ENGAGED_LABEL": "Utilisateurs engagés",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions par utilisateur actif",
      "HIGHER_THAN_LABEL": "Supérieur à",
      "MORE_THAN_LABEL": "Plus de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Nombre total de sessions achevées",
      "USER_CERTIFIED": "Utilisateurs certifiés pour toutes les missions",
      "ASSIGNMENT_CERTIFICATION": "Missions avec une certification de 100 %",
      "TRAINER_TIME_SAVED": "Gain de temps pour le formateur",
      "HOURS_LABEL": "heures",
      "PRACTICE_ASSIGNMENT_LABEL": "Missions d’entraînement",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Missions de certification",
      "START_DATE_LABEL": "Date de début",
      "END_DATE_LABEL": "Date de fin",
      "NAME_LABEL": "Nom",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membre des équipes",
      "ASSIGNMENTS_COUNT_LABEL": "Nombre de missions",
      "TOTAL_SESSIONS_LABEL": "Nombre total de sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Nombre de sessions",
      "TOTAL_USERS_LABEL": "Nombre total d’utilisateurs",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "INITIAL_SCORE_LABEL": "Note initiale",
      "HIGH_SCORE_LABEL": "Note élevée",
      "LAST_PRACTICE_DATE_LABEL": "Date du dernier entraînement",
      "PERCENT_IMPROVED_LABEL": "% d'amélioration",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Cette mesure analyse les notes de chaque session, et trace une ligne droite sur un graphique pour illustrer la tendance. Un pourcentage élevé indique que les notes s’améliorent plus rapidement, tandis qu’un pourcentage faible indique que les notes s’améliorent plus lentement.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Certifié pour les missions",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Compétent pour les missions",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Nombre de missions dans lesquelles l'utilisateur a atteint ou dépassé les critères de notation pour toutes les simulations de la mission.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Nombre de missions dans lesquelles l'utilisateur a atteint ou dépassé les critères de notation au moins une fois pour toutes les simulations de la mission.",
      "PROFICIENT_TOOLTIP": "Pourcentage d’utilisateurs de cette mission ayant atteint ou dépassé les critères de notation au moins une fois pour toutes les simulations de cette mission.",
      "IN_PROGRESS_TOOLTIP": "Pourcentage d'utilisateurs ayant terminé au moins une session de simulation dans le cadre de cette mission, et qui ont obtenu une note.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Pourcentage d'utilisateurs ayant dépassé leur nombre de tentatives allouées pour une ou plusieurs simulations de la mission.",
      "CERTIFIED_TOOLTIP": "Pourcentage d'utilisateurs ayant atteint ou dépassé les critères de notation pour toutes les simulations de la mission.",
      "SEARCH_FOR_A_USER_LABEL": "Chercher un utilisateur",
      "NO_USERS_FOUND_LABEL": "Aucun utilisateur trouvé",
      "TRAINER_TIME_SAVED_TOOLTIP": "Temps que les utilisateurs ont passé dans Quantified à tenter d’obtenir une certification.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Nombre moyen de sessions par mission",
      "ASSIGNMENTS_ENGAGED_WITH": "Missions terminées",
      "AVERAGE_IMPROVEMENT": "Amélioration moyenne",
      "STATUS": "État",
      "TOTAL_NUMBER_OF_SESSIONS": "Nombre total de sessions",
      "DATE_OF_LAST_PRACTICE": "Date du dernier entraînement",
      "CALL_NAME": "Nom de l’appel",
      "SESSION_DATE": "Date de la session",
      "DURATION_OF_SESSION": "Durée de la session",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING_SCORE": "Note d'adhésion au message",
      "METHODOLOGY_SCORE": "Note de méthodologie",
      "SKILLS_SCORE": "Note de compétences",
      "SESSIONS": "Sessions",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Toutes les missions",
      "RECENT_ASSIGNMENTS": "Missions récentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "HOURS_IN_SIMULATIONS": "Heures de simulation",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Nombre moyen de sessions pour devenir compétent",
      "PERCENT_PROFICIENT": "Pourcentage de compétence",
      "SYSTEM_RUNNING_NORMALLY": "Le système fonctionne actuellement normalement",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Aucun résultat ne correspond à vos filtres. Essayez de supprimer un ou plusieurs filtres pour élargir la recherche.",
      "USERS_PASSED": "Utilisateurs ayant réussi la simulation",
      "AVERAGE_TIME": "Temps moyen de la certification",
      "USERS_OUT_OF_ATTEMPTS": "Utilisateurs ayant épuisé toutes leurs tentatives",
      "NO_CERTIFICATION_SIMULATION": "Aucune simulation de certification trouvée",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Aucune session",
      "PERCENT_CERTIFIED": "Pourcentage certifié",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Pourcentage certifié à la première tentative",
      "USERS": "Utilisateurs",
      "ATTEMPTS_LABEL": "Tentatives",
      "NO_ATTEMPTS": "Aucune tentative",
      "DATE_OF_SESSION": "Date de la session",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Aucune mission ne correspond aux filtres choisis",
      "NO_TEAMS_DATA": "Il n'y a aucune équipe dans ce compte",
      "SIMULATION_NAME": "Nom de la simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durée moyenne d’une session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "AVERAGE_OVERALL_SCORE": "Note globale moyenne",
      "TOTAL_ASSIGNMENTS": "Total des missions",
      "ASSIGNMENTS_CERTIFIED": "Certifié pour les missions",
      "TOTAL_SESSIONS": "Nombre total de sessions",
      "HOURS_SPENT_PRACTICING": "Heures passées à l’entraînement",
      "LAST_LOGIN": "Dernière connexion",
      "SELECT_ASSIGNMENTS": "Sélectionner des missions",
      "CERTIFICATION_STATUS_LABEL": "État de la certification",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "État de la certification :",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certifié dès la première tentative ?",
      "DATE_OF_CERTIFICATION_LABEL": "Date de la certification",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "État de l’engagement :",
      "DURATION_OF_ATTEMPT": "Durée de la tentative",
      "USER_NAME": "Nom de l'utilisateur",
      "LEARNER": "Apprenant",
      "DATE_RANGE": "Fourchette de dates",
      "DATE_RANGE_LABEL": "Fourchette de dates",
      "SEARCH_USERS": "Recherche d'utilisateurs…",
      "SEARCH_SIMULATIONS": "Recherche de simulations…",
      "SEARCH_DATES": "Recherche de dates…",
      "CERTIFIED_ON_FIRST_TRY": "Certifié dès la première tentative",
      "DATE_OF_CERTIFICATION": "Date de la certification",
      "AVERAGE_CERTIFICATION_SCORE": "Note de certification moyenne",
      "TOTAL_TIME_CERTIFYING": "Durée totale de la certification",
      "OF_THE_TIME": "du temps",
      "ASSIGNED_LABEL": "Non commencée",
      "USERS_ASSIGNED_LABEL": "Total des utilisateurs assignés",
      "SESSION_ID": "ID de session",
      "USER_NAME_LABEL": "Nom de l'utilisateur",
      "NO_SIMULATIONS_FOUND_LABEL": "Aucune simulation trouvée",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "sur",
      "SECOND": "seconde",
      "SECONDS": "secondes",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNED": "Attribué",
      "ENGAGED_TOOLTIP": "Pourcentage d'utilisateurs de cette mission ayant complété une ou plusieurs sessions d'une simulation mais n'ayant pas encore atteint le niveau de compétence requis sur toutes les simulations.",
      "SEARCH_ASSIGNMENTS": "Recherche de missions…",
      "ASSIGNMENT_NAME_LABEL": "Nom de la mission",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "START_DATE": "Date de début",
      "END_DATE": "Date de fin",
      "NO_ASSIGNMENTS": "Aucune mission trouvée pour cet utilisateur.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Nombre total de missions d’entraînement",
      "SESSION_SCORES_OVER_TIME": "Note des sessions au fil du temps",
      "TIME": "Temps",
      "SCORE": "Note",
      "NO_SESSIONS_AVAILABLE": "Aucune session disponible pour le graphique.",
      "MESSAGING_SCORE_LABEL": "Note de messagerie",
      "PERSONALIZED_PRACTICE_LABEL": "Entraînement personnalisé",
      "ASSIGNMENT_ENAGEMENT": "Engagement par mission",
      "NO_PRODUCTS": "Aucun produit d’entraînement personnalisé pour les équipes sélectionnées",
      "TOTAL_TIME_SPENT_PRACTICING": "Temps total passé à pratiquer",
      "AVERAGE_SESSIONS_PER_USER": "Moyenne des sessions par utilisateur",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le plus courant",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le moins courant",
      "CLEAR_TEAMS": "Effacer les équipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Notes objectives moyennes pour l’ensemble des sessions de cet appel.",
      "METHODOLOGY": "Méthodologie",
      "MESSAGING": "Messagerie",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "La messagerie détermine si les apprenants expriment clairement 2 idées importantes au cours de cette simulation. Ces visualisations montrent le pourcentage de messages au sein d’un thème de message donné que les utilisateurs ont exprimé, en moyenne, au cours de l’ensemble des sessions de cet appel.",
      "NO_METRICS_MESSAGE": "Aucune session terminée pour les équipes sélectionnées.",
      "SELECT_ALL": "Sélectionner tout",
      "DESELECT_ALL": "Désélectionner tout",
      "SKILLS": "Compétences",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Les notes de compétences sont une évaluation par IA des compétences démontrées par les utilisateurs lors d’un appel.",
      "EXPERT": "Expert",
      "PROFICIENT": "Compétent",
      "DEVELOPING": "En développement",
      "FULLY_ARTICULATED": "Exprimé très clairement",
      "PARTIALLY_ARTICULATED": "Exprimé partiellement",
      "NOT_MENTIONED": "Non mentionné",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "La messagerie détermine si les utilisateurs expriment clairement 3 idées importantes lors de cet appel."
    },
    "reporting": {
      "AT_GLANCE": "Les missions en un coup d’œil",
      "OPEN_ASSIGNMENTS": "Missions ouvertes",
      "NOT_STARTED": "Non commencé",
      "CERTIFIED": "Certifié",
      "VIEW_LIST": "Voir la liste",
      "CERTIFICATION_ASSIGNMENTS": "Missions de certification",
      "CERTIFICATION_SUMMARY_TEXT": "Les certifications sont des missions qui ont une date d’échéance et des critères de réussite spécifiques.",
      "PRACTICE_ASSIGNMENTS": "Missions d’entraînement",
      "PRACTICE_SUMMARY_TEXT": "Les missions d’entraînement sont accessibles aux utilisateurs sans date d’échéance spécifique. Elles sont conçues pour permettre aux utilisateurs de s’entraîner régulièrement afin d’améliorer leurs compétences.",
      "THE": "Le",
      "WILL_CLOSE": "fermera dans",
      "USERS_HAVE": "les utilisateurs n'ont",
      "USER_HAS": "l’utilisateur n'a",
      "NOT_STARTED_ASSIGNMENT_DUE": "pas commencé une mission à remettre d’ici la semaine prochaine",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "pas terminé une mission à remettre d’ici la semaine prochaine",
      "DAYS": "jours",
      "DAY": "jour",
      "MODULES": "Modules",
      "MODULE": "Module",
      "CALL": "Simulation",
      "CALLS": "Simulations",
      "CERTIFICATION_ASSIGNMENT": "Mission de certification",
      "PRACTICE_ASSIGNMENT": "Mission d’entraînement",
      "AND": "et",
      "VIEW_ENGAGEMENT_DETAILS": "Voir les détails de la mission",
      "SEE_ALL": "Tout voir",
      "SEE_LESS": "Voir moins",
      "ASSIGNMENT": "Mission",
      "ASSIGNED": "Attribué",
      "IN_PROGRESS": "En cours",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNMENT_ENDS_IN": "La mission se termine dans",
      "ASSIGNMENT_CLOSED": "Mission clôturée",
      "OLDER_CERTIFICATION": "certification plus ancienne",
      "ASSIGNMENT_IS": "la mission est",
      "ASSIGNMENT_ARE": "les missions sont",
      "CURRENTLY_HIDDEN": "actuellement cachée(s)",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Toutes les missions de certification sont affichées.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Utilisateurs qui n’ont encore terminé aucune simulation ni obtenu de note pour une simulation.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Utilisateurs qui ont terminé au moins une simulation et obtenu une note.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Utilisateurs qui ont satisfait à l’exigence de certification.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Il s’agit du nombre d’utilisateurs qui peuvent accéder à la mission pour leurs certifications.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Voir toutes les missions de certification",
      "HIDE_OLDER_ASSIGNMENTS": "Masquer les missions plus anciennes",
      "AVG_PRACTICES": "Nombre moyen d’entraînements",
      "PRACTICED": "Entraîné",
      "SCORED_HIGH": "Note élevée",
      "AVG_ASSIGNMENT": "Amélioration moyenne",
      "DAYS_AGO": "jours",
      "NA": "N/A",
      "OLDER_PRACTICE": "entraînement plus ancien",
      "SEE_PRACTICE_ASSIGNMENT": "Voir toutes les missions d’entraînement",
      "ALL_PRACTICE_ASSIGNMENTS": "Toutes les missions d’entraînement sont affichées.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Utilisateurs qui n’ont encore terminé aucune simulation ni obtenu de note pour une simulation.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Ces utilisateurs ont terminé au moins une simulation et obtenu une note.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Nombre d’utilisateurs dans cette mission ayant obtenu au moins une fois un résultat égal ou supérieur au critère de note élevée défini pour toutes les simulations de cette mission.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Ces utilisateurs peuvent accéder à la mission pour s’entraîner.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Ce chiffre indique le nombre moyen de fois où des utilisateurs se sont entraînés à des simulations qui font partie de cette mission.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Cette mesure analyse les notes de chaque session, et trace une ligne droite sur un graphique pour illustrer la tendance. Un pourcentage élevé indique que les notes s’améliorent plus rapidement, tandis qu’un pourcentage faible indique que les notes s’améliorent plus lentement.",
      "USERS": "utilisateurs",
      "USER": "utilisateur",
      "DOWNLOAD_CSV": "Télécharger le CSV",
      "ERROR": "Une erreur s’est produite",
      "FIRST_NAME": "Prénom",
      "LAST_NAME": "Nom de famille",
      "ATTEMPTS": "Tentatives",
      "EMAIL": "E-mail",
      "LAST_LOGIN": "Dernière connexion",
      "ASSIGNMENT_NOT_STARTED": "Mission non commencée",
      "ASSIGNMENT_IN_PROGRESS": "Mission en cours",
      "SCORE_CRITERIA_MET": "Critères de note atteints",
      "NEVER_LOGGED_IN": "Non connecté",
      "QUANTIFIED_REPORTING": "Rapports Quantified",
      "ASSIGNED_USERS": "Utilisateurs assignés",
      "COMPLETION_REQUIREMENT": "Conditions d’achèvement",
      "AVG_SCORE_Of": "Moyenne Note de",
      "REPORTING": "Rapports",
      "CERTIFICATIONS": "Certifications",
      "PRACTICES": "Entraînements",
      "CALL_ANALYSIS": "Analyse de simulation",
      "PERCENT_CERTIFIED_ON": "Pourcentage certifié sur",
      "SHOWING": "Affichage",
      "PRACTICE_SESSIONS": "Nombre cumulatif de séances d’entraînement pour toutes les simulations du module",
      "AVG_PRACTICE_HEADING": "Nombre moyen de séances d’entraînement par utilisateur actif",
      "AVG_SCORE_LABEL": "Moyenne Note",
      "AVG_SCORE_HEADING": "Note moyenne par utilisateur",
      "AVG_PRACTICES_LABEL": "Moyenne Entraînements",
      "EXPORT_LEARNER_LIST": "Exporter la liste des apprenants",
      "PERCENT_NOT_STARTED": "% non commencé",
      "PERCENT_IN_PROGRESS": "% en cours",
      "PERCENT_CERTIFIED": "% certifié",
      "USER_CERTIFIED": "Utilisateur certifié",
      "USERS_CERTIFIED": "Utilisateurs certifiés",
      "TOTAL_ATTEMPTS": "Nombre total de tentatives",
      "Avg_ATTEMPTS_CERTIFY": "Nombre moyen de tentatives de certification",
      "ASTERICK_GROUP": "Désigne un groupe qui contient un ou plusieurs sous-groupes",
      "NO_DATA_FOUND": "Aucune donnée n’a été trouvée",
      "MODULE_HIGHLIGHTS": "Points clés du module",
      "MODULE_HIGHLIGHT_SUMMARY": "Indicateurs clés pour toutes les simulations. Pour une analyse détaillée de chaque simulation, voir l’aperçu ci-dessous",
      "HIGHEST_SCORING_QUESTION_TITLE": "QUESTION AYANT OBTENU LA NOTE LA PLUS ÉLEVÉE",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Question ayant obtenu la note la plus élevée",
      "QUESTION_BAR_MSG": "Pourcentage moyen de réponses correctes",
      "LOWEST_SCORING_QUESTION_TITLE": "QUESTION AYANT OBTENU LA NOTE LA PLUS BASSE",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Question ayant obtenu la note la plus basse",
      "TOP_SCORED_ANSWER_POINT_TITLE": "RÉPONSE LA MIEUX NOTÉE",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Question avec le moins de réponses manquées",
      "SCORE_BAR_MSG": "du temps, les utilisateurs réussissent cette question.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "RÉPONSE LA MOINS BIEN NOTÉE",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Question avec le plus de réponses manquées",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "MÉTHODOLOGIE DE NOTATION LA PLUS BASSE",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Méthodologie de notation la plus basse",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "MÉTHODOLOGIE DE NOTATION LA PLUS ÉLEVÉE",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Méthodologie de notation la plus élevée",
      "OBJECTIVE_BAR_MSG": "moyenne de points pour cette méthodologie",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MESSAGE LE MOINS CLAIR",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Message le moins clair",
      "LEAST_ARTICULATED_BAR_MSG": "Exprimez clairement ce message",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MESSAGE LE PLUS CLAIR",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Message le plus clair",
      "MOST_ARTICULATED_BAR_MSG": "Exprimez très clairement ce message",
      "Overview": "Vue d’ensemble",
      "CONSISTS_Of": "se compose de",
      "CALL_OVERVIEW_LABEL": "Le graphique montre le nombre d’utilisateurs qui ont",
      "PASSED": "Réussi",
      "ATTEMPTED": "Tenté",
      "NOT_ATTEMPTED": "Non tenté",
      "GUIDED_CALL": "Vérification des connaissances",
      "QUESTIONS": "Questions",
      "QUESTION": "Question",
      "CONVERSATIONAL_CALL": "Jeu de rôle",
      "AVG_ATTEMPTS": "Moyenne Tentatives",
      "USERS_PASSED": "utilisateurs ayant réussi",
      "DETAILED_ANALYSIS": "Analyse détaillée",
      "CALL_DETAILS": "Détails de la simulation",
      "CALL_TYPE": "Type de simulation",
      "TOTAL_SESSIONS": "Nombre total de sessions",
      "WHAT_WE_MEASURED": "Ce que nous avons mesuré",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Note globale moyenne",
      "OVERALL_SCORE_DETAIL": "Notre système fournit une « note globale » pour chaque conversation. Ce chiffre correspond à la note globale moyenne pour l’ensemble des",
      "CALL_RUN": "utilisateurs qui ont effectué cette simulation",
      "TIME": "fois",
      "TIMES": "fois",
      "OBJECTIVES": "Méthodologie",
      "AVG_OBJECTIVE": "Notes de méthodologie moyennes pour l’ensemble des",
      "OF_THIS_CALL": "de cette simulation",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "MESSAGE_ADHERENCE_DETAILS_1": "L’adhésion au message indique si les apprenants expriment clairement les",
      "MESSAGE_ADHERENCE_DETAILS_2": "idées importantes au cours de cette simulation. Ces visualisations montrent le pourcentage de messages au sein d’un thème de message donné que les utilisateurs ont exprimé, en moyenne, pour l’ensemble des",
      "IMPORTANT_IDEAS": "idées importantes au cours de cette simulation",
      "PERCENT_MESSAGE_ARTICULATED": "Ces visualisations montrent le pourcentage de fois où chaque message est exprimé clairement dans l’ensemble des",
      "FULLY_ARTICULATED": "Exprimé très clairement",
      "PARTIALLY_ARTICULATED": "Exprimé partiellement",
      "NOT_MENTIONED": "Non mentionné",
      "SKILLS_LABEL": "Compétences",
      "SKILLS_DETAILS": "Les notes de compétences sont une évaluation par IA des compétences démontrées par les utilisateurs durant une simulation. Ces visualisations montrent le pourcentage de fois où les utilisateurs ont obtenu les notes « Expert » (la plus élevée), « Compétent » et « En développement » (la plus basse) pour l’ensemble des",
      "DEVELOPING": "En développement",
      "PROFICIENT": "Compétent",
      "Expert": "Expert",
      "NO_RESULT": "Pas encore de résultats",
      "NO_RESULT_TEXT": "Aucun des utilisateurs de votre entreprise n’a encore tenté cette simulation. Une fois qu’ils l’auront fait, vous pourrez voir leurs résultats ici !",
      "CONVERSATIONAL_CALL_TOOLTIP": "Durant les jeux de rôle, l’utilisateur peut diriger le flux de la conversation, et l’IA répondra en conséquence. Les jeux de rôle sont moins structurés que les appels « vérifications des connaissances », qui ont un format strict de questions-réponses",
      "TOTAL_SESSION_TOOLTIP": "Nombre total de fois que cette simulation a été effectuée par tous les utilisateurs auxquels elle a été attribuée",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "AVERAGE_SCORE_DETAIL": "Note moyenne de tous les utilisateurs de cette simulation",
      "ANSWER_POINTS": "Points de réponse",
      "DETAILS": "Détails",
      "CONVERSATIONAL_CALL_MSG": "Les rapports sur le contenu des jeux de rôle seront bientôt disponibles",
      "ALL_CALL_DETAILS": "Tous les détails de la simulation",
      "QUESTION_TEXT_LABEL": "Texte de la question",
      "AVG_POINTS_LABEL": "Moyenne des points",
      "SHOW_ALL": "Tout afficher",
      "CORRECT_ANSWER": "réponses correctes sur",
      "OBJECTIVE_MEASURED_ON": "Cette méthodologie est mesurée sur",
      "CALLS_IN_MODULE": "simulations dans ce module",
      "VIEW_CALL_DETAILS": "Voir les détails",
      "QUESTION_UPDATED": "Cette question a été mise à jour",
      "QUESTION_UPDATED_MESSAGE": "Nous ne sommes pas en mesure d’afficher des informations détaillées sur les réponses, car des mises à jour ont été apportées à cette question. Les « points moyens » affichés représentent la moyenne de toutes les sessions de cette question (y compris avant et après les mises à jour)",
      "CLOSE_ALT": "Fermer",
      "Q_LABEL": "Q",
      "SCORING_LABEL": "Notation",
      "AVERAGE_ANSWER": "Moyenne des points de réponse obtenus par question",
      "MINIMIZE_LABEL": "Réduire",
      "VIEW_ALL_LABEL": "Voir tout",
      "DOWN_ARROW": "Flèche vers le bas",
      "NOTIFICATION": "Notification",
      "PROGRESS_ICON": "Icône de progression",
      "VIEW_MODAL": "Voir la fenêtre contextuelle",
      "VIEW_INFO": "Voir l’info",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Développer le groupe",
      "MESSAGE_ADHERENCE_V2": "Adhésion au message",
      "SCORE_OVERALL": "Note globale",
      "SCORE_SKILLS": "Compétences",
      "SCORE_CUSTOMIZED": "Méthodologie",
      "SESSIONS": "sessions",
      "SESSION": "session"
    },
    "personalizedPractice": {
      "TITLE": "Entraînement personnalisé",
      "DESCRIPTION": "Bonjour {{userFirstName}} ! Les entraînements personnalisés vous permettent de paramétrer vos propres scénarios afin qu'ils soient aussi réalistes que possible.",
      "LOADING": "Chargement…",
      "VIEW_SESSIONS": "Voir les sessions",
      "VIEW_SIMULATION": "Voir la simulation",
      "TOTAL_SESSION": "nombre total de sessions",
      "TOTAL_SESSIONS": "nombre total de sessions",
      "BREADCRUMB": "Entraînement personnalisé",
      "SCENARIO_DETAILS_TITLE": "Détails du scénario",
      "SCENARIO_DETAILS_DESCRIPTION": "Sélectionnez des variables parmi les options ci-dessous pour ajuster la simulation en fonction de vos besoins.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Sélectionnez",
      "CONVERSATION_TYPE": "Type de conversation",
      "SELECT_CONVERSATION_TYPE": "Sélectionner un type de conversation",
      "LAUNCH_SIMULATION": "Lancer la simulation avec les sélections",
      "PREVIOUS_SESSIONS": "Sessions précédentes",
      "TOTAL": "Total",
      "FILTERS": "Filtres :",
      "DATE": "Date",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "SESSION_DATE": "Date de la session",
      "SESSION_SCORE": "Note de la session",
      "DURATION": "Durée",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING": "Messagerie",
      "METHODOLOGY": "Méthodologie",
      "SKILLS": "Compétences",
      "RESULTS": "Résultats",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "OVERALL_SCORE_LABEL": "Note globale",
      "SCORE": "Note",
      "NO_PRODUCTS_TITLE": "Aucun produit disponible",
      "NO_PRODUCTS_DESCRIPTION": "Vous n'avez pas encore de produits d’entraînements personnalisés.",
      "NO_SESSIONS_FOUND": "Aucune session trouvée avec les filtres sélectionnés",
      "TIME": "Temps",
      "ALL": "Tous",
      "LEARNER": "Apprenant",
      "MOOD": "Humeur",
      "CLEAR_FILTERS": "Supprimer les filtres"
    },
    "login": {
      "TITLE": "Bienvenue",
      "SUB_TITLE": "Comment souhaitez-vous vous connecter ?  ",
      "LOGIN_WITH_SSO": "Se connecter avec le SSO de l’entreprise",
      "LOGIN_WITH_PASSWORD": "Se connecter avec un mot de passe",
      "PROVIDE_EMAIL": "Indiquez votre adresse électronique",
      "HELP_TEXT": "Vous avez besoin d’aide ? Coordonnées",
      "EMAIL_ERROR": "Nous ne sommes pas en mesure de vous connecter. Veuillez contacter l’administrateur ou le service informatique de votre entreprise.",
      "EMAIL": "E-mail",
      "LOGIN": "Se connecter",
      "ALERT": "Alerte",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "En vous connectant à votre compte, vous acceptez les {{termsLink}} et la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Conditions de service",
      "PRIVACY_POLICY": "Politique de confidentialité"
    },
    "learningPathway": {
      "BEGIN": "Commencer",
      "DUE_DATE": "Date d’échéance",
      "FOOTER_SUBTITLE_READY": "Posez-moi n'importe quelle question ! Je suis prêt à vous aider.",
      "LEAVE_STEP": "Quitter l’étape",
      "NEXT_STEP": "Étape suivante",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_NEXT_PAGE": "Page suivante",
      "PDF_NO_SOURCE": "Aucune source PDF fournie.",
      "PDF_PREVIOUS_PAGE": "Page précédente",
      "POST_CALL_SUBTITLE": "Laissez-nous un retour d’information pendant que nous traitons vos résultats",
      "POST_CALL_TITLE": "Vous avez atteint la fin de ce questionnaire.",
      "SETTINGS": "Paramètres",
      "TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran des détails du parcours pour votre prochaine étape.",
      "TOAST_TITLE": "Vos résultats pour le jeu de rôle ont été traités",
      "ASSIGNMENTS": "Missions",
      "USER_FALLBACK": "Utilisateur",
      "VIEW_RESULTS": "Voir les résultats",
      "QUIZ_TITLE": "Questionnaire"
    },
    "leaderboard": {
      "LEADERBOARD": "Tableau des notes",
      "TOP10PERCENT": "10 % les meilleures",
      "PRACTICE_ASSIGNMENT": "Missions d’entraînement",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Sélectionner une mission",
      "SELECT_SIMULATION": "Sélectionner une simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Sélectionnez une mission et une simulation pour voir les meilleures notes",
      "NO_DATA": "Aucune activité pour l’instant. Une fois que l'équipe aura commencé à s’engager, vous verrez les classements apparaître ici.",
      "NO_ASSIGNMENTS_AVAILABLE": "Aucune mission disponible",
      "NO_SIMULATIONS_AVAILABLE": "Aucune simulation disponible",
      "NAME": "Nom",
      "HIGH_SCORE": "Note élevée",
      "AVERAGE_SCORE": "Note moyenne",
      "TOTAL_SESSIONS": "Nombre total de sessions",
      "LAST_SESSION": "Dernière session",
      "TOP5": "5 meilleures",
      "OF": "sur",
      "ENGAGED_USERS": "utilisateurs engagés",
      "ENGAGED_USER": "utilisateur engagé",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Masquer les sessions dont les notes de compétences sont faibles",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Les sessions dont la note de la section compétences est « en développement » ne contribueront pas aux colonnes des notes élevées ou moyennes.",
      "NO_USERS_ENGAGED": "Aucun utilisateur engagé"
    },
    "general": {
      "NEED_HELP_QUESTION": "Vous avez besoin d’aide ?",
      "CONTACT": "Coordonnées",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Compte parent",
      "ACCOUNT": "Compte",
      "CHECKMARK": "Coche",
      "ICON": "Icône",
      "ALERT": "alerte",
      "HEADS_UP": "Attention !",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Pour un son optimal sur iPad, veuillez utiliser des écouteurs.",
      "SETTINGS": "PARAMÈTRES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Chef d’équipe pou",
      "MIAMI_SALE": "Ventes à Miami",
      "CHARLOTTE_SALES": "Ventes à Charlotte",
      "ATLANTA_SALES": "Ventes à Atlanta",
      "TEAM": "Équipe",
      "ASSIGNMENTS": "Missions",
      "MY_TEAMS": "Mes équipes",
      "REPORTING": "Rapports",
      "DASHBOARD": "Tableau de bord",
      "LEADERBOARD": "Tableau des notes",
      "PERSONALIZED_PRACTICE": "Entraînement personnalisé",
      "HELP_SEARCH_OUR": "Effectuez une recherche dans notre",
      "HELP_OR_REACH_OUT_TO": "ou contactez",
      "HELP_WITH_QUESTIONS": "pour poser des questions",
      "KNOWLEDGE_BASE": "base de connaissances"
    },
    "dashboard": {
      "ALL": "Tous",
      "IN_COMPLETE": "Incomplet",
      "COMPLETED": "Terminé",
      "NO_ASSIGNMENT_TITLE": "Vous n’avez pas de mission à accomplir.",
      "NO_ASSIGNMENT_DETAILS": "Vous serez averti lorsque vous aurez des missions à accomplir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Vous n’avez aucune mission incomplète.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Vous serez averti lorsqu’une nouvelle mission sera à remettre.",
      "COMPLETED_ASSIGNMENT_TITLE": "Vous n’avez aucune mission terminée.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Revenez une fois que vous aurez terminé une mission.",
      "VIEW_ASSIGNMENT": "Voir la mission",
      "ASSIGNMENT_LABEL": "Missions",
      "MODULE_ASSIGNMENT_ALT": "Icône de mission du module",
      "VIEW_ASSIGNMENT_FOR": "Voir la mission pour",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "AVAILABLE_IN": "Disponible dans",
      "DUE_TODAY": "À remettre aujourd’hui",
      "PRACTICE": "Entraînement",
      "CERTIFICATION": "Certification",
      "UPCOMING": "À venir",
      "TEST_ASSIGNMENT": "Mission test",
      "CLOSED": "Fermé",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Aucune mission trouvée.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Essayez d'ajuster vos filtres pour voir les missions disponibles, ou revenez plus tard lorsque de nouvelles missions auront été ajoutées.",
      "VIEW_PATHWAY": "Voir le parcours",
      "TOTAL": "Total",
      "STATUS_LABEL": "État",
      "STATUS_SELECTION_LABEL": "État :",
      "ASSIGNMENT_TYPE": "Type de mission",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Type de mission :",
      "NOT_STARTED": "Non commencé",
      "CERTIFIED": "Certifié",
      "NOT_CERTIFIED": "Non certifié",
      "IN_PROGRESS": "En cours",
      "PATHWAY": "Parcours d'apprentissage",
      "SELECT_ALL": "Sélectionner tout",
      "DESELECT_ALL": "Désélectionner tout"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bienvenue à Quantified !",
      "INVITATION_MESSAGE": "Nous sommes ravis de vous compter parmi nous ! Pour commencer, veuillez suivre les étapes ci-dessous afin de vous connecter à votre compte pour la première fois.",
      "ACCOUNT_DETAILS": "Détails de votre compte :",
      "USERNAME": "Nom d’utilisateur",
      "PASSWORD": "Mot de passe temporaire",
      "STEPS_LABEL": "Étapes suivantes pour se connecter",
      "STEP_1": "1. Cliquez sur le bouton \"Se connecter\" ci-dessous pour accéder à la page de connexion.",
      "STEP_2": "2. Saisissez votre nom d’utilisateur et le mot de passe temporaire indiqué ci-dessus.",
      "STEP_3": "3. Une fois connecté, vous serez invité à définir un nouveau mot de passe.",
      "LOGIN_BUTTON": "Se connecter",
      "ABOUT_US": "Le Simulateur de Quantified est un environnement virtuel conçu pour vous aider à développer rapidement des compétences essentielles, vous permettant de contacter des clients et de communiquer plus efficacement avec eux.",
      "EXPIRY_TIME": "Ce mot de passe temporaire expirera dans 24 heures. Si vous rencontrez des difficultés pour vous connecter, veuillez contacter notre équipe d’assistance à l’adresse",
      "TEAM": "L’équipe Quantified",
      "INVITATION_SMS_USERNAME": "Votre nom d’utilisateur est",
      "INVITATION_SMS_PASSWORD": "et le mot de passe temporaire est",
      "AUTHENTICATION_CODE": "Votre code d’authentification est",
      "PASSWORD_RESET_CODE": "Votre code de réinitialisation du mot de passe Quantified",
      "RESET_PASSWORD_EMAIL": "E-mail de réinitialisation du mot de passe",
      "HELLO": "Bonjour",
      "USE_VERIFICATION_CODE": "Vous avez demandé une réinitialisation de votre mot de passe. Veuillez utiliser le code de vérification ci-dessous pour terminer le processus.",
      "VERIFICATION_CODE": "Code de vérification",
      "NEXT_STEP": "Étapes suivantes",
      "RESET_PASSWORD_PAGE": "Retournez à la page de réinitialisation de votre mot de passe dans votre navigateur.",
      "ENTER_VERIFICATION_CODE": "Saisissez le code de vérification lorsque vous y êtes invité.",
      "CREATE_PASSWORD": "Une fois le code vérifié, suivez les instructions pour créer un nouveau mot de passe.",
      "DISREGARD_NOTE": "Si vous n’avez pas demandé à réinitialiser votre mot de passe, veuillez ignorer cet e-mail.",
      "CONTACT_SUPPORT": "Pour plus d’assistance, contactez notre équipe d’assistance à l’adresse",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Merci",
      "QUANTIFIED_TEAM": "L’équipe Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, États-Unis"
    },
    "call": {
      "LOADING": "Chargement",
      "SIMULATION_PAUSED": "La simulation a été mise en pause.",
      "CLICK_RESUME": "Cliquez sur le bouton « Reprendre » ci-dessous pour continuer.",
      "NO_INTERNET": "Aucune connexion Internet",
      "TRY_AGAIN": "Veuillez vérifier votre connexion et réessayer.",
      "MIC_MUTED": "Le micro est en sourdine",
      "MIC_MUTED_DESCRIPTION": "Oups, on dirait que votre micro est en sourdine. Rétablissez le son pour répondre et poursuivre.",
      "NO_RESPONSE": "Aucune réponse détectée",
      "MIC_NOT_CONNECTED": "Oups, on dirait que votre micro n’est pas connecté. Sélectionnez à nouveau votre appareil pour répondre et poursuivre.",
      "AUDIO_ISSUE": "Oups, un problème est survenu. Vérifiez les paramètres de votre appareil, et assurez-vous d'être dans un endroit calme, sans bruit de fond.",
      "LOADING_ALT": "Chargement...",
      "REPEAT_RESPONSE": "Vous serez automatiquement renvoyé à la simulation pour répéter votre réponse et réessayer.",
      "NEEDS_MORE_TIME_QUESTION": "a besoin de plus de temps pour réfléchir. Voulez-vous attendre ?",
      "NEEDS_MORE_TIME": "a besoin de plus de temps pour réfléchir.",
      "WAIT_OR_END_CALL": "Nous vous préviendrons lorsqu’ils seront prêts, ou vous pouvez mettre fin à l’appel et",
      "RETURN_TO_ASSIGNMENTS": "Retourner à la mission",
      "READY": "Prêt",
      "IS_READY": "est prêt à poursuivre la conversation.",
      "TRY_AGAIN_LABEL": "Réessayer",
      "CHECK_SETTINGS": "Vérifier les paramètres",
      "PAUSED_SIMULATION": "Vous avez mis cette simulation en pause.",
      "PAUSED_SIMULATION_DESCRIPTION": "L’enregistrement vidéo et audio est mis en pause jusqu’à ce que la simulation reprenne.",
      "RESUME": "Reprendre",
      "SETTINGS": "Paramètres",
      "CAPTURING_RESPONSE": "Capture de vos réponses",
      "TOUR_MESSAGE": "Une fois que vous aurez fini de parler, assurez-vous de cliquer sur le bouton Continuer pour que vos réponses soient capturées et notées.",
      "NEXT": "Suivant",
      "START_CALL": "Commencer",
      "END_CALL_TITLE": "Souhaitez-vous vraiment mettre fin à cette simulation ?",
      "END_CALL_DESCRIPTION": "Si vous mettez fin à la simulation maintenant, vous n’obtiendrez pas de note ni de retour d’information sur votre conversation.",
      "END_CALL": "Terminer",
      "BROWSER_ACCESS_DENIED": "Votre navigateur n’a pas accès à cet appareil.",
      "COPY_SESSION_ID_BUTTON": "Copier l’ID de session",
      "TIPS_GUIDANCE_MESSAGE": "Des points de discussion et des conseils s’afficheront ici.",
      "CONTINUE": "Continuer",
      "SESSION_ID_LABEL": "ID de session :",
      "SESSION_ID_COPIED": "L’ID de session a été copié !",
      "HINTS_AND_SUGGESTIONS_TITLE": "Conseils et suggestions",
      "HINT_LABEL": "Conseil",
      "CAPTIONS_LABEL": "Sous-titres",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Vidéo",
      "PARTY_EMOJI": "émoji de fête",
      "CALL_ENDED_MESSAGE": "Vous avez atteint la fin de cette simulation.",
      "CALL_ENDED_INACTIVITY": "Cette simulation a pris fin en raison d’une inactivité",
      "CALL_ENDED_GENERIC": "Cette simulation est terminée",
      "FEEDBACK_PROMPT": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "INTERACTION_THRESHOLD_NOT_MET": "Vous n’avez pas atteint notre seuil d’interaction pour la notation. Veuillez réessayer.",
      "REALISTIC_CONVERSATION_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle ?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Vous sentez-vous mieux informé et préparé après cette simulation ?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires !",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires ! Nous nous efforcerons d’améliorer l’expérience.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "L’aide visuelle n’a pas pu être chargée",
      "BEGIN_CALL": "Commencer",
      "LEAVE_CALL_BRIEFING": "Quitter les directives",
      "RESTORE_CALL": "Restauration de votre simulation",
      "FEW_SECONDS": "Cela peut prendre quelques secondes.",
      "CHECK_ALT": "Coche",
      "COPY_ALT": "Copier",
      "HINTS_ALT": "Conseils",
      "CLOSE_CAPTIONS": "Fermer les sous-titres",
      "MICROPHONE_MUTED": "Microphone en sourdine",
      "RETURN_TO_CALL": "Retourner à la simulation",
      "YES": "Oui",
      "NO": "Non",
      "VIEW_RESULTS": "Voir les résultats",
      "RETURN_TO_ASSIGNMENT": "Retourner à la mission",
      "HAVING_ISSUES": "Nous avons des difficultés à nous connecter. Veuillez vérifier votre connexion Internet, puis cliquez sur OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Désolé, nous ne sommes pas en mesure de générer des résultats pour le moment. Veuillez réessayer.",
      "INACTIVITY_ALERT_MESSAGE": "Cet appel est en train de se terminer en raison d’une inactivité. Parlez à l’avatar pour continuer, ou sélectionnez « Mettre fin à l’appel » pour terminer l’appel.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Cet appel se terminera dans {{secondsUntilHangup}} secondes",
      "INACTIVITY_SHORT_ALERT_TITLE": "Cet appel se terminera dans quelques secondes",
      "TELL_YOUR_GENDER_HEADING": "Veuillez indiquer votre genre :",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "En connaissant votre genre, l’avatar pourra utiliser une grammaire correcte, ce qui rendra la conversation plus naturelle et plus réaliste.",
      "GENDER_SELECTION": "Sélection du genre :",
      "SELECT_OPTION": "Sélectionner une option",
      "CONFIRM": "Confirmer",
      "MALE": "Homme",
      "FEMALE": "Femme",
      "NON_BINARY": "Non-binaire/Autre",
      "PREFER_NOT_TO_ANSWER": "Préfère ne pas répondre",
      "NON_BINARY_MESSAGE": "Nous comprenons et respectons votre identité de genre non binaire. En raison des limites technologiques actuelles, nous utilisons par défaut des pronoms masculins. Sachez que nous travaillons à des améliorations pour mieux prendre en compte toutes les identités de genre. Nous vous remercions de votre compréhension et de votre patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Nous respectons votre choix de ne pas fournir de genre. Dans ce cas, notre technologie utilise par défaut les pronoms masculins en raison des limitations actuelles.",
      "DISPLAY_VISUAL_AID": "Afficher l’aide visuelle",
      "FULL_SCREEN": "Plein écran",
      "COLLAPSE": "Réduire",
      "COMPLETED_CONVERSATION_MESSAGE": "Merci d'avoir terminé cette conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Laissez un retour d’information pendant que nous traitons votre conversation.",
      "ERROR_MESSAGE": "Une erreur s'est produite. Veuillez contacter",
      "SAVED_CONVERSATION_MESSAGE": "Votre conversation a été enregistrée.",
      "RETURN_TO_MY_ASSIGNMENTS": "Retourner à mes missions",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retourner à l’entraînement personnalisé",
      "PERSONALIZED_CALL_NOTE": "Vous venez de terminer une conversation d’entraînement personnalisée.",
      "LEAVE_STEP_TITLE": "Souhaitez-vous vraiment quitter cette étape ?",
      "EXIT": "Quitter"
    },
    "assignment": {
      "STATUS": "ÉTAT",
      "SCORE": "NOTE",
      "MUST_ACHIEVE": "Doit obtenir un",
      "OR_HIGHER": "ou plus",
      "TEST": "Test",
      "OUT_OF_5": "sur 5",
      "LATEST_ATTEMPT": "DERNIÈRE TENTATIVE",
      "TOTAL_ATTEMPTS": "Nombre total de tentatives",
      "UNLIMITED": "Illimité",
      "REMAINING": "Restant",
      "VIEW_CALL_DETAILS": "Voir les détails",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "DUE_DATE": "Date d’échéance",
      "DAYS": "Jours",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "ONGOING": "En cours",
      "SCORE_REQUIREMENT": "Exigence de note",
      "SCORE_REQUIREMENT_DETAIL": "Vous devez obtenir une note de",
      "TO_COMPLETE_EACH_CALL": "pour terminer chaque simulation requise.",
      "CALLS_IN_ASSIGNMENT": "Simulations de la mission",
      "INCOMPLETE_CALL": "Incomplet",
      "PREVIOUS_RESULTS": "Résultats précédents",
      "DATE": "Date",
      "RESULTS": "Résultats",
      "VIEW_PREVIOUS_RESULTS": "Voir les résultats précédents",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "LAUNCH_CALL": "Lancer",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CHECKMARK": "coche",
      "CALL": "Appeler",
      "QUESTION": "Question",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Non commencée",
      "CERTIFIED": "Certifié",
      "GUIDED": "Guidé",
      "CONVERSATIONAL": "Conversationnel",
      "GUIDED_SIMULATION": "Vérification des connaissances",
      "CONVERSATIONAL_SIMULATION": "Jeu de rôle",
      "NO_ATTEMPTS_LEFT": "Il ne reste plus de tentatives",
      "NO_ATTEMPTS": "Aucune tentative",
      "OVERVIEW": "Vue d’ensemble",
      "ABOUT_THE_AVATAR": "À propos de l’avatar",
      "SCORING_CRITERIA": "Critères de notation",
      "SIMULATION_OVERVIEW": "Aperçu de la simulation",
      "ABOUT_THE_PERSONA": "À propos de la persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Fermé"
    }
  },
  "fr-CA": {
    "root": {
      "ADMIN_PORTAL": "PORTAIL ADMIN",
      "SUPPORT": "SOUTIEN",
      "U": "U",
      "USER": "Utilisateur",
      "LOGOUT": "Déconnexion",
      "ADMIN": "Administrateur",
      "SUPPORT_SMALL": "Soutien",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMÉRA",
      "ACCESS_DENIED": "ACCÈS_REFUSÉ"
    },
    "teams": {
      "MY_TEAMS": "Mes équipes",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Pas commencé",
      "ASSIGNMET_MODULE": "Module d’affectation",
      "START_DATE": "Date de début",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNED_MEMBERS": "Membres assignés",
      "CALLS_IN_MODULE": "Simulations dans le module",
      "COMPLETION_REQUIRMENT": "Condition d’achèvement",
      "COMPLETE_ALL_CALLS": "Terminer tous les appels avec une note de",
      "OR_HIGHER": "ou plus",
      "PROGRESS_OVERVIEW": "APERÇU DES PROGRÈS RÉALISÉS",
      "TEAM_MEMBERS": "membres de l’équipe",
      "AVERAGE_HIGH_SCORE": "Moyenne des notes élevées",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Nombre moyen de tentatives par simulation",
      "TOTAL_PRACTICES": "Total des pratiques",
      "INDIVIDUAL_CALL_PROGRESS": "LA PROGRESSION DE LA SIMULATION INDIVIDUELLE",
      "OF_TEAM_MEMBERS": "Nombre de membres de l’équipe ayant terminé leur formation",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Pratiques moyennes jusqu’à l’achèvement",
      "TEAM_MEMBER_DETAILS": "INFORMATIONS SUR LES MEMBRES DE L’ÉQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Télécharger le rapport d’activité",
      "TEAM_MEMBER": "Membre de l’équipe",
      "PROGRESS": "Progrès",
      "CALLS_COMPLETED": "Simulations réalisées",
      "PRACTICES": "Séances de pratique",
      "MOST_RECENT_PRACTICE": "Dernière session",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Cette équipe n’a pas d’affectation active pour le moment.",
      "CALL_NAME_LABEL": "Nom de la simulation",
      "HIGHEST_SCORE": "Meilleure note"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assurez-vous que votre appareil est configuré.",
      "MICROPHONE_REQUIRED_NOTICE": "Un microphone en état de marche est nécessaire.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si vous n’avez pas vu de fenêtre contextuelle vous demandant d’activer vos appareils après avoir actualisé cette page, veuillez accéder aux paramètres de votre système ou de votre navigateur et activer vos appareils à partir de là. Vous trouverez ci-dessous des pages d'aide contenant des instructions supplémentaires.",
      "ENABLE_CAMERA": "Comment activer votre appareil photo :",
      "WINDOWS_USERS": "Utilisateurs de Windows",
      "MAC_USERS": "Utilisateurs de Mac",
      "IPAD_USERS": "Utilisateurs d’iPad",
      "ENABLE_MICROPHONE": "Comment activer votre microphone :",
      "ENABLE_DEVICES_BY_BROWSER": "Comment activer vos appareils par navigateur :",
      "CHROME_USERS": "Utilisateurs de Chrome",
      "SAFARI_USERS": "Utilisateurs de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Démarrage sans caméra",
      "START_CALL_BUTTON": "Début de l’appel",
      "MICROPHONE_REQUIRED_WARNING": "Un microphone en état de marche est nécessaire.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Sélectionnez votre microphone",
      "ALERT": "alerte",
      "GIVE_PERMISSION": "Donner l’autorisation",
      "SELECT_VIDEO_DEVICE": "Sélectionnez votre appareil vidéo",
      "VIDEO": "vidéo",
      "DEVICE_BLOCKED_ERROR": "Il semble que vous ayez refusé à ce navigateur l’accès à un ou plusieurs de vos appareils. Pour activer les appareils, veuillez accéder aux paramètres de votre système ou de votre navigateur et activer l’accès.",
      "DEVICE_SETTINGS": "Paramètres de l’appareil",
      "CONFIRM_SETTINGS": "Confirmer les paramètres",
      "LAPTOP": "Ordinateur portable",
      "SAD_EMOTE_FACE": "Émoji visage triste",
      "GRANT_BROWSER_ACCESS": "Pour effectuer cette simulation, veuillez autoriser l’accès du navigateur à la reconnaissance vocale.",
      "USING_IPAD": "Si vous utilisez un iPad, accédez à",
      "SETTINGS": "Paramètres",
      "PRIVACY_AND_SECURITY": "Vie privée et sécurité",
      "SPEECH_RECOGNITION": "Reconnaissance de la parole",
      "GRANT_ACCESS_REFRESH": "Accorder l’accès au navigateur et actualiser la page",
      "REFRESH_PAGE": "ACTUALISER LA PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Le navigateur ne peut pas accéder à cet appareil",
      "ACCESS_DENIED": "accès refusé",
      "CAMERA": "Appareil photo",
      "DIAGNOSTIC_PASSED": "Tous les tests de diagnostic ont réussi avec succès.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Certains tests de diagnostic ont échoué. Veuillez cliquer sur le bouton « Copier les résultats du diagnostic » ci-dessus et envoyer les résultats à l'équipe de soutien pour plus d’assistance.",
      "DIAGNOSTIC_PARTIAL": "La plupart des tests de diagnostic ont réussi avec succès. Votre connexion semble bonne.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Veuillez patienter pendant que les tests de diagnostic sont en cours d'exécution...",
      "DIAGNOSTIC_RUNNING": "Diagnostic en cours",
      "COPY_DIAGNOSTIC_RESULTS": "Copier les résultats du diagnostic",
      "RUN_DIAGNOSTIC": "Exécuter le diagnostic",
      "RERUN_DIAGNOSTIC": "Relancer le diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Résultats du diagnostic copiés dans le presse-papiers",
      "DIAGNOSTIC_FAILED": "Le diagnostic a échoué",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN : not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostics quantifiés",
      "DIAGNOSTIC_TIME": "Temps",
      "DIAGNOSTIC_SUMMARY": "Résumé",
      "DIAGNOSTIC_CLIENT_INFO": "Renseignements sur le client",
      "DIAGNOSTIC_PLATFORM": "Plateforme",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perte de paquets (envoi)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Débit binaire d'envoi moyen",
      "DIAGNOSTIC_NA": "S. O."
    },
    "results": {
      "RETURN_HOME": "RETOUR À L’ACCUEIL",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CONVERSATIONAL_CALL": "APPELS CONVERSATIONNELS",
      "INFORMATION_ICON": "Icône d’information",
      "TOOLTIP_ARROW": "Flèche d’info-bulle",
      "INFORMATION_TOOLTIP_CONTENT": "Vous contrôlez le flux de la simulation, en orientant la conversation vers un ensemble d’objectifs. Les appels conversationnels sont parfaits pour tester des capacités telles que l’approfondissement et la pose de questions de second niveau, la découverte de points douloureux et l’établissement d’une relation.",
      "CLOCK_ICON": "Icône d’horloge",
      "CALL_RESULTS": "Résultats",
      "SKILLS": "Compétences",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "TRY_AGAIN_MESSAGE": "Réessayez et améliorez votre note.",
      "PRACTICE_BENEFITS": "La pratique hebdomadaire renforce la confiance en soi et améliore les résultats dans le monde réel.",
      "CALL_SUCCESS": "Excellent travail! Vous avez terminé cette simulation avec succès.",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "TRY_AGAIN": "Réessayer",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excellent travail! Vous avez terminé",
      "COMPLETED_THIS_CALL": "cette simulation avec succès.",
      "ACHIEVED_SCORE": "Vous devez obtenir une note de",
      "ACHIEVE_SCORE": "Obtenir une note de",
      "OR_HIGHER": "ou plus",
      "OBJECTIVES_NOT_MET": "Vous n’avez pas atteint tous les objectifs requis.",
      "TRY_AGAIN_TARGET_SCORE": "Essayez à nouveau d’obtenir une note de",
      "YOUR_SCORE": "Votre note",
      "OUT_OF_5": "SUR 5",
      "CALL_FEEDBACK": "RÉSUMÉ DU RETOUR D'INFORMATION",
      "STRENGTH_ICON_ALT": "Icône de force",
      "OPPORTUNITIES_ICON_ALT": "Icône des possibilités",
      "OBJECTIVES_FEEDBACK": "RETOUR D'INFORMATION SUR LA MÉTHODOLOGIE",
      "SESSION_ID": "ID de la session :",
      "SESSION_ID_COPIED": "L’identifiant de la session a été copié!",
      "OBJECTIVE": "MÉTHODOLOGIE :",
      "HOW_YOU_DID": "Vos résultats :",
      "LIGHTBULB_ICON_ALT": "Icône d’ampoule",
      "WHAT_WE_SUGGEST": "Ce que nous suggérons :",
      "NO_SPECIFIC_RECOMMENDATION": "Notre système n’a pas pu trouver une recommandation pour vous.",
      "WHY": "Pourquoi?",
      "NO_INSIGHTS_AVAILABLE": "Notre système n’a pas été en mesure de fournir des informations sur cette suggestion.",
      "CONFETTI_ICON_ALT": "Icône de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Vous avez bien travaillé sur cette méthodologie, ne lâchez pas!",
      "PROCESSING_CALL": "Nous préparons votre note et votre retour d'information.",
      "HANG_TIGHT": "Patientez ou revenez plus tard pour",
      "VIEW_YOUR_RESULTS": "consulter vos résultats.",
      "NEED_MORE_TIME": "Nous avons besoin de plus de temps pour calculer les résultats.",
      "REFRESH_INSTRUCTION": "Veuillez revenir plus tard ou actualiser l’affectation",
      "RESULTS_IN_FEW_MINUTES": "des résultats en quelques minutes.",
      "SCORE_CALCULATION_QUESTION": "Méthode de calcul",
      "SINGLE_SCORE_EXPLANATION": "Cette simulation  comporte un seul élément de notation, donc la note affichée correspond à la fois à la note de la section et à votre note globale.",
      "OVERALL_SCORE_PERCENT": "% de la note globale",
      "SECTION_SCORE": "Note de la section",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Améliorez l’adhésion à votre message de conversation",
      "MESSAGE_ADHERENCE_NOTE": "Le respect du message est essentiel pour mener des conversations fructueuses, mais n’affecte pas votre note globale.",
      "NO_CREDIT": "Aucun crédit",
      "PARTIAL_CREDIT": "Crédit partiel",
      "FULL_CREDIT": "Crédit complet",
      "WHAT_YOU_DID_WELL": "Ce que vous avez fait de bien",
      "MISSED_ALL_KEY_POINTS": "Vous avez omis tous les points clés. Renvoyez-les puis essayez à nouveau.",
      "WHAT_TO_IMPROVE": "Ce que vous pouvez améliorer",
      "PERFECT_SCORE_MESSAGE": "Félicitations! Vous avez obtenu une note parfaite, en abordant correctement tous les points clés.",
      "POINTS_LABEL": "Points",
      "TALKING_POINTS_COVERED": "Points de discussion abordés",
      "CHECKMARK_ICON_ALT": "coche",
      "TALKING_POINTS_MISSED": "Points de discussion manqués",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Pratiquer à nouveau",
      "OUT_OF": "sur",
      "POSSIBLE_TALKING_POINTS": "points de discussion possibles",
      "YOU_COVERED": "Vous avez couvert",
      "THROUGHOUT_CALL": "tout au long de la simulation.",
      "POSITIVE_FEEDBACK_COVERAGE": "Vous avez très bien mis en évidence les points clés tout au long de l’appel et couvert",
      "MIXED_FEEDBACK_COVERAGE": "Vous avez omis certains points clés au cours de la simulation et couvert",
      "OBJECTIVES": "Méthodologie",
      "ELEVATE_OBJECTIVES_TITLE": "Améliorez votre méthodologie en matière de conversation",
      "OBJECTIVES_NOTE": "La méthodologie est essentielle pour mener des conversations fructueuses, mais n’affecte pas votre note globale.",
      "UNTIL": "jusqu’à",
      "TO_IMPROVE_SCORE": "pour améliorer votre note.",
      "TO_SCORE": "pour recevoir une note de",
      "BEFORE": "avant",
      "YOU_HAVE": "Vous avez",
      "MORE_ATTEMPTS": "plus de tentatives d’obtenir une note de",
      "OR_HIGHER_BEFORE": "ou plus avant le",
      "AND_TRY_AGAIN": "et réessayer.",
      "UNEXPECTED_STATE": "Un état inattendu s’est produit.",
      "REVIEW_APP_LOGIC": "Veuillez revoir la logique de l’application.",
      "ASSIGNMENTS": "Affectations",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "PRACTICE_SESSION": "Séance de pratique",
      "OVERALL_SCORE": "Note globale",
      "OVERALL_SCORE_EXPLANATION": "La note globale est calculée en faisant la moyenne pondérée des notes de chaque section. Le poids de chaque section est affiché sous forme de pourcentage à côté de la note.",
      "SCORE_CONFIG_NOTE": "Les pourcentages de pondération ainsi que l’inclusion et l’exclusion de sections sont fixés par votre entreprise. Toutes les notes sont arrondies au dixième de point le plus proche.",
      "STRENGTHS": "Points forts",
      "OPPORTUNITIES": "Possibilités",
      "YOUR_RESPONSE": "Votre réponse",
      "MINUS": "moins",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Réponse recommandée",
      "REVIEW_MISSED_TITLE": "Passez en revue ce que vous avez manqué.",
      "NO_TALKING_POINTS_COVERED": "Vous n’avez abordé aucun des points de discussion requis pour ce sujet.",
      "LEARN_WHAT_YOU_MISSED": "Apprenez ce que vous avez manqué",
      "NICE_JOB": "Beau travail!",
      "ALL_POINTS_COVERED": "Vous avez réussi à couvrir tous les points de discussion nécessaires pour ce sujet.",
      "COVER_ALL_MESSAGES": "Couvrir tous les messages clés.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Le fait de souligner les points clés tout au long de l’appel permet de maintenir le cap de la conversation.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oups! Il semble que vous n’ayez couvert aucun des faits de ce message.",
      "NO_SPECIFICS_AVAILABLE": "Oups! Il semble que nous n’ayons pas pu fournir de précisions sur ce qui a été omis.",
      "ALL_KEY_POINTS_COVERED": "Excellent travail! Vous avez couvert tous les points essentiels.",
      "PROCESSING_SKILLS_FEEDBACK": "Nous sommes en train de traiter votre retour d’information sur les compétences.",
      "SKILLS_SCORING_NOT_ENABLED": "Nous sommes désolés, mais nous n’avons pas pu analyser votre appel récent, car l’évaluation des compétences n’était pas activée au moment de la soumission. Pour obtenir un retour d’information, il vous suffit de soumettre à nouveau votre pratique d’appel comme vous l’avez fait précédemment. Si vous avez besoin d’aide, n’hésitez pas à contacter notre équipe de soutien. Merci de votre compréhension et de votre volonté d’amélioration!",
      "ELEVATE_CONVERSATION_SKILLS": "Améliorez vos compétences en matière de conversation",
      "SKILLS_NOTE": "Ces compétences sont essentielles pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "SKILLS_SUMMARY_TITLE": "RÉSUMÉ DES COMPÉTENCES",
      "LEARN_MORE_ABOUT_SKILLS": "En savoir plus sur les compétences",
      "SKILLS_FEEDBACK_LABEL": "RETOUR D’INFORMATION",
      "WHAT_ARE_SKILLS_TITLE": "Définition des compétences",
      "SKILLS_DESCRIPTION": "Les compétences sont établies pour favoriser la croissance et le développement personnels. Bien que ces compétences ne fassent pas partie de l’évaluation numérique de votre appel, elles ont été sélectionnées par votre organisation pour améliorer votre efficacité.",
      "PROFICIENCY_SCALE_TITLE": "ÉCHELLE DE COMPÉTENCE",
      "EXPERT": "Expert",
      "PROFICIENT": "Maîtrise de la langue",
      "DEVELOPING": "En développement",
      "CALL_TRANSCRIPT": "Transcription de l’appel",
      "COLLAPSE_ALL": "Réduire tout",
      "EXPAND_ALL": "Tout développer",
      "THUMBNAIL": "Vignette",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "points de discussion",
      "TRANSCRIPT_LABEL": "Transcription",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Vous n’avez plus de tentatives.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Passez en revue les consignes et respectez-les à l’avenir.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Réessayez et veillez à respecter les consignes de conformité.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nous avons constaté que vous n’étiez pas conforme, vous n’avez donc pas obtenu de note.",
      "WHY_OUT_OF_COMPLIANCE": "Raison de votre non-conformité",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Examinez votre relevé de notes pour voir où vous n’avez pas respecté les lignes directrices en matière de conformité.",
      "YOU_DID_FOLLOW_GUIDELINES": "Vous avez effectivement suivi ces lignes directrices.",
      "REVIEW_MISSED_GUIDELINES": "Examinez les lignes directrices relatives à la conformité manquée.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcul de la note",
      "PROCESSING_TRANSCRIPT": "Nous sommes en train de traiter votre relevé de notes.",
      "WAIT_OR_REVIEW_SCORES": "Patientez ici ou examinez les autres sections de notes",
      "TRANSCRIPT_LOADING": "pendant le chargement de la transcription.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Examinez votre retour d’information et continuez à pratiquer",
      "HIGH_PERFORMERS_PRACTICE": "Les personnes très performantes pratiquent au moins une fois par semaine",
      "SUCCESSFULLY_PASSED": "Excellent travail! Vous avez réussi cette simulation.",
      "DIDNT_REACH_PASSING_SCORE": "Vous n’avez pas atteint la note de passage pour cette simulation.",
      "OUT_OF_ATTEMPTS": "<b>Vous avez épuisé toutes vos tentatives.</b> Consultez vos commentaires pour savoir comment vous pouvez vous améliorer.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Passez en revue votre rétroaction, puis retournez à la page d’accueil lorsque vous serez prêt.",
      "GREAT_JOB_PRACTICED": "Bon travail, vous avez pratiqué {{count}} {{times}}. Continuez!",
      "TIME": "temps",
      "TIMES": "fois",
      "COMPLIANCE_GUIDELINES": "Lignes directrices en matière de conformité",
      "TALKING_POINT_TITLE": "LES POINTS DE DISCUSSION MANQUÉS OU DITS AU MAUVAIS MOMENT",
      "NO_TRANSCRIPT": "Pas de transcription disponible."
    },
    "reportingV2": {
      "DASHBOARD": "Tableau de bord",
      "LOADING_ACCOUNTS": "Chargement des comptes...",
      "SELECT_AN_ACCOUNT": "Sélectionner un compte",
      "SEARCH_TEAMS": "Équipes de recherche",
      "LOADING_TEAMS": "Chargement des équipes...",
      "ALL_TEAMS": "Toutes les équipes",
      "ACCOUNT": "Compte",
      "TEAMS": "Les équipes",
      "TEAM_LABEL": "Équipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Note de passage",
      "ASSIGNMENT_LABEL": "Affectations",
      "USER_LABEL": "Utilisateur",
      "PRACTICE_LABEL": "Pratique",
      "CERTIFICATION_LABEL": "Certification",
      "RESULTS_DESCRIPTION": "Voici les résultats de votre (vos) équipe(s) pour l'ensemble des exercices :",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement par affectation",
      "ASSIGNMENT_ENGAGEMENT": "Affectation complétée",
      "ENGAGED_LABEL": "Engagé",
      "ENGAGEMENT_STATUS_LABEL": "Statut d'engagement",
      "PROFICIENT_LABEL": "Maîtrise de la langue",
      "ASSIGNMENT_NAME": "Nom de l'affectation",
      "ACTIVE_USERS": "Utilisateurs actifs",
      "ASSIGNMENT_PROGRESS": "Progrès par affectation",
      "IN_PROGRESS_LABEL": "En cours",
      "CERTIFIED_LABEL": "Certifié",
      "OUT_OF_ATTEMPTS_LABEL": "Hors des tentatives",
      "USERS_ENGAGED_LABEL": "Utilisateurs engagés",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions par utilisateur actif",
      "HIGHER_THAN_LABEL": "Plus élevé que",
      "MORE_THAN_LABEL": "Plus de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Nombre total de sessions achevées",
      "USER_CERTIFIED": "Utilisateurs certifiés pour toutes les affectations",
      "ASSIGNMENT_CERTIFICATION": "Affectations avec une certification de 100 %",
      "TRAINER_TIME_SAVED": "Gain de temps pour le formateur",
      "HOURS_LABEL": "heures",
      "PRACTICE_ASSIGNMENT_LABEL": "Travaux pratiques",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Affectations de certification",
      "START_DATE_LABEL": "Date de début",
      "END_DATE_LABEL": "Date de fin",
      "NAME_LABEL": "Nom",
      "EMAIL_LABEL": "Courriel",
      "MEMBER_OF_TEAMS_LABEL": "Membre des équipes",
      "ASSIGNMENTS_COUNT_LABEL": "# Nombre d'affectations",
      "TOTAL_SESSIONS_LABEL": "Total des sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Nombre de sessions",
      "TOTAL_USERS_LABEL": "Total des utilisateurs",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "INITIAL_SCORE_LABEL": "Note initial",
      "HIGH_SCORE_LABEL": "Note élevée",
      "LAST_PRACTICE_DATE_LABEL": "Date de la dernière pratique",
      "PERCENT_IMPROVED_LABEL": "% d'amélioration",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Cette mesure analyse les notes de chaque session et trace une ligne droite sur un graphique pour illustrer la tendance. Un pourcentage élevé indique que les résultats s’améliorent plus rapidement, un pourcentage plus faible indique que les résultats s’améliorent plus lentement.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Affectations certifiées",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Compétent pour les affectations",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Le nombre d’affectations pour lesquelles l'utilisateur a atteint ou dépassé les critères de score pour toutes les simulations de l’affectation.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Le nombre d’affectations pour lesquelles l'utilisateur a atteint ou dépassé le critère de score au moins une fois pour toutes les simulations de l’affectation.",
      "PROFICIENT_TOOLTIP": "Le nombre d’utilisateurs dans cette affectation ayant obtenu au moins une fois un résultat égal ou supérieur au critère de haute note défini pour tous les appels de cette affectation.",
      "IN_PROGRESS_TOOLTIP": "Pourcentage d'utilisateurs ayant effectué au moins une session de simulation dans le cadre de cette affectation et ayant obtenu une note.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Le pourcentage d'utilisateurs qui ont dépassé leur nombre de tentatives pour une ou plusieurs simulations de l'affectation.",
      "CERTIFIED_TOOLTIP": "Le pourcentage d'utilisateurs qui ont atteint ou dépassé les critères de score pour toutes les simulations de l'affectation.",
      "SEARCH_FOR_A_USER_LABEL": "Recherche d'un utilisateur",
      "NO_USERS_FOUND_LABEL": "Aucun utilisateur trouvé",
      "TRAINER_TIME_SAVED_TOOLTIP": "Le temps que les utilisateurs ont passé dans Quantified à effectuer des tentatives de certification.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Nombre moyen de sessions par affectation",
      "ASSIGNMENTS_ENGAGED_WITH": "Affectations terminées",
      "AVERAGE_IMPROVEMENT": "Amélioration moyenne",
      "STATUS": "STATUT",
      "TOTAL_NUMBER_OF_SESSIONS": "Nombre total de sessions",
      "DATE_OF_LAST_PRACTICE": "Date de la dernière pratique",
      "CALL_NAME": "Nom de l’appel",
      "SESSION_DATE": "Date de la session",
      "DURATION_OF_SESSION": "Durée de la session",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING_SCORE": "Note d'adhésion au message",
      "METHODOLOGY_SCORE": "Note méthodologique",
      "SKILLS_SCORE": "Note de compétences",
      "SESSIONS": "session",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Toutes les affectations",
      "RECENT_ASSIGNMENTS": "Affectations récentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "HOURS_IN_SIMULATIONS": "Heures de simulation",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Nombre moyen de sessions pour atteindre la compétence",
      "PERCENT_PROFICIENT": "Pourcentage de réussite",
      "SYSTEM_RUNNING_NORMALLY": "Le système fonctionne actuellement normalement",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Aucun résultat ne correspond à vos filtres. Essayez de supprimer un ou plusieurs filtres pour élargir la recherche.",
      "USERS_PASSED": "Utilisateurs ayant réussi la simulation",
      "AVERAGE_TIME": "Délai moyen de certification",
      "USERS_OUT_OF_ATTEMPTS": "Utilisateurs hors de tentatives",
      "NO_CERTIFICATION_SIMULATION": "Aucune simulation de certification trouvée",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Pas de sessions",
      "PERCENT_CERTIFIED": "Pourcentage certifié",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Pourcentage certifié à la première tentative",
      "USERS": "Utilisateur",
      "ATTEMPTS_LABEL": "Tentatives",
      "NO_ATTEMPTS": "Pas de tentatives",
      "DATE_OF_SESSION": "Date de la session",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Aucune affectation ne correspond aux filtres choisis",
      "NO_TEAMS_DATA": "Il n'y a pas d'équipes dans ce compte",
      "SIMULATION_NAME": "Nom de la simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durée moyenne de la session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Nombre moyen de séances de pratique par utilisateur actif",
      "AVERAGE_OVERALL_SCORE": "Note globale moyenne",
      "TOTAL_ASSIGNMENTS": "Total des affectations",
      "ASSIGNMENTS_CERTIFIED": "Affectations certifiées",
      "TOTAL_SESSIONS": "Total des sessions",
      "HOURS_SPENT_PRACTICING": "Heures consacrées à la pratique",
      "LAST_LOGIN": "Dernière connexion",
      "SELECT_ASSIGNMENTS": "Sélectionner les affectations",
      "CERTIFICATION_STATUS_LABEL": "Statut de certification",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Statut de la certification :",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certifié dès le premier essai?",
      "DATE_OF_CERTIFICATION_LABEL": "Date de certification",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Statut d'engagement :",
      "DURATION_OF_ATTEMPT": "Durée de la tentative",
      "USER_NAME": "Nom de l'utilisateur",
      "LEARNER": "Apprenant",
      "DATE_RANGE": "Plage de dates",
      "DATE_RANGE_LABEL": "Plage de dates",
      "SEARCH_USERS": "Recherche d'utilisateurs...",
      "SEARCH_SIMULATIONS": "Simulations de recherche...",
      "SEARCH_DATES": "Dates de recherche...",
      "CERTIFIED_ON_FIRST_TRY": "Certifié du premier coup",
      "DATE_OF_CERTIFICATION": "Date de certification",
      "AVERAGE_CERTIFICATION_SCORE": "Note moyenne de certification",
      "TOTAL_TIME_CERTIFYING": "Durée totale de la certification",
      "OF_THE_TIME": "du temps",
      "ASSIGNED_LABEL": "Pas commencé",
      "USERS_ASSIGNED_LABEL": "Total des utilisateurs assignés",
      "SESSION_ID": "ID de la session :",
      "USER_NAME_LABEL": "Nom de l'utilisateur",
      "NO_SIMULATIONS_FOUND_LABEL": "Aucune simulation trouvée",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "de",
      "SECOND": "seconde",
      "SECONDS": "secondes",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNED": "Attribué",
      "ENGAGED_TOOLTIP": "Pourcentage d'utilisateurs ayant terminé une ou plusieurs sessions de simulation dans le cadre de cette affectation, mais n'ayant pas encore atteint le niveau de maîtrise requis pour toutes les simulations.",
      "SEARCH_ASSIGNMENTS": "Rechercher des affectations...",
      "ASSIGNMENT_NAME_LABEL": "Nom de l'affectation",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "START_DATE": "Date de début",
      "END_DATE": "Date de fin",
      "NO_ASSIGNMENTS": "Aucune affectation trouvée pour cet utilisateur.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total des travaux pratiques",
      "SESSION_SCORES_OVER_TIME": "Notes de session au fil du temps",
      "TIME": "Temps",
      "SCORE": "Note",
      "NO_SESSIONS_AVAILABLE": "Aucune session disponible à représenter graphiquement.",
      "MESSAGING_SCORE_LABEL": "Note de messagerie",
      "PERSONALIZED_PRACTICE_LABEL": "Pratique personnalisée",
      "ASSIGNMENT_ENAGEMENT": "Engagement par affectation",
      "NO_PRODUCTS": "Aucun produit d'entraînement personnalisé pour les équipes sélectionnées",
      "TOTAL_TIME_SPENT_PRACTICING": "Temps total consacré à l'entraînement",
      "AVERAGE_SESSIONS_PER_USER": "Nombre moyen de sessions par utilisateur",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le plus courant",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le moins courant",
      "CLEAR_TEAMS": "Supprimer les équipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Notes objectives moyennes pour toutes les sessions de cet appel.",
      "METHODOLOGY": "Méthodologie",
      "MESSAGING": "Messagerie",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "La messagerie évalue si les apprenants expriment clairement deux idées importantes au cours de cette simulation. Ces visualisations montrent les pourcentages de messages dans un thème donné que les utilisateurs ont exprimés, en moyenne, au cours de toutes les sessions de cet appel.",
      "NO_METRICS_MESSAGE": "Aucune session terminée pour les équipes sélectionnées.",
      "SELECT_ALL": "Tout sélectionner",
      "DESELECT_ALL": "Tout désélectionner",
      "SKILLS": "Compétences",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Les notes de compétences sont une évaluation par IA des compétences démontrées par les utilisateurs lors d’un appel.",
      "EXPERT": "Expert",
      "PROFICIENT": "Maîtrise de la langue",
      "DEVELOPING": "En développement",
      "FULLY_ARTICULATED": "Entièrement exprimé",
      "PARTIALLY_ARTICULATED": "Partiellement exprimé",
      "NOT_MENTIONED": "Non mentionné",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "La messagerie évalue si les utilisateurs expriment clairement trois idées importantes lors de cet appel."
    },
    "reporting": {
      "AT_GLANCE": "Les missions en un coup d’œil",
      "OPEN_ASSIGNMENTS": "Affectations ouvertes",
      "NOT_STARTED": "Pas commencé",
      "CERTIFIED": "Certifié",
      "VIEW_LIST": "Voir la liste",
      "CERTIFICATION_ASSIGNMENTS": "Affectations de certification",
      "CERTIFICATION_SUMMARY_TEXT": "Les certifications sont des affectations qui ont une date d’échéance et des critères de réussite spécifiques.",
      "PRACTICE_ASSIGNMENTS": "Travaux pratiques",
      "PRACTICE_SUMMARY_TEXT": "Les travaux pratiques sont disponibles pour les utilisateurs sans date d’échéance spécifique. Ils sont conçus pour permettre aux utilisateurs de s’entraîner régulièrement afin d’améliorer leurs compétences.",
      "THE": "Le",
      "WILL_CLOSE": "fermera en",
      "USERS_HAVE": "les utilisateurs",
      "USER_HAS": "l’utilisateur",
      "NOT_STARTED_ASSIGNMENT_DUE": "n’ont pas commencé une affectation à remettre d’ici la semaine prochaine",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "n’a pas terminé une affectation à remettre d’ici la semaine prochaine",
      "DAYS": "jours",
      "DAY": "jour",
      "MODULES": "Modules",
      "MODULE": "Module",
      "CALL": "Simulation",
      "CALLS": "Simulations",
      "CERTIFICATION_ASSIGNMENT": "Affectation de certification",
      "PRACTICE_ASSIGNMENT": "Travaux pratiques",
      "AND": "et",
      "VIEW_ENGAGEMENT_DETAILS": "Voir les détails de la mission",
      "SEE_ALL": "Tout voir",
      "SEE_LESS": "Voir moins",
      "ASSIGNMENT": "Affectation",
      "ASSIGNED": "Attribué",
      "IN_PROGRESS": "En cours",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNMENT_ENDS_IN": "L’affectation se termine en",
      "ASSIGNMENT_CLOSED": "Affectation clôturée",
      "OLDER_CERTIFICATION": "certification plus ancienne",
      "ASSIGNMENT_IS": "L’affectation est",
      "ASSIGNMENT_ARE": "Les affectations sont",
      "CURRENTLY_HIDDEN": "actuellement cachée(s)",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Toutes les affectations de certification sont affichées.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Utilisateurs qui n’ont encore terminé aucun ni obtenu de note pour une simulation.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Utilisateurs qui ont terminé au moins une simulation et obtenu une note.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Utilisateurs qui ont satisfait à l’exigence de certification.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Il s’agit du nombre d’utilisateurs qui peuvent accéder à l’affectation pour leurs certifications.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Voir toutes les affectations de certification",
      "HIDE_OLDER_ASSIGNMENTS": "Cacher les anciens devoirs",
      "AVG_PRACTICES": "Pratiques moyennes",
      "PRACTICED": "Pratiqué",
      "SCORED_HIGH": "Note élevée",
      "AVG_ASSIGNMENT": "Amélioration moyenne",
      "DAYS_AGO": "jours",
      "NA": "S. O.",
      "OLDER_PRACTICE": "pratique plus ancienne",
      "SEE_PRACTICE_ASSIGNMENT": "Voir tous les travaux pratiques",
      "ALL_PRACTICE_ASSIGNMENTS": "Tous les travaux pratiques sont affichés.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Utilisateurs qui n’ont encore terminé ou obtenu de note pour une simulation.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Ces utilisateurs ont terminé au moins une simulation et obtenu une note.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Le nombre d’utilisateurs dans cette affectation ayant obtenu au moins une fois un résultat égal ou supérieur au critère de haute note défini pour toutes les simulations de cette affectation.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Ces utilisateurs peuvent accéder à l’affectation pour s’entraîner.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Ce chiffre indique le nombre moyen de fois où les utilisateurs ont pratiqué des simulations qui font partie de cette affectation.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Cette mesure analyse les notes de chaque session et trace une ligne droite sur un graphique pour illustrer la tendance. Un pourcentage élevé indique que les résultats s’améliorent plus rapidement, un pourcentage plus faible indique que les résultats s’améliorent plus lentement.",
      "USERS": "utilisateurs",
      "USER": "utilisateur",
      "DOWNLOAD_CSV": "Télécharger le CSV",
      "ERROR": "Une erreur s’est produite",
      "FIRST_NAME": "Prénom",
      "LAST_NAME": "Nom de famille",
      "ATTEMPTS": "Tentatives",
      "EMAIL": "Courriel",
      "LAST_LOGIN": "Dernière connexion",
      "ASSIGNMENT_NOT_STARTED": "Affectation non commencée",
      "ASSIGNMENT_IN_PROGRESS": "Affectation en cours",
      "SCORE_CRITERIA_MET": "Critères de note atteints",
      "NEVER_LOGGED_IN": "Non connecté",
      "QUANTIFIED_REPORTING": "Rapports quantifiés",
      "ASSIGNED_USERS": "Utilisateurs assignés",
      "COMPLETION_REQUIREMENT": "Condition d’achèvement",
      "AVG_SCORE_Of": "Moyenne Note de",
      "REPORTING": "Rapports",
      "CERTIFICATIONS": "Certifications",
      "PRACTICES": "Pratiques",
      "CALL_ANALYSIS": "Analyse de simulation",
      "PERCENT_CERTIFIED_ON": "Pourcentage certifié sur",
      "SHOWING": "Montrer",
      "PRACTICE_SESSIONS": "Nombre cumulatif de séances de pratique pour toutes les simulations du module",
      "AVG_PRACTICE_HEADING": "Nombre moyen de séances de pratique par utilisateur actif",
      "AVG_SCORE_LABEL": "Moyenne Note",
      "AVG_SCORE_HEADING": "Note moyenne par utilisateur",
      "AVG_PRACTICES_LABEL": "Moyenne Pratiques",
      "EXPORT_LEARNER_LIST": "Exporter la liste des apprenants",
      "PERCENT_NOT_STARTED": "% Non commencé",
      "PERCENT_IN_PROGRESS": "% En cours",
      "PERCENT_CERTIFIED": "% Certifié",
      "USER_CERTIFIED": "Utilisateur certifié",
      "USERS_CERTIFIED": "Utilisateurs certifiés",
      "TOTAL_ATTEMPTS": "Total des tentatives",
      "Avg_ATTEMPTS_CERTIFY": "Moyenne des tentatives de certification",
      "ASTERICK_GROUP": "Désigne un groupe qui contient un ou plusieurs sous-groupes.",
      "NO_DATA_FOUND": "Aucune donnée n’a été trouvée",
      "MODULE_HIGHLIGHTS": "Points forts du module",
      "MODULE_HIGHLIGHT_SUMMARY": "Indicateurs clés pour toutes les simulations. Pour une analyse détaillée de chaque simulation, voir l’aperçu ci-dessous",
      "HIGHEST_SCORING_QUESTION_TITLE": "QUESTION AYANT OBTENU LA NOTE LA PLUS ÉLEVÉE",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Question ayant obtenu la note la plus élevée",
      "QUESTION_BAR_MSG": "Pourcentage moyen de réponses correctes",
      "LOWEST_SCORING_QUESTION_TITLE": "QUESTION AYANT OBTENU LA NOTE LA PLUS BASSE",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Question ayant obtenu la note la plus basse",
      "TOP_SCORED_ANSWER_POINT_TITLE": "POINT DE RÉPONSE LE MIEUX NOTÉ",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Question avec le moins de points de réponse manqués",
      "SCORE_BAR_MSG": "du temps, les utilisateurs réussissent cette question.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "POINT DE RÉPONSE LE MOINS BIEN NOTÉ",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Question avec le plus de réponses manquées",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "MÉTHODOLOGIE DE NOTATION LA PLUS BASSE",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Méthodologie de notation la plus basse",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "MÉTHODOLOGIE DE NOTATION LA PLUS ÉLEVÉE",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Méthodologie de notation la plus élevée",
      "OBJECTIVE_BAR_MSG": "moyenne de points pour cette méthodologie",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MESSAGE LE MOINS ARTICULÉ",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Message le moins articulé",
      "LEAST_ARTICULATED_BAR_MSG": "Articuler ce message",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MESSAGE LE PLUS ARTICULÉ",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Message le plus articulé",
      "MOST_ARTICULATED_BAR_MSG": "Articuler pleinement ce message",
      "Overview": "Vue d’ensemble",
      "CONSISTS_Of": "se compose de",
      "CALL_OVERVIEW_LABEL": "Le graphique montre le nombre d’utilisateurs qui ont",
      "PASSED": "Réussi",
      "ATTEMPTED": "Tenté",
      "NOT_ATTEMPTED": "Non tenté",
      "GUIDED_CALL": "Contrôle des connaissances",
      "QUESTIONS": "Questions",
      "QUESTION": "Question",
      "CONVERSATIONAL_CALL": "Appels conversationnels",
      "AVG_ATTEMPTS": "Moyenne Tentatives",
      "USERS_PASSED": "utilisateurs passés",
      "DETAILED_ANALYSIS": "Analyse détaillée",
      "CALL_DETAILS": "Détails de la simulation",
      "CALL_TYPE": "Type de simulation",
      "TOTAL_SESSIONS": "Total des sessions",
      "WHAT_WE_MEASURED": "Ce que nous avons mesuré",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Note globale moyenne",
      "OVERALL_SCORE_DETAIL": "Notre système fournit une « note globale » pour chaque conversation. Ce chiffre correspond à la note globale moyenne pour tous",
      "CALL_RUN": "les utilisateurs ont terminé cette simulation",
      "TIME": "temps",
      "TIMES": "fois",
      "OBJECTIVES": "Méthodologie",
      "AVG_OBJECTIVE": "Notes moyennes de méthodologie pour l’ensemble",
      "OF_THIS_CALL": "de cette simulation",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "MESSAGE_ADHERENCE_DETAILS_1": "L’adhésion au message mesure si les apprenants expriment les",
      "MESSAGE_ADHERENCE_DETAILS_2": "idées importantes au cours de cette simulation. Ces visualisations montrent le pourcentage moyen de points de message pour un thème donné par les utilisateurs, pour l’ensemble des",
      "IMPORTANT_IDEAS": "idées importantes au cours de cette simulation",
      "PERCENT_MESSAGE_ARTICULATED": "Ces visualisations montrent le pourcentage du temps où chaque message est exprimé dans l’ensemble des",
      "FULLY_ARTICULATED": "Entièrement articulé",
      "PARTIALLY_ARTICULATED": "Partiellement articulé",
      "NOT_MENTIONED": "Non mentionné",
      "SKILLS_LABEL": "Compétences",
      "SKILLS_DETAILS": "Les notes de compétences sont une évaluation par IA des compétences démontrées par les utilisateurs lors d’une simulation. Ces visualisations montrent le pourcentage de fois où les utilisateurs ont obtenu les notes « Expert » (la plus élevée), « Compétent » et « En développement » (la plus basse) pour l’ensemble des",
      "DEVELOPING": "En développement",
      "PROFICIENT": "Maîtrise de la langue",
      "Expert": "Expert",
      "NO_RESULT": "Pas encore de résultats",
      "NO_RESULT_TEXT": "Aucun des utilisateurs de votre organisation n’a encore tenté cette simulation. Une fois qu’ils l’auront fait, vous pourrez voir leurs résultats ici!",
      "CONVERSATIONAL_CALL_TOOLTIP": "Lors d'appels conversationnels, l’utilisateur peut diriger le flux de la conversation et obtiendra une réponse en conséquence grâce à l'IA. Les appels conversationnels sont moins structurés que les « Contrôles des connaissances », qui ont un format strict de questions-réponses.",
      "TOTAL_SESSION_TOOLTIP": "Nombre total de fois que cette simulation a été exécutée par tous les utilisateurs auxquels elle a été attribuée.",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "AVERAGE_SCORE_DETAIL": "La note moyenne de tous les utilisateurs pour cette simulation",
      "ANSWER_POINTS": "Points de réponse",
      "DETAILS": "Détails",
      "CONVERSATIONAL_CALL_MSG": "Les rapports sur le contenu des appels conversationnels seront bientôt disponibles",
      "ALL_CALL_DETAILS": "Tous les détails de la simulation",
      "QUESTION_TEXT_LABEL": "Texte de la question",
      "AVG_POINTS_LABEL": "Moyenne des points",
      "SHOW_ALL": "Tout afficher",
      "CORRECT_ANSWER": "réponses correctes sur",
      "OBJECTIVE_MEASURED_ON": "Cette méthodologie est mesurée sur",
      "CALLS_IN_MODULE": "simulations dans ce module",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "QUESTION_UPDATED": "Cette question a été mise à jour",
      "QUESTION_UPDATED_MESSAGE": "Nous ne sommes pas en mesure d’afficher des informations détaillées sur les points de réponse car des mises à jour ont été apportées à cette question. Les « points moyens » affichés représentent la moyenne de toutes les séances de cette question (y compris avant et après les mises à jour).",
      "CLOSE_ALT": "Fermer",
      "Q_LABEL": "Q",
      "SCORING_LABEL": "Notation",
      "AVERAGE_ANSWER": "Moyenne des points de réponse obtenus par question",
      "MINIMIZE_LABEL": "Minimiser",
      "VIEW_ALL_LABEL": "Voir tout",
      "DOWN_ARROW": "Flèche vers le bas",
      "NOTIFICATION": "Notification",
      "PROGRESS_ICON": "Icône de progrès",
      "VIEW_MODAL": "Voir le modal",
      "VIEW_INFO": "Voir l’info",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Développer le groupe",
      "MESSAGE_ADHERENCE_V2": "Adhésion au message",
      "SCORE_OVERALL": "Note globale",
      "SCORE_SKILLS": "Compétences",
      "SCORE_CUSTOMIZED": "Méthodologie",
      "SESSIONS": "sessions",
      "SESSION": "session"
    },
    "personalizedPractice": {
      "TITLE": "Pratique personnalisée",
      "DESCRIPTION": "Bonjour {{userFirstName}}! Les pratiques personnalisées vous permettent de paramétrer vos propres scénarios afin qu'ils soient aussi réalistes que possible.",
      "LOADING": "Chargement...",
      "VIEW_SESSIONS": "Voir les sessions",
      "VIEW_SIMULATION": "Voir la simulation",
      "TOTAL_SESSION": "session totale",
      "TOTAL_SESSIONS": "total des sessions",
      "BREADCRUMB": "Pratique personnalisée",
      "SCENARIO_DETAILS_TITLE": "Détails du scénario",
      "SCENARIO_DETAILS_DESCRIPTION": "Sélectionnez des variables parmi les options ci-dessous pour ajuster la simulation à vos besoins.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Sélectionner",
      "CONVERSATION_TYPE": "Type de conversation",
      "SELECT_CONVERSATION_TYPE": "Sélectionner le type de conversation",
      "LAUNCH_SIMULATION": "Lancer la simulation avec les sélections",
      "PREVIOUS_SESSIONS": "Sessions précédentes",
      "TOTAL": "Total",
      "FILTERS": "Filtres :",
      "DATE": "Date",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "SESSION_DATE": "Date de la session",
      "SESSION_SCORE": "Note de la session",
      "DURATION": "Durée",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING": "Messagerie",
      "METHODOLOGY": "Méthodologie",
      "SKILLS": "Compétences",
      "RESULTS": "Résultats",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "OVERALL_SCORE_LABEL": "Note globale",
      "SCORE": "Note",
      "NO_PRODUCTS_TITLE": "Aucun produit disponible",
      "NO_PRODUCTS_DESCRIPTION": "Vous n'avez pas encore de produits de pratiques personnalisées.",
      "NO_SESSIONS_FOUND": "Aucune session trouvée avec les filtres sélectionnés",
      "TIME": "Temps",
      "ALL": "Tous",
      "LEARNER": "Apprenant",
      "MOOD": "Ambiance",
      "CLEAR_FILTERS": "Supprimer les filtres"
    },
    "login": {
      "TITLE": "Bienvenue à nouveau",
      "SUB_TITLE": "Comment souhaitez-vous vous connecter?  ",
      "LOGIN_WITH_SSO": "Se connecter avec le SSO de l’entreprise",
      "LOGIN_WITH_PASSWORD": "Se connecter avec le mot de passe",
      "PROVIDE_EMAIL": "Indiquez votre adresse courriel",
      "HELP_TEXT": "Besoin d’aide? Contact",
      "EMAIL_ERROR": "Nous ne sommes pas en mesure de vous connecter, veuillez contacter l’administrateur ou le service informatique de votre entreprise.",
      "EMAIL": "Courriel",
      "LOGIN": "Se connecter",
      "ALERT": "Alerte",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "En vous connectant à votre compte, vous acceptez les {{termsLink}} et {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Conditions d'utilisation",
      "PRIVACY_POLICY": "Politique de confidentialité"
    },
    "learningPathway": {
      "BEGIN": "Commencer",
      "DUE_DATE": "Date d’échéance",
      "FOOTER_SUBTITLE_READY": "Posez-moi n'importe quelle question ! Je suis prêt à vous aider.",
      "LEAVE_STEP": "Passer l'étape",
      "NEXT_STEP": "Étape suivante",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_NEXT_PAGE": "Page suivante",
      "PDF_NO_SOURCE": "Aucune source PDF fournie.",
      "PDF_PREVIOUS_PAGE": "Page précédente",
      "POST_CALL_SUBTITLE": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "POST_CALL_TITLE": "Vous avez atteint la fin de ce quiz.",
      "SETTINGS": "Paramètres",
      "TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran de détails du parcours pour votre prochaine étape.",
      "TOAST_TITLE": "Vos résultats de jeu de rôle ont été traités",
      "ASSIGNMENTS": "Affectations",
      "USER_FALLBACK": "Utilisateur",
      "VIEW_RESULTS": "Voir les résultats",
      "QUIZ_TITLE": "Quiz"
    },
    "leaderboard": {
      "LEADERBOARD": "Tableau de bord",
      "TOP10PERCENT": "Top 10 %",
      "PRACTICE_ASSIGNMENT": "Travaux pratiques",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Sélectionner l'affectation",
      "SELECT_SIMULATION": "Sélectionner la simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Sélectionnez une mission et une simulation pour voir les chefs de file",
      "NO_DATA": "Pas encore d'activité. Une fois que l'équipe commence à s'engager, vous verrez les classements apparaître ici.",
      "NO_ASSIGNMENTS_AVAILABLE": "Pas d’affectation disponible",
      "NO_SIMULATIONS_AVAILABLE": "Pas de simulations disponibles",
      "NAME": "Nom",
      "HIGH_SCORE": "Note élevée",
      "AVERAGE_SCORE": "Note moyenne",
      "TOTAL_SESSIONS": "Total des sessions",
      "LAST_SESSION": "Dernière session",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "utilisateurs engagés",
      "ENGAGED_USER": "utilisateur engagé",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Masquer les sessions dont les notes de compétences sont faibles",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Les sessions dont la note de la section compétences est « en développement » ne contribuent pas aux colonnes des notes élevées ou moyennes.",
      "NO_USERS_ENGAGED": "Aucun utilisateur engagé"
    },
    "general": {
      "NEED_HELP_QUESTION": "Besoin d’aide?",
      "CONTACT": "Contact",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Compte parent",
      "ACCOUNT": "Compte",
      "CHECKMARK": "Coche",
      "ICON": "Icône",
      "ALERT": "alerte",
      "HEADS_UP": "Attention!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Pour un son optimal sur l’iPad, utilisez des écouteurs.",
      "SETTINGS": "PARAMÈTRES",
      "RP": "RP",
      "EMAIL_LABEL": "Courriel",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Chef d’équipe pour",
      "MIAMI_SALE": "Vente à Miami",
      "CHARLOTTE_SALES": "Ventes à Charlotte",
      "ATLANTA_SALES": "Ventes à Atlanta",
      "TEAM": "Équipe",
      "ASSIGNMENTS": "Affectations",
      "MY_TEAMS": "Mes équipes",
      "REPORTING": "Rapports",
      "DASHBOARD": "Tableau de bord",
      "LEADERBOARD": "Tableau de bord",
      "PERSONALIZED_PRACTICE": "Pratique personnalisée",
      "HELP_SEARCH_OUR": "Recherchez sur notre site",
      "HELP_OR_REACH_OUT_TO": "ou contactez",
      "HELP_WITH_QUESTIONS": "avec des questions",
      "KNOWLEDGE_BASE": "base de connaissances"
    },
    "dashboard": {
      "ALL": "Tous",
      "IN_COMPLETE": "Incomplet",
      "COMPLETED": "Terminé",
      "NO_ASSIGNMENT_TITLE": "Vous n’avez pas d’affectation à accomplir.",
      "NO_ASSIGNMENT_DETAILS": "Vous serez averti lorsque vous aurez des affectations à accomplir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Vous n’avez aucune affectation incomplète.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Vous serez averti lorsqu’une nouvelle affectation sera à remettre.",
      "COMPLETED_ASSIGNMENT_TITLE": "Vous n’avez aucune affectation terminée.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Revenez une fois que vous aurez terminé une affectation.",
      "VIEW_ASSIGNMENT": "Voir l’affectation",
      "ASSIGNMENT_LABEL": "Affectations",
      "MODULE_ASSIGNMENT_ALT": "Icône d’affectation du module",
      "VIEW_ASSIGNMENT_FOR": "Voir l’affectation pour",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "AVAILABLE_IN": "Disponible dans",
      "DUE_TODAY": "À remettre aujourd’hui",
      "PRACTICE": "Pratique",
      "CERTIFICATION": "Certification",
      "UPCOMING": "À venir",
      "TEST_ASSIGNMENT": "Test d'évaluation",
      "CLOSED": "Fermé",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Aucune affectation trouvée.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Essayez d'ajuster vos filtres pour voir les affectations disponibles, ou revenez plus tard lorsque de nouvelles affectations sont ajoutées.",
      "VIEW_PATHWAY": "Voir le parcours",
      "TOTAL": "Total",
      "STATUS_LABEL": "Statut :",
      "STATUS_SELECTION_LABEL": "Statut :",
      "ASSIGNMENT_TYPE": "Type d'affectation",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Type d'affectation :",
      "NOT_STARTED": "Pas commencé",
      "CERTIFIED": "Certifié",
      "NOT_CERTIFIED": "Non certifié",
      "IN_PROGRESS": "En cours",
      "PATHWAY": "Parcours d'apprentissage",
      "SELECT_ALL": "Tout sélectionner",
      "DESELECT_ALL": "Tout désélectionner"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bienvenue à Quantified!",
      "INVITATION_MESSAGE": "Nous sommes ravis de vous compter parmi nous! Pour commencer, veuillez suivre les étapes ci-dessous pour vous connecter à votre compte pour la première fois.",
      "ACCOUNT_DETAILS": "Les détails de votre compte :",
      "USERNAME": "Nom d’utilisateur",
      "PASSWORD": "Mot de passe temporaire",
      "STEPS_LABEL": "Prochaines étapes pour se connecter",
      "STEP_1": "1. Cliquez sur le bouton « Se connecter » ci-dessous pour accéder à la page de connexion.",
      "STEP_2": "2. Saisissez votre nom d’utilisateur et votre mot de passe temporaire fournis ci-dessus.",
      "STEP_3": "3. Une fois connecté, vous serez invité à définir un nouveau mot de passe.",
      "LOGIN_BUTTON": "Se connecter",
      "ABOUT_US": "Le Simulateur de Quantified est un environnement virtuel conçu pour vous aider à développer rapidement des compétences essentielles, vous permettant de vous connecter et de communiquer plus efficacement avec les clients.",
      "EXPIRY_TIME": "Ce mot de passe temporaire expirera dans 24 heures. Si vous rencontrez des difficultés pour vous connecter, veuillez contacter notre équipe de soutien à l’adresse suivante",
      "TEAM": "L’équipe Quantified",
      "INVITATION_SMS_USERNAME": "Votre nom d’utilisateur est",
      "INVITATION_SMS_PASSWORD": "et le mot de passe temporaire est",
      "AUTHENTICATION_CODE": "Votre code d’authentification est",
      "PASSWORD_RESET_CODE": "Votre code de réinitialisation de mot de passe Quantified",
      "RESET_PASSWORD_EMAIL": "Réinitialiser le mot de passe par courriel",
      "HELLO": "Bonjour",
      "USE_VERIFICATION_CODE": "Vous avez demandé une réinitialisation de votre mot de passe. Veuillez utiliser le code de vérification ci-dessous pour terminer le processus.",
      "VERIFICATION_CODE": "Code de vérification",
      "NEXT_STEP": "Prochaines étapes",
      "RESET_PASSWORD_PAGE": "Retournez à la page de réinitialisation de votre mot de passe dans votre navigateur.",
      "ENTER_VERIFICATION_CODE": "Saisissez le code de vérification lorsque vous y êtes invité.",
      "CREATE_PASSWORD": "Une fois le code vérifié, suivez les instructions pour créer un nouveau mot de passe.",
      "DISREGARD_NOTE": "Si vous n’avez pas demandé de réinitialisation de mot de passe, veuillez ignorer ce courriel.",
      "CONTACT_SUPPORT": "Pour plus d’assistance, contactez notre équipe de soutien à l’adresse suivante",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Merci",
      "QUANTIFIED_TEAM": "L’équipe Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, États-Unis"
    },
    "call": {
      "LOADING": "Chargement",
      "SIMULATION_PAUSED": "La simulation a été interrompue.",
      "CLICK_RESUME": "Cliquez sur le bouton « Reprendre » ci-dessous pour continuer.",
      "NO_INTERNET": "Aucune connexion Internet",
      "TRY_AGAIN": "Veuillez vérifier votre connexion et réessayer.",
      "MIC_MUTED": "Le micro est en sourdine",
      "MIC_MUTED_DESCRIPTION": "Oups, on dirait que votre micro est en sourdine. Rétablissez le son pour répondre et poursuivre l’appel.",
      "NO_RESPONSE": "Aucune réponse détectée",
      "MIC_NOT_CONNECTED": "Oups, on dirait que votre micro n’est pas connecté. Sélectionnez à nouveau votre appareil pour répondre et poursuivre l’appel.",
      "AUDIO_ISSUE": "Oups, un problème est survenu. Vérifiez les réglages de votre appareil et assurez-vous d'être dans un endroit calme, sans bruit de fond.",
      "LOADING_ALT": "Chargement...",
      "REPEAT_RESPONSE": "Vous serez automatiquement renvoyé à votre simulation pour répéter votre réponse et réessayer.",
      "NEEDS_MORE_TIME_QUESTION": "a besoin de plus de temps pour réfléchir. Voulez-vous attendre?",
      "NEEDS_MORE_TIME": "a besoin de plus de temps pour réfléchir.",
      "WAIT_OR_END_CALL": "Nous vous préviendrons lorsqu’ils seront prêts, ou vous pouvez mettre fin à l’appel et",
      "RETURN_TO_ASSIGNMENTS": "Retour à l’affectation",
      "READY": "Prêt",
      "IS_READY": "est prêt à poursuivre la conversation.",
      "TRY_AGAIN_LABEL": "Réessayer",
      "CHECK_SETTINGS": "Vérifier les paramètres",
      "PAUSED_SIMULATION": "Vous avez interrompu cette simulation.",
      "PAUSED_SIMULATION_DESCRIPTION": "L’enregistrement vidéo et audio est interrompu jusqu’à ce que la simulation reprenne.",
      "RESUME": "Reprendre",
      "SETTINGS": "Paramètres",
      "CAPTURING_RESPONSE": "Saisir vos réponses",
      "TOUR_MESSAGE": "Une fois que vous avez fini de parler, assurez-vous de cliquer sur le bouton Continuer pour que vos réponses soient saisies et notées.",
      "NEXT": "Suivant",
      "START_CALL": "Démarrage",
      "END_CALL_TITLE": "Souhaitez-vous vraiment mettre fin à cette simulation?",
      "END_CALL_DESCRIPTION": "Si vous terminez la simulation maintenant, vous n’obtiendrez pas de note ni de retour d’information sur votre conversation.",
      "END_CALL": "Fin",
      "BROWSER_ACCESS_DENIED": "Votre navigateur n’a pas accès à cet appareil.",
      "COPY_SESSION_ID_BUTTON": "Copier l’identifiant de la session",
      "TIPS_GUIDANCE_MESSAGE": "Des points de discussion et des conseils seront publiés ici.",
      "CONTINUE": "Continuer",
      "SESSION_ID_LABEL": "ID de la session :",
      "SESSION_ID_COPIED": "L’identifiant de la session a été copié!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Conseils et suggestions",
      "HINT_LABEL": "Conseil",
      "CAPTIONS_LABEL": "Sous-titres",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Vidéo",
      "PARTY_EMOJI": "émoji de fête",
      "CALL_ENDED_MESSAGE": "Vous avez atteint la fin de cette simulation.",
      "CALL_ENDED_INACTIVITY": "Cette simulation a pris fin en raison d’une inactivité",
      "CALL_ENDED_GENERIC": "Cette simulation est terminée",
      "FEEDBACK_PROMPT": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "INTERACTION_THRESHOLD_NOT_MET": "Vous n’avez pas atteint notre seuil d’interaction pour la notation, veuillez réessayer.",
      "REALISTIC_CONVERSATION_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Vous sentez-vous mieux informé et préparé après cette simulation?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires! Nous nous efforcerons d’améliorer l’expérience.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "L’aide visuelle n’a pas pu être chargée",
      "BEGIN_CALL": "Démarrage",
      "LEAVE_CALL_BRIEFING": "Breffage sur les congés",
      "RESTORE_CALL": "Restauration de la simulation",
      "FEW_SECONDS": "Cela peut prendre quelques secondes.",
      "CHECK_ALT": "Vérifier",
      "COPY_ALT": "Copie",
      "HINTS_ALT": "Conseils",
      "CLOSE_CAPTIONS": "Fermer les sous-titres",
      "MICROPHONE_MUTED": "Microphone en sourdine",
      "RETURN_TO_CALL": "Retour à la simulation",
      "YES": "Oui",
      "NO": "Non",
      "VIEW_RESULTS": "Voir les résultats",
      "RETURN_TO_ASSIGNMENT": "Retour à l’affectation",
      "HAVING_ISSUES": "Nous avons des difficultés à nous connecter. Veuillez vérifier votre connexion Internet, puis cliquez sur OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Désolé, nous ne sommes pas en mesure de générer des résultats pour le moment. Veuillez réessayer.",
      "INACTIVITY_ALERT_MESSAGE": "Cet appel sera terminé en raison d’une inactivité. Parlez à l’avatar pour continuer ou sélectionnez « Terminer l’appel » pour mettre fin à l’appel.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Cet appel se terminera dans {{secondsUntilHangup}} secondes",
      "INACTIVITY_SHORT_ALERT_TITLE": "Cet appel se terminera dans quelques secondes",
      "TELL_YOUR_GENDER_HEADING": "Veuillez indiquer votre genre :",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "En connaissant votre genre, l’avatar peut utiliser une grammaire correcte, ce qui rend la conversation plus naturelle et plus réaliste.",
      "GENDER_SELECTION": "Sélection du genre :",
      "SELECT_OPTION": "Sélectionner une option",
      "CONFIRM": "Confirmer",
      "MALE": "Homme",
      "FEMALE": "Femme",
      "NON_BINARY": "Non-binaire/Autre",
      "PREFER_NOT_TO_ANSWER": "Préfère ne pas répondre",
      "NON_BINARY_MESSAGE": "Nous comprenons et respectons votre identité de genre non binaire. En raison des limites technologiques actuelles, nous utilisons par défaut des pronoms masculins. Sachez que nous travaillons à des améliorations pour mieux prendre en compte toutes les identités de genre à l’avenir. Nous vous remercions de votre compréhension et de votre patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Nous respectons votre choix de ne pas fournir de genre. Dans de tels cas, notre technologie utilise par défaut les pronoms masculins en raison des limitations actuelles.",
      "DISPLAY_VISUAL_AID": "Afficher l’aide visuelle",
      "FULL_SCREEN": "Plein écran",
      "COLLAPSE": "Réduire",
      "COMPLETED_CONVERSATION_MESSAGE": "Merci d'avoir terminé cette conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Laissez-nous vos commentaires pendant que nous traitons votre conversation.",
      "ERROR_MESSAGE": "Une erreur s'est produite. Veuillez contacter",
      "SAVED_CONVERSATION_MESSAGE": "Votre conversation a été enregistrée.",
      "RETURN_TO_MY_ASSIGNMENTS": "Retour à mes affectations",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retour à la pratique personnalisée",
      "PERSONALIZED_CALL_NOTE": "Vous venez de terminer une conversation de pratique personnalisée.",
      "LEAVE_STEP_TITLE": "Êtes-vous sûr de vouloir quitter cette étape?",
      "EXIT": "Sortir"
    },
    "assignment": {
      "STATUS": "STATUT",
      "SCORE": "NOTE",
      "MUST_ACHIEVE": "Doit obtenir une note de",
      "OR_HIGHER": "ou plus",
      "TEST": "Test",
      "OUT_OF_5": "sur 5",
      "LATEST_ATTEMPT": "DERNIÈRE TENTATIVE",
      "TOTAL_ATTEMPTS": "Nombre total de tentatives",
      "UNLIMITED": "Illimité",
      "REMAINING": "Restant",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "DUE_DATE": "Date d’échéance",
      "DAYS": "Jours",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "ONGOING": "En cours",
      "SCORE_REQUIREMENT": "Exigence de note",
      "SCORE_REQUIREMENT_DETAIL": "Vous devez obtenir une note de",
      "TO_COMPLETE_EACH_CALL": "pour effectuer chaque simulation requise.",
      "CALLS_IN_ASSIGNMENT": "Simulations dans l'affectation",
      "INCOMPLETE_CALL": "Incomplet",
      "PREVIOUS_RESULTS": "Résultats précédents",
      "DATE": "Date",
      "RESULTS": "Résultats",
      "VIEW_PREVIOUS_RESULTS": "Voir les résultats précédents",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "LAUNCH_CALL": "Lancement",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CHECKMARK": "coche",
      "CALL": "Appeler",
      "QUESTION": "Question",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Pas commencé",
      "CERTIFIED": "Certifié",
      "GUIDED": "Guidé",
      "CONVERSATIONAL": "Conversationnel",
      "GUIDED_SIMULATION": "Contrôle des connaissances",
      "CONVERSATIONAL_SIMULATION": "Appels conversationnels",
      "NO_ATTEMPTS_LEFT": "Il ne reste plus de tentatives",
      "NO_ATTEMPTS": "Pas de tentatives",
      "OVERVIEW": "Vue d’ensemble",
      "ABOUT_THE_AVATAR": "À propos de l’avatar",
      "SCORING_CRITERIA": "Critères de notation",
      "SIMULATION_OVERVIEW": "Aperçu de la simulation",
      "ABOUT_THE_PERSONA": "À propos de la Persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Fermé"
    }
  },
  "es": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DEL ADMINISTRADOR",
      "SUPPORT": "ASISTENCIA",
      "U": "U",
      "USER": "Usuario",
      "LOGOUT": "Cierre de sesión",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Asistencia",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICRÓFONO",
      "CAMERA": "CÁMARA",
      "ACCESS_DENIED": "ACCESO_DENEGADO"
    },
    "teams": {
      "MY_TEAMS": "Mis equipos",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin iniciar",
      "ASSIGNMET_MODULE": "Módulo de tarea",
      "START_DATE": "Fecha de inicio",
      "DUE_DATE": "Fecha de entrega",
      "ASSIGNED_MEMBERS": "Miembros asignados",
      "CALLS_IN_MODULE": "Simulaciones en módulo",
      "COMPLETION_REQUIRMENT": "Requisito de finalización",
      "COMPLETE_ALL_CALLS": "Completa todas las simulaciones con una puntuación de",
      "OR_HIGHER": "o más",
      "PROGRESS_OVERVIEW": "RESUMEN DEL PROGRESO",
      "TEAM_MEMBERS": "miembros del equipo",
      "AVERAGE_HIGH_SCORE": "Puntuación media alta",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número medio de intentos por simulación",
      "TOTAL_PRACTICES": "Prácticas totales",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESO INDIVIDUAL DE LA SIMULACIÓN",
      "OF_TEAM_MEMBERS": "de los miembros del equipo completaron",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Media de prácticas hasta la finalización",
      "TEAM_MEMBER_DETAILS": "DETALLES DEL MIEMBRO DEL EQUIPO",
      "DOWNLOAD_ACTIVITY_REPORT": "Descargar informe de actividad",
      "TEAM_MEMBER": "Miembro del equipo",
      "PROGRESS": "Progreso",
      "CALLS_COMPLETED": "Simulaciones realizadas",
      "PRACTICES": "Sesiones de práctica",
      "MOST_RECENT_PRACTICE": "Sesión más reciente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Este equipo no tiene tareas activas en este momento",
      "CALL_NAME_LABEL": "Nombre de la simulación",
      "HIGHEST_SCORE": "Puntuación más alta"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Asegurémonos de que tu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "Se requiere un micrófono que funcione.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si al actualizar esta página no aparece una ventana emergente solicitándote que habilites tus dispositivos, accede a la configuración de tu sistema o navegador y habilita tus dispositivos desde allí. A continuación, encontrarás páginas de ayuda con más instrucciones.",
      "ENABLE_CAMERA": "Cómo habilitar la cámara:",
      "WINDOWS_USERS": "Usuarios de Windows",
      "MAC_USERS": "Usuarios de Mac",
      "IPAD_USERS": "Usuarios de iPad",
      "ENABLE_MICROPHONE": "Cómo activar el micrófono:",
      "ENABLE_DEVICES_BY_BROWSER": "Cómo habilitar sus dispositivos mediante el navegador:",
      "CHROME_USERS": "Usuarios de Chrome",
      "SAFARI_USERS": "Usuarios de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sin cámara",
      "START_CALL_BUTTON": "Iniciar llamada",
      "MICROPHONE_REQUIRED_WARNING": "Se requiere un micrófono que funcione.",
      "MICROPHONE_ALT": "micrófono",
      "MICROPHONE": "Micrófono",
      "SELECT_MICROPHONE": "Selecciona tu micrófono",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permiso",
      "SELECT_VIDEO_DEVICE": "Selecciona tu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que le has negado el acceso a este navegador a uno o más de tus dispositivos. Para habilitar los dispositivos, accede a la configuración de tu sistema o del navegador y habilita el acceso.",
      "DEVICE_SETTINGS": "Configuración del dispositivo",
      "CONFIRM_SETTINGS": "Confirmar ajustes",
      "LAPTOP": "Portátil",
      "SAD_EMOTE_FACE": "Cara de emoticón triste",
      "GRANT_BROWSER_ACCESS": "Para realizar esta simulación, concede al navegador acceso al reconocimiento de voz",
      "USING_IPAD": "Si utilizas un iPad, ve a",
      "SETTINGS": "Ajustes",
      "PRIVACY_AND_SECURITY": "Privacidad y seguridad",
      "SPEECH_RECOGNITION": "Reconocimiento de voz",
      "GRANT_ACCESS_REFRESH": "Concede acceso al navegador y actualiza la página",
      "REFRESH_PAGE": "ACTUALIZAR PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "El navegador no puede acceder a este dispositivo",
      "ACCESS_DENIED": "acceso denegado",
      "CAMERA": "Cámara",
      "DIAGNOSTIC_PASSED": "Todas las pruebas de diagnóstico se realizaron con éxito.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Algunas pruebas de diagnóstico fallaron. Haz clic en el botón \"Copiar resultados del diagnóstico\" situado arriba y envía los resultados al equipo de asistencia para que te ayuden.",
      "DIAGNOSTIC_PARTIAL": "La mayoría de las pruebas de diagnóstico se realizaron con éxito. Tu conexión parece buena.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Por favor, espera mientras se ejecutan las pruebas de diagnóstico...",
      "DIAGNOSTIC_RUNNING": "Ejecutando diagnóstico",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados del diagnóstico",
      "RUN_DIAGNOSTIC": "Ejecutar Diagnóstico",
      "RERUN_DIAGNOSTIC": "Reejecutar diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados del diagnóstico copiados al portapapeles",
      "DIAGNOSTIC_FAILED": "Diagnóstico fallido",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnóstico de Quantified",
      "DIAGNOSTIC_TIME": "Tiempo",
      "DIAGNOSTIC_SUMMARY": "Resumen",
      "DIAGNOSTIC_CLIENT_INFO": "Información del cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Pérdida de paquetes (enviar)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Tasa de bits de envío promedio",
      "DIAGNOSTIC_NA": "N/A"
    },
    "results": {
      "RETURN_HOME": "REGRESAR A INICIO",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CONVERSATIONAL_CALL": "JUEGO DE ROLES",
      "INFORMATION_ICON": "Icono de información",
      "TOOLTIP_ARROW": "Flecha del tooltip",
      "INFORMATION_TOOLTIP_CONTENT": "Tú controlas el desarrollo de la simulación y diriges la conversación hacia una serie de objetivos. Los juegos de rol son excelentes para poner a prueba habilidades como profundizar en detalles y hacer preguntas de segundo nivel, descubrir puntos de dolor y crear una buena relación.",
      "CLOCK_ICON": "Icono de reloj",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "TRY_AGAIN_MESSAGE": "Inténtalo de nuevo y mejora tu puntuación.",
      "PRACTICE_BENEFITS": "Practicar semanalmente aumenta la confianza y mejora los resultados en el mundo real.",
      "CALL_SUCCESS": "¡Buen trabajo! Has completado esta simulación con éxito.",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "¡Buen trabajo! Has completado",
      "COMPLETED_THIS_CALL": "correctamente esta simulación.",
      "ACHIEVED_SCORE": "Has logrado una puntuación de",
      "ACHIEVE_SCORE": "Logra una puntuación de",
      "OR_HIGHER": "o superior.",
      "OBJECTIVES_NOT_MET": "No cumpliste con todos los objetivos requeridos.",
      "TRY_AGAIN_TARGET_SCORE": "Inténtalo de nuevo para lograr una puntuación de",
      "YOUR_SCORE": "Tu puntuación",
      "OUT_OF_5": "SOBRE 5",
      "CALL_FEEDBACK": "RESUMEN DE COMENTARIOS",
      "STRENGTH_ICON_ALT": "Icono de fuerza",
      "OPPORTUNITIES_ICON_ALT": "Icono de oportunidades",
      "OBJECTIVES_FEEDBACK": "COMENTARIOS SOBRE LA METODOLOGÍA",
      "SESSION_ID": "ID de sesión:",
      "SESSION_ID_COPIED": "¡ID de sesión copiado!",
      "OBJECTIVE": "METODOLOGÍA:",
      "HOW_YOU_DID": "Qué tal lo hiciste:",
      "LIGHTBULB_ICON_ALT": "Icono de bombilla",
      "WHAT_WE_SUGGEST": "Lo que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nuestro sistema no ha podido encontrar una recomendación específica para ti.",
      "WHY": "¿Por qué?",
      "NO_INSIGHTS_AVAILABLE": "Nuestro sistema no ha podido proporcionar información sobre esta sugerencia.",
      "CONFETTI_ICON_ALT": "Icono de confeti",
      "OBJECTIVE_SUCCESS_MESSAGE": "Lo has hecho muy bien en esta metodología, ¡sigue así!",
      "PROCESSING_CALL": "Estamos preparando tu puntuación y tus comentarios.",
      "HANG_TIGHT": "Espera un momento o vuelve a consultar más tarde para",
      "VIEW_YOUR_RESULTS": "ver tus resultados.",
      "NEED_MORE_TIME": "Necesitamos más tiempo para calcular los resultados.",
      "REFRESH_INSTRUCTION": "Vuelve a consultarlo o actualiza los resultados",
      "RESULTS_IN_FEW_MINUTES": "de los resultados dentro de unos minutos.",
      "SCORE_CALCULATION_QUESTION": "¿Cómo se calcula esto?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulación solo tiene un único componente de puntuación, por lo que la puntuación mostrada es tanto la puntuación de sección individual como la puntuación general.",
      "OVERALL_SCORE_PERCENT": "% de la puntuación general",
      "SECTION_SCORE": "Puntuación de la sección",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Mejora la adherencia al mensaje en la conversación",
      "MESSAGE_ADHERENCE_NOTE": "La adherencia al mensaje es fundamental para dirigir conversaciones exitosas, pero no afecta a la puntuación general.",
      "NO_CREDIT": "Sin crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito completo",
      "WHAT_YOU_DID_WELL": "Lo que hiciste bien",
      "MISSED_ALL_KEY_POINTS": "Te has saltado todos los puntos clave; revísalos y vuelve a intentarlo.",
      "WHAT_TO_IMPROVE": "Lo que puedes mejorar",
      "PERFECT_SCORE_MESSAGE": "¡Felicidades! Has obtenido una puntuación perfecta, hablando correctamente de todos los puntos clave.",
      "POINTS_LABEL": "Puntos",
      "TALKING_POINTS_COVERED": "Temas de conversación tratados",
      "CHECKMARK_ICON_ALT": "marca de verificación",
      "TALKING_POINTS_MISSED": "Temas de conversación omitidos",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "OUT_OF": "de",
      "POSSIBLE_TALKING_POINTS": "temas de conversación posibles",
      "YOU_COVERED": "Has tratado",
      "THROUGHOUT_CALL": "durante toda la simulación.",
      "POSITIVE_FEEDBACK_COVERAGE": "Has hecho un gran trabajo al destacar los puntos clave durante toda la llamada y has tratado",
      "MIXED_FEEDBACK_COVERAGE": "Te has perdido algunos mensajes clave durante la simulación y has tratado",
      "OBJECTIVES": "Metodología",
      "ELEVATE_OBJECTIVES_TITLE": "Mejora tu metodología de conversación",
      "OBJECTIVES_NOTE": "La metodología es fundamental para dirigir conversaciones exitosas, pero no afecta a la puntuación general.",
      "UNTIL": "hasta",
      "TO_IMPROVE_SCORE": "para mejorar tu puntuación.",
      "TO_SCORE": "para puntuar",
      "BEFORE": "antes",
      "YOU_HAVE": "Tienes",
      "MORE_ATTEMPTS": "más intentos para conseguir",
      "OR_HIGHER_BEFORE": "puntos o más antes de",
      "AND_TRY_AGAIN": "e intentarlo de nuevo.",
      "UNEXPECTED_STATE": "Ha ocurrido un estado inesperado.",
      "REVIEW_APP_LOGIC": "Por favor, revisa la lógica de la aplicación.",
      "ASSIGNMENTS": "Tareas",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "PRACTICE_SESSION": "Sesión de práctica",
      "OVERALL_SCORE": "Puntuación general",
      "OVERALL_SCORE_EXPLANATION": "La puntuación general se calcula tomando una media ponderada de la puntuación de cada sección. El peso de cada sección se muestra como un porcentaje junto a la puntuación.",
      "SCORE_CONFIG_NOTE": "Los porcentajes de peso y la inclusión y exclusión de secciones los establece tu empresa. Todas las puntuaciones se redondean a la décima más cercana.",
      "STRENGTHS": "Fortalezas",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Tu respuesta",
      "MINUS": "menos",
      "PLUS": "más",
      "RECOMMENDED_RESPONSE": "Respuesta recomendada",
      "REVIEW_MISSED_TITLE": "Revisa lo que has omitido.",
      "NO_TALKING_POINTS_COVERED": "No has tratado ninguno de los temas de conversación requeridos para este tema.",
      "LEARN_WHAT_YOU_MISSED": "Descubre lo que has omitido",
      "NICE_JOB": "¡Buen trabajo!",
      "ALL_POINTS_COVERED": "Has tratado exitosamente todos los temas de conversación requeridos para este tema.",
      "COVER_ALL_MESSAGES": "Tratar todos los mensajes clave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Resaltar los puntos clave durante la llamada ayudará a mantener la conversación centrada.",
      "MESSAGES_LABEL": "Mensajes",
      "NO_FACTS_COVERED": "¡Vaya! Parece que no has mencionado ninguno de los hechos de este mensaje.",
      "NO_SPECIFICS_AVAILABLE": "¡Vaya! Parece que no hemos podido proporcionar detalles sobre lo que has omitido.",
      "ALL_KEY_POINTS_COVERED": "¡Buen trabajo! Has tratado todos los puntos clave.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos procesando los comentarios sobre tus habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lo sentimos, pero no hemos podido analizar tu llamada reciente porque la evaluación de habilidades no estaba habilitada en el momento del envío. Para recibir comentarios, solo tienes que volver a enviar tu práctica de llamada como lo hiciste anteriormente. Si necesitas ayuda, no dudes en contactar a nuestro equipo de soporte. ¡Gracias por tu comprensión y compromiso por mejorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Mejora tus habilidades de conversación",
      "SKILLS_NOTE": "Las habilidades son críticas para dirigir conversaciones exitosas, pero no afectan a la puntuación general.",
      "SKILLS_SUMMARY_TITLE": "RESUMEN DE HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Obtén más información sobre las habilidades",
      "SKILLS_FEEDBACK_LABEL": "COMENTARIOS",
      "WHAT_ARE_SKILLS_TITLE": "¿Qué son las habilidades?",
      "SKILLS_DESCRIPTION": "Las habilidades están calibradas para favorecer el desarrollo del crecimiento personal. Aunque estas habilidades no forman parte de la evaluación numérica de tu llamada, tu organización las ha seleccionado para mejorar tu eficacia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE COMPETENCIA",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "CALL_TRANSCRIPT": "Transcripción de la llamada",
      "COLLAPSE_ALL": "Colapsar todo",
      "EXPAND_ALL": "Expandir todo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 puntos",
      "TALKING_POINTS": "temas de conversación",
      "TRANSCRIPT_LABEL": "Transcripción",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Te has quedado sin intentos.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revisa las directrices y sigue cumpliéndolas en el futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Inténtalo de nuevo y presta atención a las directrices de cumplimiento.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nos hemos dado cuenta de que no cumpliste con la normativa, por lo que no has recibido ninguna puntuación.",
      "WHY_OUT_OF_COMPLIANCE": "Por qué no cumpliste con la normativa",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revisa tu transcripción para ver en qué aspectos no has cumplido con la normativa.",
      "YOU_DID_FOLLOW_GUIDELINES": "Cumpliste con estas directrices de manera efectiva.",
      "REVIEW_MISSED_GUIDELINES": "Revisa las directrices de cumplimiento incumplidas.",
      "OUT_OF_COMPLIANCE": "Incumplimiento",
      "SCORE_CALCULATION_TITLE": "Cálculo de puntuación",
      "PROCESSING_TRANSCRIPT": "Estamos procesando tu transcripción.",
      "WAIT_OR_REVIEW_SCORES": "Espera aquí o revisa las otras secciones",
      "TRANSCRIPT_LOADING": "de la puntuación mientras se carga la transcripción.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revisa tus comentarios y sigue practicando",
      "HIGH_PERFORMERS_PRACTICE": "Las personas con mejor rendimiento practican al menos una vez a la semana",
      "SUCCESSFULLY_PASSED": "¡Buen trabajo! Has superado con éxito esta simulación.",
      "DIDNT_REACH_PASSING_SCORE": "No has alcanzado la puntuación de aprobado para esta simulación.",
      "OUT_OF_ATTEMPTS": "<b>Te has quedado sin intentos.</b> Revisa tus comentarios para saber cómo puedes mejorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revisa tus comentarios y vuelve al inicio cuando estés preparado.",
      "GREAT_JOB_PRACTICED": "¡Buen trabajo! Has practicado {{count}} {{times}}. ¡Sigue así!",
      "TIME": "vez",
      "TIMES": "veces",
      "COMPLIANCE_GUIDELINES": "Normativa de cumplimiento",
      "TALKING_POINT_TITLE": "TEMAS DE CONVERSACIÓN OMITIDOS O ABORDADOS EN EL MOMENTO EQUIVOCADO",
      "NO_TRANSCRIPT": "No hay transcripción disponible."
    },
    "reportingV2": {
      "DASHBOARD": "Panel",
      "LOADING_ACCOUNTS": "Cargando cuentas…",
      "SELECT_AN_ACCOUNT": "Selecciona una cuenta",
      "SEARCH_TEAMS": "Buscar equipos",
      "LOADING_TEAMS": "Cargando equipos…",
      "ALL_TEAMS": "Todos los equipos",
      "ACCOUNT": "Cuenta",
      "TEAMS": "Equipos",
      "TEAM_LABEL": "Equipo",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Calificación mínima para aprobar",
      "ASSIGNMENT_LABEL": "Tareas",
      "USER_LABEL": "Usuarios",
      "PRACTICE_LABEL": "Práctica",
      "CERTIFICATION_LABEL": "Certificación",
      "RESULTS_DESCRIPTION": "Aquí tienes los resultados de tu(s) equipo(s) en todas las prácticas:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Participación por tarea",
      "ASSIGNMENT_ENGAGEMENT": "Participación de la tarea",
      "ENGAGED_LABEL": "Realizada",
      "ENGAGEMENT_STATUS_LABEL": "Estado de participación",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nombre de la tarea",
      "ACTIVE_USERS": "Usuarios activos",
      "ASSIGNMENT_PROGRESS": "Progreso por tarea",
      "IN_PROGRESS_LABEL": "En progreso",
      "CERTIFIED_LABEL": "Certificadas",
      "OUT_OF_ATTEMPTS_LABEL": "No quedan intentos",
      "USERS_ENGAGED_LABEL": "Usuarios participantes",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sesiones por usuario activo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Más de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sesiones completadas",
      "USER_CERTIFIED": "Usuarios certificados en todas las tareas",
      "ASSIGNMENT_CERTIFICATION": "Tareas con certificación del 100 %",
      "TRAINER_TIME_SAVED": "Ahorro de tiempo del formador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tareas de práctica",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tareas de certificación",
      "START_DATE_LABEL": "Fecha de inicio",
      "END_DATE_LABEL": "Fecha de finalización",
      "NAME_LABEL": "Nombre",
      "EMAIL_LABEL": "Correo electrónico",
      "MEMBER_OF_TEAMS_LABEL": "Miembro de equipos",
      "ASSIGNMENTS_COUNT_LABEL": "# de tareas",
      "TOTAL_SESSIONS_LABEL": "Sesiones totales",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sesiones",
      "TOTAL_USERS_LABEL": "Usuarios totales",
      "AVERAGE_SCORE_LABEL": "Puntuación media",
      "INITIAL_SCORE_LABEL": "Puntuación inicial",
      "HIGH_SCORE_LABEL": "Puntuación alta",
      "LAST_PRACTICE_DATE_LABEL": "Última fecha de práctica",
      "PERCENT_IMPROVED_LABEL": "% mejorado",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica analiza las puntuaciones de cada sesión y traza una línea recta en un gráfico para ilustrar la tendencia. Un porcentaje más alto indica que las puntuaciones están mejorando más rápidamente; un porcentaje más bajo indica que las puntuaciones están mejorando más lentamente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tareas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tareas satisfactorias",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de la tarea.",
      "PROFICIENT_TOOLTIP": "Porcentaje de usuarios de esta tarea que han cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de esta tarea.",
      "IN_PROGRESS_TOOLTIP": "Porcentaje de usuarios que han completado al menos una sesión de una simulación en esta tarea y han recibido una puntuación.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Porcentaje de usuarios que han superado los intentos asignados para una o varias simulaciones de la tarea.",
      "CERTIFIED_TOOLTIP": "Porcentaje de usuarios que han cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "SEARCH_FOR_A_USER_LABEL": "Buscar un usuario",
      "NO_USERS_FOUND_LABEL": "No se han encontrado usuarios",
      "TRAINER_TIME_SAVED_TOOLTIP": "La cantidad de tiempo que los usuarios han pasado en Quantified completando intentos de certificación.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sesiones medias por tarea",
      "ASSIGNMENTS_ENGAGED_WITH": "Tareas realizadas con",
      "AVERAGE_IMPROVEMENT": "Mejora media",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sesiones",
      "DATE_OF_LAST_PRACTICE": "Fecha de la última práctica",
      "CALL_NAME": "Nombre de la llamada",
      "SESSION_DATE": "Fecha de la sesión",
      "DURATION_OF_SESSION": "Duración de la sesión",
      "OVERALL_SCORE": "Puntuación general",
      "MESSAGING_SCORE": "Puntuación de adherencia al mensaje",
      "METHODOLOGY_SCORE": "Puntuación de metodología",
      "SKILLS_SCORE": "Puntuación por competencia",
      "SESSIONS": "Sesiones",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas las tareas",
      "RECENT_ASSIGNMENTS": "Tareas recientes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Media de sesiones por usuario activo",
      "HOURS_IN_SIMULATIONS": "Horas en simulaciones",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Promedio de sesiones hasta la competencia",
      "PERCENT_PROFICIENT": "Porcentaje competente",
      "SYSTEM_RUNNING_NORMALLY": "El sistema está funcionando con normalidad",
      "PRACTICE_SIMULATIONS_LABEL": "Simulaciones",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Ningún resultado coincide con los filtros. Prueba a borrar uno o varios filtros para ampliar la búsqueda.",
      "USERS_PASSED": "Usuarios que han superado la simulación",
      "AVERAGE_TIME": "Tiempo medio de certificación",
      "USERS_OUT_OF_ATTEMPTS": "Usuarios sin intentos",
      "NO_CERTIFICATION_SIMULATION": "No se han encontrado simulaciones de certificación",
      "No_SIMULATION": "Sin sesiones",
      "PERCENT_CERTIFIED": "Porcentaje de certificaciones",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Porcentaje de certificaciones en el primer intento",
      "USERS": "Usuarios",
      "ATTEMPTS_LABEL": "Intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "DATE_OF_SESSION": "Fecha de la sesión",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Ninguna tarea coincide con los filtros elegidos",
      "NO_TEAMS_DATA": "No hay equipos en esta cuenta",
      "SIMULATION_NAME": "Nombre de la simulación",
      "AVERAGE_DURATION_OF_SESSION": "Duración media de la sesión",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Media de sesiones por usuario activo",
      "AVERAGE_OVERALL_SCORE": "Puntuación media global",
      "TOTAL_ASSIGNMENTS": "Tareas totales",
      "ASSIGNMENTS_CERTIFIED": "Tareas certificadas",
      "TOTAL_SESSIONS": "Sesiones totales",
      "HOURS_SPENT_PRACTICING": "Horas dedicadas a practicar",
      "LAST_LOGIN": "Último acceso",
      "SELECT_ASSIGNMENTS": "Seleccionar tareas",
      "CERTIFICATION_STATUS_LABEL": "Estado de la certificación",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado de la certificación:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "¿Certificado al primer intento?",
      "DATE_OF_CERTIFICATION_LABEL": "Fecha de certificación",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado de participación:",
      "DURATION_OF_ATTEMPT": "Duración del intento",
      "USER_NAME": "Nombre de usuario",
      "LEARNER": "Estudiante",
      "DATE_RANGE": "Intervalo de fechas",
      "DATE_RANGE_LABEL": "Intervalo de fechas",
      "SEARCH_USERS": "Buscar usuarios...",
      "SEARCH_SIMULATIONS": "Buscar simulaciones...",
      "SEARCH_DATES": "Buscar fechas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado a la primera",
      "DATE_OF_CERTIFICATION": "Fecha de certificación",
      "AVERAGE_CERTIFICATION_SCORE": "Puntuación media de la certificación",
      "TOTAL_TIME_CERTIFYING": "Tiempo total de certificación",
      "OF_THE_TIME": "del tiempo",
      "ASSIGNED_LABEL": "Sin iniciar",
      "USERS_ASSIGNED_LABEL": "Total de usuarios asignados",
      "SESSION_ID": "ID de sesión",
      "USER_NAME_LABEL": "Nombre de usuario",
      "NO_SIMULATIONS_FOUND_LABEL": "No se han encontrado simulaciones",
      "MIN": "min",
      "SEC": "seg",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Asignada",
      "SIMULATION": "Simulación",
      "ENGAGED_TOOLTIP": "El porcentaje de usuarios que han completado una o más sesiones de una simulación en esta tarea pero que aún no han alcanzado la competencia en todas las simulaciones.",
      "SEARCH_ASSIGNMENTS": "Buscar tareas...",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "START_DATE": "Fecha de inicio",
      "END_DATE": "Fecha de finalización",
      "NO_ASSIGNMENTS": "No se encontró ninguna tarea para este usuario.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tareas de práctica",
      "SESSION_SCORES_OVER_TIME": "Puntuaciones de la sesión a lo largo del tiempo",
      "TIME": "Tiempo",
      "SCORE": "media",
      "NO_SESSIONS_AVAILABLE": "No hay sesiones disponibles para graficar.",
      "MESSAGING_SCORE_LABEL": "Puntuación de adherencia al mensaje",
      "PERSONALIZED_PRACTICE_LABEL": "Práctica personalizada",
      "ASSIGNMENT_ENAGEMENT": "Participación por tarea",
      "NO_PRODUCTS": "No hay productos de práctica personalizada para los equipos seleccionados",
      "TOTAL_TIME_SPENT_PRACTICING": "Tiempo total dedicado a la práctica",
      "AVERAGE_SESSIONS_PER_USER": "Promedio de sesiones por usuario",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación más común",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación menos común",
      "CLEAR_TEAMS": "Eliminar equipos",
      "METHODOLOGY_SCORE_DESCRIPTION": "Puntuaciones objetivas medias en todas las sesiones de esta llamada.",
      "METHODOLOGY": "Metodología",
      "MESSAGING": "Mensaje",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "La adherencia al mensaje mide si los alumnos articulan dos ideas importantes durante esta simulación. Estas visualizaciones muestran los porcentajes de mensajes en un tema de mensajes determinado que los usuarios articularon, en promedio, en todas las sesiones de esta llamada.",
      "NO_METRICS_MESSAGE": "No hay sesiones completadas para los equipos seleccionados.",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Las puntuaciones de las habilidades son una evaluación de la IA de las habilidades demostradas por los usuarios durante una llamada.",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "La adherencia al mensaje mide si los usuarios articulan tres ideas importantes en esta llamada."
    },
    "reporting": {
      "AT_GLANCE": "Tareas de un vistazo",
      "OPEN_ASSIGNMENTS": "Tareas abiertas",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificadas",
      "VIEW_LIST": "Ver la lista",
      "CERTIFICATION_ASSIGNMENTS": "Tareas de certificación",
      "CERTIFICATION_SUMMARY_TEXT": "Las certificaciones son tareas que tienen una fecha de entrega y unos criterios específicos para aprobarlas",
      "PRACTICE_ASSIGNMENTS": "Tareas de práctica",
      "PRACTICE_SUMMARY_TEXT": "Las tareas de práctica están disponibles para los usuarios sin una fecha de entrega específica. Están diseñadas para que los usuarios practiquen con regularidad para mejorar sus habilidades",
      "THE": "La",
      "WILL_CLOSE": "cerrará en",
      "USERS_HAVE": "los usuarios",
      "USER_HAS": "el usuario",
      "NOT_STARTED_ASSIGNMENT_DUE": "no ha(n) empezado una tarea que debe(n) entregar la semana siguiente",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "no ha(n) completado una tarea que debe(n) entregar la semana siguiente",
      "DAYS": "días",
      "DAY": "día",
      "MODULES": "Módulos",
      "MODULE": "Módulo",
      "CALL": "Simulación",
      "CALLS": "Simulaciones",
      "CERTIFICATION_ASSIGNMENT": "Tarea de certificación",
      "PRACTICE_ASSIGNMENT": "Tarea de práctica",
      "AND": "y",
      "VIEW_ENGAGEMENT_DETAILS": "Ver detalles de la participación",
      "SEE_ALL": "Ver todo",
      "SEE_LESS": "Ver menos",
      "ASSIGNMENT": "Tarea",
      "ASSIGNED": "Asignada",
      "IN_PROGRESS": "En curso",
      "DUE_DATE": "Fecha de vencimiento",
      "ASSIGNMENT_ENDS_IN": "La tarea finaliza en",
      "ASSIGNMENT_CLOSED": "Tarea cerrada",
      "OLDER_CERTIFICATION": "certificación más antigua",
      "ASSIGNMENT_IS": "la tarea está",
      "ASSIGNMENT_ARE": "las tareas están",
      "CURRENTLY_HIDDEN": "ocultas actualmente",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Se muestran todas las tareas de certificación.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Usuarios que aún no han completado y recibido una puntuación para ninguna simulación.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Usuarios que han completado al menos una simulación y han recibido una puntuación.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Usuarios que han cumplido el requisito de certificación.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Es el número de usuarios que pueden acceder a la tarea para sus certificaciones.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Ver todas las tareas de certificación",
      "HIDE_OLDER_ASSIGNMENTS": "Ocultar tareas antiguas",
      "AVG_PRACTICES": "Prácticas medias",
      "PRACTICED": "Practicado",
      "SCORED_HIGH": "Puntuación alta",
      "AVG_ASSIGNMENT": "Mejora media",
      "DAYS_AGO": "días atrás",
      "NA": "N/A",
      "OLDER_PRACTICE": "práctica más antigua",
      "SEE_PRACTICE_ASSIGNMENT": "Ver todas las tareas de práctica",
      "ALL_PRACTICE_ASSIGNMENTS": "Se están mostrando todas las tareas de práctica.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Usuarios que aún no han completado y recibido una puntuación para ninguna simulación.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Estos usuarios han terminado al menos una simulación y han recibido una puntuación.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Número de usuarios de esta tarea que han obtenido una puntuación igual o superior a los criterios de puntuación alta definidos, al menos una vez en todas las simulaciones de esta tarea.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Estos usuarios pueden acceder a la tarea para practicar.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Este número muestra el número medio de veces que los usuarios han practicado las simulaciones que forman parte de esta tarea.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Esta métrica analiza las puntuaciones de cada sesión y traza una línea recta en un gráfico para ilustrar la tendencia. Un porcentaje más alto indica que las puntuaciones están mejorando más rápidamente; un porcentaje más bajo indica que las puntuaciones están mejorando más lentamente.",
      "USERS": "usuarios",
      "USER": "usuario",
      "DOWNLOAD_CSV": "Descargar CSV",
      "ERROR": "Se ha producido un error",
      "FIRST_NAME": "Nombre",
      "LAST_NAME": "Apellido",
      "ATTEMPTS": "Intentos",
      "EMAIL": "Correo electrónico",
      "LAST_LOGIN": "Última conexión",
      "ASSIGNMENT_NOT_STARTED": "Tarea no iniciada",
      "ASSIGNMENT_IN_PROGRESS": "Tarea en curso",
      "SCORE_CRITERIA_MET": "Puntuación de criterios cumplidos",
      "NEVER_LOGGED_IN": "No conectado",
      "QUANTIFIED_REPORTING": "Informes de Quantified",
      "ASSIGNED_USERS": "Usuarios asignados",
      "COMPLETION_REQUIREMENT": "Requisito de finalización",
      "AVG_SCORE_Of": "Puntuación media de",
      "REPORTING": "Informes",
      "CERTIFICATIONS": "Certificaciones",
      "PRACTICES": "Prácticas",
      "CALL_ANALYSIS": "Análisis de simulación",
      "PERCENT_CERTIFIED_ON": "Porcentaje de certificaciones en",
      "SHOWING": "Mostrando",
      "PRACTICE_SESSIONS": "Sesiones de prácticas acumuladas en todas las simulaciones del módulo",
      "AVG_PRACTICE_HEADING": "Número medio de sesiones de práctica por usuario activo",
      "AVG_SCORE_LABEL": "Puntuación media",
      "AVG_SCORE_HEADING": "Puntuación media por usuario",
      "AVG_PRACTICES_LABEL": "Puntuación Prácticas",
      "EXPORT_LEARNER_LIST": "Exportar lista de alumnos",
      "PERCENT_NOT_STARTED": "% sin iniciar",
      "PERCENT_IN_PROGRESS": "% en progreso",
      "PERCENT_CERTIFIED": "% certificado",
      "USER_CERTIFIED": "Usuario certificado",
      "USERS_CERTIFIED": "Usuarios certificados",
      "TOTAL_ATTEMPTS": "Intentos totales",
      "Avg_ATTEMPTS_CERTIFY": "Media de intentos para certificar",
      "ASTERICK_GROUP": "Denota un grupo que contiene uno o más subgrupos",
      "NO_DATA_FOUND": "No se han encontrado datos",
      "MODULE_HIGHLIGHTS": "Puntos destacados del módulo",
      "MODULE_HIGHLIGHT_SUMMARY": "Métricas clave en todas las simulaciones. Para un análisis detallado de cada simulación, consulta el siguiente resumen",
      "HIGHEST_SCORING_QUESTION_TITLE": "PREGUNTA CON MAYOR PUNTUACIÓN",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Pregunta con mayor puntuación",
      "QUESTION_BAR_MSG": "% medio de puntos de respuesta contestados correctamente",
      "LOWEST_SCORING_QUESTION_TITLE": "PREGUNTA CON MENOR PUNTUACIÓN",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Pregunta con menor puntuación",
      "TOP_SCORED_ANSWER_POINT_TITLE": "PUNTO DE RESPUESTA CON MAYOR PUNTUACIÓN",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Pregunta de punto de respuesta menos fallada",
      "SCORE_BAR_MSG": "de las veces, los usuarios aciertan.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "PUNTO DE RESPUESTA CON MENOR PUNTUACIÓN",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Pregunta sobre el punto de respuesta más fallada",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METODOLOGÍA DE PUNTUACIÓN MÁS BAJA",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodología de puntuación más baja",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METODOLOGÍA DE MAYOR PUNTUACIÓN",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodología de mayor puntuación",
      "OBJECTIVE_BAR_MSG": "puntos medios en esta metodología",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MENSAJE MENOS ARTICULADO",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensaje menos articulado",
      "LEAST_ARTICULATED_BAR_MSG": "Articular este mensaje",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MENSAJE MÁS ARTICULADO",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensaje más articulado",
      "MOST_ARTICULATED_BAR_MSG": "Articular plenamente este mensaje",
      "Overview": "Visión general",
      "CONSISTS_Of": "consiste en",
      "CALL_OVERVIEW_LABEL": "El gráfico muestra el número de usuarios que han",
      "PASSED": "Aprobado",
      "ATTEMPTED": "Intentado",
      "NOT_ATTEMPTED": "No intentado",
      "GUIDED_CALL": "Prueba de conocimientos",
      "QUESTIONS": "Preguntas",
      "QUESTION": "Pregunta",
      "CONVERSATIONAL_CALL": "Juego de roles",
      "AVG_ATTEMPTS": "Puntuación Intentos",
      "USERS_PASSED": "usuarios aprobados",
      "DETAILED_ANALYSIS": "Análisis detallado",
      "CALL_DETAILS": "Detalles de la simulación",
      "CALL_TYPE": "Tipo de simulación",
      "TOTAL_SESSIONS": "Sesiones totales",
      "WHAT_WE_MEASURED": "Lo que medimos",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Puntuación media global",
      "OVERALL_SCORE_DETAIL": "Nuestro sistema proporciona una \"Puntuación global\" para cada conversación. Esta cifra es la puntuación global media de todos los",
      "CALL_RUN": "usuarios que han completado esta simulación",
      "TIME": "vez",
      "TIMES": "veces",
      "OBJECTIVES": "Metodología",
      "AVG_OBJECTIVE": "Puntuación media de metodología en todas las",
      "OF_THIS_CALL": "de esta simulación",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "MESSAGE_ADHERENCE_DETAILS_1": "La adherencia al mensaje mide si los alumnos articulan",
      "MESSAGE_ADHERENCE_DETAILS_2": "ideas importantes durante la simulación. Estas visualizaciones muestran el porcentaje de mensajes de un tema de mensaje determinado que los usuarios articularon, de media, en todas las",
      "IMPORTANT_IDEAS": "ideas importantes durante esta simulación",
      "PERCENT_MESSAGE_ARTICULATED": "Estas visualizaciones muestran el porcentaje de tiempo que cada mensaje se articula en todas las",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "SKILLS_LABEL": "Habilidades",
      "SKILLS_DETAILS": "Las puntuaciones de las habilidades son una evaluación de la IA de las habilidades demostradas por los usuarios durante una simulación. Estas visualizaciones muestran el porcentaje de veces que los usuarios obtuvieron puntuaciones de \"Experto\" (la más alta), \"Competente\" y \"En desarrollo\" (la más baja) en todas las",
      "DEVELOPING": "En desarrollo",
      "PROFICIENT": "Competente",
      "Expert": "Experto",
      "NO_RESULT": "Aún no hay resultados",
      "NO_RESULT_TEXT": "Ninguno de los usuarios de tu organización ha intentado aún esta simulación. Una vez que lo hagan, podrás ver sus resultados aquí.",
      "CONVERSATIONAL_CALL_TOOLTIP": "Durante los juegos de rol, el usuario puede dirigir el flujo de la conversación, y la IA responderá en consecuencia. Los juegos de rol están menos estructurados que las \"Pruebas de conocimientos\", que tienen un formato estricto de pregunta-respuesta",
      "TOTAL_SESSION_TOOLTIP": "El número total de veces que se ha completado esta simulación en todos los usuarios a los que se ha asignado",
      "AVERAGE_SCORE_LABEL": "Puntuación media",
      "AVERAGE_SCORE_DETAIL": "La puntuación media de todos los usuarios en esta simulación",
      "ANSWER_POINTS": "Puntos de respuesta",
      "DETAILS": "Detalles",
      "CONVERSATIONAL_CALL_MSG": "Pronto se publicarán informes sobre el contenido de los juegos de rol",
      "ALL_CALL_DETAILS": "Todos los detalles de la simulación",
      "QUESTION_TEXT_LABEL": "Texto de la pregunta",
      "AVG_POINTS_LABEL": "Puntos medios",
      "SHOW_ALL": "Mostrar todo",
      "CORRECT_ANSWER": "respuestas correctas de",
      "OBJECTIVE_MEASURED_ON": "Esta metodología se mide en",
      "CALLS_IN_MODULE": "simulaciones en este módulo",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "QUESTION_UPDATED": "Esta pregunta ha sido actualizada",
      "QUESTION_UPDATED_MESSAGE": "No podemos mostrar información detallada sobre los puntos de respuesta porque se han realizado actualizaciones en esta pregunta. La \"Media de puntos\" mostrada representa la media de todas las sesiones de esta pregunta (incluyendo antes y después de las actualizaciones)",
      "CLOSE_ALT": "Cerrar",
      "Q_LABEL": "P",
      "SCORING_LABEL": "Puntuación",
      "AVERAGE_ANSWER": "Media de puntos de respuesta por pregunta",
      "MINIMIZE_LABEL": "Minimizar",
      "VIEW_ALL_LABEL": "Ver todo",
      "DOWN_ARROW": "Flecha hacia abajo",
      "NOTIFICATION": "Notificación",
      "PROGRESS_ICON": "Icono de progreso",
      "VIEW_MODAL": "Ver Modal",
      "VIEW_INFO": "Ver información",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Ampliar grupo",
      "MESSAGE_ADHERENCE_V2": "Adherencia al mensaje",
      "SCORE_OVERALL": "Puntuación global",
      "SCORE_SKILLS": "Habilidades",
      "SCORE_CUSTOMIZED": "Metodología",
      "SESSIONS": "todas las sesiones",
      "SESSION": "toda la sesión"
    },
    "personalizedPractice": {
      "TITLE": "Práctica personalizada",
      "DESCRIPTION": "¡Hola, {{userFirstName}}! Las prácticas personalizadas te permiten establecer tus propios escenarios para que sean lo más realistas posible.",
      "LOADING": "Cargando...",
      "VIEW_SESSIONS": "Ver sesiones",
      "VIEW_SIMULATION": "Ver simulación",
      "TOTAL_SESSION": "sesión total",
      "TOTAL_SESSIONS": "sesiones totales",
      "BREADCRUMB": "Práctica personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalles del escenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecciona variables de las opciones a continuación para ajustar la simulación a tus necesidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleccionar",
      "CONVERSATION_TYPE": "Tipo de conversación",
      "SELECT_CONVERSATION_TYPE": "Seleccionar tipo de conversación",
      "LAUNCH_SIMULATION": "Iniciar simulación con selecciones",
      "PREVIOUS_SESSIONS": "Sesiones anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Fecha",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Fecha de la sesión",
      "SESSION_SCORE": "Puntuación de la sesión",
      "DURATION": "Duración",
      "OVERALL_SCORE": "Puntuación general",
      "MESSAGING": "Mensaje",
      "METHODOLOGY": "Metodología",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver comentarios",
      "OVERALL_SCORE_LABEL": "Puntuación global",
      "SCORE": "media",
      "NO_PRODUCTS_TITLE": "No hay productos disponibles",
      "NO_PRODUCTS_DESCRIPTION": "Aún no tienes productos de práctica personalizados.",
      "NO_SESSIONS_FOUND": "No se encontraron sesiones con los filtros seleccionados.",
      "TIME": "Tiempo",
      "ALL": "Todo",
      "LEARNER": "Estudiante",
      "MOOD": "Estado",
      "CLEAR_FILTERS": "Borrar filtros"
    },
    "login": {
      "TITLE": "Bienvenido de nuevo",
      "SUB_TITLE": "¿Cómo te gustaría iniciar sesión?  ",
      "LOGIN_WITH_SSO": "Iniciar sesión con el SSO de la empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sesión con contraseña",
      "PROVIDE_EMAIL": "Proporciona tu dirección de correo electrónico",
      "HELP_TEXT": "¿Necesitas ayuda? Contacto",
      "EMAIL_ERROR": "No podemos iniciar sesión, por favor contacta al administrador de tu empresa o al departamento de TI.",
      "EMAIL": "Correo electrónico",
      "LOGIN": "Iniciar sesión",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Al iniciar sesión en tu cuenta, aceptas los {{termsLink}} y {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "PRIVACY_POLICY": "Política de privacidad"
    },
    "learningPathway": {
      "BEGIN": "Comenzar",
      "DUE_DATE": "Fecha de vencimiento",
      "FOOTER_SUBTITLE_READY": "¡Pregúntame cualquier cosa! Estoy listo para ayudar.",
      "LEAVE_STEP": "Dejar paso",
      "NEXT_STEP": "Siguiente paso",
      "NOTIFICATIONS_ARIA": "Notificaciones",
      "PDF_NEXT_PAGE": "Siguiente página",
      "PDF_NO_SOURCE": "No se proporcionó fuente PDF.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deja algún comentario mientras procesamos tus resultados",
      "POST_CALL_TITLE": "Has llegado al final de este cuestionario.",
      "SETTINGS": "Ajustes",
      "TOAST_CONTENT": "Haz clic abajo para ver, o regresa a la pantalla de detalles de la ruta para tu siguiente paso.",
      "TOAST_TITLE": "Tus resultados de juego de roles han sido procesados",
      "ASSIGNMENTS": "Tareas",
      "USER_FALLBACK": "Usuario",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Cuestionario"
    },
    "leaderboard": {
      "LEADERBOARD": "Clasificación",
      "TOP10PERCENT": "El 10 % más alto",
      "PRACTICE_ASSIGNMENT": "Tareas de práctica",
      "SIMULATION": "Simulación",
      "SELECT_ASSIGNMENT": "Seleccionar tarea",
      "SELECT_SIMULATION": "Seleccionar simulación",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Seleccione una tarea y una simulación para ver a los líderes",
      "NO_DATA": "Aún no hay actividad. Una vez que el equipo empiece a participar, verás que las clasificaciones aparecen aquí.",
      "NO_ASSIGNMENTS_AVAILABLE": "No hay asignaciones disponibles",
      "NO_SIMULATIONS_AVAILABLE": "No hay simulaciones disponibles",
      "NAME": "Nombre",
      "HIGH_SCORE": "Puntuación alta",
      "AVERAGE_SCORE": "Puntuación media",
      "TOTAL_SESSIONS": "Sesiones totales",
      "LAST_SESSION": "Última sesión",
      "TOP5": "Mejores 5",
      "OF": "de",
      "ENGAGED_USERS": "usuarios participantes",
      "ENGAGED_USER": "usuario participante",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar las sesiones con puntuaciones bajas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Las sesiones con una puntuación de \"en desarrollo\" en la sección de habilidades no contribuirán a las columnas de puntuación alta o media.",
      "NO_USERS_ENGAGED": "No hay usuarios participantes"
    },
    "general": {
      "NEED_HELP_QUESTION": "¿Necesitas ayuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Cuenta principal",
      "ACCOUNT": "Cuenta",
      "CHECKMARK": "Marca de verificación",
      "ICON": "Icono",
      "ALERT": "alerta",
      "HEADS_UP": "¡Atención!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para obtener un sonido óptimo en iPad, utiliza auriculares.",
      "SETTINGS": "AJUSTES",
      "RP": "RP",
      "EMAIL_LABEL": "Correo electrónico",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipo de",
      "MIAMI_SALE": "ventas en Miami",
      "CHARLOTTE_SALES": "ventas en Charlotte",
      "ATLANTA_SALES": "ventas en Atlanta",
      "TEAM": "Equipo",
      "ASSIGNMENTS": "Tareas",
      "MY_TEAMS": "Mis equipos",
      "REPORTING": "Informes",
      "DASHBOARD": "Panel",
      "LEADERBOARD": "Clasificación",
      "PERSONALIZED_PRACTICE": "Práctica personalizada",
      "HELP_SEARCH_OUR": "Busca en nuestra",
      "HELP_OR_REACH_OUT_TO": "o comunícate con",
      "HELP_WITH_QUESTIONS": "con preguntas",
      "KNOWLEDGE_BASE": "base de conocimientos"
    },
    "dashboard": {
      "ALL": "Todo",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completada",
      "NO_ASSIGNMENT_TITLE": "No tienes ninguna tarea.",
      "NO_ASSIGNMENT_DETAILS": "Se te notificará cuando tengas tareas que completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "No tienes tareas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Se te notificará cuando haya una nueva tarea pendiente.",
      "COMPLETED_ASSIGNMENT_TITLE": "No tienes tareas completadas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Vuelve a comprobarlo una vez que hayas completado una tarea.",
      "VIEW_ASSIGNMENT": "Ver tarea",
      "ASSIGNMENT_LABEL": "Tareas",
      "MODULE_ASSIGNMENT_ALT": "Icono de asignación de módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarea de",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta el vencimiento",
      "PAST_DUE": "De retraso",
      "AVAILABLE_IN": "Disponible en",
      "DUE_TODAY": "Vence hoy",
      "PRACTICE": "Práctica",
      "CERTIFICATION": "Certificación",
      "UPCOMING": "Próximamente",
      "TEST_ASSIGNMENT": "Tarea de prueba",
      "CLOSED": "Cerrado",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No se encontraron tareas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Intenta ajustar tus filtros para ver las tareas disponibles, o vuelve más tarde cuando se añadan nuevas tareas.",
      "VIEW_PATHWAY": "Ver ruta",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de tarea",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarea:",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificadas",
      "NOT_CERTIFIED": "No certificado",
      "IN_PROGRESS": "En curso",
      "PATHWAY": "Ruta de aprendizaje",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo"
    },
    "cognito": {
      "INVITATION_SUBJECT": "¡Te damos la bienvenida a Quantified!",
      "INVITATION_MESSAGE": "Estamos encantados de tenerte con nosotros. Para empezar, sigue los pasos que se indican a continuación para acceder a tu cuenta por primera vez.",
      "ACCOUNT_DETAILS": "Datos de tu cuenta:",
      "USERNAME": "Nombre de usuario",
      "PASSWORD": "Contraseña temporal",
      "STEPS_LABEL": "Próximos pasos para iniciar sesión",
      "STEP_1": "1. Haz clic en el botón \"Iniciar sesión\" para ir a la página de inicio de sesión.",
      "STEP_2": "2. Introduce el nombre de usuario y la contraseña temporal que te hemos proporcionado anteriormente.",
      "STEP_3": "3. Una vez que te hayas conectado, se te pedirá que crees una nueva contraseña.",
      "LOGIN_BUTTON": "Iniciar sesión",
      "ABOUT_US": "El simulador de Quantified es un entorno virtual diseñado para ayudarte a desarrollar rápidamente habilidades esenciales, lo que te permite conectar y comunicarte más eficazmente con tus clientes.",
      "EXPIRY_TIME": "Esta contraseña temporal caducará en 24 horas. Si tienes problemas para iniciar sesión, ponte en contacto con nuestro equipo de asistencia en",
      "TEAM": "el Equipo de Quantified",
      "INVITATION_SMS_USERNAME": "Tu nombre de usuario es",
      "INVITATION_SMS_PASSWORD": "y tu contraseña temporal es",
      "AUTHENTICATION_CODE": "Tu código de autenticación es",
      "PASSWORD_RESET_CODE": "Tu código de restablecimiento de contraseña de Quantified",
      "RESET_PASSWORD_EMAIL": "Correo electrónico de restablecimiento de contraseña",
      "HELLO": "¡Hola!",
      "USE_VERIFICATION_CODE": "Has solicitado restablecer la contraseña. Utiliza el código de verificación que aparece a continuación para completar el proceso.",
      "VERIFICATION_CODE": "Código de verificación",
      "NEXT_STEP": "Próximos pasos",
      "RESET_PASSWORD_PAGE": "Vuelve a la página de restablecimiento de contraseña en el navegador.",
      "ENTER_VERIFICATION_CODE": "Introduce el código de verificación cuando se te solicite.",
      "CREATE_PASSWORD": "Una vez verificado el código, sigue las instrucciones para crear una nueva contraseña.",
      "DISREGARD_NOTE": "Si no has solicitado restablecer tu contraseña, ignora este correo electrónico.",
      "CONTACT_SUPPORT": "Si necesitas más ayuda, ponte en contacto con nuestro equipo de asistencia en",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Atentamente,",
      "QUANTIFIED_TEAM": "el Equipo de Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos"
    },
    "call": {
      "LOADING": "Cargando",
      "SIMULATION_PAUSED": "La simulación se ha pausado.",
      "CLICK_RESUME": "Haz clic en el botón «Reanudar» para continuar.",
      "NO_INTERNET": "Sin conexión a Internet",
      "TRY_AGAIN": "Revisa tu conexión y vuelve a intentarlo.",
      "MIC_MUTED": "El micrófono está silenciado",
      "MIC_MUTED_DESCRIPTION": "Vaya, parece que el micrófono está silenciado. Desactiva el silencio para responder y continuar.",
      "NO_RESPONSE": "No se detectó respuesta",
      "MIC_NOT_CONNECTED": "Vaya, parece que el micrófono no está conectado. Vuelve a seleccionar tu dispositivo para responder y continuar.",
      "AUDIO_ISSUE": "Vaya, algo ha ido mal. Comprueba la configuración de tu dispositivo y asegúrate de que estás en un lugar tranquilo y sin ruidos de fondo.",
      "LOADING_ALT": "Cargando...",
      "REPEAT_RESPONSE": "Se te remitirá automáticamente a la simulación para que repitas tu respuesta y vuelvas a intentarlo.",
      "NEEDS_MORE_TIME_QUESTION": "necesita más tiempo para pensar, ¿quieres esperar?",
      "NEEDS_MORE_TIME": "necesita más tiempo para pensar.",
      "WAIT_OR_END_CALL": "Te informaremos cuando estén listos, o puedes finalizar la llamada y",
      "RETURN_TO_ASSIGNMENTS": "Volver a la tarea",
      "READY": "Listo",
      "IS_READY": "está listo para continuar la conversación.",
      "TRY_AGAIN_LABEL": "Inténtalo de nuevo",
      "CHECK_SETTINGS": "Verificar ajustes",
      "PAUSED_SIMULATION": "Has pausado esta simulación.",
      "PAUSED_SIMULATION_DESCRIPTION": "La grabación de vídeo y audio se pausan hasta que se reanude la simulación.",
      "RESUME": "Continuar",
      "SETTINGS": "Ajustes",
      "CAPTURING_RESPONSE": "Capturando las respuestas",
      "TOUR_MESSAGE": "Una vez que termines de hablar, asegúrate de hacer clic en el botón Continuar para garantizar que las respuestas se capturan y puntúan.",
      "NEXT": "Siguiente",
      "START_CALL": "Comenzar",
      "END_CALL_TITLE": "¿Seguro de que deseas terminar esta simulación?",
      "END_CALL_DESCRIPTION": "Si terminas la simulación ahora, no recibirás una puntuación ni comentarios sobre la conversación.",
      "END_CALL": "Finalizar",
      "BROWSER_ACCESS_DENIED": "Tu navegador tiene denegado el acceso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID de sesión",
      "TIPS_GUIDANCE_MESSAGE": "Aquí aparecerán temas de conversación y consejos.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID de sesión:",
      "SESSION_ID_COPIED": "¡ID de sesión copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Pistas y sugerencias",
      "HINT_LABEL": "Pista",
      "CAPTIONS_LABEL": "Subtítulos",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de fiesta",
      "CALL_ENDED_MESSAGE": "Has llegado al final de esta simulación.",
      "CALL_ENDED_INACTIVITY": "Esta simulación ha terminado por inactividad",
      "CALL_ENDED_GENERIC": "Esta simulación ha terminado",
      "FEEDBACK_PROMPT": "Deja algún comentario mientras procesamos tus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "No has alcanzado nuestro umbral de interacción para la puntuación, inténtalo de nuevo.",
      "REALISTIC_CONVERSATION_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "¿Te sientes más informado y preparado después de esta simulación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "No se pudo cargar la ayuda visual",
      "BEGIN_CALL": "Comenzar",
      "LEAVE_CALL_BRIEFING": "Dejar la sesión",
      "RESTORE_CALL": "Restaurando la simulación",
      "FEW_SECONDS": "Esto puede tardar unos segundos.",
      "CHECK_ALT": "Comprobar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Pistas",
      "CLOSE_CAPTIONS": "Cerrar subtítulos",
      "MICROPHONE_MUTED": "Micrófono silenciado",
      "RETURN_TO_CALL": "Volver a la simulación",
      "YES": "Sí",
      "NO": "No",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "HAVING_ISSUES": "Tenemos problemas para conectarnos, comprueba tu conexión a Internet y haz clic en Aceptar.",
      "OK": "Aceptar",
      "RESULTS_NOT_GENERATED": "Lo sentimos, no podemos generar resultados en este momento, inténtalo de nuevo.",
      "INACTIVITY_ALERT_MESSAGE": "Esta llamada ha finalizado por inactividad. Habla con el avatar para continuar o selecciona “Finaliza llamada” para terminar la llamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta llamada terminará en {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta llamada terminará en unos segundos",
      "TELL_YOUR_GENDER_HEADING": "Indícanos tu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Al conocer tu género, el avatar puede utilizar la gramática adecuada, lo que hace que la conversación sea más natural y realista.",
      "GENDER_SELECTION": "Selección de género:",
      "SELECT_OPTION": "Selecciona una opción",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Femenino",
      "NON_BINARY": "No binario/Otro",
      "PREFER_NOT_TO_ANSWER": "Prefiero no contestar",
      "NON_BINARY_MESSAGE": "Entendemos y respetamos tu identidad de género no binaria. Debido a las limitaciones tecnológicas actuales, utilizamos pronombres masculinos por defecto. Te informamos que estamos trabajando en mejoras para dar cabida a todas las identidades de género en el futuro. Gracias por tu comprensión y paciencia.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respetamos tu decisión de no indicar tu género. En estos casos, nuestra tecnología utiliza por defecto pronombres masculinos debido a las limitaciones actuales.",
      "DISPLAY_VISUAL_AID": "Mostrar la ayuda visual",
      "FULL_SCREEN": "Pantalla completa",
      "COLLAPSE": "Contraer",
      "COMPLETED_CONVERSATION_MESSAGE": "Gracias por completar esta conversación.",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deja algunos comentarios mientras procesamos tu conversación.",
      "ERROR_MESSAGE": "Ha habido un error. Ponte en contacto con",
      "SAVED_CONVERSATION_MESSAGE": "Tu conversación ha sido guardada.",
      "RETURN_TO_MY_ASSIGNMENTS": "Regresar a mis tareas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Volver a la práctica personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabas de completar una conversación de práctica personalizada.",
      "LEAVE_STEP_TITLE": "¿Seguro que quieres dejar este paso?",
      "EXIT": "Salir"
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PUNTUACIÓN",
      "MUST_ACHIEVE": "Debes lograr un",
      "OR_HIGHER": "o más",
      "TEST": "Prueba",
      "OUT_OF_5": "sobre 5",
      "LATEST_ATTEMPT": "ÚLTIMO INTENTO",
      "TOTAL_ATTEMPTS": "intentos totales",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "DUE_DATE": "Fecha de vencimiento",
      "DAYS": "Días",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta el vencimiento",
      "PAST_DUE": "De retraso",
      "ONGOING": "En curso",
      "SCORE_REQUIREMENT": "Requisito de puntuación",
      "SCORE_REQUIREMENT_DETAIL": "Debes lograr una puntuación de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulación requerida.",
      "CALLS_IN_ASSIGNMENT": "Simulaciones asignadas",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Fecha",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver comentarios",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CHECKMARK": "marca de verificación",
      "CALL": "Llamada",
      "QUESTION": "Pregunta",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificadas",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Prueba de conocimientos",
      "CONVERSATIONAL_SIMULATION": "Juego de roles",
      "NO_ATTEMPTS_LEFT": "No quedan intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "OVERVIEW": "Visión general",
      "ABOUT_THE_AVATAR": "Acerca del avatar",
      "SCORING_CRITERIA": "Criterios de puntuación",
      "SIMULATION_OVERVIEW": "Resumen de la simulación",
      "ABOUT_THE_PERSONA": "Sobre la persona",
      "OUTOF_COMPLIANCE": "Incumplimiento",
      "CLOSED": "Cerrado"
    }
  },
  "es-MX": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DEL ADMINISTRADOR",
      "SUPPORT": "SOPORTE",
      "U": "U",
      "USER": "Usuario",
      "LOGOUT": "Cierre de sesión",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Soporte",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICRÓFONO",
      "CAMERA": "CÁMARA",
      "ACCESS_DENIED": "ACCESO_DENEGADO"
    },
    "teams": {
      "MY_TEAMS": "Mis equipos",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin comenzar",
      "ASSIGNMET_MODULE": "Módulo de tarea",
      "START_DATE": "Fecha de inicio",
      "DUE_DATE": "Fecha de entrega",
      "ASSIGNED_MEMBERS": "Miembros asignados",
      "CALLS_IN_MODULE": "Simulaciones en módulo",
      "COMPLETION_REQUIRMENT": "Requisito de finalización",
      "COMPLETE_ALL_CALLS": "Completa todas las simulaciones con una puntuación de",
      "OR_HIGHER": "o más",
      "PROGRESS_OVERVIEW": "RESUMEN DEL PROGRESO",
      "TEAM_MEMBERS": "miembros del equipo",
      "AVERAGE_HIGH_SCORE": "Puntuación alta promedio",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número medio de intentos por simulación",
      "TOTAL_PRACTICES": "Total de prácticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESO INDIVIDUAL DE LA SIMULACIÓN",
      "OF_TEAM_MEMBERS": "de los miembros del equipo completaron",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Promedio de prácticas hasta la finalización",
      "TEAM_MEMBER_DETAILS": "DETALLES DEL MIEMBRO DEL EQUIPO",
      "DOWNLOAD_ACTIVITY_REPORT": "Descargar informe de actividad",
      "TEAM_MEMBER": "Miembro del equipo",
      "PROGRESS": "Progreso",
      "CALLS_COMPLETED": "Simulaciones realizadas",
      "PRACTICES": "Sesiones de práctica",
      "MOST_RECENT_PRACTICE": "Sesión más reciente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Este equipo no tiene tareas activas en este momento",
      "CALL_NAME_LABEL": "Nombre de la simulación",
      "HIGHEST_SCORE": "Puntuación más alta"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Asegurémonos de que tu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "Se requiere un micrófono que funcione.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si al actualizar esta página no aparece una ventana emergente solicitándote que habilites tus dispositivos, accede a la configuración de tu sistema o navegador y habilita tus dispositivos desde allí. A continuación, encontrarás páginas de ayuda con más instrucciones.",
      "ENABLE_CAMERA": "Cómo habilitar la cámara:",
      "WINDOWS_USERS": "Usuarios de Windows",
      "MAC_USERS": "Usuarios de Mac",
      "IPAD_USERS": "Usuarios de iPad",
      "ENABLE_MICROPHONE": "Cómo activar el micrófono:",
      "ENABLE_DEVICES_BY_BROWSER": "Cómo habilitar tus dispositivos mediante el navegador:",
      "CHROME_USERS": "Usuarios de Chrome",
      "SAFARI_USERS": "Usuarios de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sin cámara",
      "START_CALL_BUTTON": "Iniciar llamada",
      "MICROPHONE_REQUIRED_WARNING": "Se requiere un micrófono que funcione.",
      "MICROPHONE_ALT": "micrófono",
      "MICROPHONE": "Micrófono",
      "SELECT_MICROPHONE": "Selecciona tu micrófono",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permiso",
      "SELECT_VIDEO_DEVICE": "Selecciona tu dispositivo de video",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Parece que le negaste el acceso a este navegador a uno o más de tus dispositivos. Para habilitar los dispositivos, accede a los ajustes de tu sistema o del navegador y habilita el acceso.",
      "DEVICE_SETTINGS": "Ajustes del dispositivo",
      "CONFIRM_SETTINGS": "Confirmar ajustes",
      "LAPTOP": "Computadora portátil",
      "SAD_EMOTE_FACE": "Cara de emoticón triste",
      "GRANT_BROWSER_ACCESS": "Para realizar esta simulación, concede al navegador acceso al reconocimiento de voz",
      "USING_IPAD": "Si utilizas un iPad, ve a",
      "SETTINGS": "Ajustes",
      "PRIVACY_AND_SECURITY": "Privacidad y seguridad",
      "SPEECH_RECOGNITION": "Reconocimiento de voz",
      "GRANT_ACCESS_REFRESH": "Concede acceso al navegador y actualiza la página",
      "REFRESH_PAGE": "ACTUALIZAR PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "El navegador no puede acceder a este dispositivo",
      "ACCESS_DENIED": "acceso denegado",
      "CAMERA": "Cámara",
      "DIAGNOSTIC_PASSED": "Todas las pruebas de diagnóstico pasaron con éxito.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Algunas pruebas de diagnóstico fallaron. Haga clic en el botón \"Copiar resultados de diagnóstico\" situado arriba y envíe los resultados al equipo de soporte para obtener asistencia.",
      "DIAGNOSTIC_PARTIAL": "La mayoría de las pruebas diagnósticas pasaron con éxito. Tu conexión parece estable.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Por favor, espera mientras se ejecutan las pruebas de diagnóstico...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico en curso",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados de diagnóstico",
      "RUN_DIAGNOSTIC": "Iniciar diagnóstico",
      "RERUN_DIAGNOSTIC": "Repetir diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados de diagnóstico copiados al portapapeles",
      "DIAGNOSTIC_FAILED": "Falló el diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos de Quantified",
      "DIAGNOSTIC_TIME": "vez",
      "DIAGNOSTIC_SUMMARY": "Resumen",
      "DIAGNOSTIC_CLIENT_INFO": "Información del cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT promedio/máx",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Pérdida de paquetes (enviar)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Promedio de tasa de bits de envío",
      "DIAGNOSTIC_NA": "N/A"
    },
    "results": {
      "RETURN_HOME": "REGRESAR A INICIO",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CONVERSATIONAL_CALL": "JUEGO DE ROLES",
      "INFORMATION_ICON": "Ícono de información",
      "TOOLTIP_ARROW": "Flecha de información sobre herramientas",
      "INFORMATION_TOOLTIP_CONTENT": "Tú controlas el desarrollo de la simulación y diriges la conversación hacia una serie de objetivos. Los juegos de rol son excelentes para poner a prueba habilidades como profundizar en detalles y hacer preguntas de segundo nivel, descubrir puntos de dolor y crear una buena relación.",
      "CLOCK_ICON": "Ícono de reloj",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "TRY_AGAIN_MESSAGE": "Inténtalo de nuevo y mejora tu puntuación.",
      "PRACTICE_BENEFITS": "Practicar semanalmente aumenta la confianza y mejora los resultados en el mundo real.",
      "CALL_SUCCESS": "¡Buen trabajo! Has completado esta simulación con éxito.",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "¡Buen trabajo! Has completado",
      "COMPLETED_THIS_CALL": "correctamente esta simulación.",
      "ACHIEVED_SCORE": "Has logrado una puntuación de",
      "ACHIEVE_SCORE": "Logra una puntuación de",
      "OR_HIGHER": "o superior.",
      "OBJECTIVES_NOT_MET": "No cumpliste con todos los objetivos requeridos.",
      "TRY_AGAIN_TARGET_SCORE": "Inténtalo de nuevo para lograr una puntuación de",
      "YOUR_SCORE": "Tu puntuación",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMEN DE COMENTARIOS",
      "STRENGTH_ICON_ALT": "Ícono de fuerza",
      "OPPORTUNITIES_ICON_ALT": "Ícono de oportunidades",
      "OBJECTIVES_FEEDBACK": "COMENTARIOS SOBRE LA METODOLOGÍA",
      "SESSION_ID": "ID de sesión:",
      "SESSION_ID_COPIED": "ID de sesión copiado",
      "OBJECTIVE": "METODOLOGÍA:",
      "HOW_YOU_DID": "Qué tal lo hiciste:",
      "LIGHTBULB_ICON_ALT": "Ícono de foco",
      "WHAT_WE_SUGGEST": "Lo que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nuestro sistema no ha podido encontrar una recomendación específica para ti.",
      "WHY": "¿Por qué?",
      "NO_INSIGHTS_AVAILABLE": "Nuestro sistema no ha podido proporcionar información sobre esta sugerencia.",
      "CONFETTI_ICON_ALT": "Ícono de confeti",
      "OBJECTIVE_SUCCESS_MESSAGE": "Lo has hecho muy bien en esta metodología, ¡sigue así!",
      "PROCESSING_CALL": "Estamos preparando tu puntuación y tus comentarios.",
      "HANG_TIGHT": "Espera un momento o vuelve a consultar más tarde para",
      "VIEW_YOUR_RESULTS": "ver tus resultados.",
      "NEED_MORE_TIME": "Necesitamos más tiempo para calcular los resultados.",
      "REFRESH_INSTRUCTION": "Vuelve a consultarlo o actualiza los resultados",
      "RESULTS_IN_FEW_MINUTES": "de la tarea dentro de unos minutos.",
      "SCORE_CALCULATION_QUESTION": "¿Cómo se calcula esto?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulación solo tiene un único componente de puntuación, por lo que la puntuación mostrada es tanto la puntuación de sección individual como la puntuación general.",
      "OVERALL_SCORE_PERCENT": "% de la puntuación global",
      "SECTION_SCORE": "Puntuación de la sección",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Mejora la adherencia al mensaje en la conversación",
      "MESSAGE_ADHERENCE_NOTE": "La adherencia al mensaje es fundamental para mantener conversaciones exitosas, pero no afecta tu puntuación global.",
      "NO_CREDIT": "Sin crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito completo",
      "WHAT_YOU_DID_WELL": "Lo que hiciste bien",
      "MISSED_ALL_KEY_POINTS": "Te has saltado todos los puntos clave; revísalos y vuelve a intentarlo.",
      "WHAT_TO_IMPROVE": "Lo que puedes mejorar",
      "PERFECT_SCORE_MESSAGE": "¡Felicidades! Has obtenido una puntuación perfecta y has hablado correctamente de todos los puntos clave.",
      "POINTS_LABEL": "Puntos",
      "TALKING_POINTS_COVERED": "Temas de conversación cubiertos",
      "CHECKMARK_ICON_ALT": "marca de verificación",
      "TALKING_POINTS_MISSED": "Temas de conversación omitidos",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "OUT_OF": "de",
      "POSSIBLE_TALKING_POINTS": "temas de conversación posibles",
      "YOU_COVERED": "Has cubierto",
      "THROUGHOUT_CALL": "durante toda la simulación.",
      "POSITIVE_FEEDBACK_COVERAGE": "Has hecho un gran trabajo al destacar los puntos clave durante toda la llamada y has cubierto",
      "MIXED_FEEDBACK_COVERAGE": "Has omitido algunos puntos clave durante la simulación y has cubierto",
      "OBJECTIVES": "Metodología",
      "ELEVATE_OBJECTIVES_TITLE": "Mejora tu metodología de conversación",
      "OBJECTIVES_NOTE": "La metodología es fundamental para dirigir conversaciones exitosas, pero no afecta la puntuación general.",
      "UNTIL": "hasta el",
      "TO_IMPROVE_SCORE": "para mejorar tu puntuación.",
      "TO_SCORE": "para obtener una puntuación",
      "BEFORE": "antes del",
      "YOU_HAVE": "Tienes",
      "MORE_ATTEMPTS": "Intentos más para conseguir",
      "OR_HIGHER_BEFORE": "puntos o más antes del",
      "AND_TRY_AGAIN": "e intentarlo de nuevo.",
      "UNEXPECTED_STATE": "Ha ocurrido un estado inesperado.",
      "REVIEW_APP_LOGIC": "Por favor, revisa la lógica de la aplicación.",
      "ASSIGNMENTS": "Tareas",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "PRACTICE_SESSION": "Sesión de práctica",
      "OVERALL_SCORE": "Puntuación global",
      "OVERALL_SCORE_EXPLANATION": "La puntuación global se calcula tomando una media ponderada de la puntuación de cada sección. El peso de cada sección se muestra como un porcentaje junto a la puntuación.",
      "SCORE_CONFIG_NOTE": "Los porcentajes de peso y la inclusión y exclusión de secciones los establece tu empresa. Todas las puntuaciones se redondean a la décima más cercana.",
      "STRENGTHS": "Fortalezas",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Tu respuesta",
      "MINUS": "menos",
      "PLUS": "más",
      "RECOMMENDED_RESPONSE": "Respuesta recomendada",
      "REVIEW_MISSED_TITLE": "Revisa lo que has omitido.",
      "NO_TALKING_POINTS_COVERED": "No has cubierto ninguno de los temas de conversación requeridos para este tema.",
      "LEARN_WHAT_YOU_MISSED": "Descubre lo que has omitido",
      "NICE_JOB": "¡Buen trabajo!",
      "ALL_POINTS_COVERED": "Has cubierto exitosamente todos los temas de conversación requeridos para este tema.",
      "COVER_ALL_MESSAGES": "Cubre todos los mensajes clave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Resaltar los puntos clave durante la llamada ayudará a mantener la conversación centrada.",
      "MESSAGES_LABEL": "Mensajes",
      "NO_FACTS_COVERED": "¡Uy! Parece que no has mencionado ninguno de los hechos de este mensaje.",
      "NO_SPECIFICS_AVAILABLE": "¡Uy! Parece que no hemos podido proporcionar detalles sobre lo que has omitido.",
      "ALL_KEY_POINTS_COVERED": "¡Buen trabajo! Has cubierto todos los puntos clave.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos procesando la retroalimentación de tus habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lo sentimos, pero no hemos podido analizar tu llamada reciente porque la evaluación de habilidades no estaba habilitada en el momento del envío. Para recibir retroalimentación, solo tienes que volver a enviar tu práctica de llamada como lo hiciste anteriormente. Si necesitas ayuda, no dudes en contactar a nuestro equipo de soporte. ¡Gracias por tu comprensión y compromiso por mejorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Mejora tus habilidades de conversación",
      "SKILLS_NOTE": "Las habilidades son críticas para mantener conversaciones exitosas, pero no afectan tu puntuación global.",
      "SKILLS_SUMMARY_TITLE": "RESUMEN DE HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Obtén más información sobre las habilidades",
      "SKILLS_FEEDBACK_LABEL": "RETROALIMENTACIÓN",
      "WHAT_ARE_SKILLS_TITLE": "¿Qué son las habilidades?",
      "SKILLS_DESCRIPTION": "Las habilidades están calibradas para favorecer el desarrollo del crecimiento personal. Aunque estas habilidades no forman parte de la evaluación numérica de tu llamada, tu organización las ha seleccionado para mejorar tu eficacia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE COMPETENCIA",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "CALL_TRANSCRIPT": "Transcripción de la llamada",
      "COLLAPSE_ALL": "Colapsar todo",
      "EXPAND_ALL": "Expandir todo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 puntos",
      "TALKING_POINTS": "temas de conversación",
      "TRANSCRIPT_LABEL": "Transcripción",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Te quedaste sin intentos.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revisa las directrices y sigue cumpliéndolas en el futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Inténtalo de nuevo y presta atención a las directrices de cumplimiento.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nos dimos cuenta de que no cumpliste con la normativa, por lo que no has recibido ninguna puntuación.",
      "WHY_OUT_OF_COMPLIANCE": "Por qué no cumpliste con la normativa",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revisa tu transcripción para ver en qué aspectos no has cumplido con la normativa.",
      "YOU_DID_FOLLOW_GUIDELINES": "Cumpliste con esta normativa de manera efectiva.",
      "REVIEW_MISSED_GUIDELINES": "Revisa la normativa de cumplimiento que no se siguió.",
      "OUT_OF_COMPLIANCE": "Incumplimiento",
      "SCORE_CALCULATION_TITLE": "Cálculo de puntuación",
      "PROCESSING_TRANSCRIPT": "Estamos procesando tu transcripción.",
      "WAIT_OR_REVIEW_SCORES": "Espera aquí o revisa las otras secciones",
      "TRANSCRIPT_LOADING": "de la puntuación mientras se carga la transcripción.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revisa tu retroalimentación y sigue practicando",
      "HIGH_PERFORMERS_PRACTICE": "Las personas con mejor rendimiento practican al menos una vez a la semana",
      "SUCCESSFULLY_PASSED": "¡Buen trabajo! Has superado con éxito esta simulación.",
      "DIDNT_REACH_PASSING_SCORE": "No has alcanzado la puntuación de aprobado para esta simulación.",
      "OUT_OF_ATTEMPTS": "<b>Se ha agotado el número de intentos.</b> Revise la retroalimentación para saber cómo puede mejorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revisa tu retroalimentación y vuelve al inicio cuando estés preparado.",
      "GREAT_JOB_PRACTICED": "¡Buen trabajo! Practicaste {{count}} {{times}}. ¡Sigue así!",
      "TIME": "vez",
      "TIMES": "veces",
      "COMPLIANCE_GUIDELINES": "Normativa de cumplimiento",
      "TALKING_POINT_TITLE": "TEMAS DE CONVERSACIÓN OMITIDOS O ABORDADOS EN EL MOMENTO EQUIVOCADO",
      "NO_TRANSCRIPT": "No hay transcripción disponible."
    },
    "reportingV2": {
      "DASHBOARD": "Panel",
      "LOADING_ACCOUNTS": "Cargando cuentas…",
      "SELECT_AN_ACCOUNT": "Seleccionar una cuenta",
      "SEARCH_TEAMS": "Buscar equipos",
      "LOADING_TEAMS": "Cargando equipos…",
      "ALL_TEAMS": "Todos los equipos",
      "ACCOUNT": "Cuenta",
      "TEAMS": "Equipos",
      "TEAM_LABEL": "Equipo",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Puntuación para aprobar",
      "ASSIGNMENT_LABEL": "Tareas",
      "USER_LABEL": "Usuarios",
      "PRACTICE_LABEL": "Práctica",
      "CERTIFICATION_LABEL": "Certificación",
      "RESULTS_DESCRIPTION": "Aquí tienes los resultados de tu(s) equipo(s) en todas las prácticas:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Ejecución por tarea",
      "ASSIGNMENT_ENGAGEMENT": "Ejecución en tarea",
      "ENGAGED_LABEL": "Ejecutada",
      "ENGAGEMENT_STATUS_LABEL": "Estado de la ejecución",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nombre de la tarea",
      "ACTIVE_USERS": "Usuarios activos",
      "ASSIGNMENT_PROGRESS": "Progreso por tarea",
      "IN_PROGRESS_LABEL": "En progreso",
      "CERTIFIED_LABEL": "Certificada",
      "OUT_OF_ATTEMPTS_LABEL": "No quedan intentos",
      "USERS_ENGAGED_LABEL": "Usuarios que participaron",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sesiones por usuario activo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Más de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sesiones completadas",
      "USER_CERTIFIED": "Usuarios certificados en todas las tareas",
      "ASSIGNMENT_CERTIFICATION": "Tareas con certificación del 100 %",
      "TRAINER_TIME_SAVED": "Ahorro de tiempo del instructor",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tareas de práctica",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tareas de certificación",
      "START_DATE_LABEL": "Fecha de inicio",
      "END_DATE_LABEL": "Fecha final",
      "NAME_LABEL": "Nombre",
      "EMAIL_LABEL": "Correo electrónico",
      "MEMBER_OF_TEAMS_LABEL": "Miembro de equipos",
      "ASSIGNMENTS_COUNT_LABEL": "# de asignaciones",
      "TOTAL_SESSIONS_LABEL": "Total de sesiones",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sesiones",
      "TOTAL_USERS_LABEL": "Total de usuarios",
      "AVERAGE_SCORE_LABEL": "Puntuación promedio",
      "INITIAL_SCORE_LABEL": "Puntuación inicial",
      "HIGH_SCORE_LABEL": "Puntuación alta",
      "LAST_PRACTICE_DATE_LABEL": "Última fecha de práctica",
      "PERCENT_IMPROVED_LABEL": "% mejorado",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica analiza las puntuaciones de cada sesión y traza una línea recta en un gráfico para ilustrar la tendencia. Un porcentaje más alto indica que las puntuaciones están mejorando más rápidamente; un porcentaje más bajo indica que las puntuaciones están mejorando más lentamente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tareas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tareas competentes",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de la tarea.",
      "PROFICIENT_TOOLTIP": "Número de usuarios de esta tarea que han obtenido una puntuación igual o superior a los criterios de puntuación alta definidos, al menos una vez en todas las simulaciones de esta tarea.",
      "IN_PROGRESS_TOOLTIP": "Porcentaje de usuarios que han completado al menos una sesión de una simulación en esta tarea y han recibido una puntuación.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Porcentaje de usuarios que han superado los intentos asignados para una o varias simulaciones de la tarea.",
      "CERTIFIED_TOOLTIP": "Porcentaje de usuarios que han cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "SEARCH_FOR_A_USER_LABEL": "Buscar un usuario",
      "NO_USERS_FOUND_LABEL": "No se han encontrado usuarios",
      "TRAINER_TIME_SAVED_TOOLTIP": "La cantidad de tiempo que los usuarios han pasado en Quantified completando intentos de certificación.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sesiones promedio por tarea",
      "ASSIGNMENTS_ENGAGED_WITH": "Tareas ejecutadas",
      "AVERAGE_IMPROVEMENT": "Promedio de mejora",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sesiones",
      "DATE_OF_LAST_PRACTICE": "Fecha de la última práctica",
      "CALL_NAME": "Nombre de la llamada",
      "SESSION_DATE": "Fecha de la sesión",
      "DURATION_OF_SESSION": "Duración de la sesión",
      "OVERALL_SCORE": "Puntuación global",
      "MESSAGING_SCORE": "Puntuación de adherencia al mensaje",
      "METHODOLOGY_SCORE": "Puntuación de la metodología",
      "SKILLS_SCORE": "Puntuación por competencias",
      "SESSIONS": "Sesiones",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas las tareas",
      "RECENT_ASSIGNMENTS": "Tareas recientes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Promedio de sesiones de usuario activo",
      "HOURS_IN_SIMULATIONS": "Horas en simulaciones",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Promedio de sesiones hasta la competencia",
      "PERCENT_PROFICIENT": "Porcentaje competente",
      "SYSTEM_RUNNING_NORMALLY": "El sistema funciona con normalidad",
      "PRACTICE_SIMULATIONS_LABEL": "Simulaciones",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Ningún resultado coincide con tus filtros. Prueba a borrar uno o varios filtros para ampliar la búsqueda.",
      "USERS_PASSED": "Usuarios que han superado la simulación",
      "AVERAGE_TIME": "Tiempo promedio de certificación",
      "USERS_OUT_OF_ATTEMPTS": "Usuarios sin intentos",
      "NO_CERTIFICATION_SIMULATION": "No se han encontrado simulaciones de certificación",
      "SIMULATION": "Simulación",
      "No_SIMULATION": "Sin sesiones",
      "PERCENT_CERTIFIED": "Porcentaje certificado",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Porcentaje certificado en el primer intento",
      "USERS": "Usuarios",
      "ATTEMPTS_LABEL": "Intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "DATE_OF_SESSION": "Fecha de la sesión",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Ninguna asignación coincide con los filtros elegidos",
      "NO_TEAMS_DATA": "No hay equipos en esta cuenta",
      "SIMULATION_NAME": "Nombre de la simulación",
      "AVERAGE_DURATION_OF_SESSION": "Duración media de la sesión",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Promedio de prácticas por usuario activo",
      "AVERAGE_OVERALL_SCORE": "Promedio de puntuación global",
      "TOTAL_ASSIGNMENTS": "Asignaciones totales",
      "ASSIGNMENTS_CERTIFIED": "Tareas certificadas",
      "TOTAL_SESSIONS": "Total de sesiones",
      "HOURS_SPENT_PRACTICING": "Horas dedicadas a practicar",
      "LAST_LOGIN": "Último acceso",
      "SELECT_ASSIGNMENTS": "Seleccionar tareas",
      "CERTIFICATION_STATUS_LABEL": "Estado de la certificación",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado de la certificación:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "¿Certificado al primer intento?",
      "DATE_OF_CERTIFICATION_LABEL": "Fecha de certificación",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado de la ejecución:",
      "DURATION_OF_ATTEMPT": "Duración del intento",
      "USER_NAME": "Nombre de usuario",
      "LEARNER": "Estudiante",
      "DATE_RANGE": "Intervalo de fechas",
      "DATE_RANGE_LABEL": "Intervalo de fechas",
      "SEARCH_USERS": "Buscar usuarios...",
      "SEARCH_SIMULATIONS": "Buscar simulaciones...",
      "SEARCH_DATES": "Buscar fechas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado al primer intento",
      "DATE_OF_CERTIFICATION": "Fecha de certificación",
      "AVERAGE_CERTIFICATION_SCORE": "Puntuación promedio de la certificación",
      "TOTAL_TIME_CERTIFYING": "Tiempo total de certificación",
      "OF_THE_TIME": "del tiempo",
      "ASSIGNED_LABEL": "Sin comenzar",
      "USERS_ASSIGNED_LABEL": "Total de usuarios asignados",
      "SESSION_ID": "ID de sesión",
      "USER_NAME_LABEL": "Nombre de usuario",
      "NO_SIMULATIONS_FOUND_LABEL": "No se han encontrado simulaciones",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Asignada",
      "ENGAGED_TOOLTIP": "El porcentaje de usuarios que han completado una o más sesiones de una simulación en esta tarea pero que aún no han alcanzado la competencia en todas las simulaciones.",
      "SEARCH_ASSIGNMENTS": "Buscar tareas...",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "START_DATE": "Fecha de inicio",
      "END_DATE": "Fecha final",
      "NO_ASSIGNMENTS": "No se encontró ninguna tarea para este usuario.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Tareas de práctica totales",
      "SESSION_SCORES_OVER_TIME": "Puntuaciones de las sesiones a lo largo del tiempo",
      "TIME": "vez",
      "SCORE": "de puntuaciones",
      "NO_SESSIONS_AVAILABLE": "No hay sesiones disponibles para graficar.",
      "MESSAGING_SCORE_LABEL": "Puntuación de la mensajería",
      "PERSONALIZED_PRACTICE_LABEL": "Práctica personalizada",
      "ASSIGNMENT_ENAGEMENT": "Ejecución por tarea",
      "NO_PRODUCTS": "No hay productos de práctica personalizados para los equipos seleccionados",
      "TOTAL_TIME_SPENT_PRACTICING": "Tiempo total dedicado a la práctica",
      "AVERAGE_SESSIONS_PER_USER": "Promedio de sesiones por usuario",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación más común",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación menos común",
      "CLEAR_TEAMS": "Eliminar equipos",
      "METHODOLOGY_SCORE_DESCRIPTION": "Puntuaciones objetivas promedio en todas las sesiones de esta convocatoria.",
      "METHODOLOGY": "Metodología",
      "MESSAGING": "Mensaje",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "La mensajería evalúa si los alumnos son capaces de articular dos ideas importantes durante esta simulación. Estas visualizaciones muestran los porcentajes de mensajes en un tema de mensajes determinado que los usuarios articularon, en promedio, en todas las sesiones de esta llamada.",
      "NO_METRICS_MESSAGE": "No hay sesiones completadas para los equipos seleccionados.",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Las puntuaciones de las habilidades son resultado de una evaluación hecha por IA respecto a las habilidades demostradas por los usuarios durante una llamada.",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "La mensajería evalúa si los usuarios son capaces de articular tres ideas importantes en esta llamada."
    },
    "reporting": {
      "AT_GLANCE": "Tareas de un vistazo",
      "OPEN_ASSIGNMENTS": "Tareas abiertas",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificada",
      "VIEW_LIST": "Ver la lista",
      "CERTIFICATION_ASSIGNMENTS": "Tareas de certificación",
      "CERTIFICATION_SUMMARY_TEXT": "Las certificaciones son tareas que tienen una fecha de entrega y criterios específicos para aprobarlas",
      "PRACTICE_ASSIGNMENTS": "Tareas de práctica",
      "PRACTICE_SUMMARY_TEXT": "Las tareas de práctica están disponibles para los usuarios sin una fecha de entrega específica. Están diseñadas para que los usuarios practiquen con regularidad para mejorar sus habilidades",
      "THE": "El",
      "WILL_CLOSE": "cerrará en",
      "USERS_HAVE": "los usuarios",
      "USER_HAS": "el usuario",
      "NOT_STARTED_ASSIGNMENT_DUE": "no ha(n) empezado una tarea que debe(n) entregar la semana siguiente",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "no ha(n) completado una tarea que debe(n) entregar la semana siguiente",
      "DAYS": "días",
      "DAY": "día",
      "MODULES": "Módulos",
      "MODULE": "Módulo",
      "CALL": "Simulación",
      "CALLS": "Simulaciones",
      "CERTIFICATION_ASSIGNMENT": "Tarea de certificación",
      "PRACTICE_ASSIGNMENT": "Tarea de práctica",
      "AND": "y",
      "VIEW_ENGAGEMENT_DETAILS": "Ver detalles de la participación",
      "SEE_ALL": "Ver todo",
      "SEE_LESS": "Ver menos",
      "ASSIGNMENT": "Tarea",
      "ASSIGNED": "Asignada",
      "IN_PROGRESS": "En curso",
      "DUE_DATE": "Fecha de entrega",
      "ASSIGNMENT_ENDS_IN": "La tarea finaliza en",
      "ASSIGNMENT_CLOSED": "Tarea cerrada",
      "OLDER_CERTIFICATION": "certificación más antigua",
      "ASSIGNMENT_IS": "la tarea está",
      "ASSIGNMENT_ARE": "las tareas están",
      "CURRENTLY_HIDDEN": "oculta(s) actualmente",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Se muestran todas las tareas de certificación.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Usuarios que aún no han completado y recibido una puntuación para ninguna simulación.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Usuarios que han completado al menos una simulación y han recibido una puntuación.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Usuarios que han cumplido el requisito de certificación.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Es el número de usuarios que pueden acceder a la tarea para sus certificaciones.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Ver todas las tareas de certificación",
      "HIDE_OLDER_ASSIGNMENTS": "Ocultar tareas antiguas",
      "AVG_PRACTICES": "Promedio de prácticas",
      "PRACTICED": "Practicado",
      "SCORED_HIGH": "Puntuación alta",
      "AVG_ASSIGNMENT": "Promedio de mejora",
      "DAYS_AGO": "días atrás",
      "NA": "N/A",
      "OLDER_PRACTICE": "práctica más antigua",
      "SEE_PRACTICE_ASSIGNMENT": "Ver todas las tareas de práctica",
      "ALL_PRACTICE_ASSIGNMENTS": "Se están mostrando todas las tareas de práctica.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Usuarios que aún no han completado y recibido una puntuación para ninguna simulación.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Estos usuarios han terminado al menos una simulación y han recibido una puntuación.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Número de usuarios de esta tarea que han obtenido una puntuación igual o superior a los criterios de puntuación alta definidos, al menos una vez en todas las simulaciones de esta tarea.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Estos usuarios pueden acceder a la tarea para practicar.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Este número muestra el número medio de veces que los usuarios han practicado las simulaciones que forman parte de esta tarea.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Esta métrica analiza las puntuaciones de cada sesión y traza una línea recta en un gráfico para ilustrar la tendencia. Un porcentaje más alto indica que las puntuaciones están mejorando más rápidamente; un porcentaje más bajo indica que las puntuaciones están mejorando más lentamente.",
      "USERS": "usuarios",
      "USER": "usuario",
      "DOWNLOAD_CSV": "Descargar CSV",
      "ERROR": "Se ha producido un error",
      "FIRST_NAME": "Nombre",
      "LAST_NAME": "Apellido",
      "ATTEMPTS": "Intentos",
      "EMAIL": "Correo electrónico",
      "LAST_LOGIN": "Última conexión",
      "ASSIGNMENT_NOT_STARTED": "Tarea no iniciada",
      "ASSIGNMENT_IN_PROGRESS": "Tarea en curso",
      "SCORE_CRITERIA_MET": "Puntuación de criterios cumplidos",
      "NEVER_LOGGED_IN": "No conectado",
      "QUANTIFIED_REPORTING": "Informes de Quantified",
      "ASSIGNED_USERS": "Usuarios asignados",
      "COMPLETION_REQUIREMENT": "Requisito de finalización",
      "AVG_SCORE_Of": "Promedio de puntuaciones de",
      "REPORTING": "Informes",
      "CERTIFICATIONS": "Certificaciones",
      "PRACTICES": "Prácticas",
      "CALL_ANALYSIS": "Análisis de simulación",
      "PERCENT_CERTIFIED_ON": "Porcentaje de certificaciones en",
      "SHOWING": "Mostrando",
      "PRACTICE_SESSIONS": "Sesiones de prácticas acumuladas en todas las simulaciones del módulo",
      "AVG_PRACTICE_HEADING": "Número medio de sesiones de práctica por usuario activo",
      "AVG_SCORE_LABEL": "Promedio de puntuaciones",
      "AVG_SCORE_HEADING": "Puntuación promedio por usuario",
      "AVG_PRACTICES_LABEL": "Promedio Prácticas",
      "EXPORT_LEARNER_LIST": "Exportar lista de alumnos",
      "PERCENT_NOT_STARTED": "% sin iniciar",
      "PERCENT_IN_PROGRESS": "% en progreso",
      "PERCENT_CERTIFIED": "% certificado",
      "USER_CERTIFIED": "Usuario certificado",
      "USERS_CERTIFIED": "Usuarios certificados",
      "TOTAL_ATTEMPTS": "Intentos totales",
      "Avg_ATTEMPTS_CERTIFY": "Promedio de intentos para certificar",
      "ASTERICK_GROUP": "Denota un grupo que contiene uno o más subgrupos",
      "NO_DATA_FOUND": "No se han encontrado datos",
      "MODULE_HIGHLIGHTS": "Puntos destacados del módulo",
      "MODULE_HIGHLIGHT_SUMMARY": "Métricas clave en todas las simulaciones. Para un análisis detallado de cada simulación, consulta el siguiente resumen",
      "HIGHEST_SCORING_QUESTION_TITLE": "PREGUNTA CON MAYOR PUNTUACIÓN",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Pregunta con mayor puntuación",
      "QUESTION_BAR_MSG": "% promedio de puntos de respuesta contestados correctamente",
      "LOWEST_SCORING_QUESTION_TITLE": "PREGUNTA CON MENOR PUNTUACIÓN",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Pregunta con menor puntuación",
      "TOP_SCORED_ANSWER_POINT_TITLE": "PUNTO DE RESPUESTA CON MAYOR PUNTUACIÓN",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Pregunta de punto de respuesta menos fallada",
      "SCORE_BAR_MSG": "de las veces los usuarios aciertan.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "PUNTO DE RESPUESTA CON MENOR PUNTUACIÓN",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Pregunta de punto de respuesta más fallada",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METODOLOGÍA DE PUNTUACIÓN MÁS BAJA",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodología de puntuación más baja",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METODOLOGÍA DE MAYOR PUNTUACIÓN",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Metodología de mayor puntuación",
      "OBJECTIVE_BAR_MSG": "puntos medios en esta metodología",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "MENSAJE MENOS ARTICULADO",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensaje menos articulado",
      "LEAST_ARTICULATED_BAR_MSG": "Articular este mensaje",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MENSAJE MÁS ARTICULADO",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Mensaje más articulado",
      "MOST_ARTICULATED_BAR_MSG": "Articular plenamente este mensaje",
      "Overview": "Visión general",
      "CONSISTS_Of": "consiste en",
      "CALL_OVERVIEW_LABEL": "El gráfico muestra el número de usuarios que",
      "PASSED": "Aprobaron",
      "ATTEMPTED": "Intentaron",
      "NOT_ATTEMPTED": "No intentaron",
      "GUIDED_CALL": "Prueba de conocimientos",
      "QUESTIONS": "Preguntas",
      "QUESTION": "Pregunta",
      "CONVERSATIONAL_CALL": "Juego de roles",
      "AVG_ATTEMPTS": "Promedio Intentos",
      "USERS_PASSED": "usuarios aprobados",
      "DETAILED_ANALYSIS": "Análisis detallado",
      "CALL_DETAILS": "Detalles de la simulación",
      "CALL_TYPE": "Tipo de simulación",
      "TOTAL_SESSIONS": "Total de sesiones",
      "WHAT_WE_MEASURED": "Lo que medimos",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Puntuación global promedio",
      "OVERALL_SCORE_DETAIL": "Nuestro sistema proporciona una \"Puntuación global\" para cada conversación. Esta cifra es la puntuación global promedio a lo largo de",
      "CALL_RUN": "usuarios que han completado esta simulación",
      "TIME": "vez",
      "TIMES": "veces",
      "OBJECTIVES": "Metodología",
      "AVG_OBJECTIVE": "Puntuación promedio de metodología en",
      "OF_THIS_CALL": "de esta simulación",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "MESSAGE_ADHERENCE_DETAILS_1": "La adherencia al mensaje mide si los alumnos articulan",
      "MESSAGE_ADHERENCE_DETAILS_2": "ideas importantes durante la simulación. Estas visualizaciones muestran el porcentaje de mensajes de un tema de mensaje determinado que los usuarios articularon, de media, en todas las",
      "IMPORTANT_IDEAS": "ideas importantes durante esta simulación",
      "PERCENT_MESSAGE_ARTICULATED": "Estas visualizaciones muestran el porcentaje de tiempo que cada mensaje se articula a lo largo de",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "SKILLS_LABEL": "Habilidades",
      "SKILLS_DETAILS": "Las puntuaciones de las habilidades son una evaluación de la IA de las habilidades demostradas por los usuarios durante una simulación. Estas visualizaciones muestran el porcentaje de veces que los usuarios obtuvieron puntuaciones de “Experto” (la más alta), “Competente” y “En desarrollo” (la más baja) a lo largo de",
      "DEVELOPING": "En desarrollo",
      "PROFICIENT": "Competente",
      "Expert": "Experto",
      "NO_RESULT": "Aún no hay resultados",
      "NO_RESULT_TEXT": "Ninguno de los usuarios de tu organización ha intentado aún esta simulación. Una vez que lo hagan, podrás ver sus resultados aquí.",
      "CONVERSATIONAL_CALL_TOOLTIP": "Durante los juegos de rol, el usuario puede dirigir el flujo de la conversación, y la IA responderá en consecuencia. Los juegos de rol son menos estructurados que las “pruebas de conocimientos”, que tienen un formato estricto de pregunta-respuesta",
      "TOTAL_SESSION_TOOLTIP": "El número total de veces que se ha completado esta simulación en todos los usuarios a los que se ha asignado",
      "AVERAGE_SCORE_LABEL": "Puntuación promedio",
      "AVERAGE_SCORE_DETAIL": "La puntuación media de todos los usuarios en esta simulación",
      "ANSWER_POINTS": "Puntos de respuesta",
      "DETAILS": "Detalles",
      "CONVERSATIONAL_CALL_MSG": "Pronto se publicarán informes sobre el contenido de los juegos de rol",
      "ALL_CALL_DETAILS": "Todos los detalles de la simulación",
      "QUESTION_TEXT_LABEL": "Texto de la pregunta",
      "AVG_POINTS_LABEL": "Promedio de puntos",
      "SHOW_ALL": "Mostrar todo",
      "CORRECT_ANSWER": "respuestas correctas de",
      "OBJECTIVE_MEASURED_ON": "Esta metodología se mide en",
      "CALLS_IN_MODULE": "simulaciones en este módulo",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "QUESTION_UPDATED": "Esta pregunta ha sido actualizada",
      "QUESTION_UPDATED_MESSAGE": "No podemos mostrar información detallada sobre los puntos de respuesta porque se han realizado actualizaciones para esta pregunta. El “promedio de puntos” que se muestra representa el promedio de todas las sesiones de esta pregunta (incluyendo antes y después de las actualizaciones)",
      "CLOSE_ALT": "Cerrar",
      "Q_LABEL": "P",
      "SCORING_LABEL": "Puntuación",
      "AVERAGE_ANSWER": "Promedio de puntos de respuesta por pregunta",
      "MINIMIZE_LABEL": "Minimizar",
      "VIEW_ALL_LABEL": "Ver todo",
      "DOWN_ARROW": "Flecha hacia abajo",
      "NOTIFICATION": "Notificación",
      "PROGRESS_ICON": "Ícono de progreso",
      "VIEW_MODAL": "Ver Modal",
      "VIEW_INFO": "Ver información",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Ampliar grupo",
      "MESSAGE_ADHERENCE_V2": "Adherencia al mensaje",
      "SCORE_OVERALL": "Puntuación global",
      "SCORE_SKILLS": "Habilidades",
      "SCORE_CUSTOMIZED": "Metodología",
      "SESSIONS": "sesiones",
      "SESSION": "sesión"
    },
    "personalizedPractice": {
      "TITLE": "Práctica personalizada",
      "DESCRIPTION": "¡Hola, {{userFirstName}}! Las prácticas personalizadas te permiten establecer tus propios escenarios para que sean lo más realistas posible.",
      "LOADING": "Cargando…",
      "VIEW_SESSIONS": "Ver sesiones",
      "VIEW_SIMULATION": "Ver simulación",
      "TOTAL_SESSION": "sesión total",
      "TOTAL_SESSIONS": "total de sesiones",
      "BREADCRUMB": "Práctica personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalles del escenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecciona variables de las opciones a continuación para ajustar la simulación a tus necesidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleccionar",
      "CONVERSATION_TYPE": "Tipo de conversación",
      "SELECT_CONVERSATION_TYPE": "Seleccionar tipo de conversación",
      "LAUNCH_SIMULATION": "Iniciar simulación con selecciones",
      "PREVIOUS_SESSIONS": "Sesiones anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Fecha",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Fecha de la sesión",
      "SESSION_SCORE": "Puntuación de la sesión",
      "DURATION": "Duración",
      "OVERALL_SCORE": "Puntuación global",
      "MESSAGING": "Mensaje",
      "METHODOLOGY": "Metodología",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver retroalimentación",
      "OVERALL_SCORE_LABEL": "Puntuación global",
      "SCORE": "de puntuaciones",
      "NO_PRODUCTS_TITLE": "No hay productos disponibles",
      "NO_PRODUCTS_DESCRIPTION": "Todavía no tienes ningún producto de práctica personalizada.",
      "NO_SESSIONS_FOUND": "No se encontraron sesiones con los filtros seleccionados",
      "TIME": "vez",
      "ALL": "Todo",
      "LEARNER": "Estudiante",
      "MOOD": "Estado de ánimo",
      "CLEAR_FILTERS": "Quitar filtros"
    },
    "login": {
      "TITLE": "Bienvenido de nuevo",
      "SUB_TITLE": "¿Cómo te gustaría iniciar sesión?  ",
      "LOGIN_WITH_SSO": "Iniciar sesión con el inicio de sesión único (SSO) de la empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sesión con contraseña",
      "PROVIDE_EMAIL": "Proporciona tu dirección de correo electrónico",
      "HELP_TEXT": "¿Necesitas ayuda? Contacto",
      "EMAIL_ERROR": "No podemos iniciar sesión; por favor, contacta al administrador de tu empresa o al departamento de TI.",
      "EMAIL": "Correo electrónico",
      "LOGIN": "Iniciar sesión",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Al acceder a tu cuenta, aceptas las {{termsLink}} y la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "PRIVACY_POLICY": "Política de privacidad"
    },
    "learningPathway": {
      "BEGIN": "Comenzar",
      "DUE_DATE": "Fecha de entrega",
      "FOOTER_SUBTITLE_READY": "¡Pregúntame cualquier cosa! Estoy listo para ayudar.",
      "LEAVE_STEP": "Abandonar paso",
      "NEXT_STEP": "Siguiente paso",
      "NOTIFICATIONS_ARIA": "Notificaciones",
      "PDF_NEXT_PAGE": "Siguiente página",
      "PDF_NO_SOURCE": "No se proporcionó el archivo PDF original.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deja algún comentario mientras procesamos tus resultados.",
      "POST_CALL_TITLE": "Has llegado al final de este cuestionario.",
      "SETTINGS": "Ajustes",
      "TOAST_CONTENT": "Haz clic abajo para ver, o regresa a la pantalla de detalles de la trayectoria para tu siguiente paso.",
      "TOAST_TITLE": "Tus resultados de juego de rol fueron procesados",
      "ASSIGNMENTS": "Tareas",
      "USER_FALLBACK": "Usuario",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Cuestionario"
    },
    "leaderboard": {
      "LEADERBOARD": "Clasificación",
      "TOP10PERCENT": "El 10 % más alto",
      "PRACTICE_ASSIGNMENT": "Tareas de práctica",
      "SIMULATION": "Simulación",
      "SELECT_ASSIGNMENT": "Seleccionar tarea",
      "SELECT_SIMULATION": "Seleccionar simulación",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecciona una tarea y una simulación para ver a los líderes",
      "NO_DATA": "Aún no hay actividad. Una vez que el equipo empiece a participar, verás que las clasificaciones aparecen aquí.",
      "NO_ASSIGNMENTS_AVAILABLE": "No hay tareas disponibles",
      "NO_SIMULATIONS_AVAILABLE": "No hay simulaciones disponibles",
      "NAME": "Nombre",
      "HIGH_SCORE": "Puntuación alta",
      "AVERAGE_SCORE": "Puntuación promedio",
      "TOTAL_SESSIONS": "Total de sesiones",
      "LAST_SESSION": "Última sesión",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "usuarios que participaron",
      "ENGAGED_USER": "usuario que participó",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar las sesiones con puntuaciones bajas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Las sesiones con una puntuación de \"en desarrollo\" en la sección de habilidades no contribuirán a las columnas de puntuación alta o media.",
      "NO_USERS_ENGAGED": "No hay usuarios participando"
    },
    "general": {
      "NEED_HELP_QUESTION": "¿Necesitas ayuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Cuenta principal",
      "ACCOUNT": "Cuenta",
      "CHECKMARK": "Marca de verificación",
      "ICON": "Ícono",
      "ALERT": "alerta",
      "HEADS_UP": "¡Atención!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Te recomendamos usar auriculares para que el sonido sea óptimo en tu iPad.",
      "SETTINGS": "AJUSTES",
      "RP": "RP",
      "EMAIL_LABEL": "Correo electrónico",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipo de",
      "MIAMI_SALE": "ventas en Miami",
      "CHARLOTTE_SALES": "ventas en Charlotte",
      "ATLANTA_SALES": "ventas en Atlanta",
      "TEAM": "Equipo",
      "ASSIGNMENTS": "Tareas",
      "MY_TEAMS": "Mis equipos",
      "REPORTING": "Informes",
      "DASHBOARD": "Panel",
      "LEADERBOARD": "Clasificación",
      "PERSONALIZED_PRACTICE": "Práctica personalizada",
      "HELP_SEARCH_OUR": "Busque en nuestra",
      "HELP_OR_REACH_OUT_TO": "o póngase en contacto con",
      "HELP_WITH_QUESTIONS": "con preguntas",
      "KNOWLEDGE_BASE": "base de conocimientos"
    },
    "dashboard": {
      "ALL": "Todo",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completada",
      "NO_ASSIGNMENT_TITLE": "No tienes ninguna tarea.",
      "NO_ASSIGNMENT_DETAILS": "Se te notificará cuando tengas tareas que completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "No tienes tareas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Se te notificará cuando haya una nueva tarea pendiente.",
      "COMPLETED_ASSIGNMENT_TITLE": "No tienes tareas completadas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Vuelve a comprobarlo una vez que hayas completado una tarea.",
      "VIEW_ASSIGNMENT": "Ver tarea",
      "ASSIGNMENT_LABEL": "Tareas",
      "MODULE_ASSIGNMENT_ALT": "Ícono de asignación de módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarea de",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta la fecha de entrega",
      "PAST_DUE": "De retraso",
      "AVAILABLE_IN": "Disponible en",
      "DUE_TODAY": "Se entrega hoy",
      "PRACTICE": "Práctica",
      "CERTIFICATION": "Certificación",
      "UPCOMING": "Próximamente",
      "TEST_ASSIGNMENT": "Asignación de prueba",
      "CLOSED": "Cerrada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No se encontraron tareas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Intenta ajustar tus filtros para ver las tareas disponibles, o vuelve a consultar más tarde cuando se agreguen nuevas tareas.",
      "VIEW_PATHWAY": "Ver trayectoria",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de tarea",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarea:",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificada",
      "NOT_CERTIFIED": "No certificado",
      "IN_PROGRESS": "En curso",
      "PATHWAY": "Trayectoria de aprendizaje",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo"
    },
    "cognito": {
      "INVITATION_SUBJECT": "¡Te damos la bienvenida a Quantified!",
      "INVITATION_MESSAGE": "Estamos encantados de tenerte con nosotros. Para empezar, sigue los pasos que se indican a continuación para acceder a tu cuenta por primera vez.",
      "ACCOUNT_DETAILS": "Datos de tu cuenta:",
      "USERNAME": "Nombre de usuario",
      "PASSWORD": "Contraseña temporal",
      "STEPS_LABEL": "Próximos pasos para iniciar sesión",
      "STEP_1": "1. Haz clic en el botón “Iniciar sesión” para ir a la página de inicio de sesión.",
      "STEP_2": "2. Introduce el nombre de usuario y la contraseña temporal que te hemos proporcionado anteriormente.",
      "STEP_3": "3. Una vez que hayas iniciado sesión, se te pedirá que crees una nueva contraseña.",
      "LOGIN_BUTTON": "Iniciar sesión",
      "ABOUT_US": "El simulador de Quantified es un entorno virtual diseñado para ayudarte a desarrollar rápidamente habilidades esenciales, lo que te permite conectar y comunicarte más eficazmente con tus clientes.",
      "EXPIRY_TIME": "Esta contraseña temporal caducará en 24 horas. Si tienes problemas para iniciar sesión, ponte en contacto con nuestro equipo de soporte en",
      "TEAM": "El equipo de Quantified",
      "INVITATION_SMS_USERNAME": "Tu nombre de usuario es",
      "INVITATION_SMS_PASSWORD": "y tu contraseña temporal es",
      "AUTHENTICATION_CODE": "Tu código de autenticación es",
      "PASSWORD_RESET_CODE": "Tu código de restablecimiento de contraseña de Quantified",
      "RESET_PASSWORD_EMAIL": "Correo electrónico de restablecimiento de contraseña",
      "HELLO": "¡Hola!",
      "USE_VERIFICATION_CODE": "Has solicitado restablecer la contraseña. Utiliza el código de verificación que aparece a continuación para completar el proceso.",
      "VERIFICATION_CODE": "Código de verificación",
      "NEXT_STEP": "Próximos pasos",
      "RESET_PASSWORD_PAGE": "Vuelve a la página de restablecimiento de contraseña en el navegador.",
      "ENTER_VERIFICATION_CODE": "Introduce el código de verificación cuando se te solicite.",
      "CREATE_PASSWORD": "Una vez verificado el código, sigue las instrucciones para crear una nueva contraseña.",
      "DISREGARD_NOTE": "Si no has solicitado restablecer tu contraseña, ignora este correo electrónico.",
      "CONTACT_SUPPORT": "Si necesitas más ayuda, ponte en contacto con nuestro equipo de soporte en",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Atentamente,",
      "QUANTIFIED_TEAM": "El equipo de Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos"
    },
    "call": {
      "LOADING": "Cargando",
      "SIMULATION_PAUSED": "La simulación se ha pausado.",
      "CLICK_RESUME": "Haz clic en el botón “Reanudar” para continuar.",
      "NO_INTERNET": "Sin conexión a Internet",
      "TRY_AGAIN": "Revisa tu conexión y vuelve a intentarlo.",
      "MIC_MUTED": "El micrófono está silenciado",
      "MIC_MUTED_DESCRIPTION": "Uy, parece que el micrófono está silenciado. Desactiva el silencio para responder y continuar.",
      "NO_RESPONSE": "No se detectó respuesta",
      "MIC_NOT_CONNECTED": "Uy, parece que el micrófono no está conectado. Vuelve a seleccionar tu dispositivo para responder y continuar.",
      "AUDIO_ISSUE": "Uy, algo salió mal. Comprueba la configuración de tu dispositivo y asegúrate de que estás en un lugar tranquilo y sin ruidos de fondo.",
      "LOADING_ALT": "Cargando…",
      "REPEAT_RESPONSE": "Se te remitirá automáticamente a la simulación para que repitas tu respuesta y vuelvas a intentarlo.",
      "NEEDS_MORE_TIME_QUESTION": "necesita más tiempo para pensar, ¿quieres esperar?",
      "NEEDS_MORE_TIME": "necesita más tiempo para pensar.",
      "WAIT_OR_END_CALL": "Te informaremos cuando estén listos, o puedes finalizar la llamada y",
      "RETURN_TO_ASSIGNMENTS": "Volver a la tarea",
      "READY": "Listo",
      "IS_READY": "está listo/a para continuar la conversación.",
      "TRY_AGAIN_LABEL": "Inténtalo de nuevo",
      "CHECK_SETTINGS": "Verificar ajustes",
      "PAUSED_SIMULATION": "Has pausado esta simulación.",
      "PAUSED_SIMULATION_DESCRIPTION": "La grabación de video y audio se pausa hasta que se reanude la simulación.",
      "RESUME": "Continuar",
      "SETTINGS": "Ajustes",
      "CAPTURING_RESPONSE": "Capturando las respuestas",
      "TOUR_MESSAGE": "Una vez que termines de hablar, asegúrate de hacer clic en el botón Continuar para garantizar que las respuestas se registran y puntúan.",
      "NEXT": "Siguiente",
      "START_CALL": "Comenzar",
      "END_CALL_TITLE": "¿Seguro/a de que deseas terminar esta simulación?",
      "END_CALL_DESCRIPTION": "Si terminas la simulación ahora, no recibirás una puntuación ni retroalimentación sobre la conversación.",
      "END_CALL": "Finalizar",
      "BROWSER_ACCESS_DENIED": "Tu navegador tiene denegado el acceso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID de sesión",
      "TIPS_GUIDANCE_MESSAGE": "Aquí aparecerán temas de conversación y consejos.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID de sesión:",
      "SESSION_ID_COPIED": "ID de sesión copiado",
      "HINTS_AND_SUGGESTIONS_TITLE": "Pistas y sugerencias",
      "HINT_LABEL": "Pista",
      "CAPTIONS_LABEL": "Subtítulos",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "emoji de fiesta",
      "CALL_ENDED_MESSAGE": "Has llegado al final de esta simulación.",
      "CALL_ENDED_INACTIVITY": "Esta simulación ha terminado por inactividad",
      "CALL_ENDED_GENERIC": "Esta simulación ha terminado",
      "FEEDBACK_PROMPT": "Deja algún comentario mientras procesamos tus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "No has alcanzado nuestro umbral de interacción para obtener una puntuación. Inténtalo de nuevo.",
      "REALISTIC_CONVERSATION_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "¿Te sientes más informado y preparado después de esta simulación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "No se pudo cargar la ayuda visual",
      "BEGIN_CALL": "Comenzar",
      "LEAVE_CALL_BRIEFING": "Salir del resumen",
      "RESTORE_CALL": "Restaurar la simulación",
      "FEW_SECONDS": "Esto puede tardar unos segundos.",
      "CHECK_ALT": "Comprobar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Pistas",
      "CLOSE_CAPTIONS": "Cerrar subtítulos",
      "MICROPHONE_MUTED": "Micrófono silenciado",
      "RETURN_TO_CALL": "Volver a la simulación",
      "YES": "Sí",
      "NO": "No",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "HAVING_ISSUES": "Tenemos problemas para conectarnos; comprueba tu conexión a Internet y haz clic en Aceptar.",
      "OK": "Aceptar",
      "RESULTS_NOT_GENERATED": "Lo sentimos, no podemos generar resultados en este momento, inténtalo de nuevo.",
      "INACTIVITY_ALERT_MESSAGE": "Esta llamada ha finalizado por inactividad. Habla con el avatar para continuar o selecciona “Finaliza llamada” para terminar la llamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta llamada terminará en {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta llamada terminará en unos segundos",
      "TELL_YOUR_GENDER_HEADING": "Indícanos tu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Al conocer tu género, el avatar puede utilizar la gramática adecuada, lo que hace que la conversación sea más natural y realista.",
      "GENDER_SELECTION": "Selección de género:",
      "SELECT_OPTION": "Selecciona una opción",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Femenino",
      "NON_BINARY": "No binario/Otro",
      "PREFER_NOT_TO_ANSWER": "Prefiero no contestar",
      "NON_BINARY_MESSAGE": "Entendemos y respetamos tu identidad de género no binaria. Debido a las limitaciones tecnológicas actuales, utilizamos pronombres masculinos por defecto. Te informamos que estamos trabajando en mejoras para incluir a todas las identidades de género en el futuro. Gracias por tu comprensión y paciencia.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respetamos tu decisión de no indicar tu género. En estos casos, nuestra tecnología utiliza por defecto pronombres masculinos debido a las limitaciones actuales.",
      "DISPLAY_VISUAL_AID": "Mostrar la ayuda visual",
      "FULL_SCREEN": "Pantalla completa",
      "COLLAPSE": "Contraer",
      "COMPLETED_CONVERSATION_MESSAGE": "Gracias por completar esta conversación",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deje una opinión mientras procesamos su conversación.",
      "ERROR_MESSAGE": "Hubo un error. Póngase en contacto con",
      "SAVED_CONVERSATION_MESSAGE": "Su conversación se ha guardado.",
      "RETURN_TO_MY_ASSIGNMENTS": "Volver a mis tareas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Regresar a la práctica personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabas de completar una conversación de práctica personalizada.",
      "LEAVE_STEP_TITLE": "¿Estás seguro de que quieres abandonar este paso?",
      "EXIT": "Salir"
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PUNTUACIÓN",
      "MUST_ACHIEVE": "Debes lograr",
      "OR_HIGHER": "o más",
      "TEST": "Prueba",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "ÚLTIMO INTENTO",
      "TOTAL_ATTEMPTS": "intentos totales",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "DUE_DATE": "Fecha de entrega",
      "DAYS": "Días",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta la fecha de entrega",
      "PAST_DUE": "De retraso",
      "ONGOING": "En curso",
      "SCORE_REQUIREMENT": "Requisito de puntuación",
      "SCORE_REQUIREMENT_DETAIL": "Debes lograr una puntuación de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulación requerida.",
      "CALLS_IN_ASSIGNMENT": "Simulaciones asignadas",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Fecha",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver retroalimentación",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CHECKMARK": "marca de verificación",
      "CALL": "Llamada",
      "QUESTION": "Pregunta",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin comenzar",
      "CERTIFIED": "Certificada",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Prueba de conocimientos",
      "CONVERSATIONAL_SIMULATION": "Juego de roles",
      "NO_ATTEMPTS_LEFT": "No quedan intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "OVERVIEW": "Visión general",
      "ABOUT_THE_AVATAR": "Acerca del avatar",
      "SCORING_CRITERIA": "Criterios de puntuación",
      "SIMULATION_OVERVIEW": "Resumen de la simulación",
      "ABOUT_THE_PERSONA": "Sobre el personaje",
      "OUTOF_COMPLIANCE": "Incumplimiento",
      "CLOSED": "Cerrada"
    }
  },
  "en": {
    "root": {
      "ADMIN_PORTAL": "ADMIN PORTAL",
      "SUPPORT": "SUPPORT",
      "U": "U",
      "USER": "User",
      "LOGOUT": "Logout",
      "ADMIN": "Admin",
      "SUPPORT_SMALL": "Support",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMERA",
      "ACCESS_DENIED": "ACCESS_DENIED"
    },
    "teams": {
      "MY_TEAMS": "My teams",
      "COMPLETED": "Completed",
      "IN_PROGRESS": "In progress",
      "NOT_STARTED": "Not started",
      "ASSIGNMET_MODULE": "Assignment Module",
      "START_DATE": "Start date",
      "DUE_DATE": "Due date",
      "ASSIGNED_MEMBERS": "Assigned members",
      "CALLS_IN_MODULE": "Simulations in module",
      "COMPLETION_REQUIRMENT": "Completion requirement",
      "COMPLETE_ALL_CALLS": "Complete all simulations with a score of",
      "OR_HIGHER": "or higher",
      "PROGRESS_OVERVIEW": "PROGRESS OVERVIEW",
      "TEAM_MEMBERS": "team members",
      "AVERAGE_HIGH_SCORE": "Average high score",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Average number of attempts per simulation",
      "TOTAL_PRACTICES": "Total practices",
      "INDIVIDUAL_CALL_PROGRESS": "INDIVIDUAL SIMULATION PROGRESS",
      "OF_TEAM_MEMBERS": "of team members completed",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Average practices to completion",
      "TEAM_MEMBER_DETAILS": "TEAM MEMBER DETAILS",
      "DOWNLOAD_ACTIVITY_REPORT": "Download activity report",
      "TEAM_MEMBER": "Team member",
      "PROGRESS": "Progress",
      "CALLS_COMPLETED": "Simulations completed",
      "PRACTICES": "Practice sessions",
      "MOST_RECENT_PRACTICE": "Most recent session",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "This team has no active assignments at this time",
      "CALL_NAME_LABEL": "Simulation name",
      "HIGHEST_SCORE": "Highest Score"
    },
    "simulationBuilder": {
      "THRESHOLD": "Threshold",
      "TYPE": "Type",
      "SELECT_AN_OPTION": "Select an option",
      "CORRECT_FEEDBACK": "Correct feedback",
      "INCORRECT_FEEDBACK": "Incorrect feedback",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Displayed when the learner gets this correct",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Displayed when the learner gets this incorrect",
      "MESSAGE_NUMBER": "Message {{ index }}",
      "ENTER_MESSAGE_TEXT": "Enter message text...",
      "DELETE": "Delete",
      "SCORABLE": "Scorable"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Let's ensure your device is configured.",
      "MICROPHONE_REQUIRED_NOTICE": "A functioning microphone is required.",
      "DEVICE_ENABLE_INSTRUCTIONS": "If you did not see a pop-up request to enable your devices after refreshing this page, please go into your system or browser settings and enable your devices. Below are support pages with further instruction.",
      "ENABLE_CAMERA": "How to enable your camera:",
      "WINDOWS_USERS": "Windows users",
      "MAC_USERS": "Mac users",
      "IPAD_USERS": "iPad users",
      "ENABLE_MICROPHONE": "How to enable your microphone:",
      "ENABLE_DEVICES_BY_BROWSER": "How to enable your devices by browser:",
      "CHROME_USERS": "Chrome users",
      "SAFARI_USERS": "Safari users",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Start without Camera",
      "START_CALL_BUTTON": "Start Call",
      "MICROPHONE_REQUIRED_WARNING": "A functioning microphone is required.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Select Your Microphone",
      "ALERT": "alert",
      "GIVE_PERMISSION": "Give Permission",
      "SELECT_VIDEO_DEVICE": "Select Your Video Device",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "It looks like you have denied this browser access to one or more of your devices. To enable the devices, please go into your system settings or browser settings and enable access.",
      "DEVICE_SETTINGS": "Device settings",
      "CONFIRM_SETTINGS": "Confirm Settings",
      "LAPTOP": "Laptop",
      "SAD_EMOTE_FACE": "Sad Emote Face",
      "GRANT_BROWSER_ACCESS": "In order to complete this simulation, please grant browser access to Speech Recognition",
      "USING_IPAD": "If using an iPad, go to",
      "SETTINGS": "Settings",
      "PRIVACY_AND_SECURITY": "Privacy & Security",
      "SPEECH_RECOGNITION": "Speech Recognition",
      "GRANT_ACCESS_REFRESH": "Grant browser access and refresh the page",
      "REFRESH_PAGE": "REFRESH PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Browser is unable to access this device",
      "ACCESS_DENIED": "access denied",
      "CAMERA": "Camera",
      "DIAGNOSTIC_PASSED": "All diagnostic tests passed successfully.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Some diagnostic tests failed. Please click the \"Copy Diagnostic Results\" button above and send the results to the support team for assistance.",
      "DIAGNOSTIC_PARTIAL": "Most diagnostic tests passed successfully. Your connection looks good.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Please wait while diagnostic tests are running...",
      "DIAGNOSTIC_RUNNING": "Diagnostic Running",
      "COPY_DIAGNOSTIC_RESULTS": "Copy Diagnostic Results",
      "RUN_DIAGNOSTIC": "Run Diagnostic",
      "RERUN_DIAGNOSTIC": "Rerun Diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Diagnostic results copied to clipboard",
      "DIAGNOSTIC_FAILED": "Diagnostic failed",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified Diagnostics",
      "DIAGNOSTIC_TIME": "Time",
      "DIAGNOSTIC_SUMMARY": "Summary",
      "DIAGNOSTIC_CLIENT_INFO": "Client info",
      "DIAGNOSTIC_PLATFORM": "Platform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Packet loss (send)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Avg send bitrate",
      "DIAGNOSTIC_NA": "n/a"
    },
    "results": {
      "RETURN_HOME": "RETURN HOME",
      "RETURN_TO_PATHWAY": "RETURN TO PATHWAY",
      "CLOSE_BUTTON": "Close Button",
      "CONVERSATIONAL_CALL": "ROLE PLAY",
      "INFORMATION_ICON": "Information Icon",
      "TOOLTIP_ARROW": "Tooltip Arrow",
      "INFORMATION_TOOLTIP_CONTENT": "You control the flow of the simulation, driving the conversation towards a set of objectives. Role plays are great for testing abilities like drilling down and asking second-level questions, uncovering pain points, and building rapport.",
      "CLOCK_ICON": "Clock Icon",
      "CALL_RESULTS": "Results",
      "QUIZ_RESULTS_SUMMARY": "Quiz Results Summary",
      "PROCESSING_RESULTS": "Processing results...",
      "SKILLS": "Skills",
      "MESSAGE_ADHERENCE": "Message Adherence",
      "TRY_AGAIN_MESSAGE": "Try again and improve your score.",
      "QUIZ_SUMMARY_BASE": "Take a moment to review your performance on this quiz.",
      "QUIZ_SUMMARY_FAILED": "Take a moment to review your performance on this quiz. Review the {{stepNames}} {{stepWord}} highlighted on the pathway overview screen to better prepare for your next attempt.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Take a moment to review your performance on this quiz. The {{stepNames}} {{stepWord}} {{stepVerb}} your lowest scoring {{areaWord}}.",
      "PRACTICE_BENEFITS": "Weekly practice boosts confidence and improves real world outcomes.",
      "CALL_SUCCESS": "Great job! You successfully completed this simulation.",
      "MAX_ATTEMPTS_REACHED": "You have reached the maximum number of attempts",
      "TRY_AGAIN": "Try Again",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Great job! You successfully",
      "COMPLETED_THIS_CALL": "completed this simulation.",
      "ACHIEVED_SCORE": "You achieved a score of",
      "ACHIEVE_SCORE": "Achieve a score of",
      "OR_HIGHER": "or higher.",
      "OBJECTIVES_NOT_MET": "You didn't meet all the required objectives.",
      "TRY_AGAIN_TARGET_SCORE": "Try again to achieve a score of",
      "YOUR_SCORE": "Your Score",
      "OUT_OF_5": "OUT OF 5",
      "OUT_OF_100": "OUT OF 100",
      "CALL_FEEDBACK": "FEEDBACK SUMMARY",
      "STRENGTH_ICON_ALT": "Strength Icon",
      "OPPORTUNITIES_ICON_ALT": "Opportunities Icon",
      "OBJECTIVES_FEEDBACK": "FEEDBACK ON METHODOLOGY",
      "SESSION_ID": "Session ID:",
      "SESSION_ID_COPIED": "Session ID copied!",
      "OBJECTIVE": "METHODOLOGY:",
      "HOW_YOU_DID": "How you did:",
      "LIGHTBULB_ICON_ALT": "Lightbulb Icon",
      "WHAT_WE_SUGGEST": "What we suggest:",
      "NO_SPECIFIC_RECOMMENDATION": "Our system could not find a specific recommendation for you.",
      "WHY": "Why?",
      "NO_INSIGHTS_AVAILABLE": "Our system could not provide insights into this suggestion.",
      "CONFETTI_ICON_ALT": "Confetti Icon",
      "OBJECTIVE_SUCCESS_MESSAGE": "You did great on this methodology, keep up the good work!",
      "PROCESSING_CALL": "We are preparing your score and feedback.",
      "HANG_TIGHT": "Hang tight or check back later to",
      "VIEW_YOUR_RESULTS": "view your results.",
      "NEED_MORE_TIME": "We need more time to calculate the results.",
      "REFRESH_INSTRUCTION": "Please check back or refresh the assignment",
      "RESULTS_IN_FEW_MINUTES": "results in a few minutes.",
      "SCORE_CALCULATION_QUESTION": "How is this calculated?",
      "SINGLE_SCORE_EXPLANATION": "This simulation only has a single score component, so the score displayed is both the individual section score as well as your overall score.",
      "OVERALL_SCORE_PERCENT": "% of overall score",
      "SECTION_SCORE": "Section score",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Elevate your conversation message adherence",
      "MESSAGE_ADHERENCE_NOTE": "Message adherence is critical for leading successful conversations, but doesn't affect your overall score.",
      "NO_CREDIT": "No credit",
      "PARTIAL_CREDIT": "Partial credit",
      "FULL_CREDIT": "Full credit",
      "WHAT_YOU_DID_WELL": "What you did well",
      "MISSED_ALL_KEY_POINTS": "You missed all the key points; review them and try again.",
      "WHAT_TO_IMPROVE": "What you can do better",
      "PERFECT_SCORE_MESSAGE": "Congrats! You got a perfect score, correctly speaking to all of the key points.",
      "POINTS_LABEL": "Points",
      "TALKING_POINTS_COVERED": "Talking points covered",
      "COVERED": "Covered",
      "CHECKMARK_ICON_ALT": "checkmark",
      "TALKING_POINTS_MISSED": "Talking points missed",
      "MISSED": "Missed",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practice again",
      "OUT_OF": "out of",
      "POSSIBLE_TALKING_POINTS": "possible talking points",
      "YOU_COVERED": "You covered",
      "THROUGHOUT_CALL": "throughout the simulation.",
      "POSITIVE_FEEDBACK_COVERAGE": "You did a great job highlighting key points throughout the call, and covered",
      "MIXED_FEEDBACK_COVERAGE": "You missed some of the key points throughout the simulation, and covered",
      "OBJECTIVES": "Methodology",
      "ELEVATE_OBJECTIVES_TITLE": "Elevate your conversation methodology",
      "OBJECTIVES_NOTE": "Methodology is critical for leading successful conversations, but doesn't affect your overall score.",
      "UNTIL": "until",
      "TO_IMPROVE_SCORE": "to improve your score.",
      "TO_SCORE": "to score",
      "BEFORE": "before",
      "YOU_HAVE": "You have",
      "MORE_ATTEMPTS": "more attempts to score",
      "OR_HIGHER_BEFORE": "or higher before",
      "AND_TRY_AGAIN": "and try again.",
      "UNEXPECTED_STATE": "An unexpected state occurred.",
      "REVIEW_APP_LOGIC": "Please review the application's logic.",
      "ASSIGNMENTS": "Assignments",
      "VIEW_CALL_DETAILS": "View call details",
      "PRACTICE_SESSION": "Practice session",
      "OVERALL_SCORE": "Overall score",
      "OVERALL_SCORE_EXPLANATION": "The overall score is calculated by taking a weighted average of the score for each section. The weight of each section is displayed as a percentage next to the score.",
      "SCORE_CONFIG_NOTE": "Weight percentages and the inclusion and exclusion of sections are set by your company. All scores are rounded to the nearest tenth of a point.",
      "STRENGTHS": "Strengths",
      "OPPORTUNITIES": "Opportunities",
      "YOUR_RESPONSE": "Your Response",
      "MINUS": "minus",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Recommended Response",
      "REVIEW_MISSED_TITLE": "Review what you missed.",
      "NO_TALKING_POINTS_COVERED": "You did not cover any of the required talking points for this topic.",
      "LEARN_WHAT_YOU_MISSED": "Learn What You Missed",
      "NICE_JOB": "Nice job!",
      "ALL_POINTS_COVERED": "You successfully covered all the required talking points for this topic.",
      "COVER_ALL_MESSAGES": "Cover all the key messages.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Highlighting the key points throughout the call will help keep the conversation focused.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oops! Looks like you didn't cover any of the facts of this message.",
      "NO_SPECIFICS_AVAILABLE": "Oops! Looks like we couldn't provide specifics on what was missed.",
      "ALL_KEY_POINTS_COVERED": "Great job! You covered all the key points.",
      "PROCESSING_SKILLS_FEEDBACK": "We are processing your skills feedback.",
      "SKILLS_SCORING_NOT_ENABLED": "We're sorry, but we couldn't analyze your recent call because skill scoring wasn't enabled at the time of submission. To get feedback, just resubmit your call practice as you did before. If you need help, feel free to reach out to our support team. Thanks for your understanding and commitment to improvement!",
      "ELEVATE_CONVERSATION_SKILLS": "Elevate Your Conversation Skills",
      "SKILLS_NOTE": "Skills are critical for leading successful conversations, but don't affect your overall score.",
      "SKILLS_SUMMARY_TITLE": "SKILLS SUMMARY",
      "LEARN_MORE_ABOUT_SKILLS": "Learn more about skills",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "What Are Skills",
      "SKILLS_DESCRIPTION": "Skills are calibrated to support personal growth development. While these skills are not part of the numerical evaluation for your call, they've been selected by your organization to enhance your effectiveness.",
      "PROFICIENCY_SCALE_TITLE": "PROFICIENCY SCALE",
      "EXPERT": "Expert",
      "PROFICIENT": "Proficient",
      "DEVELOPING": "Developing",
      "CALL_TRANSCRIPT": "Call transcript",
      "COLLAPSE_ALL": "Collapse All",
      "EXPAND_ALL": "Expand All",
      "THUMBNAIL": "Thumbnail",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "talking points",
      "TRANSCRIPT_LABEL": "Transcript",
      "YOU_ARE_OUT_OF_ATTEMPTS": "You’re out of attempts.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Review the guidelines and remain compliant in the future.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Try again and pay attention to compliance guidelines.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "We noticed you were out of compliance, therefore you did not receive a score.",
      "WHY_OUT_OF_COMPLIANCE": "Why You Were Out of Compliance",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Review your transcript to see where you missed compliance guidelines.",
      "YOU_DID_FOLLOW_GUIDELINES": "You did effectively follow these guidelines.",
      "REVIEW_MISSED_GUIDELINES": "Review the missed compliance guidelines.",
      "OUT_OF_COMPLIANCE": "Out of compliance",
      "SCORE_CALCULATION_TITLE": "Score calculation",
      "PROCESSING_TRANSCRIPT": "We are processing your transcript.",
      "WAIT_OR_REVIEW_SCORES": "Wait here, or review the other score",
      "TRANSCRIPT_LOADING": "sections while the transcript loads.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Review your feedback and keep practicing",
      "HIGH_PERFORMERS_PRACTICE": "High performers practice at least once a week",
      "SUCCESSFULLY_PASSED": "Great job! You successfully passed this simulation.",
      "DIDNT_REACH_PASSING_SCORE": "You didn't reach the passing score for this simulation.",
      "OUT_OF_ATTEMPTS": "<b>You are out of attempts.</b> Review your feedback to learn how you can improve.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Review your feedback, then return home when you are ready.",
      "GREAT_JOB_PRACTICED": "Great job, you've practiced {{count}} {{times}}. Keep going!",
      "TIME": "time",
      "TIMES": "times",
      "COMPLIANCE_GUIDELINES": "Compliance guidelines",
      "TALKING_POINT_TITLE": "TALKING POINTS MISSED OR SAID AT WRONG TIME",
      "NO_TRANSCRIPT": "No transcript available.",
      "RETURN_TO_ASSIGNMENT": "Return to assignment",
      "NONE_PERFECT": "None - Perfect!"
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Loading accounts...",
      "SELECT_AN_ACCOUNT": "Select an account",
      "SELECT_ASSIGNMENTS": "Select Assignments",
      "SEARCH_TEAMS": "Search teams",
      "LOADING_TEAMS": "Loading teams...",
      "ALL_TEAMS": "All teams",
      "ACCOUNT": "Account",
      "TEAMS": "Teams",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Passing Score",
      "ASSIGNMENT_LABEL": "Assignments",
      "USER_LABEL": "Users",
      "PRACTICE_LABEL": "Practice",
      "CERTIFICATION_LABEL": "Certification",
      "CERTIFICATION_STATUS_LABEL": "Certification status",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Certification Status:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certified on first attempt?",
      "DATE_OF_CERTIFICATION_LABEL": "Date of certification",
      "RESULTS_DESCRIPTION": "Here are the results of your team(s) across all practice assignments:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement by assignment",
      "ASSIGNMENT_ENGAGEMENT": "Assignment Engagement",
      "ENGAGED_LABEL": "Engaged",
      "ENGAGEMENT_STATUS_LABEL": "Engagement status",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Engagement Status:",
      "PROFICIENT_LABEL": "Proficient",
      "ASSIGNMENT_NAME": "Assignment name",
      "ACTIVE_USERS": "Active users",
      "ASSIGNMENT_PROGRESS": "Progress by assignment",
      "IN_PROGRESS_LABEL": "In progress",
      "CERTIFIED_LABEL": "Certified",
      "OUT_OF_ATTEMPTS_LABEL": "Out of attempts",
      "USERS_ENGAGED_LABEL": "Users engaged",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions per active user",
      "HIGHER_THAN_LABEL": "Higher than",
      "MORE_THAN_LABEL": "More than",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total sessions completed",
      "USER_CERTIFIED": "Users certified on all assignments",
      "ASSIGNMENT_CERTIFICATION": "Assignments with 100% certification",
      "TRAINER_TIME_SAVED": "Trainer time saved",
      "HOURS_LABEL": "hours",
      "PRACTICE_ASSIGNMENT_LABEL": "Practice Assignments",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Certification Assignments",
      "START_DATE_LABEL": "Start date",
      "END_DATE_LABEL": "End date",
      "NAME_LABEL": "Name",
      "EMAIL_LABEL": "Email",
      "MEMBER_OF_TEAMS_LABEL": "Member of teams",
      "ASSIGNMENTS_COUNT_LABEL": "# of assignments",
      "TOTAL_SESSIONS_LABEL": "Total sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Number of sessions",
      "TOTAL_USERS_LABEL": "Total Users",
      "AVERAGE_SCORE_LABEL": "Average score",
      "INITIAL_SCORE_LABEL": "Initial score",
      "HIGH_SCORE_LABEL": "High score",
      "LAST_PRACTICE_DATE_LABEL": "Last practice date",
      "PERCENT_IMPROVED_LABEL": "% improved",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "This metric analyzes the scores from each session and draws a straight line on a graph to illustrate the trend. A higher percentage indicates that scores are improving faster, a lower percentage indicates the scores are improving more slowly.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Assignments certified",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Assignments proficient",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "The number of assignments where the user has met or exceeded the score criteria for all simulations in the assignment",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "The number of assignments where the user has met or exceeded the score criteria at least once on all simulations in the assignment",
      "PROFICIENT_TOOLTIP": "The percent of users in this assignment that have met or exceeded the score criteria at least once on all simulations in this assignment",
      "ENGAGED_TOOLTIP": "The percent of users who have completed one or more sessions of a simulation in this assignment but have not yet achieved proficiency on all simulations.",
      "IN_PROGRESS_TOOLTIP": "The percent of users that have completed at least one session of a simulation in this assignment and received a score.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "The percent of users who have exceeded their allotted attempts for one or more simulations in the assignment.",
      "CERTIFIED_TOOLTIP": "The percent of users who have met or exceeded the score criteria for all simulations in the assignment.",
      "SEARCH_FOR_A_USER_LABEL": "Search for a user",
      "NO_USERS_FOUND_LABEL": "No users found",
      "TRAINER_TIME_SAVED_TOOLTIP": "The amount of time users have spent in Quantified completing certification attempts.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Avg. sessions per assignment",
      "ASSIGNMENTS_ENGAGED_WITH": "Assignments engaged with",
      "AVERAGE_IMPROVEMENT": "Average improvement",
      "STATUS": "Status",
      "TOTAL_NUMBER_OF_SESSIONS": "Total number of sessions",
      "DATE_OF_LAST_PRACTICE": "Date of last practice",
      "CALL_NAME": "Call Name",
      "SESSION_DATE": "Session date",
      "DURATION_OF_SESSION": "Duration of session",
      "DURATION_OF_ATTEMPT": "Duration of attempt",
      "OVERALL_SCORE": "Overall score",
      "MESSAGING_SCORE": "Message adherence score",
      "METHODOLOGY_SCORE": "Methodology score",
      "SKILLS_SCORE": "Skills score",
      "SESSIONS": "Sessions",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "All assignments",
      "RECENT_ASSIGNMENTS": "Recent assignments",
      "USER_NAME": "User name",
      "LEARNER": "Learner",
      "DATE_RANGE": "Date Range",
      "DATE_RANGE_LABEL": "Date range",
      "SEARCH_USERS": "Search users...",
      "SEARCH_SIMULATIONS": "Search simulations...",
      "SEARCH_DATES": "Search dates...",
      "SEARCH_ASSIGNMENTS": "Search assignments...",
      "CERTIFIED_ON_FIRST_TRY": "Certified on the first try",
      "DATE_OF_CERTIFICATION": "Date of certification",
      "AVERAGE_CERTIFICATION_SCORE": "Average certification score",
      "TOTAL_TIME_CERTIFYING": "Total time certifying",
      "OF_THE_TIME": "of the time",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Average sessions active user",
      "HOURS_IN_SIMULATIONS": "Hours in simulations",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Average sessions to proficiency",
      "PERCENT_PROFICIENT": "Percent proficient",
      "SYSTEM_RUNNING_NORMALLY": "System is currently running normally",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "SIMULATION_NAME": "Simulation name",
      "AVERAGE_DURATION_OF_SESSION": "Average duration of session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Average sessions per active user",
      "NO_USERS_MATCHING_FILTERS_LABEL": "No results match your filters. Try clearing one or more filters to broaden the search.",
      "USERS_PASSED": "Users who have passed the simulation",
      "AVERAGE_TIME": "Average time to certify",
      "USERS_OUT_OF_ATTEMPTS": "Users out of attempts",
      "NO_CERTIFICATION_SIMULATION": "No certification simulations found",
      "AVERAGE_OVERALL_SCORE": "Average overall score",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "No Sessions",
      "PERCENT_CERTIFIED": "Percent certified",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percent certified on the 1st attempt",
      "USERS": "Users",
      "ATTEMPTS_LABEL": "Attempts",
      "NO_ATTEMPTS": "No attempts",
      "DATE_OF_SESSION": "Date of session",
      "TOTAL_ASSIGNMENTS": "Total assignments",
      "ASSIGNMENTS_CERTIFIED": "Assignments certified",
      "TOTAL_SESSIONS": "Total sessions",
      "HOURS_SPENT_PRACTICING": "Hours spent practicing",
      "LAST_LOGIN": "Last login",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "No assignments match the chosen filters",
      "NO_TEAMS_DATA": "There are no teams within this account",
      "ASSIGNED_LABEL": "Not started",
      "USERS_ASSIGNED_LABEL": "Total assigned users",
      "SESSION_ID": "Session ID",
      "USER_NAME_LABEL": "User name",
      "NO_SIMULATIONS_FOUND_LABEL": "No Simulations Found",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "of",
      "SECOND": "second",
      "SECONDS": "seconds",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNMENT_NAME_LABEL": "Assignment Name",
      "SIMULATION_NAME_LABEL": "Simulation Name",
      "START_DATE": "Start Date",
      "END_DATE": "End Date",
      "NO_ASSIGNMENTS": "No assignment found for this user.",
      "ASSIGNED": "Assigned",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total practice assignments",
      "SESSION_SCORES_OVER_TIME": "Session scores over time",
      "TIME": "Time",
      "SCORE": "Score",
      "NO_SESSIONS_AVAILABLE": "No sessions available to graph.",
      "MESSAGING_SCORE_LABEL": "Messaging score",
      "PERSONALIZED_PRACTICE_LABEL": "Personalized practice",
      "NO_PRODUCTS": "No personalized practice products for the selected teams",
      "TOTAL_TIME_SPENT_PRACTICING": "Total time spent practicing",
      "AVERAGE_SESSIONS_PER_USER": "Average sessions per user",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Most common conversation type selection",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Least common conversation type selection",
      "CLEAR": "Clear",
      "CLEAR_TEAMS": "Clear teams",
      "METHODOLOGY_SCORE_DESCRIPTION": "Measures how well learners follow the recommended call structure. Scores reflect the average across all sessions of this simulation.",
      "METHODOLOGY": "Methodology",
      "MESSAGING": "Messaging",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Measures whether learners articulate key ideas during the call. Charts show the average percentage of messages correctly articulated per theme, across all sessions.",
      "NO_METRICS_MESSAGE": "More sessions needed to generate insights.",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "SKILLS": "Skills",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Measures how well learners demonstrate key skills during the call. Scores reflect an AI assessment averaged across all sessions.",
      "EXPERT": "Expert",
      "PROFICIENT": "Proficient",
      "DEVELOPING": "Developing",
      "FULLY_ARTICULATED": "Fully articulated",
      "PARTIALLY_ARTICULATED": "Partially articulated",
      "NOT_MENTIONED": "Not mentioned",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Measures whether learners articulate key ideas during the call. Charts show how often each message was correctly articulated, across all sessions.",
      "CLEAR_STATUS": "Clear status",
      "CLEAR_USERS": "Clear users",
      "CLEAR_SIMULATIONS": "Clear simulations",
      "CLEAR_ASSIGNMENTS": "Clear assignments",
      "MODAL_SUBHEADING": "All {{ count }} objectives — average scores across all sessions",
      "VIEW_ALL_OBJECTIVES": "View all {{ count }} objectives →"
    },
    "reporting": {
      "AT_GLANCE": "Assignments at a glance",
      "OPEN_ASSIGNMENTS": "Open Assignments",
      "NOT_STARTED": "Not Started",
      "CERTIFIED": "Certified",
      "VIEW_LIST": "View List",
      "CERTIFICATION_ASSIGNMENTS": "Certification Assignments",
      "CERTIFICATION_SUMMARY_TEXT": "Certifications are assignments that have a specific due date and criteria to pass",
      "PRACTICE_ASSIGNMENTS": "Practice Assignments",
      "PRACTICE_SUMMARY_TEXT": "Practice Assignments are available to users without a specific due date. They are designed to enable users to practice regularly to improve their skills",
      "THE": "The",
      "WILL_CLOSE": "will close in",
      "USERS_HAVE": "users have",
      "USER_HAS": "user has",
      "NOT_STARTED_ASSIGNMENT_DUE": "not started an assignment due within the next week",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "not completed an assignment due within the next week",
      "DAYS": "days",
      "DAY": "day",
      "MODULES": "Modules",
      "MODULE": "Module",
      "CALL": "Simulation",
      "CALLS": "Simulations",
      "CERTIFICATION_ASSIGNMENT": "Certification Assignment",
      "PRACTICE_ASSIGNMENT": "Practice Assignment",
      "AND": "and",
      "VIEW_ENGAGEMENT_DETAILS": "View Engagement Details",
      "SEE_ALL": "See All",
      "SEE_LESS": "See Less",
      "ASSIGNMENT": "Assignment",
      "ASSIGNED": "Assigned",
      "IN_PROGRESS": "In Progress",
      "DUE_DATE": "Due Date",
      "ASSIGNMENT_ENDS_IN": "Assignment ends in",
      "ASSIGNMENT_CLOSED": "Assignment Closed",
      "OLDER_CERTIFICATION": "older certification",
      "ASSIGNMENT_IS": "assignment is",
      "ASSIGNMENT_ARE": "assignments are",
      "CURRENTLY_HIDDEN": "currently hidden",
      "ALL_CERTIFICATION_ASSIGNMENTS": "All certification assignments are being shown.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Users who have not yet completed and received a score for any simulations.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Users who have completed at least one simulation and received a score.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Users who have met the certification requirement.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "This is the number of users who are able to access the assignment for their certifications.",
      "SEE_CERTIFICATION_ASSIGNMENT": "See all certification assignments",
      "HIDE_OLDER_ASSIGNMENTS": "Hide older assignments",
      "AVG_PRACTICES": "Avg Practices",
      "PRACTICED": "Practiced",
      "SCORED_HIGH": "Scored High",
      "AVG_ASSIGNMENT": "Avg Improvement",
      "DAYS_AGO": "days ago",
      "NA": "N/A",
      "OLDER_PRACTICE": "older practice",
      "SEE_PRACTICE_ASSIGNMENT": "See all practice assignments",
      "ALL_PRACTICE_ASSIGNMENTS": "All practice assignments are being shown.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Users who have not yet completed and received a score for any simulation.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "These users have finished at least one simulation and received a score.",
      "PRACTICE_CERTIFIED_TOOLTIP": "The number of users in this assignment that have scored at or above the defined high score criteria at least once on all simulations in this assignment.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "These users are able to access the assignment to practice.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "This number shows the average number of times users have practiced simulations that are a part of this assignment.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "This metric analyzes the scores from each session and draws a straight line on a graph to illustrate the trend. A higher percentage indicates that scores are improving faster, a lower percentage indicates the scores are improving more slowly.",
      "USERS": "users",
      "USER": "user",
      "DOWNLOAD_CSV": "Download CSV",
      "ERROR": "An error occurred",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "ATTEMPTS": "Attempts",
      "EMAIL": "Email",
      "LAST_LOGIN": "Last Login",
      "ASSIGNMENT_NOT_STARTED": "Assignment Not Started",
      "ASSIGNMENT_IN_PROGRESS": "Assignment In Progress",
      "SCORE_CRITERIA_MET": "Score Criteria Met",
      "NEVER_LOGGED_IN": "Not logged in",
      "QUANTIFIED_REPORTING": "Quantified Reporting",
      "ASSIGNED_USERS": "Assigned Users",
      "COMPLETION_REQUIREMENT": "Completion Requirement",
      "AVG_SCORE_Of": "Avg. Score of",
      "REPORTING": "Reporting",
      "CERTIFICATIONS": "Certifications",
      "PRACTICES": "Practices",
      "CALL_ANALYSIS": "Simulation Analysis",
      "PERCENT_CERTIFIED_ON": "Percent Certified on",
      "SHOWING": "Showing",
      "PRACTICE_SESSIONS": "Cumulative practice sessions across all simulations in module",
      "AVG_PRACTICE_HEADING": "Average number of practice sessions per active user",
      "AVG_SCORE_LABEL": "Avg. Score",
      "AVG_SCORE_HEADING": "Average score per user",
      "AVG_PRACTICES_LABEL": "Avg. Practices",
      "EXPORT_LEARNER_LIST": "Export Learner List",
      "PERCENT_NOT_STARTED": "% Not started",
      "PERCENT_IN_PROGRESS": "% In progress",
      "PERCENT_CERTIFIED": "% Certified",
      "USER_CERTIFIED": "User certified",
      "USERS_CERTIFIED": "Users certified",
      "TOTAL_ATTEMPTS": "Total Attempts",
      "Avg_ATTEMPTS_CERTIFY": "Avg. attempts to certify",
      "ASTERICK_GROUP": "Denotes a group that contains one or more sub-group",
      "NO_DATA_FOUND": "No data found",
      "MODULE_HIGHLIGHTS": "Module Highlights",
      "MODULE_HIGHLIGHT_SUMMARY": "Key metrics across all simulations. For detailed analysis of each simulation, see the overview below",
      "HIGHEST_SCORING_QUESTION_TITLE": "HIGHEST SCORING QUESTION",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Highest Scoring Question",
      "QUESTION_BAR_MSG": "Average % of answer points answered correctly",
      "LOWEST_SCORING_QUESTION_TITLE": "LOWEST SCORING QUESTION",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Lowest Scoring Question",
      "TOP_SCORED_ANSWER_POINT_TITLE": "TOP SCORED ANSWER POINT",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Least Missed Answer Point Question",
      "SCORE_BAR_MSG": "of the time, users get this right.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "LEAST SCORED ANSWER POINT",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Most Missed Answer Point Question",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "LOWEST SCORING METHODOLOGY",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Lowest Scoring Methodology",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "HIGHEST SCORING METHODOLOGY",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Highest Scoring Methodology",
      "OBJECTIVE_BAR_MSG": "avg. points on this methodology",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "LEAST ARTICULATED MESSAGE",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Least Articulated Message",
      "LEAST_ARTICULATED_BAR_MSG": "Articulate this message",
      "MOST_ARTICULATED_MESSAGE_TITLE": "MOST ARTICULATED MESSAGE",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Most Articulated Message",
      "MOST_ARTICULATED_BAR_MSG": "Fully articulate this message",
      "Overview": "Overview",
      "CONSISTS_Of": "consists of",
      "CALL_OVERVIEW_LABEL": "Chart shows number of users that have",
      "PASSED": "Passed",
      "ATTEMPTED": "Attempted",
      "NOT_ATTEMPTED": "Not Attempted",
      "GUIDED_CALL": "Knowledge Check",
      "QUESTIONS": "Questions",
      "QUESTION": "Question",
      "CONVERSATIONAL_CALL": "Role Play",
      "AVG_ATTEMPTS": "Avg. Attempts",
      "USERS_PASSED": "users passed",
      "DETAILED_ANALYSIS": "Detailed Analysis",
      "CALL_DETAILS": "Simulation Details",
      "CALL_TYPE": "Simulation Type",
      "TOTAL_SESSIONS": "Total Sessions",
      "WHAT_WE_MEASURED": "What we measured",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Average Overall Score",
      "OVERALL_SCORE_DETAIL": "Our system provides an \"Overall Score\" for each conversation. This number is the average Overall Score across the",
      "CALL_RUN": "users have completed this simulation",
      "TIME": "time",
      "TIMES": "times",
      "OBJECTIVES": "Methodology",
      "AVG_OBJECTIVE": "Average methodology scores across all",
      "OF_THIS_CALL": "of this simulation",
      "MESSAGE_ADHERENCE": "Message Adherence",
      "MESSAGE_ADHERENCE_DETAILS_1": "Message Adherence measures whether learners articulate",
      "MESSAGE_ADHERENCE_DETAILS_2": "important ideas during this simulation. These visualizations show the percentage of messages in a given message theme users articulated, on average, across all",
      "IMPORTANT_IDEAS": "important ideas during this simulation",
      "PERCENT_MESSAGE_ARTICULATED": "These visualizations show the percentage of time each message is articulated across all",
      "FULLY_ARTICULATED": "Fully Articulated",
      "PARTIALLY_ARTICULATED": "Partially Articulated",
      "NOT_MENTIONED": "Not Mentioned",
      "SKILLS_LABEL": "Skills",
      "SKILLS_DETAILS": "Skills scores are an AI assessment of skills demonstrated by users during a simulation. These visualizations show the percentage of times users earned \"Expert,\" (Highest), \"Proficient,\" and \"Developing\" (lowest) scores across all",
      "DEVELOPING": "Developing",
      "PROFICIENT": "Proficient",
      "Expert": "Expert",
      "NO_RESULT": "No Results Yet",
      "NO_RESULT_TEXT": "None of the users in your organization have attempted this simulation yet. Once they do, you'll be able to see their results here!",
      "CONVERSATIONAL_CALL_TOOLTIP": "During role plays, the user can direct the flow of the conversation and the AI will respond accordingly. Role plays are less structured than \"Knowledge Checks\", which have a strict question-answer format",
      "TOTAL_SESSION_TOOLTIP": "The total number of times this simulation has been completed across all of the users that it has been assigned to",
      "AVERAGE_SCORE_LABEL": "Average Score",
      "AVERAGE_SCORE_DETAIL": "The average score of all users on this simulation",
      "ANSWER_POINTS": "Answer Points",
      "DETAILS": "Details",
      "CONVERSATIONAL_CALL_MSG": "Content reports for role plays are coming soon",
      "ALL_CALL_DETAILS": "All Simulation Details",
      "QUESTION_TEXT_LABEL": "Question Text",
      "AVG_POINTS_LABEL": "Average Points",
      "SHOW_ALL": "Show All",
      "CORRECT_ANSWER": "correct answers out of",
      "OBJECTIVE_MEASURED_ON": "This methodology is measured on",
      "CALLS_IN_MODULE": "simulations in this module",
      "VIEW_CALL_DETAILS": "View Details",
      "QUESTION_UPDATED": "This question has been updated",
      "QUESTION_UPDATED_MESSAGE": "We're not able to show detailed Answer Point information because updates have been made to this question. The \"Average Points\" displayed represent the average of all sessions of this question (including before and after the updates)",
      "CLOSE_ALT": "Close",
      "Q_LABEL": "Q",
      "SCORING_LABEL": "Scoring",
      "AVERAGE_ANSWER": "Average answer points scored per question",
      "MINIMIZE_LABEL": "Minimize",
      "VIEW_ALL_LABEL": "View All",
      "DOWN_ARROW": "Down Arrow",
      "NOTIFICATION": "Notification",
      "PROGRESS_ICON": "Progress Icon",
      "VIEW_MODAL": "View Modal",
      "VIEW_INFO": "View Info",
      "TOTAL_LABEL": "Total",
      "EXPAND_GROUP": "Expand Group",
      "MESSAGE_ADHERENCE_V2": "Message Adherence",
      "SCORE_OVERALL": "Overall Score",
      "SCORE_SKILLS": "Skills",
      "SCORE_CUSTOMIZED": "Methodology",
      "SESSIONS": "sessions",
      "SESSION": "session"
    },
    "personalizedPractice": {
      "TITLE": "Personalized Practice",
      "DESCRIPTION": "Hi {{userFirstName}}! Personalized practices allow you to set your own scenarios so they are as realistic as possible.",
      "LOADING": "Loading...",
      "VIEW_SESSIONS": "View sessions",
      "VIEW_SIMULATION": "View simulation",
      "TOTAL_SESSION": "total session",
      "TOTAL_SESSIONS": "total sessions",
      "BREADCRUMB": "Personalized practice",
      "SCENARIO_DETAILS_TITLE": "Scenario details",
      "SCENARIO_DETAILS_DESCRIPTION": "Select variables from the options below to adjust the simulation to fit your needs.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Select",
      "CONVERSATION_TYPE": "Conversation type",
      "SELECT_CONVERSATION_TYPE": "Select conversation type",
      "LAUNCH_SIMULATION": "Launch simulation with selections",
      "PREVIOUS_SESSIONS": "Previous sessions",
      "TOTAL": "Total",
      "FILTERS": "Filters:",
      "DATE": "Date",
      "DIFFICULTY": "Difficulty",
      "TEMPERAMENT": "Temperament",
      "SESSION_DATE": "Session date",
      "SESSION_SCORE": "Session score",
      "DURATION": "Duration",
      "OVERALL_SCORE": "Overall score",
      "MESSAGING": "Messaging",
      "METHODOLOGY": "Methodology",
      "SKILLS": "Skills",
      "RESULTS": "Results",
      "VIEW_FEEDBACK": "View feedback",
      "OVERALL_SCORE_LABEL": "Overall Score",
      "SCORE": "Score",
      "NO_PRODUCTS_TITLE": "No products available",
      "NO_PRODUCTS_DESCRIPTION": "You don't have any personalized practice products yet.",
      "NO_SESSIONS_FOUND": "No sessions found with the selected filters",
      "TIME": "Time",
      "ALL": "All",
      "LEARNER": "Learner",
      "MOOD": "Mood",
      "CLEAR_FILTERS": "Clear filters"
    },
    "login": {
      "TITLE": "Welcome back",
      "SUB_TITLE": "How would you like to log in?  ",
      "LOGIN_WITH_SSO": "Log in with company SSO",
      "LOGIN_WITH_PASSWORD": "Log in with password",
      "PROVIDE_EMAIL": "Provide your email address",
      "HELP_TEXT": "Need help? Contact",
      "EMAIL_ERROR": "We are unable to log you in, please contact your company admin or IT department.",
      "EMAIL": "Email",
      "LOGIN": "Log in",
      "ALERT": "Alert",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "By logging into your account you agree to the {{termsLink}} and {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Terms of Service",
      "PRIVACY_POLICY": "Privacy Policy",
      "WRONG_REGION_MESSAGE": "We're unable to log you in, please contact your company admin.",
      "WRONG_REGION_LINK": "You may also try logging into the {{regionName}} site."
    },
    "learningPathway": {
      "BEGIN": "Begin",
      "SUBMIT_ANSWER": "Submit Answer",
      "CONTINUE": "Continue",
      "REVIEW_MATERIAL": "Review material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Ask questions about the pathway",
      "DUE_DATE": "Due Date",
      "FOOTER_SUBTITLE_READY": "Ask me anything! I'm ready to help.",
      "FOOTER_SUBTITLE_MUTED": "You are currently muted. The coach cannot hear you.",
      "FOOTER_SUBTITLE_LISTENING": "Listening to your question...",
      "FOOTER_SUBTITLE_THINKING": "Thinking of a response...",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Click the button on the right →",
      "LEAVE_STEP": "Leave Step",
      "VIEW_CALL_DETAILS": "View call details",
      "NEXT_STEP": "Next Step",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_LOADING": "Loading PDF",
      "PDF_NEXT_PAGE": "Next page",
      "PDF_NO_SOURCE": "No PDF source provided.",
      "PDF_PREVIOUS_PAGE": "Previous page",
      "PDF_SCROLL_HINT": "Scroll to continue reading",
      "POST_CALL_SUBTITLE": "Leave some feedback while we process your results",
      "POST_CALL_TITLE": "You have reached the end of this quiz.",
      "SETTINGS": "Settings",
      "TOAST_CONTENT": "Click below to view, or return to the pathway details screen for your next step.",
      "TOAST_TITLE": "Your role-play results have been processed",
      "ASSIGNMENTS": "Assignments",
      "USER_FALLBACK": "User",
      "VIEW_RESULTS": "View results",
      "QUIZ_TITLE": "Quiz",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "The overall score is the weighted average of your answers for this attempt.",
      "QUIZ_COLUMN_DATE": "Date",
      "QUIZ_COLUMN_OVERALL_SCORE": "Overall Score",
      "QUIZ_COLUMN_ANSWER_POINTS": "Answer points",
      "QUIZ_COLUMN_RESULTS": "Results",
      "COMPLETE_STEP": "Complete",
      "ERROR_TITLE": "Something went wrong",
      "ERROR_MESSAGE": "Please exit and re-enter the pathway. If the problem persists, reach out to",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "You have completed this pathway",
      "PATHWAY_COMPLETED_BODY": "You can review your results at any time, or revisit any step to keep practicing.",
      "PATHWAY_COMPLETED_RETURN": "Return to assignments",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "You are out of attempts for a step on the pathway",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Reach out to your manager to discuss next steps.",
      "COMPLETED": "Completed",
      "EXITING_QUIZ_EARLY": "Exiting this quiz now will count as an attempt",
      "TRY_AGAIN": "Try Again",
      "RETURN_TO_PATHWAY": "Return to pathway home",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Review this step before reattempting the quiz"
    },
    "leaderboard": {
      "LEADERBOARD": "Leaderboard",
      "TOP10PERCENT": "Top 10%",
      "PRACTICE_ASSIGNMENT": "Practice Assignments",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Select assignment",
      "SELECT_SIMULATION": "Select simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Select an assignment and simulation to see the leaders",
      "NO_DATA": "No activity yet. Once the team starts engaging, you’ll see rankings appear here.",
      "NO_ASSIGNMENTS_AVAILABLE": "No Assignments available",
      "NO_SIMULATIONS_AVAILABLE": "No Simulations available",
      "NAME": "Name",
      "HIGH_SCORE": "High score",
      "AVERAGE_SCORE": "Average score",
      "TOTAL_SESSIONS": "Total sessions",
      "LAST_SESSION": "Last session",
      "TOP5": "Top 5",
      "OF": "of",
      "ENGAGED_USERS": "engaged users",
      "ENGAGED_USER": "engaged user",
      "NO_USERS_ENGAGED": "No users engaged",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Hide sessions with low skills scores",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Sessions with a skills section score of \"developing\" will not contribute to the high or average score columns."
    },
    "general": {
      "NEED_HELP_QUESTION": "Need help?",
      "CONTACT": "Contact",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Parent Account",
      "ACCOUNT": "Account",
      "CHECKMARK": "Checkmark",
      "ICON": "Icon",
      "ALERT": "alert",
      "HEADS_UP": "Heads up!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "For optimal audio on iPad, please use headphones.",
      "SETTINGS": "SETTINGS",
      "RP": "RP",
      "EMAIL_LABEL": "Email",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Team Manager for",
      "MIAMI_SALE": "Miami Sale",
      "CHARLOTTE_SALES": "Charlotte Sales",
      "ATLANTA_SALES": "Atlanta Sales",
      "TEAM": "Team",
      "ASSIGNMENTS": "Assignments",
      "MY_TEAMS": "My Teams",
      "REPORTING": "Reporting",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Leaderboard",
      "PERSONALIZED_PRACTICE": "Personalized Practice",
      "HELP_SEARCH_OUR": "Search our",
      "HELP_OR_REACH_OUT_TO": "or reach out to",
      "HELP_WITH_QUESTIONS": "with questions",
      "KNOWLEDGE_BASE": "knowledge base"
    },
    "dashboard": {
      "ALL": "All",
      "IN_COMPLETE": "Incomplete",
      "COMPLETED": "Completed",
      "NO_ASSIGNMENT_TITLE": "You do not have any assignments.",
      "NO_ASSIGNMENT_DETAILS": "You will be notified when you have assignments to complete.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "You have no incomplete assignments.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "You will be notified when a new assignment is due.",
      "COMPLETED_ASSIGNMENT_TITLE": "You have no completed assignments.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Check back once you have completed an assignment.",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No assignments found.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Try adjusting your filters to see available assignments, or check back later when new assignments are added.",
      "VIEW_ASSIGNMENT": "View Assignment",
      "VIEW_PATHWAY": "View pathway",
      "GET_STARTED": "Get started",
      "ASSIGNMENT_LABEL": "Assignments",
      "MODULE_ASSIGNMENT_ALT": "Module Assignment Icon",
      "VIEW_ASSIGNMENT_FOR": "View assignment for",
      "DAY": "Day",
      "UNTILL_DUE": "Until Due",
      "PAST_DUE": "Past Due",
      "AVAILABLE_IN": "Available in",
      "DUE_TODAY": "Due Today",
      "PRACTICE": "Practice",
      "CERTIFICATION": "Certification",
      "UPCOMING": "Upcoming",
      "TEST_ASSIGNMENT": "Test Assignment",
      "CLOSED": "Closed",
      "TOTAL": "Total",
      "ASSIGNMENT_STATUS_LABEL": "Assignment status",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Assignment status:",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Assignment type",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Assignment type:",
      "NOT_STARTED": "Not Started",
      "CERTIFIED": "Certified",
      "NOT_CERTIFIED": "Not Certified",
      "IN_PROGRESS": "In Progress",
      "PATHWAY": "Learning Pathway",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "CLEAR_STATUS": "Clear status"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Welcome to Quantified!",
      "INVITATION_MESSAGE": "We're excited to have you on board! To get started, please follow the steps below to log in to your account for the first time.",
      "ACCOUNT_DETAILS": "Your account details:",
      "USERNAME": "Username",
      "PASSWORD": "Temporary password",
      "STEPS_LABEL": "Next steps to log in",
      "STEP_1": "1. Click the “Log In” button below to go to the login page.",
      "STEP_2": "2. Enter your username and temporary password provided above.",
      "STEP_3": "3. Once logged in, you’ll be prompted to set a new password.",
      "LOGIN_BUTTON": "Log In",
      "ABOUT_US": "Quantified’s Simulator is a virtual environment designed to help you quickly build essential skills, enabling you to connect and communicate more effectively with customers.",
      "EXPIRY_TIME": "This temporary password will expire in 24 hours. If you experience any issues logging in, please contact our support team at",
      "TEAM": "The Quantified Team",
      "INVITATION_SMS_USERNAME": "Your username is",
      "INVITATION_SMS_PASSWORD": "and temporary password is",
      "AUTHENTICATION_CODE": "Your authentication code is",
      "PASSWORD_RESET_CODE": "Your Quantified Password Reset Code",
      "RESET_PASSWORD_EMAIL": "Reset Password Email",
      "HELLO": "Hello",
      "USE_VERIFICATION_CODE": "You requested a password reset. Please use the verification code below to complete the process.",
      "VERIFICATION_CODE": "Verification code",
      "NEXT_STEP": "Next steps",
      "RETURN_TO_PATHWAY": "Return to pathway home",
      "RESET_PASSWORD_PAGE": "Return to your password reset page in your browser.",
      "ENTER_VERIFICATION_CODE": "Enter the verification code when prompted.",
      "CREATE_PASSWORD": "Once the code is verified, follow the instructions to create a new password.",
      "DISREGARD_NOTE": "If you didn’t request a password reset, please disregard this email.",
      "CONTACT_SUPPORT": "For further assistance, reach out to our support team at",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Thank you",
      "QUANTIFIED_TEAM": "The Quantified Team",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, United States"
    },
    "call": {
      "LOADING": "Loading",
      "SIMULATION_PAUSED": "The simulation has been paused.",
      "CLICK_RESUME": "Click the 'Resume' button below to continue.",
      "NO_INTERNET": "No internet connection",
      "TRY_AGAIN": "Please check your connection and try again.",
      "MIC_MUTED": "Mic is muted",
      "MIC_MUTED_DESCRIPTION": "Oops, looks like your mic is muted. Unmute to respond and continue.",
      "NO_RESPONSE": "No Response Detected",
      "MIC_NOT_CONNECTED": "Oops, looks like your mic isn't connected. Reselect your device to respond and continue.",
      "AUDIO_ISSUE": "Oops, something went wrong. Check your device settings and ensure you are in a quiet place free of background noise.",
      "LOADING_ALT": "Loading...",
      "REPEAT_RESPONSE": "You'll automatically be sent back to the simulation to repeat your response and try again.",
      "NEEDS_MORE_TIME_QUESTION": "needs more time to think, do you want to wait?",
      "NEEDS_MORE_TIME": "needs more time to think.",
      "WAIT_OR_END_CALL": "We will let you know when they're ready, or you can end the call and",
      "RETURN_TO_ASSIGNMENTS": "Return to Assignment",
      "READY": "Ready",
      "IS_READY": "is ready to continue your conversation.",
      "TRY_AGAIN_LABEL": "Try Again",
      "CHECK_SETTINGS": "Check Settings",
      "PAUSED_SIMULATION": "You've paused this simulation.",
      "PAUSED_SIMULATION_DESCRIPTION": "Video and audio recording are paused until the simulation is resumed.",
      "RESUME": "Resume",
      "SETTINGS": "Settings",
      "CAPTURING_RESPONSE": "Capturing Your Responses",
      "TOUR_MESSAGE": "Once you finish speaking, be sure to click the Continue button to ensure your responses are captured and scored.",
      "NEXT": "Next",
      "START_CALL": "Start",
      "END_CALL_TITLE": "Are you sure you want to end this simulation?",
      "END_CALL_DESCRIPTION": "If you end the simulation now you will not receive a score or feedback on your conversation.",
      "END_CALL": "End",
      "BROWSER_ACCESS_DENIED": "Your browser is denied access to this device.",
      "COPY_SESSION_ID_BUTTON": "Copy session ID",
      "TIPS_GUIDANCE_MESSAGE": "Talking points and tips will appear here.",
      "CONTINUE": "Continue",
      "SESSION_ID_LABEL": "Session ID:",
      "SESSION_ID_COPIED": "Session ID copied!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Hints & Suggestions",
      "HINT_LABEL": "Hint",
      "CAPTIONS_LABEL": "Captions",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "party emoji",
      "CALL_ENDED_MESSAGE": "You've reached the end of this simulation.",
      "CALL_ENDED_INACTIVITY": "This simulation has ended due to inactivity",
      "CALL_ENDED_GENERIC": "This simulation has ended",
      "FEEDBACK_PROMPT": "Leave some feedback while we process your results.",
      "INTERACTION_THRESHOLD_NOT_MET": "You did not meet our interaction threshold for scoring, please try again.",
      "REALISTIC_CONVERSATION_QUESTION": "Did this conversation feel realistic and natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Do you feel more knowledgeable and prepared after this simulation?",
      "FEEDBACK_THANK_YOU": "Thank you for your feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Thank you for your feedback! We will work on improving the experience.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "Visual Aid could not be loaded",
      "BEGIN_CALL": "Start",
      "LEAVE_STEP_TITLE": "Are you sure you want to leave this step?",
      "EXIT": "Exit",
      "LEAVE_CALL_BRIEFING": "Leave Briefing",
      "RESTORE_CALL": "Restoring your simulation",
      "FEW_SECONDS": "This may take a few seconds.",
      "CHECK_ALT": "Check",
      "COPY_ALT": "Copy",
      "HINTS_ALT": "Hints",
      "CLOSE_CAPTIONS": "Close Captions",
      "MICROPHONE_MUTED": "Microphone Muted",
      "RETURN_TO_CALL": "Return to Simulation",
      "YES": "Yes",
      "NO": "No",
      "VIEW_RESULTS": "View Results",
      "RETURN_TO_ASSIGNMENT": "Return to Assignment",
      "HAVING_ISSUES": "We're having trouble connecting, please check your internet connection, then click OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Sorry, we're unable to generate results at this time, please try again.",
      "INACTIVITY_ALERT_MESSAGE": "This call is being ended due to inactivity. Speak to the avatar to continue or select 'End Call' to end the call.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "This call will end in {{secondsUntilHangup}} seconds",
      "INACTIVITY_SHORT_ALERT_TITLE": "This call will end in a few seconds",
      "TELL_YOUR_GENDER_HEADING": "Please tell us your gender:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "By knowing your gender, the avatar can use proper grammar, making the conversation more natural and realistic.",
      "GENDER_SELECTION": "Gender selection:",
      "SELECT_OPTION": "Select an option",
      "CONFIRM": "Confirm",
      "MALE": "Male",
      "FEMALE": "Female",
      "NON_BINARY": "Non-binary/Other",
      "PREFER_NOT_TO_ANSWER": "Prefer not to answer",
      "NON_BINARY_MESSAGE": "We understand and respect your non-binary gender identity. Due to current technological limitations, we default to using masculine pronouns. Please know that we are working on improvements to better accommodate all gender identities in the future. Thank you for your understanding and patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "We respect your choice not to provide a gender. In such cases, our technology defaults to using masculine pronouns due to current limitations.",
      "DISPLAY_VISUAL_AID": "Display Visual Aid",
      "FULL_SCREEN": "Full Screen",
      "COLLAPSE": "Collapse",
      "COMPLETED_CONVERSATION_MESSAGE": "Thank you for completing this conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Leave some feedback while we process your conversation.",
      "ERROR_MESSAGE": "There was an error. Please reach out to",
      "SAVED_CONVERSATION_MESSAGE": "Your conversation has been saved.",
      "RETURN_TO_MY_ASSIGNMENTS": "Return to my assignments",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Return to personalized practice",
      "CERT_ACK_TITLE": "Certification Video Acknowledgement",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accept and begin",
      "CERT_ACK_RESUME_CALL": "Resume call",
      "CERT_ACK_PROCESSING": "Processing...",
      "CERT_ACK_CAMERA_WARNING": "Please enable your camera to proceed with the certification.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Your camera was turned off. Please re-enable your camera to resume the certification.",
      "CERT_ACK_TEXT_1": "To ensure the integrity and fairness of this certification, your camera must remain on throughout the session, and the session will be monitored. This requirement is to confirm compliance with all certification standards.",
      "CERT_ACK_TEXT_2": "By continuing, you acknowledge and agree to these requirements.",
      "CERT_ACK_END_CALL": "End call",
      "LAUNCH_SIMULATION": "Launch simulation",
      "DEBRIEF_LATEST_SESSION": "Debrief latest session"
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "SCORE",
      "MUST_ACHIEVE": "Must achieve a",
      "OR_HIGHER": "or higher",
      "TEST": "Test",
      "OUT_OF_5": "out of 5",
      "LATEST_ATTEMPT": "LATEST ATTEMPT",
      "TOTAL_ATTEMPTS": "total attempts",
      "UNLIMITED": "Unlimited",
      "REMAINING": "Remaining",
      "VIEW_CALL_DETAILS": "View Details",
      "MAX_ATTEMPTS_REACHED": "You have reached the maximum number of attempts",
      "DUE_DATE": "Due Date",
      "DAYS": "Days",
      "DAY": "Day",
      "UNTILL_DUE": "Until Due",
      "PAST_DUE": "Past Due",
      "ONGOING": "Ongoing",
      "SCORE_REQUIREMENT": "Score Requirement",
      "SCORE_REQUIREMENT_DETAIL": "You must achieve a score of",
      "TO_COMPLETE_EACH_CALL": "to complete each required simulation.",
      "CALLS_IN_ASSIGNMENT": "Simulations in Assignment",
      "INCOMPLETE_CALL": "Incomplete",
      "PREVIOUS_RESULTS": "Previous Results",
      "DATE": "Date",
      "RESULTS": "Results",
      "VIEW_PREVIOUS_RESULTS": "View Previous Results",
      "VIEW_FEEDBACK": "View Feedback",
      "LAUNCH_CALL": "Launch",
      "CLOSE_BUTTON": "Close Button",
      "CHECKMARK": "checkmark",
      "CALL": "Call",
      "QUESTION": "Question",
      "COMPLETED": "Completed",
      "IN_PROGRESS": "In progress",
      "NOT_STARTED": "Not started",
      "CERTIFIED": "Certified",
      "GUIDED": "Guided",
      "CONVERSATIONAL": "Conversational",
      "GUIDED_SIMULATION": "Knowledge Check",
      "CONVERSATIONAL_SIMULATION": "Role Play",
      "NO_ATTEMPTS_LEFT": "No attempts left",
      "NO_ATTEMPTS": "No attempts",
      "OVERVIEW": "Overview",
      "ABOUT_THE_AVATAR": "About the Avatar",
      "SCORING_CRITERIA": "Scoring Criteria",
      "SIMULATION_OVERVIEW": "Simulation Overview",
      "ABOUT_THE_PERSONA": "About the Persona",
      "OUTOF_COMPLIANCE": "Out of compliance",
      "CLOSED": "Closed"
    }
  },
  "de": {
    "root": {
      "ADMIN_PORTAL": "ADMIN-PORTAL",
      "SUPPORT": "SUPPORT",
      "U": "U",
      "USER": "Benutzer",
      "LOGOUT": "Abmelden",
      "ADMIN": "Admin",
      "SUPPORT_SMALL": "Support",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MIKROFON",
      "CAMERA": "KAMERA",
      "ACCESS_DENIED": "ZUGANG_VERWEIGERT"
    },
    "teams": {
      "MY_TEAMS": "Meine Teams",
      "COMPLETED": "Abgeschlossen",
      "IN_PROGRESS": "Wird ausgeführt",
      "NOT_STARTED": "Nicht gestartet",
      "ASSIGNMET_MODULE": "Aufgabenmodul",
      "START_DATE": "Startdatum",
      "DUE_DATE": "Fälligkeitsdatum",
      "ASSIGNED_MEMBERS": "Zugewiesene Mitglieder",
      "CALLS_IN_MODULE": "Simulationen im Modul",
      "COMPLETION_REQUIRMENT": "Voraussetzung für den Abschluss",
      "COMPLETE_ALL_CALLS": "Schließen Sie alle Simulationen mit einer Punktzahl von",
      "OR_HIGHER": "oder höher ab",
      "PROGRESS_OVERVIEW": "FORTSCHRITTSÜBERSICHT",
      "TEAM_MEMBERS": "Teammitglieder",
      "AVERAGE_HIGH_SCORE": "Durchschnittlich höchste Punktzahl",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Durchschnittliche Anzahl von Versuchen pro Simulation",
      "TOTAL_PRACTICES": "Übungen insgesamt",
      "INDIVIDUAL_CALL_PROGRESS": "INDIVIDUELLER SIMULATIONSFORTSCHRITT",
      "OF_TEAM_MEMBERS": "der Teammitglieder abgeschlossen",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Durchschnittliche Übungen bis zum Abschluss",
      "TEAM_MEMBER_DETAILS": "INFOS ZUM TEAMMITGLIED",
      "DOWNLOAD_ACTIVITY_REPORT": "Aktivitätsbericht herunterladen",
      "TEAM_MEMBER": "Teammitglied",
      "PROGRESS": "Fortschritt",
      "CALLS_COMPLETED": "Abgeschlossene Simulationen",
      "PRACTICES": "Übungssitzungen",
      "MOST_RECENT_PRACTICE": "Letzte Sitzung",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Dieses Team hat zur Zeit keine aktiven Aufgaben",
      "CALL_NAME_LABEL": "Name der Simulation",
      "HIGHEST_SCORE": "Höchste Punktzahl"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Stellen Sie sicher, dass Ihr Gerät konfiguriert ist.",
      "MICROPHONE_REQUIRED_NOTICE": "Ein funktionierendes Mikrofon ist erforderlich.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Falls nach dem Aktualisieren dieser Seite kein Pop-up zur Gerätefreigabe erschienen ist, öffnen Sie bitte Ihre System- oder Browsereinstellungen und aktivieren Sie die Geräte. Nachstehend finden Sie Support-Seiten mit weiteren Anweisungen.",
      "ENABLE_CAMERA": "So aktivieren Sie Ihre Kamera:",
      "WINDOWS_USERS": "Windows-Benutzer",
      "MAC_USERS": "Mac-Benutzer",
      "IPAD_USERS": "iPad-Benutzer",
      "ENABLE_MICROPHONE": "So aktivieren Sie Ihr Mikrofon:",
      "ENABLE_DEVICES_BY_BROWSER": "Wie Sie Ihre Geräte per Browser aktivieren:",
      "CHROME_USERS": "Chrome-Benutzer",
      "SAFARI_USERS": "Safari-Benutzer",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Ohne Kamera starten",
      "START_CALL_BUTTON": "Anruf starten",
      "MICROPHONE_REQUIRED_WARNING": "Ein funktionierendes Mikrofon ist erforderlich.",
      "MICROPHONE_ALT": "Mikrofon",
      "MICROPHONE": "Mikrofon",
      "SELECT_MICROPHONE": "Wählen Sie Ihr Mikrofon",
      "ALERT": "Alarm",
      "GIVE_PERMISSION": "Erlaubnis erteilen",
      "SELECT_VIDEO_DEVICE": "Wählen Sie Ihr Videogerät",
      "VIDEO": "Video",
      "DEVICE_BLOCKED_ERROR": "Anscheinend wurde diesem Browser der Zugriff auf eines oder mehrere Ihrer Geräte verweigert. Um die Geräte zu aktivieren, gehen Sie bitte in Ihre System- oder Browsereinstellungen und aktivieren Sie den Zugriff.",
      "DEVICE_SETTINGS": "Geräteeinstellungen",
      "CONFIRM_SETTINGS": "Einstellungen bestätigen",
      "LAPTOP": "Laptop",
      "SAD_EMOTE_FACE": "Trauriges Emoji-Gesicht",
      "GRANT_BROWSER_ACCESS": "Um diese Simulation abzuschließen, benötigt der Browser Zugriff auf die Spracherkennung",
      "USING_IPAD": "Wenn Sie ein iPad verwenden, gehen Sie zu",
      "SETTINGS": "Einstellungen",
      "PRIVACY_AND_SECURITY": "Datenschutz und Sicherheit",
      "SPEECH_RECOGNITION": "Spracherkennung",
      "GRANT_ACCESS_REFRESH": "Gewähren Sie dem Browser Zugriff und aktualisieren Sie die Seite",
      "REFRESH_PAGE": "SEITE AKTUALISIEREN",
      "BROWSER_UNABLE_TO_ACCESS": "Der Browser kann nicht auf dieses Gerät zugreifen",
      "ACCESS_DENIED": "Zugriff verweigert",
      "CAMERA": "Kamera",
      "DIAGNOSTIC_PASSED": "Alle Diagnosetests wurden erfolgreich bestanden.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Einige Diagnosetests sind fehlgeschlagen. Bitte klicken Sie oben auf die Schaltfläche „Diagnoseergebnisse kopieren“ und senden Sie die Ergebnisse an das Support-Team, um Unterstützung zu erhalten.",
      "DIAGNOSTIC_PARTIAL": "Die meisten Diagnosetests wurden erfolgreich bestanden. Ihre Verbindung sieht gut aus.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Bitte warten Sie, während die Diagnosetests laufen...",
      "DIAGNOSTIC_RUNNING": "Diagnose läuft",
      "COPY_DIAGNOSTIC_RESULTS": "Kopie der Diagnoseergebnisse",
      "RUN_DIAGNOSTIC": "Diagnose durchführen",
      "RERUN_DIAGNOSTIC": "Diagnose erneut ausführen",
      "DIAGNOSTIC_RESULTS_COPIED": "Diagnoseergebnisse in die Zwischenablage kopiert",
      "DIAGNOSTIC_FAILED": "Diagnose fehlgeschlagen",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified Diagnostik",
      "DIAGNOSTIC_TIME": "Zeit",
      "DIAGNOSTIC_SUMMARY": "Zusammenfassung",
      "DIAGNOSTIC_CLIENT_INFO": "Kundeninformationen",
      "DIAGNOSTIC_PLATFORM": "Plattform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Paketverlust (Senden)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Durchschnittliche Sendebitrate",
      "DIAGNOSTIC_NA": "K.A."
    },
    "results": {
      "RETURN_HOME": "ZURÜCK ZUR STARTSEITE",
      "CLOSE_BUTTON": "Schaltfläche „Schließen“",
      "CONVERSATIONAL_CALL": "ROLLENSPIEL",
      "INFORMATION_ICON": "Informationssymbol",
      "TOOLTIP_ARROW": "Tooltip-Pfeil",
      "INFORMATION_TOOLTIP_CONTENT": "Sie steuern den Simulationsverlauf und lenken das Gespräch auf eine Reihe von Zielen. Rollenspiele sind ideal, um Fertigkeiten wie tiefgehendes Fragenstellen, das Aufdecken von Herausforderungen und das Schaffen einer Gesprächsbasis zu trainieren.",
      "CLOCK_ICON": "Uhr-Symbol",
      "CALL_RESULTS": "Ergebnisse",
      "SKILLS": "Fertigkeiten",
      "MESSAGE_ADHERENCE": "Einhaltung der Gesprächsinhalte",
      "TRY_AGAIN_MESSAGE": "Versuchen Sie es erneut und verbessern Sie Ihr Ergebnis.",
      "PRACTICE_BENEFITS": "Wöchentliches Üben stärkt das Selbstvertrauen und verbessert die Ergebnisse in der Praxis.",
      "CALL_SUCCESS": "Gut gemacht! Sie haben diese Simulation erfolgreich abgeschlossen.",
      "MAX_ATTEMPTS_REACHED": "Sie haben die maximale Anzahl von Versuchen erreicht",
      "TRY_AGAIN": "Erneut versuchen",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Gut gemacht! Sie haben",
      "COMPLETED_THIS_CALL": "diese Simulation erfolgreich abgeschlossen.",
      "ACHIEVED_SCORE": "Sie haben eine Punktzahl von",
      "ACHIEVE_SCORE": "Erreichen Sie eine Punktzahl von",
      "OR_HIGHER": "oder höher erzielt.",
      "OBJECTIVES_NOT_MET": "Sie haben nicht alle erforderlichen Ziele erreicht.",
      "TRY_AGAIN_TARGET_SCORE": "Versuchen Sie es erneut, um folgende Punktzahl zu erreichen:",
      "YOUR_SCORE": "Ihr Ergebnis",
      "OUT_OF_5": "AUS 5",
      "CALL_FEEDBACK": "FEEDBACK-ZUSAMMENFASSUNG",
      "STRENGTH_ICON_ALT": "Stärken-Symbol",
      "OPPORTUNITIES_ICON_ALT": "Chancen-Symbol",
      "OBJECTIVES_FEEDBACK": "FEEDBACK ZUR METHODIK",
      "SESSION_ID": "Sitzungs-ID:",
      "SESSION_ID_COPIED": "Sitzungs-ID kopiert!",
      "OBJECTIVE": "METHODIK:",
      "HOW_YOU_DID": "Ihr Ergebnis:",
      "LIGHTBULB_ICON_ALT": "Glühbirnen-Symbol",
      "WHAT_WE_SUGGEST": "Was wir vorschlagen:",
      "NO_SPECIFIC_RECOMMENDATION": "Unser System konnte keine spezifische Empfehlung für Sie finden.",
      "WHY": "Warum?",
      "NO_INSIGHTS_AVAILABLE": "Unser System konnte keine Erkenntnisse zu diesem Vorschlag liefern.",
      "CONFETTI_ICON_ALT": "Konfetti-Symbol",
      "OBJECTIVE_SUCCESS_MESSAGE": "Ausgezeichnete Leistung bei dieser Methodik – bleiben Sie dran!",
      "PROCESSING_CALL": "Wir bereiten Ihre Punktzahl und Ihr Feedback vor.",
      "HANG_TIGHT": "Bitte warten Sie einen Moment oder rufen Sie die Seite später erneut auf, um",
      "VIEW_YOUR_RESULTS": "Ihre Ergebnisse zu sehen.",
      "NEED_MORE_TIME": "Die Berechnung der Ergebnisse dauert noch an.",
      "REFRESH_INSTRUCTION": "Bitte schauen Sie noch einmal nach oder aktualisieren Sie die Aufgabeergebnisse",
      "RESULTS_IN_FEW_MINUTES": "in wenigen Minuten.",
      "SCORE_CALCULATION_QUESTION": "Wie wird dies berechnet?",
      "SINGLE_SCORE_EXPLANATION": "Da diese Simulation nur eine Bewertungskomponente enthält, entspricht die angezeigte Punktzahl sowohl der Abschnittsbewertung als auch Ihrer Gesamtpunktzahl.",
      "OVERALL_SCORE_PERCENT": "% der Gesamtpunktzahl",
      "SECTION_SCORE": "Ergebnis für diesen Abschnitt",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Optimieren Sie die Einhaltung Ihrer Gesprächsinhalte",
      "MESSAGE_ADHERENCE_NOTE": "Eine konsistente Gesprächsführung ist entscheidend für den Erfolg, beeinflusst jedoch nicht Ihre Gesamtbewertung.",
      "NO_CREDIT": "Nicht angerechnet",
      "PARTIAL_CREDIT": "Teilweise angerechnet",
      "FULL_CREDIT": "Vollständig angerechnet",
      "WHAT_YOU_DID_WELL": "Was Sie gut gemacht haben",
      "MISSED_ALL_KEY_POINTS": "Sie haben alle wichtigen Punkte übersehen; überprüfen Sie sie und versuchen Sie es erneut.",
      "WHAT_TO_IMPROVE": "Was Sie besser machen können",
      "PERFECT_SCORE_MESSAGE": "Herzlichen Glückwunsch! Sie haben ein perfektes Ergebnis erzielt, da Sie alle wichtigen Punkte richtig angesprochen haben.",
      "POINTS_LABEL": "Punkte",
      "TALKING_POINTS_COVERED": "Abgedeckte Gesprächsthemen",
      "CHECKMARK_ICON_ALT": "Häkchen",
      "TALKING_POINTS_MISSED": "Nicht behandelte Gesprächsthemen",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Übung wiederholen",
      "OUT_OF": "von",
      "POSSIBLE_TALKING_POINTS": "möglichen Gesprächsthemen",
      "YOU_COVERED": "Sie haben",
      "THROUGHOUT_CALL": "in der Simulation abgedeckt.",
      "POSITIVE_FEEDBACK_COVERAGE": "Sie haben die wichtigsten Punkte während des gesamten Gesprächs sehr gut herausgestellt und Folgendes abgedeckt:",
      "MIXED_FEEDBACK_COVERAGE": "Sie haben einige der wichtigsten Punkte während der Simulation nicht erwähnt und Folgendes abgedeckt:",
      "OBJECTIVES": "Methodik",
      "ELEVATE_OBJECTIVES_TITLE": "Optimieren Sie Ihre Gesprächsmethodik",
      "OBJECTIVES_NOTE": "Eine konsistente Methodik ist entscheidend für den Erfolg, beeinflusst jedoch nicht Ihre Gesamtbewertung.",
      "UNTIL": "bis",
      "TO_IMPROVE_SCORE": ", um Ihr Ergebnis zu verbessern.",
      "TO_SCORE": ", um zu erzielen",
      "BEFORE": "bevor",
      "YOU_HAVE": "Sie haben",
      "MORE_ATTEMPTS": "weitere Versuche, um",
      "OR_HIGHER_BEFORE": "oder höher zu erzielen, bevor",
      "AND_TRY_AGAIN": "und es erneut zu versuchen.",
      "UNEXPECTED_STATE": "Ein unerwarteter Zustand ist eingetreten.",
      "REVIEW_APP_LOGIC": "Bitte überprüfen Sie die Logik der Anwendung.",
      "ASSIGNMENTS": "Aufgaben",
      "VIEW_CALL_DETAILS": "Anrufdetails anzeigen",
      "PRACTICE_SESSION": "Übungssitzung",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "OVERALL_SCORE_EXPLANATION": "Die Gesamtpunktzahl wird aus dem gewichteten Durchschnitt der Punktzahlen der einzelnen Abschnitte berechnet. Die Gewichtung der einzelnen Abschnitte wird als Prozentsatz neben der Punktzahl angezeigt.",
      "SCORE_CONFIG_NOTE": "Ihr Unternehmen legt fest, welche Abschnitte einbezogen oder ausgeschlossen werden und wie sie gewichtet sind. Alle Punktzahlen werden auf den nächsten Zehntelpunkt gerundet.",
      "STRENGTHS": "Stärken",
      "OPPORTUNITIES": "Chancen",
      "YOUR_RESPONSE": "Ihre Antwort",
      "MINUS": "minus",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Empfohlene Antwort",
      "REVIEW_MISSED_TITLE": "Überprüfen Sie, was Sie verpasst haben.",
      "NO_TALKING_POINTS_COVERED": "Sie haben keines der geforderten Gesprächsthemen für dieses Thema behandelt.",
      "LEARN_WHAT_YOU_MISSED": "Erfahren Sie, was Sie verpasst haben",
      "NICE_JOB": "Gute Arbeit!",
      "ALL_POINTS_COVERED": "Sie haben alle für dieses Thema erforderlichen Gesprächsthemen erfolgreich abgedeckt.",
      "COVER_ALL_MESSAGES": "Behandeln Sie alle Schlüsselaussagen.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Wenn Sie die Schlüsselpunkte im Gespräch betonen, bleibt die Unterhaltung zielgerichtet.",
      "MESSAGES_LABEL": "Nachrichten",
      "NO_FACTS_COVERED": "Hoppla! Sie haben keines der geforderten Gesprächsthemen für diese Nachricht abgedeckt.",
      "NO_SPECIFICS_AVAILABLE": "Hoppla! Es sieht so aus, als könnten wir nicht genau sagen, was gefehlt hat.",
      "ALL_KEY_POINTS_COVERED": "Gut gemacht! Sie haben alle wichtigen Punkte angesprochen.",
      "PROCESSING_SKILLS_FEEDBACK": "Ihr Fertigkeiten-Feedback wird derzeit verarbeitet.",
      "SKILLS_SCORING_NOT_ENABLED": "Wir bedauern, dass Ihr letzter Anruf nicht analysiert werden konnte, da die Funktion zur Bewertung von Fertigkeiten deaktiviert war. Reichen Sie Ihre Gesprächsübung erneut ein, um Feedback zu erhalten – wie beim letzten Mal. Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unser Support-Team. Vielen Dank für Ihr Verständnis und Ihr Engagement für Verbesserungen!",
      "ELEVATE_CONVERSATION_SKILLS": "Optimieren Sie Ihre Konversationsfertigkeiten",
      "SKILLS_NOTE": "Fertigkeiten sind entscheidend für eine erfolgreiche Gesprächsführung, haben aber keinen Einfluss auf die Gesamtpunktzahl.",
      "SKILLS_SUMMARY_TITLE": "ZUSAMMENFASSUNG DER FERTIGKEITEN",
      "LEARN_MORE_ABOUT_SKILLS": "Erfahren Sie mehr über Fertigkeiten",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "Was sind Fertigkeiten?",
      "SKILLS_DESCRIPTION": "Die Fertigkeiten werden so kalibriert, dass sie die Entwicklung der Persönlichkeit unterstützen. Diese Fertigkeiten fließen zwar nicht in die Punktzahl Ihres Gesprächs ein, wurden jedoch von Ihrer Organisation ausgewählt, um Ihre Gesprächsführung zu verbessern",
      "PROFICIENCY_SCALE_TITLE": "KOMPETENZSKALA",
      "EXPERT": "Experte",
      "PROFICIENT": "Fortgeschritten",
      "DEVELOPING": "In Entwicklung",
      "CALL_TRANSCRIPT": "Gesprächsprotokoll",
      "COLLAPSE_ALL": "Alle minimieren",
      "EXPAND_ALL": "Alle erweitern",
      "THUMBNAIL": "Vorschaubild",
      "OUT_OF_FIVE_POINTS": "/5 Punkte",
      "TALKING_POINTS": "Gesprächsthemen",
      "TRANSCRIPT_LABEL": "Abschrift",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Du hast keine Versuche mehr.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Überprüfen Sie die Richtlinien und halten Sie sich auch in Zukunft daran.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Versuchen Sie es erneut und achten Sie auf die Einhaltung der Richtlinien.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Wir haben festgestellt, dass Sie gegen die Vorschriften verstoßen haben, daher wurde keine Bewertung vergeben.",
      "WHY_OUT_OF_COMPLIANCE": "Gründe für die fehlende Regelkonformität",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Überprüfen Sie Ihre Abschrift, um festzustellen, wo Sie die Richtlinien nicht eingehalten haben.",
      "YOU_DID_FOLLOW_GUIDELINES": "Sie haben die Richtlinien erfolgreich umgesetzt.",
      "REVIEW_MISSED_GUIDELINES": "Sehen Sie sich die nicht eingehaltenen Richtlinien an.",
      "OUT_OF_COMPLIANCE": "Nicht konform",
      "SCORE_CALCULATION_TITLE": "Berechnung der Punktzahl",
      "PROCESSING_TRANSCRIPT": "Wir verarbeiten Ihre Abschrift.",
      "WAIT_OR_REVIEW_SCORES": "Bitte warten Sie hier oder sehen Sie sich die anderen Bewertungsabschnitte an,",
      "TRANSCRIPT_LOADING": "während die Abschrift geladen wird.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Überprüfen Sie Ihr Feedback und üben Sie weiter",
      "HIGH_PERFORMERS_PRACTICE": "High Performer üben mindestens einmal pro Woche",
      "SUCCESSFULLY_PASSED": "Gut gemacht! Sie haben diese Simulation erfolgreich bestanden.",
      "DIDNT_REACH_PASSING_SCORE": "Sie haben die erforderliche Punktzahl für diese Simulation nicht erreicht.",
      "OUT_OF_ATTEMPTS": "<b>Sie haben keine Versuche mehr.</b> Prüfen Sie Ihr Feedback, um zu erfahren, wie Sie sich verbessern können.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Prüfen Sie Ihr Feedback und navigieren Sie zur Startseite, wenn Sie fertig sind.",
      "GREAT_JOB_PRACTICED": "Großartige Arbeit – Sie haben {{count}} {{times}} geübt. Weiter so!",
      "TIME": "Mal",
      "TIMES": "Mal",
      "COMPLIANCE_GUIDELINES": "Richtlinien zur Einhaltung",
      "TALKING_POINT_TITLE": "GESPRÄCHSTHEMEN, DIE NICHT ODER ZUR FALSCHEN ZEIT EINGEBRACHT WURDEN",
      "NO_TRANSCRIPT": "Keine Abschrift verfügbar."
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Konten laden...",
      "SELECT_AN_ACCOUNT": "Konto wählen",
      "SEARCH_TEAMS": "Teams suchen",
      "LOADING_TEAMS": "Teams laden...",
      "ALL_TEAMS": "Alle Teams",
      "ACCOUNT": "Konto",
      "TEAMS": "Teams",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Insgesamt",
      "PASSING_SCORE": "Punktzahl zum Bestehen",
      "ASSIGNMENT_LABEL": "Aufgaben",
      "USER_LABEL": "Benutzer",
      "PRACTICE_LABEL": "Übung",
      "CERTIFICATION_LABEL": "Zertifizierung",
      "CERTIFICATION_STATUS_LABEL": "Zertifizierungsstatus",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Zertifizierungsstatus:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Beim ersten Versuch zertifiziert?",
      "DATE_OF_CERTIFICATION_LABEL": "Datum der Zertifizierung",
      "RESULTS_DESCRIPTION": "Hier sind die Ergebnisse Ihres/Ihrer Teams für alle Übungsaufgaben:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Beteiligung nach Aufgabe",
      "ASSIGNMENT_ENGAGEMENT": "Aufgabenbeteiligung",
      "ENGAGED_LABEL": "Beteiligt",
      "ENGAGEMENT_STATUS_LABEL": "Beteiligungsstatus",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Beteiligungsstatus:",
      "PROFICIENT_LABEL": "Fortgeschritten",
      "ASSIGNMENT_NAME": "Name der Aufgabe",
      "ACTIVE_USERS": "Aktive Nutzer",
      "ASSIGNMENT_PROGRESS": "Fortschritt je Aufgabe",
      "IN_PROGRESS_LABEL": "Wird ausgeführt",
      "CERTIFIED_LABEL": "Zertifiziert",
      "OUT_OF_ATTEMPTS_LABEL": "Keine Versuche mehr",
      "USERS_ENGAGED_LABEL": "Beteiligte Nutzer",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sitzungen pro aktivem Nutzer",
      "HIGHER_THAN_LABEL": "Höher als",
      "MORE_THAN_LABEL": "Mehr als",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Abgeschlossene Sitzungen insgesamt",
      "USER_CERTIFIED": "Benutzer für alle Aufgaben zertifiziert",
      "ASSIGNMENT_CERTIFICATION": "Aufgaben mit 100%iger Zertifizierung",
      "TRAINER_TIME_SAVED": "Zeitersparnis für Trainer",
      "HOURS_LABEL": "Stunden",
      "PRACTICE_ASSIGNMENT_LABEL": "Übungsaufgaben",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Zertifizierungsaufgaben",
      "START_DATE_LABEL": "Startdatum",
      "END_DATE_LABEL": "Enddatum",
      "NAME_LABEL": "Name",
      "EMAIL_LABEL": "E-Mail",
      "MEMBER_OF_TEAMS_LABEL": "Teammitglied",
      "ASSIGNMENTS_COUNT_LABEL": "# Anzahl von Aufgaben",
      "TOTAL_SESSIONS_LABEL": "Sitzungen insgesamt",
      "NUMBER_OF_SESSIONS_LABEL": "Anzahl der Sitzungen",
      "TOTAL_USERS_LABEL": "Benutzer insgesamt",
      "AVERAGE_SCORE_LABEL": "Durchschnittliche Punktzahl",
      "INITIAL_SCORE_LABEL": "Anfangspunktzahl",
      "HIGH_SCORE_LABEL": "Höchste Punktzahl",
      "LAST_PRACTICE_DATE_LABEL": "Letzter Übungstermin",
      "PERCENT_IMPROVED_LABEL": "% verbessert",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Diese Metrik analysiert die Ergebnisse der einzelnen Sitzungen und zeigt den Trend als Gerade im Diagramm. Ein höherer Prozentsatz bedeutet, dass sich die Ergebnisse schneller verbessern, ein niedrigerer Prozentsatz, dass sich die Ergebnisse langsamer verbessern.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Zertifizierte Aufgaben",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Erfolgreich absolvierte Aufgaben",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Die Anzahl der Aufgaben, bei denen der Benutzer die Bewertungskriterien für alle Simulationen in der Aufgabe erfüllt oder überschritten hat.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Die Anzahl der Aufgaben, bei denen der Benutzer die Bewertungskriterien bei allen Simulationen in der Aufgabe mindestens einmal erreicht oder überschritten hat.",
      "PROFICIENT_TOOLTIP": "Der Prozentsatz der Benutzer in dieser Aufgabe, die die Bewertungskriterien bei allen Simulationen in dieser Aufgabe mindestens einmal erreicht oder überschritten haben.",
      "IN_PROGRESS_TOOLTIP": "Der Prozentsatz der Benutzer, die mindestens eine Sitzung einer Simulation in dieser Aufgabe abgeschlossen und eine Bewertung erhalten haben.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Der Prozentsatz der Benutzer, die die ihnen zugeteilten Versuche für eine oder mehrere Simulationen in der Aufgabe überschritten haben.",
      "CERTIFIED_TOOLTIP": "Der Prozentsatz der Benutzer, die die Bewertungskriterien für alle Simulationen in der Aufgabe erfüllt oder übertroffen haben.",
      "SEARCH_FOR_A_USER_LABEL": "Suche nach einem Benutzer",
      "NO_USERS_FOUND_LABEL": "Keine Benutzer gefunden",
      "TRAINER_TIME_SAVED_TOOLTIP": "Die Zeit, die Benutzer in Quantified verbracht haben, um Zertifizierungsversuche abzuschließen.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Durchschnittliche Anzahl von Sitzungen pro Aufgabe",
      "ASSIGNMENTS_ENGAGED_WITH": "Aufgaben sind in Bearbeitung",
      "AVERAGE_IMPROVEMENT": "Durchschnittliche Verbesserung",
      "STATUS": "Status",
      "TOTAL_NUMBER_OF_SESSIONS": "Gesamtzahl der Sitzungen",
      "DATE_OF_LAST_PRACTICE": "Datum der letzten Übung",
      "CALL_NAME": "Name des Anrufs",
      "SESSION_DATE": "Datum der Sitzung",
      "DURATION_OF_SESSION": "Dauer der Sitzung",
      "DURATION_OF_ATTEMPT": "Dauer des Versuchs",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "MESSAGING_SCORE": "Punktzahl für die Einhaltung der Gesprächsinhalte",
      "METHODOLOGY_SCORE": "Methodik-Punktzahl",
      "SKILLS_SCORE": "Kompetenzwert",
      "SESSIONS": "Sitzunen",
      "TOTAL": "Insgesamt",
      "ALL_ASSIGNMENTS": "Alle Aufgaben",
      "RECENT_ASSIGNMENTS": "Neueste Aufgaben",
      "USER_NAME": "Benutzername",
      "LEARNER": "Lernende:r",
      "DATE_RANGE": "Datumsbereich",
      "DATE_RANGE_LABEL": "Datumsbereich",
      "SEARCH_USERS": "Benutzer suchen ...",
      "SEARCH_SIMULATIONS": "Simulationen suchen ...",
      "SEARCH_DATES": "Daten suchen ...",
      "CERTIFIED_ON_FIRST_TRY": "Im ersten Anlauf zertifiziert",
      "DATE_OF_CERTIFICATION": "Datum der Zertifizierung",
      "AVERAGE_CERTIFICATION_SCORE": "Durchschnittliche Zertifizierungspunktzahl",
      "TOTAL_TIME_CERTIFYING": "Gesamtdauer der Zertifizierung",
      "OF_THE_TIME": "der Zeit",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Durchschnittliche Sitzungen aktiver Benutzer",
      "HOURS_IN_SIMULATIONS": "Stunden in Simulationen",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Durchschnittliche Anzahl an Sitzungen bis zur Zielerreichung",
      "PERCENT_PROFICIENT": "Prozentsatz der Kompetenz",
      "SYSTEM_RUNNING_NORMALLY": "Das System läuft derzeit normal",
      "PRACTICE_SIMULATIONS_LABEL": "Simulationen",
      "SIMULATION_NAME": "Name der Simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durchschnittliche Dauer der Sitzung",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Durchschnittliche Anzahl von Sitzungen pro aktivem Nutzer",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Keine Ergebnisse entsprechen Ihren Filtern. Versuchen Sie, einen oder mehrere Filter zu deaktivieren, um die Suche zu erweitern.",
      "USERS_PASSED": "Benutzer, die die Simulation bestanden haben",
      "AVERAGE_TIME": "Durchschnittliche Zeit bis zur Zertifizierung",
      "USERS_OUT_OF_ATTEMPTS": "Keine Versuche mehr verfügbar",
      "NO_CERTIFICATION_SIMULATION": "Keine Zertifizierungssimulationen gefunden",
      "AVERAGE_OVERALL_SCORE": "Durchschnittliche Gesamtpunktzahl",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Keine Sitzungen",
      "PERCENT_CERTIFIED": "Prozent zertifiziert",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Prozent zertifiziert beim 1. Versuch",
      "USERS": "Benutzer",
      "ATTEMPTS_LABEL": "Versuche",
      "NO_ATTEMPTS": "Keine Versuche",
      "DATE_OF_SESSION": "Datum der Sitzung",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Keine Aufgaben entsprechen den gewählten Filtern",
      "NO_TEAMS_DATA": "In diesem Konto sind keine Teams vorhanden",
      "ASSIGNED_LABEL": "Nicht gestartet",
      "USERS_ASSIGNED_LABEL": "Zugewiesene Benutzer insgesamt",
      "SESSION_ID": "Sitzungs-ID",
      "NO_SIMULATIONS_FOUND_LABEL": "Keine Simulationen gefunden",
      "USER_NAME_LABEL": "Benutzername",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "von",
      "SECOND": "Sekunde",
      "SECONDS": "Sekunden",
      "MINUTE": "Minute",
      "MINUTES": "Minuten",
      "ASSIGNED": "Zugewiesen",
      "SELECT_ASSIGNMENTS": "Aufgaben wählen",
      "TOTAL_ASSIGNMENTS": "Aufgaben insgesamt",
      "ASSIGNMENTS_CERTIFIED": "Zertifizierte Aufgaben",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "HOURS_SPENT_PRACTICING": "Anzahl der Übungsstunden",
      "LAST_LOGIN": "Letzte Anmeldung",
      "ENGAGED_TOOLTIP": "Der Prozentsatz der Benutzer, die eine oder mehrere Sitzungen einer Simulation in dieser Aufgabe abgeschlossen haben, aber noch nicht in allen Simulationen die erforderliche Kompetenz erreicht haben.",
      "SEARCH_ASSIGNMENTS": "Aufgaben suchen...",
      "ASSIGNMENT_NAME_LABEL": "Name der Aufgabe",
      "SIMULATION_NAME_LABEL": "Name der Simulation",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "NO_ASSIGNMENTS": "Keine Aufgabe für diesen Benutzer gefunden.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Gesamtzahl der Übungsaufgaben",
      "SESSION_SCORES_OVER_TIME": "Sitzungsergebnisse im Zeitverlauf",
      "TIME": "Zeit",
      "SCORE": "Punktzahl",
      "NO_SESSIONS_AVAILABLE": "Keine Sitzungen für die grafische Darstellung verfügbar.",
      "MESSAGING_SCORE_LABEL": "Punktzahl für Gesprächsinhalte",
      "PERSONALIZED_PRACTICE_LABEL": "Personalisierte Übung",
      "ASSIGNMENT_ENAGEMENT": "Beteiligung je Aufgabe",
      "NO_PRODUCTS": "Keine personalisierten Übungsprodukte für die ausgewählten Teams",
      "TOTAL_TIME_SPENT_PRACTICING": "Gesamte Übungszeit",
      "AVERAGE_SESSIONS_PER_USER": "Durchschnittliche Sitzungen pro Benutzer",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Häufigste Auswahl des Gesprächstyps",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Seltenste Auswahl des Gesprächstyps",
      "CLEAR_TEAMS": "Teams löschen",
      "METHODOLOGY_SCORE_DESCRIPTION": "Durchschnittliche objektive Punktzahlen über alle Sitzungen dieses Anrufs hinweg.",
      "METHODOLOGY": "Methodik",
      "MESSAGING": "Messaging",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Messaging misst, ob Lernende 2 wichtige Ideen während dieser Simulation artikulieren. Diese Visualisierungen zeigen die Prozentsätze der Nachrichten, die Benutzer im Durchschnitt in einer bestimmten Nachricht geäußert haben, über alle Sitzungen dieses Anrufs.",
      "NO_METRICS_MESSAGE": "Keine Sitzungen für die ausgewählten Teams abgeschlossen.",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen",
      "SKILLS": "Fertigkeiten",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Bei der Bewertung der Fertigkeiten handelt es sich um eine KI-Bewertung der von den Nutzern bei einem Anruf gezeigten Fertigkeiten.",
      "EXPERT": "Experte",
      "PROFICIENT": "Fortgeschritten",
      "DEVELOPING": "In Entwicklung",
      "FULLY_ARTICULATED": "Vollständig artikuliert",
      "PARTIALLY_ARTICULATED": "Teilweise artikuliert",
      "NOT_MENTIONED": "Nicht erwähnt",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Messaging misst, ob Benutzer 3 wichtige Ideen in diesem Anruf artikulieren."
    },
    "reporting": {
      "AT_GLANCE": "Aufgaben im Überblick",
      "OPEN_ASSIGNMENTS": "Offene Aufgaben",
      "NOT_STARTED": "Nicht begonnen",
      "CERTIFIED": "Zertifiziert",
      "VIEW_LIST": "Liste anzeigen",
      "CERTIFICATION_ASSIGNMENTS": "Zertifizierungsaufgaben",
      "CERTIFICATION_SUMMARY_TEXT": "Zertifizierungen sind Aufgaben, die ein bestimmtes Fälligkeitsdatum und bestimmte Kriterien zum Bestehen haben",
      "PRACTICE_ASSIGNMENTS": "Übungsaufgaben",
      "PRACTICE_SUMMARY_TEXT": "Übungsaufgaben sind für Benutzer ohne ein bestimmtes Fälligkeitsdatum verfügbar. Sie sind so konzipiert, dass die Nutzer regelmäßig üben können, um ihre Fähigkeiten zu verbessern.",
      "THE": "Das",
      "WILL_CLOSE": "wird geschlossen in",
      "USERS_HAVE": "Benutzer haben",
      "USER_HAS": "Benutzer hat",
      "NOT_STARTED_ASSIGNMENT_DUE": "eine in der nächsten Woche fällige Aufgabe nicht begonnen",
      "NOT_COMPLETED_ASSIGNMENT_DUE": "eine in der nächsten Woche fällige Aufgabe nicht abgeschlossen",
      "DAYS": "Tage",
      "DAY": "Tag",
      "MODULES": "Module",
      "MODULE": "Modul",
      "CALL": "Simulation",
      "CALLS": "Simulationen",
      "CERTIFICATION_ASSIGNMENT": "Zertifizierungsaufgabe",
      "PRACTICE_ASSIGNMENT": "Übungsaufgabe",
      "AND": "und",
      "VIEW_ENGAGEMENT_DETAILS": "Informationen zur Aktivität anzeigen",
      "SEE_ALL": "Alle anzeigen",
      "SEE_LESS": "Weniger anzeigen",
      "ASSIGNMENT": "Aufgabe",
      "ASSIGNED": "Zugewiesen",
      "IN_PROGRESS": "Wird bearbeitet",
      "DUE_DATE": "Fälligkeitsdatum",
      "ASSIGNMENT_ENDS_IN": "Aufgabe endet in",
      "ASSIGNMENT_CLOSED": "Aufgabe abgeschlossen",
      "OLDER_CERTIFICATION": "ältere Zertifizierung",
      "ASSIGNMENT_IS": "Aufgabe ist",
      "ASSIGNMENT_ARE": "Aufgaben sind",
      "CURRENTLY_HIDDEN": "derzeit ausgeblendet",
      "ALL_CERTIFICATION_ASSIGNMENTS": "Es werden alle Zertifizierungsaufgaben angezeigt.",
      "CERTIFICATION_NOT_STARTED_TOOLTIP": "Nutzer, die noch keine Simulationen abgeschlossen und keine Bewertung erhalten haben.",
      "CERTIFICATION_IN_PROGRESS_TOOLTIP": "Nutzer, die mindestens eine Simulation abgeschlossen und eine Bewertung erhalten haben.",
      "CERTIFICATION_CERTIFIED_TOOLTIP": "Nutzer, die die Zertifizierungsanforderungen erfüllt haben.",
      "CERTIFICATION_USER_ASSIGNMENT_TOOLTIP": "Dies ist die Anzahl der Benutzer, die auf die Aufgabe für ihre Zertifizierungen zugreifen können.",
      "SEE_CERTIFICATION_ASSIGNMENT": "Alle Zertifizierungsaufgaben anzeigen",
      "HIDE_OLDER_ASSIGNMENTS": "Ältere Aufgaben ausblenden",
      "AVG_PRACTICES": "Durchschn. Übungen",
      "PRACTICED": "Durchgeführt",
      "SCORED_HIGH": "Hohe Punktzahl erzielt",
      "AVG_ASSIGNMENT": "Durchschn. Verbesserung",
      "DAYS_AGO": "vor Tagen",
      "NA": "K.A.",
      "OLDER_PRACTICE": "ältere Übung",
      "SEE_PRACTICE_ASSIGNMENT": "Alle Übungsaufgaben anzeigen",
      "ALL_PRACTICE_ASSIGNMENTS": "Alle Übungsaufgaben werden angezeigt.",
      "PRACTICE_NOT_STARTED_TOOLTIP": "Nutzer, die noch keine Simulation abgeschlossen und keine Bewertung erhalten haben.",
      "PRACTICE_IN_PROGRESS_TOOLTIP": "Diese Nutzer haben mindestens eine Simulation abgeschlosen und eine Bewertung erhalten.",
      "PRACTICE_CERTIFIED_TOOLTIP": "Zahl der Nutzer, die in allen Simulationen dieser Aufgabe mindestens einmal die Kriterien für eine hohe Punktzahl erfüllt haben.",
      "PRACTICE_USER_ASSIGNMENTCOUNT_TOOLTIP": "Diese Nutzer haben Zugriff auf die Übungsaufgabe.",
      "PRACTICE_AVG_PRACTICE_TOOLTIP": "Diese Kennzahl zeigt, wie häufig Nutzer im Schnitt die Simulationen dieser Aufgabe geübt haben.",
      "PRACTICE_AVG_IMPROVEMENT_TOOLTIP": "Diese Metrik analysiert die Ergebnisse der einzelnen Sitzungen und zeigt den Trend als Gerade im Diagramm. Ein höherer Prozentsatz bedeutet, dass sich die Ergebnisse schneller verbessern, ein niedrigerer Prozentsatz, dass sich die Ergebnisse langsamer verbessern.",
      "USERS": "Benutzer",
      "USER": "Benutzer",
      "DOWNLOAD_CSV": "CSV herunterladen",
      "ERROR": "Es ist ein Fehler aufgetreten",
      "FIRST_NAME": "Vorname",
      "LAST_NAME": "Nachname",
      "ATTEMPTS": "Versuche",
      "EMAIL": "E-Mail",
      "LAST_LOGIN": "Letzte Anmeldung",
      "ASSIGNMENT_NOT_STARTED": "Aufgabe nicht begonnen",
      "ASSIGNMENT_IN_PROGRESS": "Aufgabe wird ausgeführt",
      "SCORE_CRITERIA_MET": "Bewertungskriterien erfüllt",
      "NEVER_LOGGED_IN": "Nicht angemeldet bei",
      "QUANTIFIED_REPORTING": "Quantified Berichte",
      "ASSIGNED_USERS": "Zugewiesene Benutzer",
      "COMPLETION_REQUIREMENT": "Voraussetzung für den Abschluss",
      "AVG_SCORE_Of": "Durchschn. Ergebnis von",
      "REPORTING": "Berichterstattung",
      "CERTIFICATIONS": "Zertifizierungen",
      "PRACTICES": "Übungen",
      "CALL_ANALYSIS": "Simulationsanalyse",
      "PERCENT_CERTIFIED_ON": "Prozentsatz zertifiziert am",
      "SHOWING": "Anzeige",
      "PRACTICE_SESSIONS": "Kumulative Übungssitzungen für alle Simulationen im Modul",
      "AVG_PRACTICE_HEADING": "Durchschnittliche Anzahl von Übungssitzungen pro aktivem Nutzer",
      "AVG_SCORE_LABEL": "Durchschn. Punktzahl",
      "AVG_SCORE_HEADING": "Durchschnittliche Punktzahl pro Nutzer",
      "AVG_PRACTICES_LABEL": "Durchschn. Übungen",
      "EXPORT_LEARNER_LIST": "Liste der Lernenden exportieren",
      "PERCENT_NOT_STARTED": "% nicht begonnen",
      "PERCENT_IN_PROGRESS": "% in Bearbeitung",
      "PERCENT_CERTIFIED": "% zertifiziert",
      "USER_CERTIFIED": "Benutzer zertifiziert",
      "USERS_CERTIFIED": "Benutzer zertifiziert",
      "TOTAL_ATTEMPTS": "Versuche insgesamt",
      "Avg_ATTEMPTS_CERTIFY": "Durchschn. Zertifizierungsversuche",
      "ASTERICK_GROUP": "Bezeichnet eine Gruppe, die eine oder mehrere Untergruppen enthält",
      "NO_DATA_FOUND": "Keine Daten gefunden",
      "MODULE_HIGHLIGHTS": "Modul-Highlights",
      "MODULE_HIGHLIGHT_SUMMARY": "Schlüsselkennzahlen für alle Simulationen. Eine detaillierte Analyse der einzelnen Simulationen finden Sie in der folgenden Übersicht",
      "HIGHEST_SCORING_QUESTION_TITLE": "FRAGE MIT DER HÖCHSTEN PUNKTZAHL",
      "HIGHEST_SCORING_QUESTION_MODAL_TITLE": "Frage mit der höchsten Punktzahl",
      "QUESTION_BAR_MSG": "Durchschnittlicher Anteil korrekt beantworteter Fragenpunkte",
      "LOWEST_SCORING_QUESTION_TITLE": "FRAGE MIT DER NIEDRIGSTEN PUNKTZAHL",
      "LOWEST_SCORING_QUESTION_MODAL_TITLE": "Frage mit der niedrigsten Punktzahl",
      "TOP_SCORED_ANSWER_POINT_TITLE": "BESTBEWERTETER ANTWORTPUNKT",
      "TOP_SCORED_ANSWER_POINT_MODAL_TITLE": "Am wenigsten verfehlte Antwortpunkt-Frage",
      "SCORE_BAR_MSG": "– wird von den Nutzern meist richtig beantwortet.",
      "LEAST_SCORED_ANSWER_POINT_TITLE": "AM NIEDRIGSTEN BEWERTETER ANTWORTPUNKT",
      "LEAST_SCORED_ANSWER_POINT_MODAL_TITLE": "Am meisten verfehlte Antwortpunkt-Frage",
      "LOWEST_SCORING_OBJECTIVE_TITLE": "METHODIK MIT DER NIEDRIGSTEN PUNKTZAHL",
      "LOWEST_SCORING_OBJECTIVE_MODAL_TITLE": "Methodik mit der niedrigsten Punktzahl",
      "HIGHEST_SCORING_OBJECTIVE_TITLE": "METHODIK MIT DER HÖCHSTEN PUNKTZAHL",
      "HIGHEST_SCORING_OBJECTIVE_MODAL_TITLE": "Methodik mit der höchsten Punktzahl",
      "OBJECTIVE_BAR_MSG": "Durchschnittliche Punktzahl für diese Methodik",
      "LEAST_ARTICULATED_MESSAGE_TITLE": "AM WENIGSTEN ARTIKULIERTE BOTSCHAFT",
      "LEAST_ARTICULATED_MESSAGE_MODAL_TITLE": "Am wenigsten artikulierte Botschaft",
      "LEAST_ARTICULATED_BAR_MSG": "Diese Botschaft artikulieren",
      "MOST_ARTICULATED_MESSAGE_TITLE": "AM MEISTEN ARTIKULIERTE BOTSCHAFT",
      "MOST_ARTICULATED_MESSAGE_MODAL_TITLE": "Am meisten artikulierte Botschaft",
      "MOST_ARTICULATED_BAR_MSG": "Diese Botschaft vollständig artikulieren",
      "Overview": "Übersicht",
      "CONSISTS_Of": "besteht aus",
      "CALL_OVERVIEW_LABEL": "Das Diagramm zeigt die Anzahl der Nutzer, die",
      "PASSED": "die Aufgabe bestanden haben",
      "ATTEMPTED": "die Aufgabe versucht haben",
      "NOT_ATTEMPTED": "die Aufgabe nicht versucht haben",
      "GUIDED_CALL": "Wissens-Check",
      "QUESTIONS": "Fragen",
      "QUESTION": "Frage",
      "CONVERSATIONAL_CALL": "Rollenspiel",
      "AVG_ATTEMPTS": "Durchschn. Versuche",
      "USERS_PASSED": "Benutzer bestanden",
      "DETAILED_ANALYSIS": "Detaillierte Analyse",
      "CALL_DETAILS": "Details zur Simulation",
      "CALL_TYPE": "Simulationstyp",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "WHAT_WE_MEASURED": "Was wir gemessen haben",
      "AVATAR": "Avatar",
      "CONVERSATIONAL_AVG_HEADING": "Durchschnittliche Gesamtpunktzahl",
      "OVERALL_SCORE_DETAIL": "Unser System vergibt eine „Gesamtpunktzahl“ für jedes Gespräch. Diese Zahl ist die durchschnittliche Gesamtpunktzahl für",
      "CALL_RUN": "Benutzer haben diese Simulation abgeschlossen",
      "TIME": "Mal",
      "TIMES": "Mal",
      "OBJECTIVES": "Methodik",
      "AVG_OBJECTIVE": "Durchschnittliche Methodikbewertungen für alle",
      "OF_THIS_CALL": "dieser Simulation",
      "MESSAGE_ADHERENCE": "Einhaltung der Gesprächsinhalte",
      "MESSAGE_ADHERENCE_DETAILS_1": "Die Einhaltung der Gesprächsinhalte misst, ob die Lernenden",
      "MESSAGE_ADHERENCE_DETAILS_2": "während dieser Simulation wichtige Inhalte klar zum Ausdruck bringen. Diese Visualisierungen zeigen den durchschnittlichen Prozentsatz der Botschaften innerhalb eines bestimmten Nachrichtenthemas, die von den Nutzern artikuliert wurden – über alle",
      "IMPORTANT_IDEAS": "wichtige Inhalte während dieser Simulation",
      "PERCENT_MESSAGE_ARTICULATED": "Diese Visualisierungen zeigen den Prozentsatz der Zeit, in der jede Botschaft artikuliert wurde – über alle",
      "FULLY_ARTICULATED": "Vollständig artikuliert",
      "PARTIALLY_ARTICULATED": "Teilweise artikuliert",
      "NOT_MENTIONED": "Nicht erwähnt",
      "SKILLS_LABEL": "Fertigkeiten",
      "SKILLS_DETAILS": "Bei der Bewertung der Fertigkeiten handelt es sich um eine KI-Bewertung der von den Nutzern während einer Simulation gezeigten Fertigkeiten. Diese Visualisierungen zeigen den Prozentsatz der Fälle, in denen Nutzer die Bewertungen „Experte“ (höchste), „Fortgeschritten“ und „In Entwicklung“ (niedrigste) erhalten haben – über alle",
      "DEVELOPING": "In Entwicklung",
      "PROFICIENT": "Fortgeschritten",
      "Expert": "Experte",
      "NO_RESULT": "Noch keine Ergebnisse",
      "NO_RESULT_TEXT": "Kein Nutzer in Ihrer Organisation hat diese Simulation bisher versucht. Sobald sie das getan haben, können Sie ihre Ergebnisse hier sehen!",
      "CONVERSATIONAL_CALL_TOOLTIP": "Bei Rollenspielen kann der Nutzer den Gesprächsverlauf bestimmen und die KI wird entsprechend reagieren. Rollenspiele sind weniger strukturiert als „Wissens-Checks“, die ein strenges Frage-Antwort-Format haben.",
      "TOTAL_SESSION_TOOLTIP": "Die Gesamtzahl, wie oft diese Simulation von allen Benutzern, denen sie zugewiesen wurde, ausgeführt wurde.",
      "AVERAGE_SCORE_LABEL": "Durchschnittliche Punktzahl",
      "AVERAGE_SCORE_DETAIL": "Die durchschnittliche Punktzahl aller Nutzer bei dieser Simulation",
      "ANSWER_POINTS": "Antwortpunkte",
      "DETAILS": "Details",
      "CONVERSATIONAL_CALL_MSG": "Inhaltsberichte für Rollenspiele sind in Kürze verfügbar",
      "ALL_CALL_DETAILS": "Alle Details zur Simulation",
      "QUESTION_TEXT_LABEL": "Fragetext",
      "AVG_POINTS_LABEL": "Durchschnittliche Punkte",
      "SHOW_ALL": "Alle anzeigen",
      "CORRECT_ANSWER": "richtige Antworten aus",
      "OBJECTIVE_MEASURED_ON": "Diese Methodik wird gemessen an",
      "CALLS_IN_MODULE": "Simulationen in diesem Modul",
      "VIEW_CALL_DETAILS": "Details anzeigen",
      "QUESTION_UPDATED": "Diese Frage wurde aktualisiert",
      "QUESTION_UPDATED_MESSAGE": "Wir sind nicht in der Lage, detaillierte Antwortpunktinformationen anzuzeigen, da diese Frage aktualisiert wurde. Die angezeigten „Durchschnittspunkte“ sind der Durchschnitt aller Sitzungen zu dieser Frage (einschließlich vor und nach den Aktualisierungen).",
      "CLOSE_ALT": "Schließen",
      "Q_LABEL": "F",
      "SCORING_LABEL": "Bewertung",
      "AVERAGE_ANSWER": "Durchschnittlich erzielte Antwortpunkte pro Frage",
      "MINIMIZE_LABEL": "Minimieren",
      "VIEW_ALL_LABEL": "Alle anzeigen",
      "DOWN_ARROW": "Pfeil nach unten",
      "NOTIFICATION": "Benachrichtigung",
      "PROGRESS_ICON": "Fortschrittssymbol",
      "VIEW_MODAL": "Modal anzeigen",
      "VIEW_INFO": "Infos anzeigen",
      "TOTAL_LABEL": "Insgesamt",
      "EXPAND_GROUP": "Gruppe erweitern",
      "MESSAGE_ADHERENCE_V2": "Einhaltung der Gesprächsinhalte",
      "SCORE_OVERALL": "Gesamtpunktzahl",
      "SCORE_SKILLS": "Fertigkeiten",
      "SCORE_CUSTOMIZED": "Methodik",
      "SESSIONS": "Sitzungen",
      "SESSION": "Sitzung"
    },
    "personalizedPractice": {
      "TITLE": "Personalisierte Übung",
      "DESCRIPTION": "Hi {{userFirstName}}! Personalisierte Übungen ermöglichen es Ihnen, eigene Szenarien festzulegen, sodass diese möglichst realistisch sind.",
      "LOADING": "Laden...",
      "VIEW_SESSIONS": "Sitzungen anzeigen",
      "VIEW_SIMULATION": "Simulation anzeigen",
      "TOTAL_SESSION": "Sitzung insgesamt",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "BREADCRUMB": "Personalisierte Übung",
      "SCENARIO_DETAILS_TITLE": "Szenariodetails",
      "SCENARIO_DETAILS_DESCRIPTION": "Bitte wählen Sie aus den folgenden Optionen die Variablen aus, mit denen Sie die Simulation individuell auf Ihre Anforderungen abstimmen können.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Auswählen",
      "CONVERSATION_TYPE": "Gesprächstyp",
      "SELECT_CONVERSATION_TYPE": "Gesprächstyp auswählen",
      "LAUNCH_SIMULATION": "Simulation mit den ausgewählten Einstellungen starten",
      "PREVIOUS_SESSIONS": "Vorherige Sitzungen",
      "TOTAL": "Insgesamt",
      "FILTERS": "Filter:",
      "DATE": "Datum",
      "DIFFICULTY": "Schwierigkeitsgrad",
      "TEMPERAMENT": "Temperament",
      "SESSION_DATE": "Datum der Sitzung",
      "SESSION_SCORE": "Punktzahl der Sitzung",
      "DURATION": "Dauer",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "MESSAGING": "Gesprächsinhalt",
      "METHODOLOGY": "Methodik",
      "SKILLS": "Fertigkeiten",
      "RESULTS": "Ergebnisse",
      "VIEW_FEEDBACK": "Feedback anzeigen",
      "OVERALL_SCORE_LABEL": "Gesamtpunktzahl",
      "SCORE": "Punktzahl",
      "NO_PRODUCTS_TITLE": "Keine Produkte verfügbar",
      "NO_PRODUCTS_DESCRIPTION": "Sie haben noch keine personalisierten Übungsprodukte.",
      "NO_SESSIONS_FOUND": "Keine Sitzungen mit den ausgewählten Filtern gefunden",
      "TIME": "Zeit",
      "ALL": "Alle",
      "LEARNER": "Lernende:r",
      "MOOD": "Stimmung",
      "CLEAR_FILTERS": "Filter zurücksetzen"
    },
    "login": {
      "TITLE": "Willkommen zurück",
      "SUB_TITLE": "Wie möchten Sie sich anmelden?  ",
      "LOGIN_WITH_SSO": "Anmeldung mit Unternehmens-SSO",
      "LOGIN_WITH_PASSWORD": "Mit Passwort anmelden",
      "PROVIDE_EMAIL": "Geben Sie Ihre E-Mail-Adresse an",
      "HELP_TEXT": "Benötigen Sie Hilfe? Kontakt",
      "EMAIL_ERROR": "Wir können Sie nicht anmelden. Bitte wenden Sie sich an die Verwaltung oder IT-Abteilung Ihres Unternehmens.",
      "EMAIL": "E-Mail",
      "LOGIN": "Anmelden",
      "ALERT": "Alarm",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Wenn Sie sich in Ihr Konto einloggen, stimmen Sie den {{termsLink}} und {{privacyLink}} zu.",
      "TERMS_OF_SERVICE": "Nutzungsbedingungen",
      "PRIVACY_POLICY": "Datenschutzbestimmungen"
    },
    "learningPathway": {
      "BEGIN": "Start",
      "DUE_DATE": "Fälligkeitsdatum",
      "FOOTER_SUBTITLE_READY": "Stellen Sie mir jede Frage. Ich helfe Ihnen gerne.",
      "LEAVE_STEP": "Schritt überspringen",
      "NEXT_STEP": "Nächster Schritt",
      "NOTIFICATIONS_ARIA": "Benachrichtigungen",
      "PDF_NEXT_PAGE": "Nächste Seite",
      "PDF_NO_SOURCE": "Keine PDF-Quelle angegeben.",
      "PDF_PREVIOUS_PAGE": "Vorherige Seite",
      "POST_CALL_SUBTITLE": "Hinterlassen Sie ein Feedback, während wir Ihre Ergebnisse verarbeiten",
      "POST_CALL_TITLE": "Sie haben das Ende dieses Quiz erreicht.",
      "SETTINGS": "Einstellungen",
      "TOAST_CONTENT": "Zum Anzeigen klicken Sie unten, oder kehren Sie zum Detailbildschirm des Lernpfads zurück, um mit dem nächsten Schritt fortzufahren.",
      "TOAST_TITLE": "Die Ergebnisse Ihres Rollenspiels wurden verarbeitet",
      "ASSIGNMENTS": "Aufgaben",
      "USER_FALLBACK": "Benutzer",
      "VIEW_RESULTS": "Ergebnisse anzeigen",
      "QUIZ_TITLE": "Quiz"
    },
    "leaderboard": {
      "LEADERBOARD": "Bestenliste",
      "TOP10PERCENT": "Top 10 %",
      "PRACTICE_ASSIGNMENT": "Übungsaufgaben",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Aufgabe wählen",
      "SELECT_SIMULATION": "Simulation wählen",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Wählen Sie eine Aufgabe und eine Simulation aus, um die Bestenliste anzuzeigen",
      "NO_DATA": "Noch keine Aktivität. Sobald das Team anfängt, sich zu beteiligen, werden hier die Ranglisten angezeigt.",
      "NO_ASSIGNMENTS_AVAILABLE": "Keine Aufgaben verfügbar",
      "NO_SIMULATIONS_AVAILABLE": "Keine Simulationen verfügbar",
      "NAME": "Name",
      "HIGH_SCORE": "Höchste Punktzahl",
      "AVERAGE_SCORE": "Durchschnittliche Punktzahl",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "LAST_SESSION": "Letzte Sitzung",
      "TOP5": "Top 5",
      "OF": "von",
      "ENGAGED_USERS": "beteiligte Nutzer",
      "ENGAGED_USER": "beteiligter Nutzer",
      "NO_USERS_ENGAGED": "Keine Benutzer beteiligt",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Sitzungen mit niedrigen Kompetenzwerten ausblenden",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Sitzungen mit einer Kompetenzbewertung von „in der Entwicklung“ werden bei der Berechnung der hohen und durchschnittlichen Punktzahlen nicht berücksichtigt."
    },
    "general": {
      "NEED_HELP_QUESTION": "Benötigen Sie Hilfe?",
      "CONTACT": "Kontakt",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Übergeordnetes Konto",
      "ACCOUNT": "Konto",
      "CHECKMARK": "Häkchen",
      "ICON": "Symbol",
      "ALERT": "Alarm",
      "HEADS_UP": "Aufgepasst!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Für bestmöglichen Klang auf dem iPad empfehlen wir die Verwendung von Kopfhörern.",
      "SETTINGS": "EINSTELLUNGEN",
      "RP": "RP",
      "EMAIL_LABEL": "E-Mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Teamleiter für",
      "MIAMI_SALE": "Vertrieb Miami",
      "CHARLOTTE_SALES": "Vertrieb Charlotte",
      "ATLANTA_SALES": "Vertrieb Atlanta",
      "TEAM": "Team",
      "ASSIGNMENTS": "Aufgaben",
      "MY_TEAMS": "Meine Teams",
      "REPORTING": "Berichterstattung",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Bestenliste",
      "PERSONALIZED_PRACTICE": "Personalisierte Übung",
      "HELP_SEARCH_OUR": "Durchsuchen Sie unsere",
      "HELP_OR_REACH_OUT_TO": "oder wenden Sie sich an",
      "HELP_WITH_QUESTIONS": "bei Fragen",
      "KNOWLEDGE_BASE": "Wissensdatenbank"
    },
    "dashboard": {
      "ALL": "Alle",
      "IN_COMPLETE": "Unvollständig",
      "COMPLETED": "Abgeschlossen",
      "NO_ASSIGNMENT_TITLE": "Sie haben keine Aufgaben.",
      "NO_ASSIGNMENT_DETAILS": "Sie werden benachrichtigt, wenn Sie Aufgaben zu erledigen haben.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Sie haben keine unvollständigen Aufgaben.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Sie werden benachrichtigt, wenn eine neue Aufgabe fällig ist.",
      "COMPLETED_ASSIGNMENT_TITLE": "Sie haben keine abgeschlossenen Aufgaben.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Kommen Sie zurück, wenn Sie eine Aufgabe abgeschlossen haben.",
      "VIEW_ASSIGNMENT": "Aufgabe anzeigen",
      "ASSIGNMENT_LABEL": "Aufgaben",
      "MODULE_ASSIGNMENT_ALT": "Symbol für Modulaufgaben",
      "VIEW_ASSIGNMENT_FOR": "Aufgabe anzeigen für",
      "DAY": "Tag",
      "UNTILL_DUE": "Verbleibende Zeit",
      "PAST_DUE": "Überfällig",
      "AVAILABLE_IN": "Verfügbar in",
      "DUE_TODAY": "Heute fällig",
      "PRACTICE": "Übung",
      "CERTIFICATION": "Zertifizierung",
      "UPCOMING": "Demnächst",
      "TEST_ASSIGNMENT": "Testaufgabe",
      "CLOSED": "Abgeschlossen",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Keine Aufgaben gefunden.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Passen Sie Ihre Filter an, um verfügbare Aufgaben anzuzeigen, oder schauen Sie später noch einmal vorbei, wenn neue Aufgaben hinzugefügt wurden.",
      "VIEW_PATHWAY": "Lernpfad anzeigen",
      "TOTAL": "Insgesamt",
      "STATUS_LABEL": "Status",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Aufgabentyp",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Aufgabentyp:",
      "NOT_STARTED": "Nicht begonnen",
      "CERTIFIED": "Zertifiziert",
      "NOT_CERTIFIED": "Nicht zertifiziert",
      "IN_PROGRESS": "Wird bearbeitet",
      "PATHWAY": "Lernpfad",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Willkommen bei Quantified!",
      "INVITATION_MESSAGE": "Wir freuen uns, Sie an Bord zu haben! Bitte befolgen Sie die folgenden Schritte, um sich zum ersten Mal bei Ihrem Konto anzumelden.",
      "ACCOUNT_DETAILS": "Ihre Kontodaten:",
      "USERNAME": "Benutzername",
      "PASSWORD": "Temporäres Passwort",
      "STEPS_LABEL": "Nächste Schritte zum Einloggen",
      "STEP_1": "1. Klicken Sie unten auf die Schaltfläche „Anmelden“, um zur Anmeldeseite zu gelangen.",
      "STEP_2": "2. Geben Sie Ihren Benutzernamen und Ihr temporäres Passwort ein, wie oben angegeben.",
      "STEP_3": "3. Sobald Sie angemeldet sind, werden Sie aufgefordert, ein neues Passwort festzulegen.",
      "LOGIN_BUTTON": "Anmelden",
      "ABOUT_US": "Der Simulator von Quantified ist eine virtuelle Umgebung, in der Sie schnell wichtige Fähigkeiten erwerben, um effektiver mit Kunden zu kommunizieren.",
      "EXPIRY_TIME": "Dieses temporäre Passwort läuft in 24 Stunden ab. Sollten Sie Probleme bei der Anmeldung haben, wenden Sie sich bitte an unser Support-Team unter",
      "TEAM": "Das Quantified-Team",
      "INVITATION_SMS_USERNAME": "Ihr Benutzername lautet",
      "INVITATION_SMS_PASSWORD": "und das vorläufige Passwort lautet",
      "AUTHENTICATION_CODE": "Ihr Authentifizierungscode lautet",
      "PASSWORD_RESET_CODE": "Ihr Code zum Zurücksetzen Ihres Quantified-Passworts",
      "RESET_PASSWORD_EMAIL": "E-Mail zum Zurücksetzen des Passworts",
      "HELLO": "Hallo",
      "USE_VERIFICATION_CODE": "Sie haben ein neues Passwort beantragt. Bitte geben Sie den untenstehenden Verifizierungscode ein, um den Vorgang abzuschließen.",
      "VERIFICATION_CODE": "Verifizierungscode",
      "NEXT_STEP": "Nächste Schritte",
      "RESET_PASSWORD_PAGE": "Rufen Sie die Seite zum Zurücksetzen Ihres Passworts in Ihrem Browser erneut auf.",
      "ENTER_VERIFICATION_CODE": "Geben Sie den Verifizierungscode ein, wenn Sie dazu aufgefordert werden.",
      "CREATE_PASSWORD": "Sobald der Code verifiziert ist, folgen Sie den Anweisungen, um ein neues Passwort zu erstellen.",
      "DISREGARD_NOTE": "Wenn Sie kein neues Passwort angefordert haben, ignorieren Sie bitte diese E-Mail.",
      "CONTACT_SUPPORT": "Für weitere Unterstützung wenden Sie sich bitte an unser Support-Team unter",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Vielen Dank",
      "QUANTIFIED_TEAM": "Das Quantified-Team",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, USA"
    },
    "call": {
      "LOADING": "Laden",
      "SIMULATION_PAUSED": "Die Simulation wurde angehalten.",
      "CLICK_RESUME": "Klicken Sie auf die Schaltfläche „Fortfahren“, um fortzufahren.",
      "NO_INTERNET": "Keine Internetverbindung",
      "TRY_AGAIN": "Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "MIC_MUTED": "Mikrofon ist stummgeschaltet",
      "MIC_MUTED_DESCRIPTION": "Hoppla, es sieht so aus, als ob Ihr Mikrofon stumm geschaltet ist. Heben Sie die Stummschaltung auf, um zu antworten und fortzufahren.",
      "NO_RESPONSE": "Keine Antwort erkannt",
      "MIC_NOT_CONNECTED": "Hoppla, es sieht so aus, als ob Ihr Mikrofon nicht angeschlossen ist. Wählen Sie Ihr Gerät erneut aus, um zu antworten und fortzufahren.",
      "AUDIO_ISSUE": "Hoppla, da ist etwas schief gelaufen. Überprüfen Sie die Einstellungen Ihres Geräts und stellen Sie sicher, dass Sie sich an einem ruhigen Ort befinden, der frei von Hintergrundgeräuschen ist.",
      "LOADING_ALT": "Laden...",
      "REPEAT_RESPONSE": "Sie werden automatisch zu der Simulation zurückgeführt, um Ihre Antwort zu wiederholen und es erneut zu versuchen.",
      "NEEDS_MORE_TIME_QUESTION": "braucht mehr Zeit zum Nachdenken, wollen Sie warten?",
      "NEEDS_MORE_TIME": "braucht mehr Zeit zum Nachdenken.",
      "WAIT_OR_END_CALL": "Wir werden Sie benachrichtigen, wenn sie fertig sind, oder Sie können den Anruf beenden und",
      "RETURN_TO_ASSIGNMENTS": "Zurück zur Aufgabe",
      "READY": "Bereit",
      "IS_READY": "ist bereit, Ihr Gespräch fortzusetzen.",
      "TRY_AGAIN_LABEL": "Erneut versuchen",
      "CHECK_SETTINGS": "Einstellungen überprüfen",
      "PAUSED_SIMULATION": "Sie haben die Simulation angehalten.",
      "PAUSED_SIMULATION_DESCRIPTION": "Die Video- und Audioaufzeichnung wird angehalten, bis die Simulation fortgesetzt wird.",
      "RESUME": "Fortsetzen",
      "SETTINGS": "Einstellungen",
      "CAPTURING_RESPONSE": "Erfassen Ihrer Antworten",
      "TOUR_MESSAGE": "Sobald Sie Ihren Beitrag beendet haben, klicken Sie auf „Weiter“, damit Ihre Antworten erfasst und bewertet werden.",
      "NEXT": "Weiter",
      "START_CALL": "Start",
      "END_CALL_TITLE": "Sind Sie sicher, dass Sie diese Simulation beenden möchten?",
      "END_CALL_DESCRIPTION": "Wenn Sie die Simulation jetzt beenden, erhalten Sie weder eine Bewertung noch ein Feedback zu Ihrem Gespräch.",
      "END_CALL": "Ende",
      "BROWSER_ACCESS_DENIED": "Ihrem Browser wird der Zugriff auf dieses Gerät verweigert.",
      "COPY_SESSION_ID_BUTTON": "Sitzungs-ID kopieren",
      "TIPS_GUIDANCE_MESSAGE": "Hier werden Diskussionspunkte und Tipps angezeigt.",
      "CONTINUE": "Fortsetzen",
      "SESSION_ID_LABEL": "Sitzungs-ID:",
      "SESSION_ID_COPIED": "Sitzungs-ID kopiert!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Hinweise und Vorschläge",
      "HINT_LABEL": "Hinweis",
      "CAPTIONS_LABEL": "Untertitel",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "Party-Emoji",
      "CALL_ENDED_MESSAGE": "Sie sind am Ende dieser Simulation angelangt.",
      "CALL_ENDED_INACTIVITY": "Diese Simulation wurde aufgrund von Inaktivität beendet",
      "CALL_ENDED_GENERIC": "Diese Simulation ist beendet",
      "FEEDBACK_PROMPT": "Hinterlassen Sie ein Feedback, während wir Ihre Ergebnisse verarbeiten.",
      "INTERACTION_THRESHOLD_NOT_MET": "Sie haben unsere Interaktionsschwelle für die Bewertung nicht erreicht. Bitte versuchen Sie es erneut.",
      "REALISTIC_CONVERSATION_QUESTION": "Hat sich dieses Gespräch realistisch und natürlich angefühlt?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Fühlen Sie sich nach dieser Simulation besser informiert und vorbereitet?",
      "FEEDBACK_THANK_YOU": "Vielen Dank für Ihr Feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Vielen Dank für Ihr Feedback! Wir werden daran arbeiten, diese Erfahrung zu verbessern.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "Visuelle Unterstützung konnte nicht geladen werden",
      "BEGIN_CALL": "Start",
      "LEAVE_CALL_BRIEFING": "Briefing verlassen",
      "RESTORE_CALL": "Wiederherstellung Ihrer Simulation",
      "FEW_SECONDS": "Dies kann ein paar Sekunden dauern.",
      "CHECK_ALT": "Häkchen",
      "COPY_ALT": "Kopieren",
      "HINTS_ALT": "Hinweise",
      "CLOSE_CAPTIONS": "Untertitel ausblenden",
      "MICROPHONE_MUTED": "Mikrofon stummgeschaltet",
      "RETURN_TO_CALL": "Zurück zur Simulation",
      "YES": "Ja",
      "NO": "Nein",
      "VIEW_RESULTS": "Ergebnisse anzeigen",
      "RETURN_TO_ASSIGNMENT": "Zurück zur Aufgabe",
      "HAVING_ISSUES": "Es gibt Probleme mit der Verbindung. Bitte überprüfen Sie Ihre Internetverbindung und klicken Sie dann auf „OK“.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Leider können wir zu diesem Zeitpunkt keine Ergebnisse generieren. Bitte versuchen Sie es erneut.",
      "INACTIVITY_ALERT_MESSAGE": "Dieser Anruf wird aufgrund von Inaktivität beendet. Sprechen Sie mit dem Avatar, um den Anruf fortzusetzen, oder wählen Sie „Anruf beenden“, um das Gespräch zu beenden.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Dieser Aufruf wird in {{secondsUntilHangup}} Sekunden beendet",
      "INACTIVITY_SHORT_ALERT_TITLE": "Dieser Anruf wird in wenigen Sekunden beendet",
      "TELL_YOUR_GENDER_HEADING": "Bitte teilen Sie uns Ihre bevorzugte Anrede mit:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "So kann der Avatar die richtige Grammatik verwenden, was die Unterhaltung natürlicher und realistischer macht.",
      "GENDER_SELECTION": "Auswahl der Anrede:",
      "SELECT_OPTION": "Wählen Sie eine Option",
      "CONFIRM": "Bestätigen",
      "MALE": "Männlich",
      "FEMALE": "Weiblich",
      "NON_BINARY": "Nicht-binär/Andere",
      "PREFER_NOT_TO_ANSWER": "Keine Angabe",
      "NON_BINARY_MESSAGE": "Wir verstehen und respektieren Ihre nicht-binäre Geschlechtsidentität. Aufgrund der derzeitigen technischen Einschränkungen verwenden wir standardmäßig männliche Pronomen. Bitte beachten Sie, dass wir an Verbesserungen arbeiten, um in Zukunft alle Geschlechteridentitäten besser zu berücksichtigen. Wir danken Ihnen für Ihr Verständnis und Ihre Geduld.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Wir respektieren Ihre Entscheidung, kein Geschlecht anzugeben. In solchen Fällen verwendet unsere Technologie aufgrund der derzeitigen Beschränkungen standardmäßig männliche Pronomen.",
      "DISPLAY_VISUAL_AID": "Visuelle Unterstützung anzeigen",
      "FULL_SCREEN": "Vollbild",
      "COLLAPSE": "Minimieren",
      "COMPLETED_CONVERSATION_MESSAGE": "Vielen Dank, dass Sie dieses Gespräch abgeschlossen haben.",
      "CONVERSATION_COMPLETION_FEEDBACK": "Hinterlassen Sie bitte ein Feedback, während wir Ihr Gespräch verarbeiten.",
      "ERROR_MESSAGE": "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an",
      "SAVED_CONVERSATION_MESSAGE": "Ihr Gespräch wurde gespeichert.",
      "RETURN_TO_MY_ASSIGNMENTS": "Zurück zu meinen Aufgaben",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Zurück zur personalisierten Übung",
      "PERSONALIZED_CALL_NOTE": "Sie haben soeben ein personalisiertes Übungsgespräch abgeschlossen.",
      "LEAVE_STEP_TITLE": "Wollen Sie diesen Schritt wirklich verlassen?",
      "EXIT": "Ausgang"
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "PUNKTZAHL",
      "MUST_ACHIEVE": "Erforderliche Punktzahl von",
      "OR_HIGHER": "oder höher ab",
      "OUT_OF_5": "von 5",
      "LATEST_ATTEMPT": "VORIGER VERSUCH",
      "TOTAL_ATTEMPTS": "Gesamtversuche",
      "UNLIMITED": "Unbegrenzt",
      "REMAINING": "Verbleibende",
      "VIEW_CALL_DETAILS": "Details anzeigen",
      "MAX_ATTEMPTS_REACHED": "Sie haben die maximale Anzahl von Versuchen erreicht",
      "DUE_DATE": "Fälligkeitsdatum",
      "DAYS": "Tage",
      "DAY": "Tag",
      "UNTILL_DUE": "Verbleibende Zeit",
      "PAST_DUE": "Überfällig",
      "ONGOING": "Laufend",
      "SCORE_REQUIREMENT": "Erforderliche Punktzahl",
      "SCORE_REQUIREMENT_DETAIL": "Sie müssen eine Punktzahl von",
      "TO_COMPLETE_EACH_CALL": "erreichen, um jede erforderliche Simulation abzuschließen.",
      "CALLS_IN_ASSIGNMENT": "Simulationen in der Aufgabe",
      "INCOMPLETE_CALL": "Unvollständig",
      "PREVIOUS_RESULTS": "Vorherige Ergebnisse",
      "DATE": "Datum",
      "RESULTS": "Ergebnisse",
      "VIEW_PREVIOUS_RESULTS": "Vorherige Ergebnisse anzeigen",
      "VIEW_FEEDBACK": "Feedback anzeigen",
      "LAUNCH_CALL": "Start",
      "CLOSE_BUTTON": "Schaltfläche „Schließen“",
      "CHECKMARK": "Häkchen",
      "CALL": "Anruf",
      "QUESTION": "Frage",
      "COMPLETED": "Abgeschlossen",
      "IN_PROGRESS": "Wird ausgeführt",
      "NOT_STARTED": "Nicht gestartet",
      "CERTIFIED": "Zertifiziert",
      "GUIDED": "Mit Anleitung",
      "CONVERSATIONAL": "Dialogorientiert",
      "GUIDED_SIMULATION": "Wissens-Check",
      "CONVERSATIONAL_SIMULATION": "Rollenspiel",
      "NO_ATTEMPTS_LEFT": "Keine verbleibenden Versuche",
      "OVERVIEW": "Übersicht",
      "ABOUT_THE_AVATAR": "Über den Avatar",
      "SCORING_CRITERIA": "Kriterien für die Punktevergabe",
      "SIMULATION_OVERVIEW": "Überblick über die Simulation",
      "ABOUT_THE_PERSONA": "Über die Persona",
      "OUTOF_COMPLIANCE": "Nicht konform",
      "TEST": "Test",
      "NO_ATTEMPTS": "Keine Versuche",
      "CLOSED": "Abgeschlossen"
    }
  }
};
